module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01f9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var $iterCreate = __webpack_require__("41a0");
var setToStringTag = __webpack_require__("7f20");
var getPrototypeOf = __webpack_require__("38fd");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var defined = __webpack_require__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "044b":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "07e3":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "0a06":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("2444");
var utils = __webpack_require__("c532");
var InterceptorManager = __webpack_require__("f6b4");
var dispatchRequest = __webpack_require__("5270");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "0a49":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("9b43");
var IObject = __webpack_require__("626a");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var asc = __webpack_require__("cd1c");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ce10");
var enumBugKeys = __webpack_require__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "0df6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "0fc9":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("3a38");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "1169":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("2d95");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "1173":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "11e9":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("52a7");
var createDesc = __webpack_require__("4630");
var toIObject = __webpack_require__("6821");
var toPrimitive = __webpack_require__("6a99");
var has = __webpack_require__("69a8");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("9e1e") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var anObject = __webpack_require__("cb7c");
var getKeys = __webpack_require__("0d58");

module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "1654":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("71c1")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("30f1")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "1691":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "1991":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("9b43");
var invoke = __webpack_require__("31f4");
var html = __webpack_require__("fab2");
var cel = __webpack_require__("230e");
var global = __webpack_require__("7726");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("2d95")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "1af6":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__("63b6");

$export($export.S, 'Array', { isArray: __webpack_require__("9003") });


/***/ }),

/***/ "1bc3":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("f772");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "1d2b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "1ec9":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("f772");
var document = __webpack_require__("e53d").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "1fa8":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("cb7c");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "20fd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("d9f6");
var createDesc = __webpack_require__("aebd");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "214f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("b0c5");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var wks = __webpack_require__("2b4c");
var regexpExec = __webpack_require__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "2350":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("2d95");
var TAG = __webpack_require__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "241e":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("25eb");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "2444":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("c532");
var normalizeHeaderName = __webpack_require__("c8af");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("b50d");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("b50d");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("f28c")))

/***/ }),

/***/ "24c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("b8e3");
var global = __webpack_require__("e53d");
var ctx = __webpack_require__("d864");
var classof = __webpack_require__("40c3");
var $export = __webpack_require__("63b6");
var isObject = __webpack_require__("f772");
var aFunction = __webpack_require__("79aa");
var anInstance = __webpack_require__("1173");
var forOf = __webpack_require__("a22a");
var speciesConstructor = __webpack_require__("f201");
var task = __webpack_require__("4178").set;
var microtask = __webpack_require__("aba2")();
var newPromiseCapabilityModule = __webpack_require__("656e");
var perform = __webpack_require__("4439");
var userAgent = __webpack_require__("bc13");
var promiseResolve = __webpack_require__("cd78");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("5168")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("5c95")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("45f2")($Promise, PROMISE);
__webpack_require__("4c95")(PROMISE);
Wrapper = __webpack_require__("584a")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("4ee1")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "25eb":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "27ee":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("23c6");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var Iterators = __webpack_require__("84f2");
module.exports = __webpack_require__("8378").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "294c":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var has = __webpack_require__("69a8");
var SRC = __webpack_require__("ca5a")('src');
var $toString = __webpack_require__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("cb7c");
var dPs = __webpack_require__("1495");
var enumBugKeys = __webpack_require__("e11e");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("5537")('wks');
var uid = __webpack_require__("ca5a");
var Symbol = __webpack_require__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d83":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("387f");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2e67":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "3024":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "30b5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "30f1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("b8e3");
var $export = __webpack_require__("63b6");
var redefine = __webpack_require__("9138");
var hide = __webpack_require__("35e8");
var Iterators = __webpack_require__("481b");
var $iterCreate = __webpack_require__("8f60");
var setToStringTag = __webpack_require__("45f2");
var getPrototypeOf = __webpack_require__("53e2");
var ITERATOR = __webpack_require__("5168")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "31f4":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");
module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "32fc":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("e53d").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "335c":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("6b4c");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "33a4":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("84f2");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "35e8":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("d9f6");
var createDesc = __webpack_require__("aebd");
module.exports = __webpack_require__("8e60") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "36c3":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("335c");
var defined = __webpack_require__("25eb");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "3702":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("481b");
var ITERATOR = __webpack_require__("5168")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "3846":
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__("9e1e") && /./g.flags != 'g') __webpack_require__("86cc").f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__("0bfb")
});


/***/ }),

/***/ "387f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("69a8");
var toObject = __webpack_require__("4bf8");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "3934":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "3a38":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "3c11":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("63b6");
var core = __webpack_require__("584a");
var global = __webpack_require__("e53d");
var speciesConstructor = __webpack_require__("f201");
var promiseResolve = __webpack_require__("cd78");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "40c3":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("6b4c");
var TAG = __webpack_require__("5168")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "40db":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  getEnv: function getEnv() {
    return this.getUrlParts().env
  },
  getDomain: function getDomain() {
    return this.getUrlParts().domain
  },
  getSubDomain: function getSubDomain() {
    return this.getUrlParts().subDomain
  },
  getFullDomain: function getFullDomain(urlParts) {
    var _urlParts = urlParts || this.getUrlParts()

    if (_urlParts.subDomain) {
      return _urlParts.subDomain + '.' + _urlParts.domain
    } else {
      return _urlParts.domain
    }
  },
  getApiUrl: function getApiUrl(apiName) {
    var urlParts = this.getUrlParts()
    var fullDomain = this.getFullDomain(urlParts)

    if (urlParts.type === 'www') {
      return location.protocol + '//' + fullDomain + '/' + apiName
    } else if (urlParts.type === 'apps') {
      return location.protocol + '//' + apiName + '.' + fullDomain
    } else if (urlParts.type === 'www2') {
      return location.protocol + '//' + apiName + '.' + (urlParts.env !== 'prd' ? 'apps' + '-' + urlParts.env : 'apps') + '.' + urlParts.domain
    } else if (urlParts.type === 'local') {
      return location.protocol + '//' + fullDomain + ':' + urlParts.port + '/' + apiName
    }

    return undefined
  },
  getApiRouterUrl: function getApiRouterUrl() {
    return this.getApiUrl('apirouter')
  },
  getApiForwardUrl: function getApiForwardUrl() {
    var apirouterUrl = this.getApiRouterUrl()

    if (apirouterUrl) {
      return apirouterUrl + '/api/forward'
    }

    return undefined
  },
  getCdnUrl: function getCdnUrl() {
    var env = this.getEnv()
    if (env === 'dev' || env === 'local') {
      return location.protocol + '//www-dev.wwt.com/cdn/shared-cdn-assets/dist'
    } else if (env === 'tst' || env === 'test') {
      return location.protocol + '//www-tst.wwt.com/cdn/shared-cdn-assets/dist'
    } else if (env === 'prod' || env === 'prd') {
      return location.protocol + '//www.wwt.com/cdn/shared-cdn-assets/dist'
    }
  },
  getUrlParts: function getUrlParts() {
    var hostPatterns = {
      local: new RegExp(/^.*?\.?(localhost)|(\d{1,3}(\.\d{1,3}){3})$/),
      www: new RegExp(/^(www-?([^2]*)?)\.(wwt\.com|telcobuy\.com)$/),
      sharepoint: new RegExp(/^(wwt(dev|test)?)\.(sharepoint\.com)$/),
      beta: new RegExp(/^(beta-?([^2]*)?)\.(wwt\.com|telcobuy\.com)$/),
      apps: new RegExp(/^.*?\.?(apps-?(.*))\.(wwt\.com|telcobuy\.com)$/),
      www2: new RegExp(/^(www2-?(.*)?)\.(wwt\.com)$/)
    }

    var urlParts = {
      type: undefined,
      protocol: location.protocol.replace(':', ''),
      host: location.hostname,
      port: undefined,
      domain: undefined,
      subDomain: undefined,
      env: undefined
    }

    for (var pattern in hostPatterns) {
      if (hostPatterns.hasOwnProperty(pattern)) {
        var matches = urlParts.host.match(hostPatterns[pattern])
        if (matches) {
          urlParts.type = pattern
          if (pattern === 'local') {
            urlParts.domain = matches[0]
            urlParts.port = location.port.toString()
            urlParts.env = pattern
            return urlParts
          } else if (pattern === 'www' || pattern === 'beta' || pattern === 'sharepoint') {
            urlParts.subDomain = matches[1]
            urlParts.env = matches[2] || 'prod'
            urlParts.domain = matches[3]
            return urlParts
          } else if (pattern === 'apps' || pattern === 'www2') {
            urlParts.subDomain = matches[1]
            urlParts.env = matches[2] || 'prd'
            urlParts.domain = matches[3]
            return urlParts
          }
        }
      }
    }
    return urlParts
  }
}


/***/ }),

/***/ "4178":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("d864");
var invoke = __webpack_require__("3024");
var html = __webpack_require__("32fc");
var cel = __webpack_require__("1ec9");
var global = __webpack_require__("e53d");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("6b4c")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("2aeb");
var descriptor = __webpack_require__("4630");
var setToStringTag = __webpack_require__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "43fc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("63b6");
var newPromiseCapability = __webpack_require__("656e");
var perform = __webpack_require__("4439");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "4439":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "454f":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("46a7");
var $Object = __webpack_require__("584a").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "45f2":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("d9f6").f;
var has = __webpack_require__("07e3");
var TAG = __webpack_require__("5168")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "467f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("2d83");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "46a7":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("63b6");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("8e60"), 'Object', { defineProperty: __webpack_require__("d9f6").f });


/***/ }),

/***/ "481b":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return addStylesClient; });
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4a59":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("9b43");
var call = __webpack_require__("1fa8");
var isArrayIter = __webpack_require__("33a4");
var anObject = __webpack_require__("cb7c");
var toLength = __webpack_require__("9def");
var getIterFn = __webpack_require__("27ee");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "4c61":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".list-item-wrapper[data-v-fed10dde]{display:flex;align-items:flex-start;margin-bottom:.5rem}.list-item-wrapper a[data-v-fed10dde]{text-decoration:none;color:#0a0b19;font-size:.875rem;line-height:1.5rem}.list-item-wrapper a[data-v-fed10dde]:hover{color:#006dc7;text-decoration:underline;border-radius:.25rem}.list-item-wrapper a:hover .app-name[data-v-fed10dde]{text-decoration:underline}.list-item-wrapper a:hover .arrow[data-v-fed10dde]{opacity:1;transform:translateX(0)}.list-item-wrapper a[data-v-fed10dde]:focus-visible{outline:none;box-shadow:inset 0 0 0 2px #006dc7;color:#006dc7;text-decoration:underline;border-radius:.25rem}.list-item-wrapper a:focus-visible .app-name[data-v-fed10dde]{text-decoration:underline}.list-item-wrapper a:focus-visible .arrow[data-v-fed10dde]{opacity:1;transform:translateX(0)}.list-item-wrapper .app-name[data-v-fed10dde]{flex:1;font-size:.875rem;padding-left:.5rem}.list-item-wrapper .icon[data-v-fed10dde]{height:1rem;width:1rem}.list-item-wrapper .app-wrapper[data-v-fed10dde]{display:flex;flex-direction:row;display:inline-flex;align-items:center}.list-item-wrapper .arrow[data-v-fed10dde]{width:2.25rem;text-align:center;font-size:1.75rem;line-height:1.5rem;opacity:0;transform:translateX(-40%);transition:all .15s ease}.list-item-wrapper .favorite[data-v-fed10dde]{color:#7766b7;cursor:pointer;width:2.25rem;text-align:center;font-size:1.25rem;line-height:1.5rem}.list-item-wrapper .favorite svg[data-v-fed10dde]{padding:.25rem;border-radius:.25rem;box-sizing:content-box;margin-left:-.25rem}.list-item-wrapper .favorite[data-v-fed10dde]:hover{color:#1c0087}.list-item-wrapper .favorite[data-v-fed10dde]:focus-visible{color:#1c0087;outline:none}.list-item-wrapper .favorite:focus-visible svg[data-v-fed10dde]{box-shadow:inset 0 0 0 2px #006dc7}", ""]);

// exports


/***/ }),

/***/ "4c95":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("e53d");
var core = __webpack_require__("584a");
var dP = __webpack_require__("d9f6");
var DESCRIPTORS = __webpack_require__("8e60");
var SPECIES = __webpack_require__("5168")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "4ee1":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("5168")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "50ed":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "5168":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("dbdb")('wks');
var uid = __webpack_require__("62a0");
var Symbol = __webpack_require__("e53d").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "520a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "5270":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var transformData = __webpack_require__("c401");
var isCancel = __webpack_require__("2e67");
var defaults = __webpack_require__("2444");
var isAbsoluteURL = __webpack_require__("d925");
var combineURLs = __webpack_require__("e683");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "53e2":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("07e3");
var toObject = __webpack_require__("241e");
var IE_PROTO = __webpack_require__("5559")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "549b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("d864");
var $export = __webpack_require__("63b6");
var toObject = __webpack_require__("241e");
var call = __webpack_require__("b0dc");
var isArrayIter = __webpack_require__("3702");
var toLength = __webpack_require__("b447");
var createProperty = __webpack_require__("20fd");
var getIterFn = __webpack_require__("7cd6");

$export($export.S + $export.F * !__webpack_require__("4ee1")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "54a1":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("6c1c");
__webpack_require__("1654");
module.exports = __webpack_require__("95d5");


/***/ }),

/***/ "551c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var global = __webpack_require__("7726");
var ctx = __webpack_require__("9b43");
var classof = __webpack_require__("23c6");
var $export = __webpack_require__("5ca1");
var isObject = __webpack_require__("d3f4");
var aFunction = __webpack_require__("d8e8");
var anInstance = __webpack_require__("f605");
var forOf = __webpack_require__("4a59");
var speciesConstructor = __webpack_require__("ebd6");
var task = __webpack_require__("1991").set;
var microtask = __webpack_require__("8079")();
var newPromiseCapabilityModule = __webpack_require__("a5b8");
var perform = __webpack_require__("9c80");
var userAgent = __webpack_require__("a25f");
var promiseResolve = __webpack_require__("bcaa");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("2b4c")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("dcbc")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("7f20")($Promise, PROMISE);
__webpack_require__("7a56")(PROMISE);
Wrapper = __webpack_require__("8378")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("5cc5")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5559":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("dbdb")('keys');
var uid = __webpack_require__("62a0");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "584a":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "5b4e":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("36c3");
var toLength = __webpack_require__("b447");
var toAbsoluteIndex = __webpack_require__("0fc9");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "5c95":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("35e8");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var hide = __webpack_require__("32e9");
var redefine = __webpack_require__("2aba");
var ctx = __webpack_require__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5cc5":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("2b4c")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "5dbc":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var setPrototypeOf = __webpack_require__("8b97").set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),

/***/ "5df3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("02f4")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("01f9")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5537")('keys');
var uid = __webpack_require__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "6219":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b029");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("2e1b0c0c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "626a":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "62a0":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "63b6":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("e53d");
var core = __webpack_require__("584a");
var ctx = __webpack_require__("d864");
var hide = __webpack_require__("35e8");
var has = __webpack_require__("07e3");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "656e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("79aa");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "67ab":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("ca5a")('meta');
var isObject = __webpack_require__("d3f4");
var has = __webpack_require__("69a8");
var setDesc = __webpack_require__("86cc").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("79e5")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("626a");
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "6894":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AppTile_vue_vue_type_style_index_0_id_06eec416_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ed21");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AppTile_vue_vue_type_style_index_0_id_06eec416_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AppTile_vue_vue_type_style_index_0_id_06eec416_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AppTile_vue_vue_type_style_index_0_id_06eec416_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "696e":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("c207");
__webpack_require__("1654");
__webpack_require__("6c1c");
__webpack_require__("24c5");
__webpack_require__("3c11");
__webpack_require__("43fc");
module.exports = __webpack_require__("584a").Promise;


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "6b4c":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "6b54":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("3846");
var anObject = __webpack_require__("cb7c");
var $flags = __webpack_require__("0bfb");
var DESCRIPTORS = __webpack_require__("9e1e");
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__("2aba")(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__("79e5")(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),

/***/ "6c1c":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("c367");
var global = __webpack_require__("e53d");
var hide = __webpack_require__("35e8");
var Iterators = __webpack_require__("481b");
var TO_STRING_TAG = __webpack_require__("5168")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "6fa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_WwtAppSwitcher_vue_vue_type_style_index_0_id_1861a91c_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6219");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_WwtAppSwitcher_vue_vue_type_style_index_0_id_1861a91c_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_WwtAppSwitcher_vue_vue_type_style_index_0_id_1861a91c_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_WwtAppSwitcher_vue_vue_type_style_index_0_id_1861a91c_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "71c1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("3a38");
var defined = __webpack_require__("25eb");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "7333":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("0d58");
var gOPS = __webpack_require__("2621");
var pIE = __webpack_require__("52a7");
var toObject = __webpack_require__("4bf8");
var IObject = __webpack_require__("626a");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("79e5")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "7514":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__("5ca1");
var $find = __webpack_require__("0a49")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("9c6c")(KEY);


/***/ }),

/***/ "7588":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropdown_vue_vue_type_style_index_0_id_224cdfb0_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("aed8");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropdown_vue_vue_type_style_index_0_id_224cdfb0_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropdown_vue_vue_type_style_index_0_id_224cdfb0_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropdown_vue_vue_type_style_index_0_id_224cdfb0_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "774e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("d2d5");

/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "794b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("8e60") && !__webpack_require__("294c")(function () {
  return Object.defineProperty(__webpack_require__("1ec9")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "795b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("696e");

/***/ }),

/***/ "79aa":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7a56":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7726");
var dP = __webpack_require__("86cc");
var DESCRIPTORS = __webpack_require__("9e1e");
var SPECIES = __webpack_require__("2b4c")('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "7a77":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "7aac":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "7cd6":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("40c3");
var ITERATOR = __webpack_require__("5168")('iterator');
var Iterators = __webpack_require__("481b");
module.exports = __webpack_require__("584a").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "7e90":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("d9f6");
var anObject = __webpack_require__("e4ae");
var getKeys = __webpack_require__("c3a1");

module.exports = __webpack_require__("8e60") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("86cc").f;
var has = __webpack_require__("69a8");
var TAG = __webpack_require__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "7f7f":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__("9e1e") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "8079":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var macrotask = __webpack_require__("1991").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("2d95")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "8436":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "85f2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("454f");

/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "87b3":
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__("2aba")(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),

/***/ "8b97":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("d3f4");
var anObject = __webpack_require__("cb7c");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("9b43")(Function.call, __webpack_require__("11e9").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "8df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("7a77");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "8e60":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("294c")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "8f60":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("a159");
var descriptor = __webpack_require__("aebd");
var setToStringTag = __webpack_require__("45f2");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("35e8")(IteratorPrototype, __webpack_require__("5168")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "9003":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("6b4c");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "9138":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("35e8");


/***/ }),

/***/ "95d5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("40c3");
var ITERATOR = __webpack_require__("5168")('iterator');
var Iterators = __webpack_require__("481b");
module.exports = __webpack_require__("584a").isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ "96cf":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9c80":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "9fa6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "a159":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("e4ae");
var dPs = __webpack_require__("7e90");
var enumBugKeys = __webpack_require__("1691");
var IE_PROTO = __webpack_require__("5559")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("1ec9")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("32fc").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "a22a":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("d864");
var call = __webpack_require__("b0dc");
var isArrayIter = __webpack_require__("3702");
var anObject = __webpack_require__("e4ae");
var toLength = __webpack_require__("b447");
var getIterFn = __webpack_require__("7cd6");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "a24d":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".tile-wrapper[data-v-06eec416]{display:flex;width:50%;padding:1rem;padding-left:0;padding-bottom:.5rem}.tile[data-v-06eec416]{display:flex;color:#0a0b19;text-decoration:none;align-items:flex-start;position:relative}.tile .app-name[data-v-06eec416]{flex:1;font-size:.875rem;line-height:1.4;padding-left:.25rem}.tile .app-wrapper[data-v-06eec416]{display:flex;flex-direction:row;align-items:flex-start}.tile[data-v-06eec416]:focus-visible{outline:none;box-shadow:0 0 0 2px #006dc7;border-radius:.25rem;color:#006dc7;text-decoration:underline}.tile:focus-visible .arrow[data-v-06eec416]{opacity:1;transform:translateX(0)}.tile[data-v-06eec416]:hover{color:#006dc7;text-decoration:underline}.tile:hover .arrow[data-v-06eec416]{opacity:1;transform:translateX(0)}.icon[data-v-06eec416]{height:1rem;width:1rem}.arrow[data-v-06eec416]{width:2.25rem;text-align:center;font-size:1.75rem;line-height:1.625rem;opacity:0;transform:translateX(-40%);transition:all .15s ease;padding-top:.125rem}.favorite[data-v-06eec416]{color:#7766b7;cursor:pointer}.favorite svg[data-v-06eec416]{box-sizing:content-box;padding:.25rem;border-radius:.25rem;margin-left:-.25rem}.favorite[data-v-06eec416]:hover{color:#1c0087}.favorite[data-v-06eec416]:focus-visible{color:#1c0087;outline:none}.favorite:focus-visible svg[data-v-06eec416]{box-shadow:inset 0 0 0 2px #006dc7}", ""]);

// exports


/***/ }),

/***/ "a25f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "a481":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("cb7c");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var toInteger = __webpack_require__("4588");
var advanceStringIndex = __webpack_require__("0390");
var regExpExec = __webpack_require__("5f1b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "a5b8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("d8e8");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "a745":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("f410");

/***/ }),

/***/ "aba2":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("e53d");
var macrotask = __webpack_require__("4178").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("6b4c")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("cadf");
var getKeys = __webpack_require__("0d58");
var redefine = __webpack_require__("2aba");
var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var wks = __webpack_require__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "aebd":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "aed8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f583");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("9fa0bf82", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b029":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".wwt-app-switcher-wrapper[data-v-1861a91c]{position:relative;font-family:Roobert,-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;box-sizing:border-box;line-height:1;padding-top:1px;padding-left:1px;height:38px;width:32px}.wwt-app-switcher-wrapper[data-v-1861a91c]  *,.wwt-app-switcher-wrapper[data-v-1861a91c]  :after,.wwt-app-switcher-wrapper[data-v-1861a91c]  :before{box-sizing:inherit}.wwt-app-switcher-wrapper *[data-v-1861a91c]{font-family:Roobert,-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol}.wwt-app-switcher-wrapper>.icon-wrapper[data-v-1861a91c]{color:#4e4f5f;height:100%;width:100%;display:inline-block;cursor:pointer}.wwt-app-switcher-wrapper>.icon-wrapper svg[data-v-1861a91c]{height:100%!important;width:100%!important}.wwt-app-switcher-wrapper>.icon-wrapper[data-v-1861a91c]:focus-visible{outline:none;border-radius:.125rem;box-shadow:0 0 0 2px #006dc7}", ""]);

// exports


/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__("520a");
__webpack_require__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "b0dc":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("e4ae");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "b39a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "b447":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("3a38");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "b50d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var settle = __webpack_require__("467f");
var buildURL = __webpack_require__("30b5");
var parseHeaders = __webpack_require__("c345");
var isURLSameOrigin = __webpack_require__("3934");
var createError = __webpack_require__("2d83");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("9fa6");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ( true &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("7aac");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "b8e3":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "bc13":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("e53d");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "bc3a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cee4");

/***/ }),

/***/ "bc89":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AppList_vue_vue_type_style_index_0_id_fed10dde_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d19f");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AppList_vue_vue_type_style_index_0_id_fed10dde_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AppList_vue_vue_type_style_index_0_id_fed10dde_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_10_oneOf_1_0_node_modules_css_loader_index_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AppList_vue_vue_type_style_index_0_id_fed10dde_lang_less_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "bcaa":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var isObject = __webpack_require__("d3f4");
var newPromiseCapability = __webpack_require__("a5b8");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "c207":
/***/ (function(module, exports) {



/***/ }),

/***/ "c26b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("86cc").f;
var create = __webpack_require__("2aeb");
var redefineAll = __webpack_require__("dcbc");
var ctx = __webpack_require__("9b43");
var anInstance = __webpack_require__("f605");
var forOf = __webpack_require__("4a59");
var $iterDefine = __webpack_require__("01f9");
var step = __webpack_require__("d53b");
var setSpecies = __webpack_require__("7a56");
var DESCRIPTORS = __webpack_require__("9e1e");
var fastKey = __webpack_require__("67ab").fastKey;
var validate = __webpack_require__("b39a");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "c345":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("6821");
var toLength = __webpack_require__("9def");
var toAbsoluteIndex = __webpack_require__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c367":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("8436");
var step = __webpack_require__("50ed");
var Iterators = __webpack_require__("481b");
var toIObject = __webpack_require__("36c3");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("30f1")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "c3a1":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("e6f3");
var enumBugKeys = __webpack_require__("1691");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "c401":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "c532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("1d2b");
var isBuffer = __webpack_require__("044b");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c8af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "c8bb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("54a1");

/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("9c6c");
var step = __webpack_require__("d53b");
var Iterators = __webpack_require__("84f2");
var toIObject = __webpack_require__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "cd1c":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("e853");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "cd78":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("e4ae");
var isObject = __webpack_require__("f772");
var newPromiseCapability = __webpack_require__("656e");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("69a8");
var toIObject = __webpack_require__("6821");
var arrayIndexOf = __webpack_require__("c366")(false);
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "cee4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var bind = __webpack_require__("1d2b");
var Axios = __webpack_require__("0a06");
var defaults = __webpack_require__("2444");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("7a77");
axios.CancelToken = __webpack_require__("8df4");
axios.isCancel = __webpack_require__("2e67");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("0df6");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "d19f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4c61");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("4d2a883e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d2d5":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1654");
__webpack_require__("549b");
module.exports = __webpack_require__("584a").Array.from;


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d864":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("79aa");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "d925":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "d9f6":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("e4ae");
var IE8_DOM_DEFINE = __webpack_require__("794b");
var toPrimitive = __webpack_require__("1bc3");
var dP = Object.defineProperty;

exports.f = __webpack_require__("8e60") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "dbdb":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("584a");
var global = __webpack_require__("e53d");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("b8e3") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "dcbc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("2aba");
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),

/***/ "e0b8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7726");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var redefineAll = __webpack_require__("dcbc");
var meta = __webpack_require__("67ab");
var forOf = __webpack_require__("4a59");
var anInstance = __webpack_require__("f605");
var isObject = __webpack_require__("d3f4");
var fails = __webpack_require__("79e5");
var $iterDetect = __webpack_require__("5cc5");
var setToStringTag = __webpack_require__("7f20");
var inheritIfRequired = __webpack_require__("5dbc");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "e4ae":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("f772");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "e53d":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "e683":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "e6f3":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("07e3");
var toIObject = __webpack_require__("36c3");
var arrayIndexOf = __webpack_require__("5b4e")(false);
var IE_PROTO = __webpack_require__("5559")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "e853":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var isArray = __webpack_require__("1169");
var SPECIES = __webpack_require__("2b4c")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "ebd6":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("cb7c");
var aFunction = __webpack_require__("d8e8");
var SPECIES = __webpack_require__("2b4c")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "ed21":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("a24d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("334218a6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "f201":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("e4ae");
var aFunction = __webpack_require__("79aa");
var SPECIES = __webpack_require__("5168")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "f28c":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "f400":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("c26b");
var validate = __webpack_require__("b39a");
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__("e0b8")(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ "f410":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1af6");
module.exports = __webpack_require__("584a").Array.isArray;


/***/ }),

/***/ "f583":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".dropdown-wrapper[data-v-224cdfb0]{position:absolute;box-sizing:border-box;right:-60px;top:46px;border:1px solid #f0f0fa;background-color:#fff;height:550px;display:flex;flex-direction:column;border-radius:5px;width:96vw;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;box-shadow:0 0 12px rgba(0,0,0,.06),0 0 16px rgba(28,0,135,.2)}.dropdown-wrapper *[data-v-224cdfb0]{font-family:inherit}.dropdown-wrapper *[data-v-224cdfb0],.dropdown-wrapper[data-v-224cdfb0] :after,.dropdown-wrapper[data-v-224cdfb0] :before{box-sizing:inherit}.dropdown-wrapper .search-input[data-v-224cdfb0]{box-sizing:content-box}.dropdown-wrapper .caret[data-v-224cdfb0],.dropdown-wrapper[data-v-224cdfb0]:before{content:\"\";position:absolute;width:1rem;height:1rem;top:-8px;right:67px;background-color:#fff;pointer-events:none;transform:rotate(45deg)}.dropdown-wrapper[data-v-224cdfb0]:before{z-index:1}.dropdown-wrapper[data-v-224cdfb0]:after{content:\"\";position:absolute;width:1rem;height:1rem;top:-8px;right:67px;background-color:#fff;pointer-events:none;transform:rotate(45deg);box-shadow:0 0 12px rgba(0,0,0,.06),0 0 16px rgba(28,0,135,.2);z-index:-1}@media (min-width:380px){.dropdown-wrapper[data-v-224cdfb0]{width:370px}}.dropdown-wrapper.app-tour[data-v-224cdfb0]{height:150px;width:300px}.dropdown-wrapper.app-tour .dropdown-main-content[data-v-224cdfb0]{color:#5e5f73;padding:1rem}.dropdown-wrapper.app-tour .dropdown-main-content h3[data-v-224cdfb0]{margin:0 0 .5rem}.dropdown-wrapper.app-tour .dropdown-main-content p[data-v-224cdfb0]{margin:0;line-height:1.6}.dropdown-wrapper.app-tour .asd-footer[data-v-224cdfb0]{display:flex;justify-content:flex-end;padding:.5rem;border-top:1px solid #f0f0fa}.dropdown-wrapper.app-tour .asd-footer button[data-v-224cdfb0]{font-size:.825rem;text-transform:uppercase;color:#0072c7;letter-spacing:.05em;background:rgba(0,0,0,0);border-radius:2px;border:.2em solid rgba(0,0,0,0)}.dropdown-wrapper.app-tour .asd-footer button[data-v-224cdfb0]:hover{background-color:#f0f0fa;color:#0086ea}.dropdown-wrapper.app-tour .asd-footer button[data-v-224cdfb0]:focus{outline:none;background-color:#f0f0fa}.dropdown-wrapper .dropdown-main-content[data-v-224cdfb0]{flex:1 1 auto;overflow:hidden;position:relative;z-index:1}.dropdown-wrapper .dropdown-main-content.oops[data-v-224cdfb0]{margin:0 auto;padding:7.5rem 1.25rem 1.25rem 1.25rem;width:300px}.dropdown-wrapper .dropdown-main-content.oops[data-v-224cdfb0]:hover,.dropdown-wrapper .dropdown-main-content.oops:hover a[data-v-224cdfb0]{color:#0086ea}.dropdown-wrapper .dropdown-main-content.oops:hover .oops-icon[data-v-224cdfb0],.dropdown-wrapper .dropdown-main-content.oops:hover a .oops-icon[data-v-224cdfb0]{background-color:#0086ea}.dropdown-wrapper .dropdown-main-content .all-apps[data-v-224cdfb0],.dropdown-wrapper .dropdown-main-content .favorites[data-v-224cdfb0]{height:100%;width:100%;overflow-y:auto;position:absolute;transition:all .3s ease;padding:.75rem 2rem .5rem}.dropdown-wrapper .dropdown-main-content .empty-list[data-v-224cdfb0]{color:#a3a4b7;line-height:1.6;padding:1rem;font-size:.875rem;text-align:center;width:100%}.dropdown-wrapper .slide-enter-active[data-v-224cdfb0],.dropdown-wrapper .slide-leave-active[data-v-224cdfb0]{transition:1s}.dropdown-wrapper .slide-enter[data-v-224cdfb0],.dropdown-wrapper .slide-leave-to[data-v-224cdfb0]{transform:translate(-100%)}.dropdown-wrapper .slideback-enter-active[data-v-224cdfb0],.dropdown-wrapper .slideback-leave-active[data-v-224cdfb0]{transition:1s}.dropdown-wrapper .slideback-enter[data-v-224cdfb0],.dropdown-wrapper .slideback-leave-to[data-v-224cdfb0]{transform:translate(100%)}.dropdown-wrapper .input-wrapper[data-v-224cdfb0]{padding:1rem;position:relative}.dropdown-wrapper .input-wrapper>i[data-v-224cdfb0]{position:absolute;color:#a3a4b7;top:50%;transform:translateY(-50%)}.dropdown-wrapper .input-wrapper>i.wwt-icon-search[data-v-224cdfb0]{left:1.625rem}.dropdown-wrapper .input-wrapper>i.wwt-icon-times-circle[data-v-224cdfb0]{opacity:.5;right:1.125rem;padding:.5rem;cursor:pointer}.dropdown-wrapper .input-wrapper>i.wwt-icon-times-circle[data-v-224cdfb0]:hover{opacity:1}.dropdown-wrapper .search[data-v-224cdfb0]{padding:1.5rem 2rem 0 2rem;color:#0a0b19}.dropdown-wrapper h2[data-v-224cdfb0]{color:#1c0087;position:relative;margin:0;font-size:1.25rem;font-weight:300;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol}.nav[data-v-224cdfb0]{cursor:pointer;display:flex;flex-direction:row;padding:2rem 2rem .75rem 2rem}.nav-item[data-v-224cdfb0]{color:#0a0b19;cursor:pointer;border-bottom:.25rem;flex-shrink:0;display:inline-block;margin-bottom:.25rem;margin-right:.5rem;padding:.25rem .5rem .5rem .5rem;text-align:center;font-weight:300;transition:color .2s,transform .4s}.nav-item[data-v-224cdfb0]:hover{font-weight:600}.nav-item[data-v-224cdfb0]:focus-visible{outline:none;border-radius:.25rem;box-shadow:0 0 0 2px #0072c7}.nav-item.active[data-v-224cdfb0]{font-weight:600;border-bottom:.25rem;border-bottom-style:solid;border-bottom-color:#0086ea}@media screen and (min-width:theme(\"screens.xs\")){.nav-item[data-v-224cdfb0]{@apply px-2}}@media screen and (min-width:theme(\"screens.md\")){.nav-item[data-v-224cdfb0]{@apply mr-4}}@media screen and (min-width:theme(\"screens.lg\")){.nav-item[data-v-224cdfb0]{@apply mr-6}}.nav-item[data-v-224cdfb0]:last-child{@apply mr-0}.nav-item[data-v-224cdfb0]:after{display:block;content:attr(text);font-weight:700;height:0;overflow:hidden;visibility:hidden}.wwt-dropdown-section.tiles>span[data-v-224cdfb0]{display:flex;flex-wrap:wrap}.wwt-dropdown-section.recents[data-v-224cdfb0]{margin-bottom:2rem}.wwt-dropdown-section button[data-v-224cdfb0]{border:none;padding:0;background-color:rgba(0,0,0,0);font-size:.813rem;line-height:1rem;cursor:pointer;display:inline-block;text-decoration:none;color:#5e5f73}.wwt-dropdown-section button.align-right[data-v-224cdfb0]{margin-left:auto}.wwt-dropdown-section button[data-v-224cdfb0]:hover{color:#0086ea}.wwt-dropdown-footer[data-v-224cdfb0]{background-color:#f0f0fa;padding:1rem;display:flex;border-bottom-right-radius:5px;border-bottom-left-radius:5px;position:relative}.apps-list-btn[data-v-224cdfb0]{border:none;padding:0;background-color:rgba(0,0,0,0);font-size:.813rem;line-height:1rem;cursor:pointer;display:inline-block;text-decoration:none;color:#5e5f73}.apps-list-btn.align-right[data-v-224cdfb0]{margin-left:auto}.apps-list-btn[data-v-224cdfb0]:hover{color:#0072c7}.apps-list-btn[data-v-224cdfb0]:focus-visible{outline:none;color:#0072c7;border-radius:.25rem;box-shadow:0 0 0 1px #fff,0 0 0 3px #0072c7}.fade-slide-enter-active[data-v-224cdfb0],.fade-slide-leave-active[data-v-224cdfb0]{transition:opacity .12s ease,transform .12s ease}.fade-slide-enter[data-v-224cdfb0],.fade-slide-leave-to[data-v-224cdfb0]{opacity:0}.fade-slide-enter.align-right[data-v-224cdfb0],.fade-slide-leave-to.align-right[data-v-224cdfb0]{transform:translateX(-200%)}.fade-slide-enter.align-left[data-v-224cdfb0],.fade-slide-leave-to.align-left[data-v-224cdfb0]{transform:translateX(200%)}.fade-slide-enter-to[data-v-224cdfb0],.fade-slide-leave[data-v-224cdfb0]{opacity:1;transform:translateX(0)}.scale-enter-active[data-v-224cdfb0],.scale-leave-active[data-v-224cdfb0]{transition:transform .12 ease}.scale-enter[data-v-224cdfb0],.scale-leave-to[data-v-224cdfb0]{transform:scale(0)}.oops-icon[data-v-224cdfb0]{display:flex;margin:0 auto;width:3.75rem;height:3.75rem;padding:1rem;text-decoration:none;align-items:center;position:relative;font-size:1.25rem;justify-content:center;text-align:center;border-radius:50%;background-color:#a3a4b7;color:#fff}.oops-message[data-v-224cdfb0],.oops-message a[data-v-224cdfb0]{color:#a3a4b7;line-height:1.5;text-align:center;text-decoration:none;padding:0 .625rem;width:13.75rem;margin:1.25rem auto}", ""]);

// exports


/***/ }),

/***/ "f605":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "f6b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f751":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("5ca1");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("7333") });


/***/ }),

/***/ "f772":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"6f03bffb-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/WwtAppSwitcher.vue?vue&type=template&id=1861a91c&scoped=true&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wwt-app-switcher-wrapper",class:{ 'is-open': _vm.isOpen },attrs:{"id":"wwt-app-switcher"}},[_c('span',{staticClass:"icon-wrapper",attrs:{"tabindex":"0"},on:{"click":_vm.toggleDropdown,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggleDropdown($event)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.checkToggleDropdown($event)}}},[_c('svg',{attrs:{"viewbox":"0 0 31 37","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.56.006H4.442A.941.941 0 003.5.947v4.116c0 .52.421.94.941.94h4.12c.52 0 .94-.42.94-.94V.947a.941.941 0 00-.94-.94zM17.564.006h-4.12a.941.941 0 00-.941.941v4.116c0 .52.421.94.941.94h4.12c.52 0 .94-.42.94-.94V.947a.941.941 0 00-.94-.94zM26.559 0h-4.12a.941.941 0 00-.941.941v4.115c0 .52.421.942.941.942h4.12c.52 0 .94-.422.94-.942V.941A.941.941 0 0026.56 0zM8.56 9.021H4.442a.941.941 0 00-.941.942v4.115c0 .52.421.941.941.941h4.12c.52 0 .94-.421.94-.941V9.963a.941.941 0 00-.94-.942zM17.564 9.021h-4.12a.941.941 0 00-.941.942v4.115c0 .52.421.941.941.941h4.12c.52 0 .94-.421.94-.941V9.963a.941.941 0 00-.94-.942zM26.559 8.998h-4.12a.941.941 0 00-.941.941v4.116c0 .52.421.94.941.94h4.12c.52 0 .94-.42.94-.94V9.939a.941.941 0 00-.94-.941zM8.56 18.002H4.442a.941.941 0 00-.941.942v4.115c0 .52.421.941.941.941h4.12c.52 0 .94-.421.94-.941v-4.116a.941.941 0 00-.94-.94zM17.56 18.002h-4.12a.941.941 0 00-.941.942v4.115c0 .52.421.941.941.941h4.12c.52 0 .94-.421.94-.941v-4.116a.941.941 0 00-.94-.94zM26.559 17.996h-4.12a.941.941 0 00-.941.941v4.116c0 .52.421.94.941.94h4.12c.52 0 .94-.42.94-.94v-4.116a.941.941 0 00-.94-.94z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.548 27.856c-1.572 0-2.592.936-2.664 2.136h1.32c.024-.54.492-1.032 1.272-1.032s1.236.42 1.236 1.008c0 .24-.144.408-.444.408H5.152c-1.356 0-2.268.732-2.268 1.908 0 1.044.816 1.812 2.016 1.812.864 0 1.56-.396 1.812-.996v.9h1.452v-3.888c0-1.368-1.08-2.256-2.616-2.256zm-.3 5.148c-.552 0-.936-.312-.936-.78 0-.528.42-.876 1.044-.876h1.356v.096c0 .912-.54 1.56-1.464 1.56zm4.228 3.444h1.464V33.34c.336.468.984.756 1.716.756 1.776 0 2.916-1.272 2.916-3.12s-1.068-3.12-2.808-3.12c-.804 0-1.464.336-1.824.852v-.756H9.476v8.496zm3.012-3.624c-.996 0-1.644-.732-1.644-1.848s.648-1.848 1.644-1.848c.972 0 1.62.732 1.62 1.848s-.648 1.848-1.62 1.848zm4.16 3.624h1.464V33.34c.336.468.984.756 1.716.756 1.776 0 2.916-1.272 2.916-3.12s-1.068-3.12-2.808-3.12c-.804 0-1.464.336-1.824.852v-.756h-1.464v8.496zm3.012-3.624c-.996 0-1.644-.732-1.644-1.848s.648-1.848 1.644-1.848c.972 0 1.62.732 1.62 1.848s-.648 1.848-1.62 1.848zm6.202 1.272c1.416 0 2.34-.744 2.34-1.884 0-2.736-3.36-1.296-3.36-2.604 0-.408.348-.648.876-.648.468 0 .984.288 1.068.852h1.344c-.06-1.176-1.032-1.956-2.448-1.956-1.248 0-2.172.744-2.172 1.8 0 2.556 3.312 1.272 3.312 2.616 0 .36-.384.648-.96.648-.66 0-1.104-.36-1.164-.936h-1.344c.072 1.296 1.044 2.112 2.508 2.112z","fill":"currentColor"}})])]),(_vm.isOpen || _vm.showAppTour)?_c('Dropdown',{attrs:{"showAppTour":_vm.showAppTour,"apps":_vm.apps,"favorites":_vm.favorites,"recents":_vm.recents},on:{"toggle-dropdown":_vm.toggleDropdown,"hide-app-tour":_vm.hideAppTour,"toggle-favorite":_vm.toggleFavorite,"remove-favorite":_vm.removeFavorite,"add-recent":_vm.addRecent}}):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/WwtAppSwitcher.vue?vue&type=template&id=1861a91c&scoped=true&lang=html&

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.iterator.js
var es6_string_iterator = __webpack_require__("5df3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.map.js
var es6_map = __webpack_require__("f400");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__("7514");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/array/is-array.js
var is_array = __webpack_require__("a745");
var is_array_default = /*#__PURE__*/__webpack_require__.n(is_array);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (is_array_default()(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/array/from.js
var from = __webpack_require__("774e");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/is-iterable.js
var is_iterable = __webpack_require__("c8bb");
var is_iterable_default = /*#__PURE__*/__webpack_require__.n(is_iterable);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/iterableToArray.js


function _iterableToArray(iter) {
  if (is_iterable_default()(Object(iter)) || Object.prototype.toString.call(iter) === "[object Arguments]") return from_default()(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js



function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/promise.js
var promise = __webpack_require__("795b");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    promise_default.a.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new promise_default.a(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"6f03bffb-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Dropdown.vue?vue&type=template&id=224cdfb0&scoped=true&lang=html&
var Dropdownvue_type_template_id_224cdfb0_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAppTour === true)?_c('div',{staticClass:"dropdown-wrapper app-tour"},[_vm._m(0),_c('div',{staticClass:"asd-footer"},[_c('button',{on:{"click":function($event){return _vm.$emit('hide-app-tour')}}},[_vm._v("Got it!")])])]):(_vm.apps.length === 0)?_c('div',{staticClass:"dropdown-wrapper"},[_c('div',{staticClass:"dropdown-main-content oops"},[_vm._m(1),_c('p',{staticClass:"oops-message"},[_c('a',{attrs:{"href":_vm.constructNamUrl},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.checkToggleDropdown($event)}}},[_vm._v("Oops, we lost your connection! Please click here to log in.")])])])]):_c('div',{staticClass:"dropdown-wrapper"},[_c('div',{staticClass:"search"},[_c('wwt-search-input',{staticClass:"search-input",attrs:{"aria-label":'Search All Applications',"id":"wwt-app-switcher-search","placeholder":"Search All Applications"},on:{"clear":_vm.handleClear},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1),_c('div',{staticClass:"nav"},[_c('div',{staticClass:"nav-item",class:{ 'active': !_vm.showAllApps },attrs:{"text":"Your Apps","tabindex":"0"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.showAllApps = false},"click":function($event){_vm.showAllApps = false}}},[_vm._v("\n      Your Apps\n    ")]),_c('div',{staticClass:"nav-item",class:{ 'active': _vm.showAllApps },attrs:{"text":"All Apps","tabindex":"0"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.showAllApps = true},"click":function($event){_vm.showAllApps = true}}},[_vm._v("\n      All Apps\n    ")])]),_c('div',{staticClass:"dropdown-main-content"},[_c('transition',{attrs:{"name":"slide"}},[(!_vm.showAllApps)?_c('div',{staticClass:"favorites"},[_c('h2',[_vm._v("Recent Apps")]),_c('div',{staticClass:"wwt-dropdown-section tiles recents"},[(_vm.recents.length === 0)?_c('p',{staticClass:"empty-list"},[_vm._v("\n            No recently visited apps.\n          ")]):_vm._e(),_c('transition-group',{attrs:{"name":"scale"}},_vm._l((_vm.recents),function(app){return _c('AppTile',{key:app.applicationId,attrs:{"app":app,"isRecent":true},on:{"toggle-favorite":function($event){return _vm.$emit('toggle-favorite', app)},"add-recent":function($event){return _vm.$emit('add-recent', app)}}})}),1)],1),_c('h2',[_vm._v("My Favorites")]),_c('div',{staticClass:"wwt-dropdown-section tiles"},[(_vm.favorites.length === 0)?_c('p',{staticClass:"empty-list"},[_vm._v("\n            You haven't favorited any apps yet! "),_c('br'),_vm._v(" Click the star next to an app\n            from the\n            "),_c('button',{key:"all",staticClass:"apps-list-btn",attrs:{"tabindex":"0"},on:{"click":function($event){_vm.showAllApps = true},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.checkToggleDropdown($event)}}},[_vm._v("\n              All Apps\n            ")]),_vm._v(" list to add it here.\n          ")]):_vm._e(),_c('transition-group',{attrs:{"name":"scale"}},_vm._l((_vm.favorites),function(app,idx){return _c('AppTile',{key:app.applicationId,attrs:{"app":app},on:{"toggle-favorite":function($event){return _vm.$emit('toggle-favorite', app)},"add-recent":function($event){return _vm.$emit('add-recent', app)},"check-focus":function($event){return _vm.checkTileTabFocus($event, idx)}}})}),1)],1)]):_vm._e()]),_c('transition',{attrs:{"name":"slideback"}},[(_vm.showAllApps)?_c('div',{staticClass:"all-apps"},[(_vm.filteredApps.length === 0)?_c('p',{staticClass:"empty-list"},[_vm._v("\n          No Apps found. Please try again.\n        ")]):_vm._e(),_vm._l((_vm.filteredApps),function(app,idx){return _c('AppList',{key:app.applicationId,attrs:{"app":app},on:{"toggle-favorite":function($event){return _vm.$emit('toggle-favorite', app)},"add-recent":function($event){return _vm.$emit('add-recent', app)},"check-focus":function($event){return _vm.checkListTabFocus($event, idx)}}})})],2):_vm._e()])],1)])}
var Dropdownvue_type_template_id_224cdfb0_scoped_true_lang_html_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-main-content"},[_c('h3',[_vm._v("Heads up!")]),_c('p',[_vm._v("Click here to access your applications and favorites.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"oops-icon"},[_c('i',{staticClass:"wwt-icon-exclamation-triangle"})])}]


// CONCATENATED MODULE: ./src/Dropdown.vue?vue&type=template&id=224cdfb0&scoped=true&lang=html&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"6f03bffb-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/AppTile.vue?vue&type=template&id=06eec416&scoped=true&lang=html&
var AppTilevue_type_template_id_06eec416_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile-wrapper"},[_c('span',{staticClass:"favorite",attrs:{"tabindex":"0"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleFavorite($event)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggleFavorite($event)}}},[(!_vm.app.isFavorite)?_c('icon-star',{staticClass:"icon"}):_c('icon-star-fill',{staticClass:"icon"})],1),_c('div',{staticClass:"app-wrapper"},[_c('a',{staticClass:"tile",attrs:{"href":_vm.app.url,"target":"_blank"},on:{"click":function($event){return _vm.$emit('add-recent', _vm.app)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.$emit('check-focus', $event)}}},[_c('span',{staticClass:"app-name"},[_vm._v(_vm._s(_vm.app.name))]),_c('icon-caret-right',{staticClass:"icon arrow"})],1)])])}
var AppTilevue_type_template_id_06eec416_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/AppTile.vue?vue&type=template&id=06eec416&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/@blue-steel/icons/dist/icons.js
var IconsExample = "<template> \n  <div class=\"w-full\">\n    <a href=\"/blue-steel-icons\">  Full Icon List </a>\n    <h2>Basic Usage</h2>\n    <p>{{ explanation.basicUsage }}</p>\n    <icon-happy-face class=\"example\" />\n\n    <h2>Color Styling</h2>\n    <p><b>Component</b></p>\n    <p>{{ explanation.changeColor.component }}</p>\n\n    <icon-happy-face class=\"example blue-face rounded-full\" />\n    <icon-webex-color class=\"webex\" />\n\n    <p><b>Scoped Styling with Icon Component</b></p>\n    <p>{{ explanation.changeColor.scoped }}</p>\n\n    <p> \n      .a >>> path { fill: green; }\n\n      <b>SCSS/SASS</b>\n      .a ::v-deep path { fill: blue; }\n    </p>\n      \n    <p><b>NOTES</b></p>\n    <p><b>Scoped styles do not eliminate the need for classes.</b> {{ explanation.changeColor.eleminate }}</p> \n    <p><b>Be careful with descendant selectors in recursive components!</b> {{ explanation.changeColor.careful }}</p> \n  \n    <p><b>SVG</b></p>\n    <p>{{ explanation.changeColor.svg }}</p>\n    <colorExampleOne class=\"example\">\n      <svg\n        data-v-95854320=\"\"\n        fill=\"none\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 16 16\"\n        class=\"h-10 w-10 rounded-full\"\n        data-v-f2874d9e=\"\"\n      ><path\n        d=\"M8 16a8 8 0 118-8 8.01 8.01 0 01-8 8zM8 1a7 7 0 107 7 7.009 7.009 0 00-7-7z\"\n        fill=\"cyan\"\n      /><path\n        d=\"M10.564 6.645a.538.538 0 100-1.076.538.538 0 000 1.076zM5.437 6.645a.538.538 0 100-1.076.538.538 0 000 1.076zM8 12.433a4.57 4.57 0 01-3.942-2.115.5.5 0 01.857-.515A3.565 3.565 0 008 11.433a3.565 3.565 0 003.086-1.63.5.5 0 11.857.515A4.57 4.57 0 018 12.433z\"\n        fill=\"magenta\"\n      /></svg>\n    </colorExampleOne>\n    <colorExampleTwo class=\"example\">\n      <svg\n        data-v-95854320=\"\"\n        fill=\"none\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 16 16\"\n        class=\"h-10 w-10 rounded-full bg-yellow stroke-current text-blue-700\"\n        data-v-f2874d9e=\"\"\n      ><path\n        d=\"M8 16a8 8 0 118-8 8.01 8.01 0 01-8 8zM8 1a7 7 0 107 7 7.009 7.009 0 00-7-7z\"\n        fill=\"currentColor\"\n      /><path\n        d=\"M10.564 6.645a.538.538 0 100-1.076.538.538 0 000 1.076zM5.437 6.645a.538.538 0 100-1.076.538.538 0 000 1.076zM8 12.433a4.57 4.57 0 01-3.942-2.115.5.5 0 01.857-.515A3.565 3.565 0 008 11.433a3.565 3.565 0 003.086-1.63.5.5 0 11.857.515A4.57 4.57 0 018 12.433z\"\n        fill=\"currentColor\"\n      /></svg>\n    </colorExampleTwo>\n  </div>\n</template>\n\n<script>\n  module.exports = {\n    name: 'IconsExample',\n\n    data() {\n      return {\n        explanation: {\n          basicUsage: \"With the new update you are now able to use the individual icons as a component or use the svg directly. \" +\n          \"If you choose to use it as a component, you'll simply import it like any other component and insert it wherever needed. \" +\n          \"You will need to define it's height and width as those are defaulted to 100% of the parent container. \",\n\n          changeColor: {\n            component: \"You can change the color of your icon component using a class and then styling the path fill \" +\n              \"(ie. .happy-face path {fill: color} ) to change all the line fills. You can also change the individual path fills by using the nth selector. \",\n            \n            scoped: \"If you want to change the color in scoped styles, you will need to use 'deep', i.e. affecting child components, you can use the >>> combinator. \" +  \n              \"Some pre-processors, such as Sass/Scss, may not be able to parse >>> properly. In those cases you can use the ::v-deep combinator instead.\",\n            \n            eleminate: \"Due to the way browsers render various CSS selectors, p { color: red } will be many times slower when scoped (i.e. when combined with an attribute selector). \" + \n              \"If you use classes or ids instead, such as in .example { color: red }, then you virtually eliminate that performance hit.\",\n\n            careful: \"For a CSS rule with the selector .a .b, if the element that matches .a contains a recursive child component, then all .b in that child component will be matched by the rule.\",\n\n            svg:  \"For an svg we don't change the path fills, so you'll want to make sure to change all the inline fills to currentColor and \" +\n              \"set your color to the svg element or place it in the class. You may also change the path fills the same way as the component.\",\n\n          },\n        },\n      };\n    },\n  }\n\n</script>\n\n<style scoped>\n\n  .example {\n    height: 2.5rem;\n    width: 2.5rem;\n    margin: 1rem;\n    display: inline-flex;\n  }\n\n  .blue-face {\n    background: lightblue;\n  }\n\n  .blue-face path {\n    fill: green;\n  }\n\n  .webex {\n    width: 2.5rem; \n    height: 2.5rem; \n    margin: 1rem; \n    display: inline-flex;\n  }\n  \n  .webex path:nth-child(1) {\n    fill: purple;\n  }\n\n  .webex path:nth-child(2) {\n    fill: magenta;\n  }\n\n  .webex path:nth-child(4) {\n    fill: cyan;\n  }\n  \n\n\n</style>";

var iconActionEllipsis = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12.5 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM3.5 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z","fill":"currentColor"}})]) } };

var iconActivityFeed = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M1.504 16A1.506 1.506 0 010 14.496V.5A.5.5 0 01.5 0h13.996A1.505 1.505 0 0116 1.503v12.495h-1V1.504A.504.504 0 0014.496 1H1v13.496a.504.504 0 00.504.504L16 14.998v1L1.504 16z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13 7.5H3v1h10v-1zM13 11.5H3v1h10v-1zM13 3.5H3v1h10v-1z","fill":"currentColor"}})]) } };

var iconAddUser = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10.012 9.5l-.28 1c1.212.34 2.894 1.14 2.894 1.75v2.25H1v-2.28c0-.55 1.803-1.46 3.405-1.93a1.452 1.452 0 001.181-1.55.66.66 0 00-.19-.39A4.13 4.13 0 014.125 5.2c0-2 1.192-3.7 2.663-3.7 1.472 0 2.664 1.66 2.664 3.7S8.26 8.91 6.788 8.91v1c2.003 0 3.665-2.11 3.665-4.71S8.811.5 6.788.5C4.766.5 3.124 2.61 3.124 5.2a5.224 5.224 0 001.462 3.77c0 .13-.15.27-.45.36C3.163 9.61 0 10.65 0 12.22v2.66a.639.639 0 00.66.62h12.256a.651.651 0 00.661-.63v-2.65c0-1.61-3.014-2.54-3.565-2.72zM16 5.82h-1.542V4.27h-1.001v1.55h-1.552v1h1.552v1.55h1.001V6.82H16v-1z","fill":"currentColor"}})]) } };

var iconAdditionalResources = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8.166 3.998a3.999 3.999 0 00-3.118 6.7 3.973 3.973 0 002.946 1.294c.857 0 1.692-.276 2.38-.786l-.595-.803a3 3 0 01-3.815-4.619 2.999 2.999 0 014.482 3.932l.819.576a4.004 4.004 0 00-1.583-5.928 3.965 3.965 0 00-1.516-.366z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.5 9.491v-1h1v-1h-1v-1h-1v1h-1v1h1v1h1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 6h-1.318a6.396 6.396 0 00-.396-.958l.932-.932a.501.501 0 000-.707l-2.121-2.12a.5.5 0 00-.707 0l-.929.927A6.46 6.46 0 0010 1.812V.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v1.312c-.33.107-.652.24-.96.398l-.929-.928a.5.5 0 00-.707 0l-2.12 2.121a.5.5 0 000 .707l.93.931c-.158.309-.29.63-.396.959H.5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h1.324c.107.327.24.645.396.952l-.937.937a.5.5 0 000 .707l2.121 2.121a.498.498 0 00.707 0l.94-.94c.306.156.623.287.949.392V15.5a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-1.33c.326-.106.644-.237.95-.393l.94.94a.514.514 0 00.707 0l2.12-2.121a.498.498 0 000-.707l-.937-.937c.158-.306.29-.625.397-.952H15.5a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM15 9h-1.198a.499.499 0 00-.484.374 5.47 5.47 0 01-.586 1.41.498.498 0 00.076.61l.85.848-1.415 1.415-.851-.852a.498.498 0 00-.608-.077 5.46 5.46 0 01-1.409.582.5.5 0 00-.375.484V15H7v-1.206a.5.5 0 00-.375-.484 5.445 5.445 0 01-1.408-.582.501.501 0 00-.608.077l-.851.852-1.414-1.415.848-.849a.501.501 0 00.078-.608 5.455 5.455 0 01-.587-1.411A.499.499 0 002.199 9H1V7h1.194a.5.5 0 00.485-.375c.127-.498.324-.975.584-1.418a.5.5 0 00-.077-.607l-.842-.843 1.414-1.414.84.84a.5.5 0 00.607.077c.443-.262.921-.46 1.42-.588A.5.5 0 007 2.187V1h2v1.188a.5.5 0 00.375.484c.498.128.976.326 1.419.588a.502.502 0 00.608-.077l.841-.84 1.414 1.414-.842.843a.5.5 0 00-.078.607c.261.442.458.92.584 1.417a.5.5 0 00.485.376H15v2z","fill":"currentColor"}})]) } };

var iconAgile = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M3 10.51l.78-.67c-.11-.13-.22-.26-.32-.4A4.25 4.25 0 015.6 3l-.34-.95a5.28 5.28 0 00-3.6 5 5.16 5.16 0 00.92 3c.132.16.272.314.42.46z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.85 11.47l-2.29-2.31-.74.71 1.44 1.45h-4.07a5.22 5.22 0 002.25-4.27 5.32 5.32 0 00-4.2-5.15l1.85-1-.5-.9-2.92 1.6a.53.53 0 00-.256.505.46.46 0 00.066.185l1.63 2.86.9-.5L8 2.88a4.3 4.3 0 013.4 4.17 4.32 4.32 0 01-4.35 4.27H0v1h14.26l-1.44 1.45.74.71 2.29-2.32a.5.5 0 000-.69z","fill":"currentColor"}})]) } };

var iconAppSwitcher = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M3.374.004H.627A.627.627 0 000 .632v2.743c0 .347.28.628.627.628h2.747c.346 0 .627-.281.627-.628V.632a.627.627 0 00-.627-.628zM9.375.004H6.63A.627.627 0 006 .632v2.743c0 .347.281.628.628.628h2.746c.347 0 .627-.281.627-.628V.632a.627.627 0 00-.627-.628zM15.373 0h-2.747A.627.627 0 0012 .627v2.744c0 .346.28.627.627.627h2.747c.346 0 .627-.28.627-.627V.627A.627.627 0 0015.373 0zM3.374 6.014H.627A.627.627 0 000 6.642v2.743c0 .347.28.628.627.628h2.747c.346 0 .627-.281.627-.628V6.642a.627.627 0 00-.627-.628zM9.375 6.014H6.63A.627.627 0 006 6.642v2.743c0 .347.281.628.628.628h2.746c.347 0 .627-.281.627-.628V6.642a.627.627 0 00-.627-.628zM15.373 5.998h-2.747a.627.627 0 00-.627.628v2.743c0 .347.28.628.627.628h2.747c.346 0 .627-.281.627-.628V6.626a.627.627 0 00-.627-.628zM3.374 12.002H.627a.627.627 0 00-.627.627v2.744c0 .346.28.627.627.627h2.747c.346 0 .627-.28.627-.627v-2.744a.627.627 0 00-.627-.627zM9.373 12.002H6.627a.627.627 0 00-.628.627v2.744c0 .346.281.627.628.627h2.746c.347 0 .628-.28.628-.627v-2.744a.627.627 0 00-.628-.627zM15.373 11.997h-2.747a.627.627 0 00-.627.628v2.743c0 .347.28.628.627.628h2.747c.346 0 .627-.281.627-.628v-2.743a.627.627 0 00-.627-.628z","fill":"currentColor"}})]) } };

var iconApps = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('g',{attrs:{"clip-path":"url(#assets-icon-apps_svg__clip0)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M10.555 7.284H3.417v1h7.138v-1z"}}),_c('path',{attrs:{"d":"M13.973 10.995V1.5a.5.5 0 00-.5-.5H1.494A1.494 1.494 0 000 2.492v9.497a.5.5 0 00.5.5h11.978a1.496 1.496 0 001.495-1.494zM1.494 2h11.479v1.539H1V2.492A.494.494 0 011.494 2zM1 4.537h11.973v6.458a.495.495 0 01-.495.495H1V4.537z"}}),_c('path',{attrs:{"d":"M15.507 3.641l-.491-.006L15 13.503a.499.499 0 01-.499.498H2.76v-.522h-1V14.5a.5.5 0 00.5.5H14.5a1.5 1.5 0 001.5-1.498V4.14a.5.5 0 00-.494-.5z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"assets-icon-apps_svg__clip0"}},[_c('path',{attrs:{"fill":"currentColor","transform":"translate(0 1)","d":"M0 0h16v14H0z"}})])])]) } };

var iconArchive = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 1H.5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h.25v8.503A1.499 1.499 0 002.247 15H14.75a.5.5 0 00.5-.5V6h-1v8H2.247a.497.497 0 01-.497-.497V5H15.5a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM15 4H1V2h14v2z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M4.999 6.505a.5.5 0 00-.5.5v1.991a.5.5 0 00.5.5h5.996a.5.5 0 00.5-.5v-1.99a.497.497 0 00-.5-.5H5zm5.496 1.991H5.5v-.99h4.996v.99z","fill":"currentColor"}})]) } };

var iconArticle = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.005 7.5h-1.999v.998h2v-.999zM9.997 7.5H6.008v.998h3.989v-.999zM14.005 9.993H6.03v.998h7.975v-.998zM14.005 2.506h-3.484v.999h3.484v-.999zM14.005 5.003h-3.52V6h3.52v-.998zM14.005 12.492h-3.988v1h3.988v-1zM8.002 12.492H6.008v1h1.994v-1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16 .5a.5.5 0 00-.5-.5H5.537A1.497 1.497 0 004.04 1.494v11.988a1.515 1.515 0 01-.537 1.158 1.491 1.491 0 01-.898.36H2.58a1.584 1.584 0 01-.32-.02A1.593 1.593 0 011 13.374v-9.78a.503.503 0 01.503-.502.463.463 0 01.496.46l.036 9.442 1-.004-.037-9.44a1.461 1.461 0 00-1.495-1.457A1.503 1.503 0 000 3.595v9.78a2.598 2.598 0 002.101 2.59c.137.023.276.034.415.034h11.979A1.503 1.503 0 0016 14.5V2.007h-1V14.5a.503.503 0 01-.505.5H4.531c.33-.437.51-.97.51-1.518V1.494A.496.496 0 015.537 1L16 1.008V.499z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.002 6.001a.5.5 0 00.5-.499V3.005a.5.5 0 00-.5-.499H6.511a.5.5 0 00-.5.5v2.496a.499.499 0 00.5.5h2.491zM7.011 3.505h1.491v1.498H7.011V3.505z","fill":"currentColor"}})]) } };

var iconAssessment = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M15.854 4.825l-1.228-1.233a.497.497 0 00-.706 0L8.826 8.708c-.095.094-.123.122-.692 1.734a.813.813 0 00.766 1.065.758.758 0 00.325-.073 7.373 7.373 0 001.52-.769l5.109-5.131a.503.503 0 000-.709zm-5.766 5.082c-.147.076-.538.264-.85.412.151-.423.295-.812.356-.965l4.68-4.699.52.524-4.706 4.728zM10.502 4.478H2.545V5.48h7.957V4.478zM7.66 7.151H2.515v1.003H7.66V7.151zM6.442 9.825H2.515v1.003h3.927V9.825zM10.502 12.5H2.545v1.002h7.957v-1.003z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.001 14.489a.508.508 0 01-.507.508H.998V2.99a.508.508 0 01.506-.508h1.977v.501a.5.5 0 00.499.502h5.057a.5.5 0 00.5-.502v-.501H12v1.003H13V1.98a.5.5 0 00-.5-.5H9.538v-.225a.5.5 0 00-.5-.501H7.782a1.451 1.451 0 00-2.546 0H3.98a.5.5 0 00-.5.501v.224H1.505A1.51 1.51 0 000 2.99v12.508A.5.5 0 00.5 16h10.994A1.51 1.51 0 0013 14.489v-3.985H12v3.985zM4.48 1.757h1.103a.5.5 0 00.49-.409.464.464 0 01.873 0 .5.5 0 00.49.409h1.103v.725H4.48v-.725z","fill":"currentColor"}})]) } };

var iconAtcAtom = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8.75 8.27a.75.75 0 10-1.5-.04.75.75 0 001.5.04z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16 8.23c0-.67-.39-1.64-2.23-2.44l-.4.93c1 .44 1.63 1 1.63 1.51 0 .88-1.76 1.84-4.38 2.24.1-.17.21-.33.31-.51a16.149 16.149 0 002-5.25c.24-1.71-.09-2.97-.93-3.48-.57-.33-1.59-.47-3.2.74l.6.81c.88-.67 1.67-.92 2.1-.67.43.25.63 1.19.44 2.45-.15.86-.388 1.7-.71 2.51-.1-.18-.18-.36-.28-.53a15.73 15.73 0 00-3.53-4.35C6.06 1.09 4.84.76 4 1.27c-.6.33-1.23 1.15-1 3.17l1-.12c-.13-1.12 0-1.93.47-2.18.47-.25 1.33 0 2.32.84a12 12 0 011.8 1.87L8 4.83C4.12 4.83 0 6 0 8.27c0 .67.39 1.64 2.23 2.44l.4-.93C1.61 9.34 1 8.77 1 8.27 1 7.39 2.76 6.44 5.38 6c-.1.17-.21.33-.31.51C3.13 9.93 2.1 14.15 4 15.27c.274.156.585.235.9.23a4 4 0 002.3-1l-.6-.81c-.88.67-1.67.92-2.1.67-.75-.44-.7-2.46.27-5 .09.18.18.36.28.53 1.66 2.9 4.16 5.51 6 5.51.32.008.635-.075.91-.24.57-.33 1.2-1.15 1-3.17l-1 .12c.13 1.12 0 1.93-.47 2.18-.75.44-2.45-.62-4.12-2.71h.59c3.92.09 8.04-1.11 8.04-3.35zM5.93 9.46c-.23-.41-.44-.81-.63-1.21.19-.4.4-.8.63-1.21.23-.41.48-.78.72-1.15h2.7a17.49 17.49 0 011.35 2.36c-.2.4-.41.81-.64 1.21-.23.4-.47.78-.71 1.15-.44 0-.89.05-1.35.05-.46 0-.91 0-1.35-.05-.24-.36-.48-.75-.72-1.15z","fill":"currentColor"}})]) } };

var iconAttachment = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('g',{attrs:{"clip-path":"url(#assets-icon-attachment_svg__clip0)"}},[_c('path',{attrs:{"d":"M10.025 5.14l-.71-.71L3.745 10a2 2 0 001.38 3.49 2 2 0 001.42-.59l4.28-4.28 3.44-3.44a3 3 0 00.13-4.32 2.87 2.87 0 00-2-.86 3.17 3.17 0 00-2.29 1l-7.66 7.64-.34.36a4.23 4.23 0 00-.28 5.92A3.83 3.83 0 004.535 16a4.509 4.509 0 003.21-1.35l.34-.34 5.56-5.56-.74-.75-5.6 5.61-.3.3A3.51 3.51 0 014.545 15a2.8 2.8 0 01-2-.81 3.21 3.21 0 01.27-4.5l.31-.3 7.69-7.7a2.18 2.18 0 011.53-.69 1.84 1.84 0 011.33.57 2 2 0 01-.13 2.9l-2.57 2.58-.86.86-1.14 1.14-3.14 3.15a1.05 1.05 0 01-.75.33 1 1 0 01-.67-1.78l5.61-5.61z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"assets-icon-attachment_svg__clip0"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h16v16H0z"}})])])]) } };

var iconAutomation = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6.263 10.064a.997.997 0 01-.932-.646l-.136-.36a3.96 3.96 0 01-.565-.019l-.159.35a.996.996 0 01-1.32.495l-.52-.235a.995.995 0 01-.497-1.317l.16-.35a4.008 4.008 0 01-.383-.41l-.364.136a1.004 1.004 0 01-1.282-.582l-.201-.538a.99.99 0 01.59-1.28l.356-.134c-.007-.186 0-.373.019-.56l-.35-.158a.999.999 0 01-.497-1.317l.241-.524a.995.995 0 011.316-.49l.354.16a4.03 4.03 0 01.413-.382l-.135-.361a.993.993 0 01.586-1.28l.537-.2a.997.997 0 011.28.583l.137.363c.188-.006.375 0 .562.02l.162-.352a.997.997 0 011.32-.489l.52.237a.995.995 0 01.493 1.32l-.16.35c.13.123.253.254.367.393l.364-.137a.997.997 0 011.284.582l.202.53a.993.993 0 01-.58 1.284l-.362.136c.007.186.001.373-.017.558l.352.159a.992.992 0 01.495 1.32l-.234.518a.999.999 0 01-1.317.498l-.355-.16a3.935 3.935 0 01-.41.381l.136.363a.993.993 0 01-.582 1.279l-.537.2a.992.992 0 01-.351.066zm-.734-2.037a.5.5 0 01.467.323l.27.716.533-.204-.272-.711a.5.5 0 01.196-.595c.288-.187.541-.423.749-.696a.499.499 0 01.603-.152l.698.315.229-.518-.693-.309a.499.499 0 01-.284-.557c.069-.336.08-.681.032-1.02a.5.5 0 01.318-.538l.718-.271-.206-.526-.713.271a.5.5 0 01-.592-.19 3.05 3.05 0 00-.69-.737.5.5 0 01-.152-.607l.32-.695-.52-.23-.316.693a.498.498 0 01-.556.28 2.974 2.974 0 00-1.025-.035.503.503 0 01-.536-.32L3.838.995l-.534.204.272.71a.5.5 0 01-.196.593c-.289.188-.544.424-.754.698a.501.501 0 01-.602.15l-.695-.313-.237.516.695.306a.5.5 0 01.284.559 3.02 3.02 0 00-.037 1.023.5.5 0 01-.318.534L1 6.246l.2.527.714-.271a.5.5 0 01.593.192c.19.288.427.542.701.751a.5.5 0 01.154.606l-.318.697.52.226.312-.692a.499.499 0 01.557-.283c.338.069.686.08 1.028.033a.52.52 0 01.067-.005z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.046 6.392h-.008a1.362 1.362 0 01-.954-2.326c.267-.241.61-.38.968-.395a1.36 1.36 0 01-.006 2.721zm0-1.72a.36.36 0 100 .72.36.36 0 10.001-.72h-.002zM10.518 16a.995.995 0 01-.996-.99l-.002-.385a4.063 4.063 0 01-.523-.213l-.272.274a.996.996 0 01-1.408.007l-.408-.403a.99.99 0 01-.005-1.406l.272-.274a4 4 0 01-.216-.516l-.39.002h-.002a1 1 0 01-.997-.992v-.574h1v.57l.764-.008h.002a.5.5 0 01.488.387c.076.335.21.655.394.945a.5.5 0 01-.066.623l-.541.543.408.392.534-.542a.5.5 0 01.62-.073c.293.183.616.314.953.389a.499.499 0 01.39.485l.005.764.569-.009-.006-.76a.5.5 0 01.39-.49c.336-.076.656-.21.947-.394a.5.5 0 01.618.068l.543.537.398-.407-.542-.53a.5.5 0 01-.074-.62c.182-.292.313-.612.387-.948a.5.5 0 01.484-.392l.767-.005-.007-.566-.763.009h-.002a.5.5 0 01-.487-.384 3.014 3.014 0 00-.39-.93.5.5 0 01.068-.622l.542-.541-.406-.395-.538.54a.5.5 0 01-.62.07 3.013 3.013 0 00-.948-.388.5.5 0 01-.391-.488l-.001-.766-.571.008-.002-1 .575-.001a.997.997 0 01.998.99v.388c.178.059.352.13.52.214l.275-.275a1 1 0 011.408-.002l.406.405a.993.993 0 01.002 1.407l-.273.273c.08.16.15.325.207.495l.39-.003h.001a.998.998 0 011 .992l.004.569a.996.996 0 01-.99 1l-.388.003a3.94 3.94 0 01-.212.518l.275.27a.99.99 0 01.005 1.41l-.4.404a.999.999 0 01-1.408.01l-.276-.273a4.016 4.016 0 01-.52.216l.001.388a.996.996 0 01-.99.996l-.573.004h-.006z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.783 12.693a1.906 1.906 0 01-1.295-.51 1.896 1.896 0 01-.481-2.052 1.904 1.904 0 013.076-.717 1.894 1.894 0 01-1.3 3.28zm-.84-2.21a.895.895 0 00.525 1.153.899.899 0 001.215-.868.895.895 0 00-1.268-.784.904.904 0 00-.473.5z","fill":"currentColor"}})]) } };

var iconAward = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.94 13.557l-2.326-4.293a.531.531 0 01.163-.022 1.67 1.67 0 001.63-1.03 1.646 1.646 0 00-.426-1.872.662.662 0 010-.988 1.645 1.645 0 00.427-1.87 1.664 1.664 0 00-1.632-1.031.67.67 0 01-.705-.7A1.672 1.672 0 009.16.55a.692.692 0 01-.999 0 1.672 1.672 0 00-2.909 1.203.655.655 0 01-.193.503.664.664 0 01-.512.196 1.666 1.666 0 00-1.204 2.902.663.663 0 010 .988 1.653 1.653 0 001.062 2.886l-2.345 4.33a.5.5 0 00.431.738l2.171.033 1.357 1.503a.501.501 0 00.8-.079l1.392-2.334-.86-.511L6.31 14.66l-1.05-1.163a.5.5 0 00-.363-.165l-1.563-.024 1.9-3.506c.012.045.02.092.022.14a1.647 1.647 0 001.024 1.622c.207.087.429.132.653.133a1.64 1.64 0 00.809-.224l2.434 4.272a.5.5 0 00.806.087l1.357-1.504 2.17-.032a.5.5 0 00.432-.739zm-8.276-2.916a.65.65 0 01-.411-.648 1.669 1.669 0 00-1.755-1.749.612.612 0 01-.655-.413.646.646 0 01.17-.746 1.664 1.664 0 00-.001-2.475.646.646 0 01-.17-.746.638.638 0 01.655-.413 1.667 1.667 0 001.754-1.75.648.648 0 01.411-.648.66.66 0 01.76.169 1.674 1.674 0 001.24.548 1.674 1.674 0 001.24-.549.664.664 0 01.759-.169.65.65 0 01.412.649 1.667 1.667 0 001.754 1.749.614.614 0 01.656.413.646.646 0 01-.17.745 1.662 1.662 0 000 2.476.645.645 0 01.17.746.636.636 0 01-.655.413 1.669 1.669 0 00-1.754 1.75.651.651 0 01-.412.648.66.66 0 01-.758-.17 1.68 1.68 0 00-1.24-.547h-.002a1.672 1.672 0 00-1.238.549.661.661 0 01-.76.168zm5.441 2.69a.498.498 0 00-.364.166l-1.04 1.152-2.113-3.71a.646.646 0 01.075-.015.667.667 0 01.5.22 1.656 1.656 0 001.883.42 1.633 1.633 0 00.99-1.268l1.632 3.012-1.563.024z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.789 5.847a3.11 3.11 0 10-6.219-.023 3.11 3.11 0 006.219.023zm-5.218 0a2.109 2.109 0 114.218-.023 2.109 2.109 0 01-4.218.023z","fill":"currentColor"}})]) } };

var iconBan = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 16a8 8 0 118-8 8.01 8.01 0 01-8 8zM8 1a7 7 0 107 7 7.009 7.009 0 00-7-7z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8 13.495a5.403 5.403 0 01-2.769-.772l-.557-.328L12.31 4.76l.686.76-.353.317.002.002-6.318 6.318c.53.223 1.098.339 1.673.34A4.5 4.5 0 0012.495 8c0-.299-.032-.597-.095-.89l.979-.209c.077.362.116.73.116 1.099A5.5 5.5 0 018 13.495zM3.607 11.332l-.327-.556A5.41 5.41 0 012.505 8 5.501 5.501 0 018 2.505a5.41 5.41 0 012.776.776l.557.327-7.726 7.724zM8 3.505A4.5 4.5 0 003.505 8c0 .577.116 1.148.34 1.68l5.836-5.834A4.327 4.327 0 008 3.505z","fill":"currentColor"}})]) } };

var iconBarGraph = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M16 16H.499A.498.498 0 010 15.501V0h.997v15.003H16V16z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.67 13.98h-.997V6.637H3.477v7.343H2.48V6.138a.498.498 0 01.499-.499H5.17a.498.498 0 01.499.499v7.842zM10.32 13.98h-.997V9.314H8.128v4.666H7.13V8.815a.498.498 0 01.5-.499h2.192a.498.498 0 01.498.499v5.165zM14.97 13.98h-.998V3.087h-1.194V13.98h-.998V2.588a.496.496 0 01.499-.499h2.192a.499.499 0 01.498.499V13.98z","fill":"currentColor"}})]) } };

var iconBiplane = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.432 2.57h-4.043l.006-.146a1.463 1.463 0 00-1.51-1.409H8.5V1h1.472V0H6.049v1H7.5v.015h-.364a1.467 1.467 0 00-1.51 1.43l.005.124H1.567A1.57 1.57 0 000 4.14v2.716a1.57 1.57 0 001.567 1.57h4.381a.499.499 0 00.37-.164l.916-1.004h1.519l.605.64-.085-.005-.435 6.78c0 .114-.13.236-.322.294V13.07h-1v1.902c-.206-.056-.344-.19-.345-.332L6.81 9.114l-.998.066.22 3.355c-1.689.52-2.793 1.661-2.793 2.965a.5.5 0 00.5.5h8.542a.5.5 0 00.5-.5c0-1.306-1.11-2.45-2.804-2.968l.264-4.108h4.19A1.57 1.57 0 0016 6.855V4.138a1.57 1.57 0 00-1.568-1.569zm-7.806-.146a.474.474 0 01.51-.409h1.75a.468.468 0 01.509.39l-.007.164H6.632l-.006-.145zm-.527 11.14l.073 1.109c.002.111.02.221.053.327H4.338a2.867 2.867 0 011.761-1.436zM11.683 15H9.79c.03-.096.045-.195.046-.295l.074-1.145A2.875 2.875 0 0111.683 15zM15 6.855a.57.57 0 01-.568.57h-4.146l-.954-1.011a.498.498 0 00-.363-.157H7.014a.499.499 0 00-.37.163l-.916 1.004h-4.16A.57.57 0 011 6.855V4.138a.57.57 0 01.567-.569h12.865a.57.57 0 01.568.57v2.716z","fill":"currentColor"}})]) } };

var iconBlog = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.746 15a9.785 9.785 0 01-3.155-.523 7.55 7.55 0 01-2.117-1.426c-.158.008-.315.012-.474.012-4.411 0-8-2.93-8-6.531C0 2.93 3.589 0 8 0s8 2.93 8 6.532a6.075 6.075 0 01-.73 2.733c-.454.84-1.1 1.56-1.885 2.1l-.592-.81a5.05 5.05 0 001.584-1.745c.383-.7.597-1.48.623-2.278 0-3.048-3.14-5.527-7-5.527s-7 2.48-7 5.527c0 3.046 3.14 5.525 7 5.525.21 0 .418-.007.624-.022a.48.48 0 01.39.145c.565.56 1.22 1.02 1.938 1.36.54.196 1.103.324 1.674.382a14.88 14.88 0 01-.526-.702 10.089 10.089 0 01-.998-1.794l.91-.415a9.24 9.24 0 00.904 1.629c.375.529.783 1.033 1.223 1.51a.504.504 0 01-.356.85h-.037z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5 7.585a.78.78 0 00.779-.782A.78.78 0 005 6.02a.78.78 0 00-.778.783.78.78 0 00.778.782zM8 7.585a.78.78 0 00.779-.782A.78.78 0 008 6.02a.78.78 0 00-.778.783.78.78 0 00.778.782zM11 7.585a.78.78 0 00.779-.782A.78.78 0 0011 6.02a.78.78 0 00-.778.783.78.78 0 00.778.782z","fill":"currentColor"}})]) } };

var iconBlueprint = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5.996H5.604v1H15v13.003H1v-1.942a1.25 1.25 0 012.5 0 .5.5 0 001 0V1.77a1.335 1.335 0 00-.408-.98A2.507 2.507 0 001.355.185 2.259 2.259 0 000 2.258V15.5a.5.5 0 00.5.5h15a.497.497 0 00.5-.5V1.496a.5.5 0 00-.5-.5zM1 2.258a1.259 1.259 0 01.755-1.156c.155-.068.323-.103.493-.103.44.021.856.208 1.163.523.061.068.093.156.089.247v9.411a2.344 2.344 0 00-2.5 0V2.258z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.102 12.547v1h2.19a.499.499 0 00.5-.5V4.003a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5v9.044a.5.5 0 00.5.5H8.63a.499.499 0 00.5-.5 1.511 1.511 0 011.504-1.514v-1a2.511 2.511 0 00-2.454 2.014H6.792V4.503h6v2.463h-2.5V6.09h-1V8.9h1v-.934h2.5v4.58h-1.69z","fill":"currentColor"}})]) } };

var iconBookmarkFill = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13 0H3a.5.5 0 00-.5.5v15a.5.5 0 00.787.41L8 12.608l4.713 3.3a.501.501 0 00.787-.41V.5A.5.5 0 0013 0z","fill":"currentColor"}})]) } };

var iconBookmarkStroke = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13 16a.501.501 0 01-.287-.09L8 12.608l-4.713 3.3a.5.5 0 01-.787-.41V.5A.5.5 0 013 0h10a.5.5 0 01.5.5v.499L3.5 1v13.54l4.213-2.951a.502.502 0 01.574 0l4.213 2.95V2h1v13.5a.498.498 0 01-.5.5z","fill":"currentColor"}})]) } };

var iconBriefcase = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 14"}},[_c('path',{attrs:{"d":"M15.5 3.148H1.504c-.399 0-.781.155-1.063.43-.282.276-.44.65-.441 1.039v8.894a.478.478 0 00.146.346A.501.501 0 00.5 14h14.001a1.52 1.52 0 001.06-.43A1.45 1.45 0 0016 12.537v-8.9a.48.48 0 00-.146-.345.5.5 0 00-.354-.143zm-2.354 5.72A2.868 2.868 0 0015 8.184v4.353c0 .129-.053.253-.146.344a.505.505 0 01-.353.143H1v-4.84c.513.44 1.172.683 1.854.686h3.903v.96a.478.478 0 00.146.345.501.501 0 00.354.143h1.486a.511.511 0 00.354-.143.488.488 0 00.146-.346V7.352a.479.479 0 00-.146-.346.5.5 0 00-.354-.143H7.257a.51.51 0 00-.354.143.488.488 0 00-.146.346v.54H2.854c-.491 0-.962-.192-1.31-.531C1.196 7.02 1 6.56 1 6.08V4.616c0-.13.053-.256.148-.348a.51.51 0 01.356-.144H15V6.08c0 .48-.196.941-.544 1.28-.348.34-.819.531-1.31.532h-2.8v.977h2.8zm-5.39.472v-1.5h.487v1.5h-.486zM6.418 1.977h3.164v.682h1v-1.17a.48.48 0 00-.146-.346.5.5 0 00-.354-.143H5.918a.51.51 0 00-.354.143.488.488 0 00-.146.346v1.17h1v-.682z","fill":"currentColor"}})]) } };

var iconBriefing = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M11.788 2.166L9.5 4.24l.672.74 2.288-2.073-.672-.741z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 0H1.501A1.503 1.503 0 000 1.501v2.18h1v-2.18A.502.502 0 011.501 1H15v6.67a.496.496 0 01-.495.496h-7.93v1h7.93A1.497 1.497 0 0016 7.67V.5a.5.5 0 00-.5-.5z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.896 5.734a1.241 1.241 0 00-1.242-1.238h-4.37a1.79 1.79 0 00.705-1.487 1.58 1.58 0 00-1.426-1.724A1.58 1.58 0 002.136 3.01a1.79 1.79 0 00.706 1.487H1.51A1.498 1.498 0 00.013 5.99v3.09a1.218 1.218 0 001.24 1.222c.08-.008.158-.023.234-.045v4.47A1.277 1.277 0 002.765 16c.284-.005.557-.107.776-.289.219.182.492.284.776.289a1.277 1.277 0 001.277-1.273V6.972h3.06a1.24 1.24 0 001.242-1.238zM3.563 2.285c.2 0 .426.31.426.724s-.225.724-.426.724c-.202 0-.427-.31-.427-.724s.225-.724.427-.724zm1.53 3.687a.5.5 0 00-.5.5v8.255c0 .311-.552.311-.552 0v-4.01h-1v4.01c0 .312-.554.31-.554 0V9.19h-.016c.01-.042.018-.084.024-.127v-2.76h-1v2.76a.215.215 0 01-.241.238c-.064 0-.233 0-.241-.238V5.99a.497.497 0 01.498-.494h7.143a.238.238 0 110 .476h-3.56z","fill":"currentColor"}})]) } };

var iconBubble = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.101 14.202a7.1 7.1 0 117.04-6.164l-.998-.13a6.095 6.095 0 10-5.269 5.24l.126.998a7.23 7.23 0 01-.899.056z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M3.063 7.352H2.057a5.302 5.302 0 015.296-5.296v1.006a4.295 4.295 0 00-4.29 4.29zM12.28 16a3.719 3.719 0 11.001-7.437 3.719 3.719 0 010 7.437zm0-6.432a2.712 2.712 0 10.001 5.425 2.712 2.712 0 000-5.425z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.32 12.26h-1.006a2.134 2.134 0 012.13-2.13v1.006a1.126 1.126 0 00-1.123 1.125z","fill":"currentColor"}})]) } };

var iconBuilding = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M5.5 2.52h-1v1h1v-1zM8.55 2.52h-1v1h1v-1zM11.5 2.52h-1v1h1v-1zM5.5 5.52h-1v1h1v-1zM8.55 5.52h-1v1h1v-1zM11.5 5.52h-1v1h1v-1zM5.5 8.52h-1v1h1v-1zM8.55 8.52h-1v1h1v-1zM11.5 8.52h-1v1h1v-1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14 .5a.5.5 0 00-.5-.5h-10A1.5 1.5 0 002 1.5v14a.5.5 0 00.5.5h4.25a.5.5 0 00.5-.5v-2.94h1.5v2.94a.5.5 0 00.5.5h4.25a.5.5 0 00.5-.5V2h-1v13H9.75v-2.94a.5.5 0 00-.5-.5h-2.5a.5.5 0 00-.5.5V15H3V1.5a.51.51 0 01.5-.5H14V.5z","fill":"currentColor"}})]) } };

var iconCalendarPlus = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 1.77h-1.874v-.518A1.253 1.253 0 0012.375 0h-.162a1.253 1.253 0 00-1.25 1.252v.617H6.357v1h4.655a1.235 1.235 0 001.2 1.001h.162a1.239 1.239 0 001.22-1.1H15V5.35H1v-2.08a.503.503 0 01.502-.502h1.006A1.239 1.239 0 003.73 3.87h.161a1.253 1.253 0 001.251-1.25V1.251A1.253 1.253 0 003.891 0h-.162a1.253 1.253 0 00-1.251 1.252v.517h-.976A1.503 1.503 0 000 3.271V15.5a.5.5 0 00.5.5h13.998A1.504 1.504 0 0016 14.498V2.269a.5.5 0 00-.5-.5zm-2.874.85a.252.252 0 01-.251.25h-.162a.251.251 0 01-.25-.25V1.251a.252.252 0 01.25-.252h.162a.251.251 0 01.25.252v1.367zM3.478 1.251A.251.251 0 013.729 1h.161a.251.251 0 01.251.252v1.367a.251.251 0 01-.25.251h-.162a.251.251 0 01-.251-.25V1.251zM14.498 15H1V6.35h14v8.147a.503.503 0 01-.502.502z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.5 7.99h-1v2.24H5.259v1h2.24v2.24h1v-2.24h2.24v-1H8.5V7.99z","fill":"currentColor"}})]) } };

var iconCalendar = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 1.77h-1.873V1.25A1.253 1.253 0 0012.375 0h-.16a1.252 1.252 0 00-1.252 1.251v1.368a1.252 1.252 0 001.251 1.251h.162a1.239 1.239 0 001.22-1.1H15V5.35H1v-2.08a.503.503 0 01.502-.501h1.005a1.24 1.24 0 001.222 1.1h.16a1.236 1.236 0 001.202-1h4.613v-1H5.141V1.25A1.253 1.253 0 003.89 0h-.16a1.253 1.253 0 00-1.252 1.251v.519h-.975A1.503 1.503 0 000 3.27V15.5a.5.5 0 00.5.5h13.998A1.504 1.504 0 0016 14.498V2.27a.5.5 0 00-.5-.5zm-2.873.85a.251.251 0 01-.252.25h-.16a.251.251 0 01-.252-.25V1.25a.251.251 0 01.251-.25h.162a.251.251 0 01.25.25v1.368zM3.476 1.25a.252.252 0 01.252-.25h.16a.252.252 0 01.252.25v1.368a.252.252 0 01-.252.251h-.16a.252.252 0 01-.252-.25V1.25zm1.164 8.384h2.91v2.284h-2.91V9.635zm-1 2.284h-2.64V9.635h2.64v2.284zm3.91-3.284h-2.91V6.351h2.91v2.284zm1-2.284h2.911v2.284h-2.91V6.351zm-1 6.568V15h-2.91v-2.08h2.91zm1 0h2.911V15h-2.91v-2.08zm0-1V9.635h2.911v2.284h-2.91zm3.912-2.284H15v2.284h-2.537V9.635zm0-1V6.351H15v2.284h-2.537zM3.64 6.351v2.284h-2.64V6.351h2.64zm-2.64 6.568h2.64V15h-2.64v-2.08zM14.497 15h-2.035v-2.08H15v1.579a.503.503 0 01-.502.502z","fill":"currentColor"}})]) } };

var iconCameraPlus = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 2.5h-4.29V1a.5.5 0 00-.5-.5H5.26a.5.5 0 00-.5.5v1.5H1.5A1.5 1.5 0 000 3.98v10a.5.5 0 00.5.5h8.44v-.98H1V3.98a.5.5 0 01.5-.48H15v5h1V2.98a.5.5 0 00-.5-.48zm-5.29 0H5.76v-1h4.45v1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.89 8.62h1A3.91 3.91 0 108 12.5v-1a2.91 2.91 0 112.91-2.91l-.02.03z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.93 8.69h1a1.12 1.12 0 011.12-1.12v-1a2.12 2.12 0 00-2.12 2.12zM13.5 5.5a.5.5 0 100-1 .5.5 0 000 1zM13.51 9.65h-1v2.42h-2.42v1h2.42v2.43h1v-2.43h2.43v-1h-2.43V9.65z","fill":"currentColor"}})]) } };

var iconCamera = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M4.073 7.973a3.91 3.91 0 107.82.001 3.91 3.91 0 00-7.82 0zm6.82 0a2.911 2.911 0 11-5.821 0 2.911 2.911 0 015.822 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.927 8.04h1a1.122 1.122 0 011.12-1.121v-1a2.123 2.123 0 00-2.12 2.12zM13 4.5a.5.5 0 101 0 .5.5 0 00-1 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16 10.997v-8.52a.5.5 0 00-.5-.5h-4.287V.5a.5.5 0 00-.5-.5H5.26a.5.5 0 00-.5.5v1.477H1.5A1.503 1.503 0 000 3.477V13.5a.5.5 0 00.5.5h14a1.502 1.502 0 001.5-1.5v-.503h-1v.503a.501.501 0 01-.5.5H1V3.477a.501.501 0 01.501-.5H15v8.02h1zM5.76 1h4.453v.977H5.76V1z","fill":"currentColor"}})]) } };

var iconCaretDown = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8.048 13.375a.745.745 0 01-.526-.217L0 5.686l1.053-1.061 6.995 6.95 6.897-6.85 1.053 1.06-7.423 7.373a.745.745 0 01-.527.217z","fill":"currentColor"}})]) } };

var iconCaretLeftDouble = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M9.146 7.95l6.756-6.896L14.856 0 7.584 7.423a.756.756 0 000 1.054L14.954 16 16 14.947 9.146 7.95z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.532 1.054L7.486 0 .214 7.423a.756.756 0 000 1.054L7.584 16l1.046-1.053L1.776 7.95l6.756-6.896z","fill":"currentColor"}})]) } };

var iconCaretLeft = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10.22 16L2.847 8.577a.748.748 0 010-1.054L10.319 0l1.06 1.053L4.432 8.05l6.85 6.896L10.22 16z","fill":"currentColor"}})]) } };

var iconCaretRightDouble = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8.282 7.423L1.126 0 .096 1.054 6.744 7.95 0 14.947 1.03 16l7.252-7.523a.762.762 0 000-1.054z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.774 7.423L8.618 0l-1.03 1.054 6.648 6.896-6.744 6.997L8.522 16l7.252-7.523a.763.763 0 000-1.054z","fill":"currentColor"}})]) } };

var iconCaretRight = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M5.686 16l-1.061-1.053 6.95-6.997-6.85-6.896L5.784 0l7.373 7.423a.748.748 0 010 1.054L5.686 16z","fill":"currentColor"}})]) } };

var iconCaretSortDown = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8.25 1.762l4.021 4.197 1.025-1.016L8.764.21a.728.728 0 00-1.026 0L3.204 4.943l1.025 1.016L8.25 1.762zM13.444 10.258a.716.716 0 00-.66-.445H3.716a.716.716 0 00-.66.445.736.736 0 00.148.79l4.533 4.732a.707.707 0 001.026 0l4.534-4.732a.737.737 0 00.147-.79zM8.25 14.23l-2.837-2.962h5.674L8.25 14.23z","fill":"currentColor"}})]) } };

var iconCaretSortUp = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.296 4.943L8.764.21a.728.728 0 00-1.026 0L3.204 4.943a.736.736 0 00.115 1.113c.117.08.256.122.397.122h9.068a.716.716 0 00.66-.445.736.736 0 00-.148-.79zm-7.883-.22L8.25 1.762l2.837 2.961H5.413zM8.25 14.23l-4.021-4.197-1.025 1.015 4.533 4.732a.709.709 0 001.026 0l4.534-4.732-1.026-1.015L8.25 14.23z","fill":"currentColor"}})]) } };

var iconCaretSort = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8.125 1.762l4.084 4.197 1.041-1.016L8.646.21a.748.748 0 00-1.042 0L3 4.943l1.041 1.016 4.084-4.197zM8.125 14.23l-4.084-4.197L3 11.048l4.604 4.732a.728.728 0 001.042 0l4.604-4.732-1.041-1.015-4.084 4.197z","fill":"currentColor"}})]) } };

var iconCaretUp = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.947 11.375L7.95 4.425l-6.896 6.85L0 10.216l7.423-7.373a.748.748 0 011.053 0L16 10.314l-1.053 1.061z","fill":"currentColor"}})]) } };

var iconCarrierNetworking = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.236 11.33a6.804 6.804 0 00-1.315-.807 5.899 5.899 0 001.017-2.851h.805V6.665h-.805a5.898 5.898 0 00-.937-2.731 6.768 6.768 0 001.235-.769l-.625-.786a5.92 5.92 0 01-1.247.745 5.834 5.834 0 00-9.293.974l-1.37-.003L.7 5.102l.884.002a5.894 5.894 0 00-.351 1.56H0v1.008h1.233c.05.59.187 1.17.409 1.72H.7L.702 10.4l1.465-.002a5.84 5.84 0 009.096.927c.482.203.935.47 1.348.79l.625-.786zm-2.28-1.209a11.218 11.218 0 00-1.522-.41c.127-.673.202-1.355.224-2.04h2.254a4.874 4.874 0 01-.955 2.45zm-3.87 1.957c-.362 0-.81-.617-1.138-1.67.747.005 1.493.048 2.235.128-.324.976-.751 1.542-1.098 1.542zM5.731 9.396h-.031c-.1-.57-.16-1.146-.178-1.724h3.125c-.02.632-.09 1.26-.21 1.881a24.315 24.315 0 00-2.706-.157zM8.23 3.952c-.774.086-1.552.132-2.331.137.331-1.155.807-1.83 1.186-1.83.364 0 .816.625 1.145 1.693zM5.668 5.1l.067-.001a24.172 24.172 0 002.734-.162c.101.57.16 1.148.179 1.728H5.523c.015-.524.064-1.047.145-1.565zm6.244 1.565H9.658a13.453 13.453 0 00-.196-1.888 11.107 11.107 0 001.597-.437c.48.689.773 1.49.853 2.325zM9.237 3.794a6.522 6.522 0 00-.466-1.215 4.85 4.85 0 011.55.943c-.356.11-.718.2-1.084.272zM5.4 2.579a6.954 6.954 0 00-.548 1.52H3.31a4.867 4.867 0 012.09-1.52zM2.675 5.106a1206.98 1206.98 0 001.98 0 13.756 13.756 0 00-.142 1.559H2.259c.051-.54.192-1.066.416-1.56zm-.416 2.566h2.254c.019.575.074 1.15.165 1.718H2.76a4.865 4.865 0 01-.501-1.718zm1.18 2.724l1.453.001c.12.47.29.927.508 1.36a4.86 4.86 0 01-1.96-1.36zm5.332 1.362a6.31 6.31 0 00.424-1.066c.33.062.66.141.989.236-.42.355-.899.636-1.413.83zM15.087 8.087A.916.916 0 0016 7.168a.916.916 0 00-.913-.918.916.916 0 00-.912.918c0 .508.408.919.912.919zM13.993 11.663a.919.919 0 10-.012 1.838.919.919 0 00.012-1.838zM13.993 2.837A.919.919 0 1014.005 1a.919.919 0 00-.012 1.837z","fill":"currentColor"}})]) } };

var iconCart = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.552 9.55a.62.62 0 01-.15.24H4.497v1h8.905a1.26 1.26 0 001.11-1c.08-.25 1.369-5.34 1.419-5.58a1.38 1.38 0 00-.2-1.25 1.21 1.21 0 00-1-.44H2.739l-.14-1.32a.51.51 0 00-.5-.45H0v1h1.65l.998 10a1.749 1.749 0 102 1.72 1.731 1.731 0 00-.19-.72h7.535c-.115.233-.177.49-.18.75a1.75 1.75 0 101.75-1.75H3.567l-.57-6.17h10.564v-1H2.918l-.09-1h11.934a.29.29 0 01.19.06.53.53 0 010 .4c-.07.34-1.34 5.3-1.4 5.51zm-10.664 4.7a.75.75 0 110-1.499.75.75 0 010 1.499zm11.424-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0z","fill":"currentColor"}})]) } };

var iconCaseStudy = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M6.546 5.993a2.218 2.218 0 00-.552 1.618l1-.064a1.233 1.233 0 011.154-1.31l-.064-.998a2.226 2.226 0 00-1.538.754zM3.1 6.558H1.997v1h1.101v-1zM3.414 8.701H1.998v1h1.416v-1zM5.35 10.845H1.998v1H5.35v-1zM10.887 12.988H1.998v1h8.89v-1zM11.52 3.797V2.5a.502.502 0 00-.5-.5H2.486a.5.5 0 00-.502.5V5a.5.5 0 00.502.5h1.056v-1h-.555V3h7.531v.797h1.003z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.853 13.263L11.53 8.95c.26-.558.379-1.172.343-1.787a3.767 3.767 0 00-7.519.484 3.764 3.764 0 004.002 3.508 3.76 3.76 0 001.313-.335l2.855 2.848v.837a.497.497 0 01-.497.496H1.002V1.495A.496.496 0 011.5 1h11.03v7.593h1.003V.5a.5.5 0 00-.501-.5H1.499A1.499 1.499 0 000 1.495V15.5a.5.5 0 00.501.5h11.525a1.495 1.495 0 001.484-1.348l.475.474a.502.502 0 00.71 0l1.158-1.156a.498.498 0 000-.707zM8.29 10.156a2.76 2.76 0 11-.176-5.511 2.767 2.767 0 012.757 2.581 2.76 2.76 0 01-2.58 2.93zm6.05 3.91l-3.807-3.799c.145-.117.282-.245.41-.382.016-.02.027-.043.044-.062l3.803 3.794-.45.448z","fill":"currentColor"}})]) } };

var iconCatalog = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6.52 3.195a6.848 6.848 0 00-4.539.014.505.505 0 00-.31.467l.002 2.395a.508.508 0 00.425.499.494.494 0 00.234-.021 7.348 7.348 0 013.875-.002.499.499 0 00.644-.484L6.848 3.67a.504.504 0 00-.327-.474zM2.67 5.423l-.001-1.389a6.074 6.074 0 013.181.003l.002 1.386a9.019 9.019 0 00-3.182 0zM4.257 10.585a9.125 9.125 0 00-2.2.247 2.598 2.598 0 01-.295.058l.004 1.01c.172-.01.343-.037.509-.082a8.106 8.106 0 011.982-.224c.69 0 1.378.063 2.057.186.147.029.295.048.444.056l.003-1.01c-.058-.001-.153-.02-.282-.042-.733-.132-1.477-.2-2.222-.2zM4.257 8.123a9.175 9.175 0 00-2.2.247 2.598 2.598 0 01-.295.058l.004 1.01a2.39 2.39 0 00.509-.082 8.148 8.148 0 011.982-.223c.69 0 1.379.063 2.058.185.146.029.294.048.443.056l.003-1.01c-.058-.001-.153-.02-.283-.042a12.542 12.542 0 00-2.221-.199z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.986 2.103a.505.505 0 00-.339-.478 12.532 12.532 0 00-7.675-.05 12.386 12.386 0 00-7.67.06A.506.506 0 000 2.1l.014 12.39a.506.506 0 00.225.421.499.499 0 00.47.042 11.458 11.458 0 017.133.018.494.494 0 00.16.027c.025 0 .047-.02.072-.024.045 0 .09-.008.134-.021a11.46 11.46 0 017.133.018.495.495 0 00.604-.248.508.508 0 00.055-.23l-.014-12.39zM4.122 13.387c-1.05-.012-2.097.12-3.112.392L.998 2.446a11.839 11.839 0 016.491.027l.013 11.34a13.17 13.17 0 00-3.38-.426zm7.498 0c-1.05-.012-2.096.12-3.111.392L8.497 2.446a11.84 11.84 0 016.492.027L15 13.813a13.192 13.192 0 00-3.38-.426z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.757 10.571a8.469 8.469 0 00-2.21.27c-.094.027-.19.047-.286.062l.005 1.01c.176-.01.35-.04.518-.09a7.445 7.445 0 011.973-.242c.688 0 1.374.068 2.05.201.148.032.298.052.45.062l.005-1.01c-.058-.003-.15-.022-.277-.045a11.533 11.533 0 00-2.228-.218zM11.757 6.763a8.436 8.436 0 00-2.208.271c-.095.026-.19.046-.287.062l.004 1.01c.176-.01.35-.04.519-.09a7.434 7.434 0 011.972-.243c.688 0 1.374.068 2.049.202.148.031.299.052.45.062l.005-1.01a2.744 2.744 0 01-.277-.046 11.57 11.57 0 00-2.227-.218zM11.757 2.956a8.47 8.47 0 00-2.21.27c-.094.026-.19.047-.286.062l.005 1.01c.176-.01.35-.04.518-.09a7.439 7.439 0 011.973-.243c.688.001 1.374.069 2.05.202.148.032.298.053.45.062l.005-1.01c-.058-.002-.15-.022-.277-.045a11.558 11.558 0 00-2.228-.218z","fill":"currentColor"}})]) } };

var iconCategory = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15 0H4.002v.997h11V0zM15 3.75H4.002v.997h11V3.75zM15 7.501H4.002v.997h11v-.997zM15 15.003H4.002V16h11v-.997zM15 11.252H4.002v.997h11v-.997zM2.978 0H1v.997h1.978V0zM2.978 3.75H1v.997h1.978V3.75zM2.978 7.501H1v.997h1.978v-.997zM2.978 11.252H1v.997h1.978v-.997zM2.978 15.003H1V16h1.978v-.997z","fill":"currentColor"}})]) } };

var iconCheck = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M5.86 14.25a.496.496 0 01-.353-.146L.147 8.74a.506.506 0 01-.01-.703l1.75-1.86a.498.498 0 01.716-.011l.354.354-1.759 1.853 4.661 4.664 8.926-8.933L13.6 2.957l-7.455 7.467a.495.495 0 01-.705 0L3.163 8.146l.705-.714 1.923 1.925 7.45-7.46a.498.498 0 01.698-.007l1.908 1.846a.504.504 0 01.005.72l-9.64 9.647a.497.497 0 01-.353.147z","fill":"currentColor"}})]) } };

var iconCircleCheck = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6.709 11.082a.5.5 0 01-.354-.147L3.504 8.083l.707-.707 2.498 2.498 5.087-5.086.707.707-5.44 5.44a.498.498 0 01-.354.146z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.998 15.998a7.999 7.999 0 116.019-2.729l-.752-.66a6.995 6.995 0 10-.876.842l.627.778a8.017 8.017 0 01-5.018 1.769z","fill":"currentColor"}})]) } };

var iconCircleEllipsis = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}},[_c('path',{attrs:{"d":"M8.5 17a8.5 8.5 0 116.394-2.9l-.799-.7a7.422 7.422 0 10-.93.894l.667.827A8.522 8.522 0 018.5 17z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.75 9.329a.84.84 0 100-1.68.84.84 0 000 1.68zM8.493 9.329a.84.84 0 100-1.68.84.84 0 000 1.68zM5.235 9.329a.84.84 0 100-1.68.84.84 0 000 1.68z","fill":"currentColor"}})]) } };

var iconCircleExclamation = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.998 15.998a7.999 7.999 0 116.019-2.729l-.752-.66a6.995 6.995 0 10-.876.842l.627.778a8.017 8.017 0 01-5.018 1.769z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.25 3.5h1.5l-.346 6.931h-.808L7.25 3.5zm1.385 7.759V12.5h-1.27v-1.241h1.27z","fill":"currentColor"}})]) } };

var iconCircleInfo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 0a8 8 0 105.017 14.23l-.627-.778A6.922 6.922 0 018 14.999a7 7 0 115.266-2.388l.752.66A8 8 0 008 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.496 6.16h-.992v6.244h.992V6.16zM8.57 3.595H7.43v1.387h1.14V3.595z","fill":"currentColor"}})]) } };

var iconCircleMinus = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 0a8 8 0 105.017 14.231l-.627-.778A6.927 6.927 0 018 15a7 7 0 115.265-2.388l.752.659A8 8 0 008 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.5 8.5h4.51v-1H2.99v1H8.5z","fill":"currentColor"}})]) } };

var iconCirclePause = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}},[_c('path',{attrs:{"d":"M7.276 5.303H6.214v6.374h1.062V5.303zM10.787 5.303H9.725v6.374h1.062V5.303z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.5 17a8.5 8.5 0 116.394-2.9l-.799-.7a7.415 7.415 0 10-.93.894l.667.827A8.521 8.521 0 018.5 17z","fill":"currentColor"}})]) } };

var iconCirclePlay = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}},[_c('path',{attrs:{"d":"M6.517 12.53a.664.664 0 01-.346-.098.698.698 0 01-.331-.617V5.177a.685.685 0 011.044-.612L12.9 7.892a.673.673 0 01.005 1.206l-.005.003-6.017 3.328a.74.74 0 01-.365.1zm-.15-1.03l-.004.002.004-.002zm.535-5.711v5.415l4.895-2.708L6.902 5.79zm-.534-.296l.002.001h-.002z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.5 17a8.5 8.5 0 116.394-2.9l-.799-.7a7.422 7.422 0 10-.93.894l.667.827A8.522 8.522 0 018.5 17z","fill":"currentColor"}})]) } };

var iconCirclePlus = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 0a8 8 0 105.017 14.231l-.627-.778A6.927 6.927 0 018 15a7 7 0 115.265-2.388l.752.659A8 8 0 008 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.5 13.01V8.5h4.51v-1H8.5V2.99h-1V7.5H2.99v1H7.5v4.51h1z","fill":"currentColor"}})]) } };

var iconCircleQuestion = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 0a8 8 0 105.017 14.231l-.627-.778a7.002 7.002 0 11.876-.841l.752.659A8 8 0 008 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.713 5.82c0-1.351-1.04-2.206-2.651-2.206a2.55 2.55 0 00-2.775 2.453H6.29a1.622 1.622 0 011.772-1.549c.991 0 1.56.471 1.56 1.314 0 1.808-3.79.595-3.79 2.949 0 1.127.793 1.648 1.982 1.648h1.784v-.855h-1.76c-.594 0-1.003-.199-1.003-.806 0-1.375 3.878-.47 3.878-2.949zM8.446 11.234H7.319v1.152h1.127v-1.152z","fill":"currentColor"}})]) } };

var iconCircleStop = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}},[_c('path',{attrs:{"d":"M11.69 12.22H5.311a.531.531 0 01-.53-.53V5.312a.53.53 0 01.53-.532h6.379a.53.53 0 01.531.532v6.378a.532.532 0 01-.531.53zm-5.847-1.062h5.316V5.843H5.843v5.315z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.5 17a8.5 8.5 0 116.394-2.9l-.799-.7a7.422 7.422 0 10-.93.894l.667.827A8.522 8.522 0 018.5 17z","fill":"currentColor"}})]) } };

var iconCircleX = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10.619 4.67l-2.62 2.619L5.382 4.67l-.707.707 2.619 2.619-2.62 2.618.708.707L8 8.703l2.619 2.618.707-.707-2.62-2.618 2.62-2.619-.707-.707z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8 0a8 8 0 105.017 14.231l-.627-.778A6.925 6.925 0 018 14.999a7 7 0 115.265-2.387l.752.659A8 8 0 008 0z","fill":"currentColor"}})]) } };

var iconClock = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 14.16a5.15 5.15 0 01-3.11-1.048 5.193 5.193 0 01-1.855-2.72 5.216 5.216 0 01.15-3.294A5.186 5.186 0 015.277 4.56a5.146 5.146 0 016.197.564 5.215 5.215 0 011.162 6.143l-.896-.444a4.22 4.22 0 00.257-3.08A4.197 4.197 0 0010.09 5.32a4.162 4.162 0 00-3.04-.456A4.18 4.18 0 004.52 6.622a4.217 4.217 0 00.935 5.669 4.166 4.166 0 005.69-.573l.753.66A5.17 5.17 0 018 14.16z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.507 2.34V.502a.503.503 0 00-.5-.502H5.994a.498.498 0 00-.5.502V2.34a7.044 7.044 0 00-3.6 3.144 7.099 7.099 0 00-.777 4.729 7.076 7.076 0 002.404 4.14A7.013 7.013 0 008 16a7.014 7.014 0 004.48-1.647 7.076 7.076 0 002.403-4.14 7.099 7.099 0 00-.776-4.729 7.045 7.045 0 00-3.6-3.144zM8 14.995a6.019 6.019 0 01-4.086-1.634 6.085 6.085 0 01-.6-8.209A6.029 6.029 0 017.12 2.936h.06V1.93h-.685v-.926h3.013v.926h-.67v1.005h.045a6.029 6.029 0 013.804 2.216 6.086 6.086 0 01-.6 8.21A6.02 6.02 0 018 14.994z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.217 6.303h-1v3.529a.505.505 0 00.5.502h2.788V9.329H8.218l-.001-3.026z","fill":"currentColor"}})]) } };

var iconClose = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M16 1.057L14.943 0 8 6.943 1.057 0 0 1.057 6.943 8 0 14.943 1.057 16 8 9.057 14.943 16 16 14.943 9.057 8 16 1.057z","fill":"currentColor"}})]) } };

var iconCloud = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M3.94 13A3.938 3.938 0 01.096 9.928a3.947 3.947 0 012.145-4.43A4.188 4.188 0 015.39 1.13a4.178 4.178 0 014.703 2.073 4.187 4.187 0 01.19 3.568l-.926-.378a3.188 3.188 0 00-2.33-4.332 3.18 3.18 0 00-3.491 1.764 3.187 3.187 0 00-.266 1.867.5.5 0 01-.094.436.505.505 0 01-.281.178 2.94 2.94 0 00-1.847 3.282A2.944 2.944 0 003.94 12h8.827a2.239 2.239 0 002.197-1.839 2.244 2.244 0 00-1.405-2.498.5.5 0 01-.264-.702 2.021 2.021 0 00-.618-2.616 1.604 1.604 0 00-1.515-.2l-.338-.941a2.592 2.592 0 012.428.322 3.008 3.008 0 011.13 3.425 3.241 3.241 0 01.36 5.374 3.237 3.237 0 01-1.968.675L3.94 13z","fill":"currentColor"}})]) } };

var iconCoaching = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M2.878 10.32a2.525 2.525 0 00.53 1.845c.413.521 1.014.857 1.673.935h.26a2.509 2.509 0 001.665-.657c.457-.417.744-.987.807-1.603A2.555 2.555 0 007.275 9a2.473 2.473 0 00-2.648-.829 2.473 2.473 0 00-1.75 2.159v-.01zM5.5 9.08a1.453 1.453 0 01.997.55 1.522 1.522 0 01-1.306 2.46 1.516 1.516 0 01-1.206-1.564A1.522 1.522 0 015.34 9.09l.16-.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.85 5.31a.498.498 0 00-.349-.14H5.291a5.388 5.388 0 00-3.786 1.664 5.425 5.425 0 00.155 7.658A5.392 5.392 0 005.51 16a5.386 5.386 0 003.661-1.386 5.415 5.415 0 001.764-3.504l4.686-1.19A.498.498 0 0016 9.43V5.67a.51.51 0 00-.15-.36zM15.003 9l-4.657 1.19a.487.487 0 00-.379.47 4.426 4.426 0 01-1.336 3.091 4.401 4.401 0 01-3.12 1.25 4.382 4.382 0 01-3.134-1.215 4.407 4.407 0 01-.148-6.223A4.383 4.383 0 015.301 6.2h9.702V9zM9.838 0H8.84v2.65h.997V0zM13.059 1.43L12.37.7l-1.895 1.87.688.73 1.895-1.87zM8.232 2.57L6.338.7l-.688.73L7.544 3.3l.688-.73z","fill":"currentColor"}})]) } };

var iconCodeExchange = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M16 12.998V.5a.5.5 0 00-.5-.5H1.497A1.499 1.499 0 000 1.497V15.5a.5.5 0 00.5.5h13.996A1.506 1.506 0 0016 14.496v-.498h-1v.498a.504.504 0 01-.504.504H1V4.014h14V13h1zM1 3.014V1.497A.498.498 0 011.497 1H15v2.014H1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M2.395 1.483a.505.505 0 10-.001 1.01.505.505 0 000-1.01zM3.922 7.346L2.045 9.293a.5.5 0 00.014.708l1.877 1.807.693-.72-1.517-1.46 1.53-1.588-.72-.694zM9.833 5.889l-4.514 6.91.838.547 4.514-6.91-.838-.547zM12.055 11.808l1.877-1.807a.5.5 0 00.013-.708l-1.877-1.947-.72.694 1.53 1.587-1.517 1.46.694.721zM4.395 1.483a.505.505 0 10-.001 1.01.505.505 0 000-1.01zM6.395 1.483a.505.505 0 10-.001 1.01.505.505 0 000-1.01z","fill":"currentColor"}})]) } };

var iconCode = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M2.752 11.122L.28 8.696a.949.949 0 01-.026-1.32l2.484-2.628.729.684L.984 8.058l2.469 2.354-.701.71zM4.747 14l-.844-.536L11.247 2l.844.536L4.747 14zM13.249 11.122l-.702-.71 2.471-2.426-2.484-2.554.728-.684 2.483 2.627a.949.949 0 01-.025 1.32l-2.471 2.427z","fill":"currentColor"}})]) } };

var iconCollapse = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.226 8.253H2.311v1.019h3.693L0 15.28l.72.72 5.997-6.001v3.68h1.018V8.763a.509.509 0 00-.509-.509zM16 .72L15.28 0 9.274 6.007V2.312H8.256v4.917a.509.509 0 00.51.51h4.914V6.72h-3.678L16 .72z","fill":"currentColor"}})]) } };

var iconColorFacebook = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6.286 16V8.844H3.88V6h2.406V3.75c0-1.188.333-2.11 1-2.766C7.953.328 8.838 0 9.942 0c.896 0 1.625.042 2.188.125v2.531h-1.5c-.563 0-.948.125-1.156.375-.167.209-.25.542-.25 1V6h2.656l-.375 2.844H9.224V16H6.286z","fill":"#4267B2"}})]) } };

var iconColorGoogle = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M16 8.184c0-.544-.044-1.09-.14-1.626H8.16v3.08h4.409a3.7 3.7 0 01-1.632 2.431v2h2.63c1.545-1.394 2.433-3.452 2.433-5.885z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M8.162 16c2.2 0 4.057-.709 5.41-1.932l-2.63-1.998c-.732.487-1.677.764-2.777.764-2.13 0-3.935-1.408-4.583-3.301H.868v2.06C2.254 14.295 5.076 16 8.162 16z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M3.58 9.533a4.701 4.701 0 010-3.063V4.41H.867a7.864 7.864 0 000 7.184L3.58 9.533z","fill":"#FBBC04"}}),_c('path',{attrs:{"d":"M8.162 3.166a4.485 4.485 0 013.13 1.2l2.33-2.284A7.933 7.933 0 008.163 0C5.076 0 2.254 1.705.868 4.41L3.58 6.47c.645-1.896 2.453-3.304 4.583-3.304z","fill":"#EA4335"}})]) } };

var iconColorLinkedIn = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M3.571 16H.25V5.321h3.321V16zM1.93 3.857c-.524 0-.977-.19-1.358-.571A1.854 1.854 0 010 1.929C0 1.405.19.952.571.57A1.854 1.854 0 011.93 0c.523 0 .976.19 1.357.571.38.381.571.834.571 1.358 0 .523-.19.976-.571 1.357-.381.38-.834.571-1.357.571zM16 16h-3.321v-5.214c0-.857-.072-1.476-.215-1.857-.262-.643-.774-.965-1.535-.965-.762 0-1.298.286-1.608.857-.238.429-.357 1.06-.357 1.893V16H5.68V5.321h3.178v1.465h.036c.238-.476.619-.87 1.143-1.179.571-.38 1.238-.571 2-.571 1.547 0 2.63.488 3.25 1.464.476.786.714 2 .714 3.643V16z","fill":"#0077B5"}})]) } };

var iconColorTeams = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.271 5.78c1.104 0 2.007-.89 2.007-1.977 0-1.088-.903-1.978-2.007-1.978-1.103 0-2.006.89-2.006 1.978 0 1.087.903 1.977 2.006 1.977zm0-2.966a.999.999 0 011.003.989.999.999 0 01-1.003.988.999.999 0 01-1.003-.988.999.999 0 011.003-.99z","fill":"#5056C3"}}),_c('path',{attrs:{"d":"M15.188 6.354H7.954V5.7c.14.02.28.04.421.04 1.465 0 2.659-1.177 2.659-2.62C11.034 1.676 9.84.5 8.375.5 6.912.5 5.718 1.677 5.718 3.12c0 .327.07.643.18.93H.502A.508.508 0 000 4.554v6.852c0 .277.22.495.502.495h3.56c.161.92.593 1.76 1.295 2.412a4.375 4.375 0 003.02 1.187c.08 0 .16 0 .24-.01 1.525-.079 2.849-1.018 3.571-2.333.301.098.612.178.933.178h.15C14.806 13.255 16 11.95 16 10.357V7.155c0-.445-.361-.801-.813-.801zM6.72 3.12c0-.9.742-1.631 1.655-1.631s1.655.731 1.655 1.631-.742 1.632-1.655 1.632c-.15 0-.29-.03-.421-.06v-.138a.493.493 0 00-.502-.494h-.431c-.19-.267-.301-.594-.301-.94zM2.217 6.74v-.99H5.728v.99H4.474v3.46H3.471V6.74H2.217zm9.55 4.211c0 1.87-1.435 3.461-3.2 3.55a3.393 3.393 0 01-2.518-.91 3.26 3.26 0 01-.973-1.7h2.377c.281 0 .502-.218.502-.495V7.342h3.812v3.61zm3.23-.603c0 1.048-.803 1.938-1.786 1.988-.22.01-.441-.03-.662-.099.12-.415.21-.84.21-1.286V7.352h2.238v2.996z","fill":"#5056C3"}})]) } };

var iconColorTwitter = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.344 4.75c.02.083.031.219.031.406 0 1.5-.365 2.948-1.094 4.344-.75 1.48-1.802 2.656-3.156 3.531-1.48.98-3.177 1.469-5.094 1.469-1.833 0-3.51-.49-5.031-1.469.23.021.49.031.781.031 1.521 0 2.886-.468 4.094-1.406-.73 0-1.37-.213-1.922-.64a3.263 3.263 0 01-1.14-1.61c.208.021.406.031.593.031.292 0 .584-.03.875-.093a3.306 3.306 0 01-1.875-1.156 3.146 3.146 0 01-.75-2.063v-.063c.459.271.948.417 1.469.438a3.64 3.64 0 01-1.063-1.188 3.152 3.152 0 01-.406-1.578c0-.573.156-1.12.469-1.64A9.048 9.048 0 004.109 4.53a9.083 9.083 0 003.766 1c-.042-.25-.063-.5-.063-.75 0-.583.146-1.13.438-1.64.292-.51.688-.912 1.188-1.204a3.17 3.17 0 011.624-.437c.48 0 .922.094 1.329.281.406.188.765.438 1.078.75a6.675 6.675 0 002.094-.781c-.25.77-.73 1.375-1.438 1.813A7.049 7.049 0 0016 3.03a7.213 7.213 0 01-1.656 1.719z","fill":"#1DA1F2"}})]) } };

var iconColorVimeo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.4 16c.88 0 1.6-.72 1.6-1.6V1.6c0-.88-.72-1.6-1.6-1.6H1.6C.72 0 0 .72 0 1.6v12.8c0 .88.72 1.6 1.6 1.6h12.8zm-3.293-6.053c1.52-1.96 2.306-3.507 2.36-4.627.066-1.507-.494-2.28-1.667-2.307-1.6-.053-2.68.84-3.253 2.707.293-.12.573-.187.853-.187.587 0 .84.334.773.987-.026.4-.293.987-.773 1.747-.493.76-.853 1.146-1.093 1.146-.307 0-.6-.6-.854-1.773-.08-.347-.24-1.227-.466-2.653-.214-1.307-.774-1.92-1.667-1.84-.387.04-.96.386-1.72 1.04-.501.453-1.003.897-1.514 1.348l-.18.158.547.707c.52-.36.827-.547.907-.547.4 0 .773.627 1.12 1.867.153.573.31 1.143.467 1.713.156.57.313 1.14.466 1.714.467 1.24 1.027 1.866 1.707 1.866 1.08 0 2.413-1.026 3.987-3.066z","fill":"#1AB7EA"}})]) } };

var iconColorWebex = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M13.41 2.135a7.595 7.595 0 012.312 3.788 7.966 7.966 0 01-3.37 8.783 7.986 7.986 0 01-3.114 1.184 7.817 7.817 0 01-6.867-2.208c-.088-.084-.164-.182-.246-.274l-.06-.089.002.004-.046-.051.002.001a1.563 1.563 0 00-.031-.2 1.373 1.373 0 011.09-1.767c.3-.017.598-.004.894.039l.073.037c.037.059.077.114.122.166A5.093 5.093 0 009.26 13.05a5.206 5.206 0 003.95-5.342 5.197 5.197 0 00-.675-2.282 4.278 4.278 0 00-1.151-1.369l-.038-.073c-.012-.122-.015-.246-.038-.366a1.39 1.39 0 011.768-1.616c.066.015.133.025.2.031v-.001l.05.045-.004-.002.09.06z","fill":"#015072"}}),_c('path',{attrs:{"d":"M3.977 11.345a4.422 4.422 0 00-.894-.039 1.376 1.376 0 00-1.09 1.767c.014.066.024.133.03.2a13.083 13.083 0 01-.849-1.11 7.98 7.98 0 012-10.538A7.997 7.997 0 016.747.108a7.848 7.848 0 016.323 1.715 2.3 2.3 0 01.205.21 1.564 1.564 0 01-.2-.03 1.394 1.394 0 00-1.768 1.615c.023.12.026.244.038.366-.057-.039-.116-.076-.171-.117a5.129 5.129 0 00-3.599-1.058 5.218 5.218 0 00-4.718 4.273 5.205 5.205 0 00.094 2.262 5.724 5.724 0 001.025 2zM13.41 2.135l-.088-.06.089.06zM13.326 2.077l-.051-.045.051.045z","fill":"#01BBEA"}}),_c('path',{attrs:{"d":"M3.977 11.345a5.724 5.724 0 01-1.025-2.001 5.205 5.205 0 012.459-5.87 5.218 5.218 0 012.165-.665 5.128 5.128 0 013.599 1.057c.055.042.113.079.17.118l.038.073c.012.598-.008 1.197-.061 1.793a6.575 6.575 0 01-5.249 5.441 7.893 7.893 0 01-2.023.091l-.073-.037z","fill":"#fff"}}),_c('path',{attrs:{"d":"M4.05 11.382a7.893 7.893 0 002.023-.09 6.586 6.586 0 005.249-5.442c.053-.596.073-1.195.061-1.793.476.37.868.837 1.151 1.369a5.196 5.196 0 01-1.153 6.54c-.614.52-1.34.892-2.121 1.084a5.097 5.097 0 01-5.088-1.502 1.381 1.381 0 01-.123-.166z","fill":"#6DBD4A"}})]) } };

var iconColorWwtLogo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M9.893 10.218l1.836 1.867a.081.081 0 00.058.023h2.296a.08.08 0 00.075-.05.084.084 0 00-.017-.09l-2.986-3.034 1.836-1.867a.083.083 0 000-.116l-1.147-1.167a.08.08 0 00-.115 0L6.796 10.8a.081.081 0 00-.025.06.083.083 0 00.025.058l1.147 1.167A.083.083 0 008 12.11a.08.08 0 00.058-.024l1.835-1.868z","fill":"#0086EA"}}),_c('path',{attrs:{"d":"M9.781 3.914l-1.78 1.812-1.782-1.812a.081.081 0 00-.059-.024H3.865a.08.08 0 00-.076.05.084.084 0 00.018.091l2.931 2.978-.63.642-3.674-3.737a.082.082 0 00-.059-.024H.082a.08.08 0 00-.076.05.084.084 0 00.018.091l6.026 6.128a.08.08 0 00.09.019.08.08 0 00.026-.019l6.025-6.128a.084.084 0 00-.013-.127.08.08 0 00-.046-.014H9.838a.08.08 0 00-.058.024M13.567 3.914l-1.092 1.111a.082.082 0 00-.024.059.083.083 0 00.024.058l1.147 1.167a.08.08 0 00.088.018.08.08 0 00.026-.018l2.24-2.278a.083.083 0 00.018-.09.08.08 0 00-.075-.05h-2.296a.082.082 0 00-.058.023","fill":"#EE282A"}})]) } };

var iconColorYoutube = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.678 4.138c.136.528.234 1.329.293 2.403L16 8.006l-.03 1.466c-.058 1.094-.156 1.904-.292 2.432a2.043 2.043 0 01-.528.879c-.254.254-.557.43-.908.527-.508.137-1.7.235-3.575.293L8 13.633l-2.667-.03c-1.875-.058-3.067-.156-3.575-.293a2.031 2.031 0 01-.908-.527 2.043 2.043 0 01-.528-.88C.186 11.377.088 10.567.03 9.473L0 8.006c0-.43.01-.918.03-1.465.058-1.074.156-1.875.292-2.403.098-.351.274-.654.528-.908s.557-.43.908-.528c.508-.136 1.7-.234 3.575-.293L8 2.38l2.667.03c1.875.058 3.067.156 3.575.292.351.098.654.274.908.528s.43.557.528.908zM6.359 10.41l4.19-2.403-4.19-2.373v4.776z","fill":"red"}})]) } };

var iconColorZoom = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm1.77 10.2c0 .17-.13.3-.3.3H4.71c-.79 0-1.43-.64-1.43-1.43V5.82c0-.17.13-.3.3-.3h4.76c.79 0 1.43.64 1.43 1.43v3.25zm3.18.1c0 .12-.14.2-.24.12L10.77 9V7l1.95-1.44c.1-.07.24 0 .24.12v4.62h-.01z","fill":"#008EFF"}})]) } };

var iconColumnFiveImage = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M5.94 7.11a2 2 0 10-4 0 2 2 0 004 0zm-3 0a1 1 0 112 0 1 1 0 01-2 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 0h-14A1.5 1.5 0 00.002 1.5V13h1V4.49h14v5.22l-1.92-1.77a.52.52 0 00-.68 0l-3.84 3.57-2.2-1.9a.51.51 0 00-.68 0L.15 15.13a.49.49 0 00-.11.549.5.5 0 00.46.32h14a1.5 1.5 0 001.499-1.5V.5a.5.5 0 00-.5-.5zM15 14.49a.5.5 0 01-.5.5H1.71l4.35-4.32 2.18 1.89a.5.5 0 00.67 0L12.75 9 15 11.07v3.42zM7 1h2v2.49H7V1zM6 3.49H4V1h2v2.49zM10 1h2v2.49h-2V1zm-9 .5a.5.5 0 01.5-.5H3v2.49H1V1.5zm12 2V1h2v2.49l-2 .01z","fill":"currentColor"}})]) } };

var iconColumnFourCard = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.25 13.23a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5H2.75a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h10.5zm-.5-1h-6.1v-5h6.1v5zm-9.5-5h2.4v5h-2.4v-5z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.41 8.24H8v1h3.41v-1zM10.44 10.24H8v1h2.44v-1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 0h-14A1.5 1.5 0 000 1.5V14h1V4.49h14v10a.5.5 0 01-.5.5H0v.51a.5.5 0 00.5.5h14a1.5 1.5 0 001.5-1.5V.5a.5.5 0 00-.5-.5zm-7 1h2.75v2.49H8.5V1zm-1 2.49H4.75V1H7.5v2.49zM1 1.5a.5.5 0 01.5-.5h2.25v2.49H1V1.5zm11.25 2V1H15v2.49l-2.75.01z","fill":"currentColor"}})]) } };

var iconColumnTwoCard = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.25 13.23a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5H2.75a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h10.5zm-.5-1h-6.1v-5h6.1v5zm-9.5-5h2.4v5h-2.4v-5z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.41 8.24H8v1h3.41v-1zM10.44 10.24H8v1h2.44v-1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 0h-14A1.5 1.5 0 000 1.5V14h1V4.49h14v10a.5.5 0 01-.5.5H0v.51a.5.5 0 00.5.5h14a1.5 1.5 0 001.5-1.5V.5a.5.5 0 00-.5-.5zM1 1.5a.5.5 0 01.5-.5h6v2.49H1V1.5zm7.5 2V1H15v2.49l-6.5.01z","fill":"currentColor"}})]) } };

var iconColumnTwoCenterText = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.51 6.22h-9v1h9v-1zM11.19 9.22H4.83v1h6.36v-1zM12.01 12.22H4.02v1h7.99v-1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 0h-14A1.5 1.5 0 000 1.5V14h1V4.49h14v10a.5.5 0 01-.5.5H0v.51a.5.5 0 00.5.5h14a1.5 1.5 0 001.5-1.5V.5a.5.5 0 00-.5-.5zM1 1.5a.5.5 0 01.5-.5h6v2.49H1V1.5zm7.5 2V1H15v2.49l-6.5.01z","fill":"currentColor"}})]) } };

var iconColumnTwoIframe = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 0h-14A1.5 1.5 0 000 1.5V14h1V4.49h14v10a.5.5 0 01-.5.5H0v.51a.5.5 0 00.5.5h14a1.5 1.5 0 001.5-1.5V.5a.5.5 0 00-.5-.5zM1 1.5a.5.5 0 01.5-.5h6v2.49H1V1.5zm7.5 2V1H15v2.49l-6.5.01z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 8a1 1 0 100-2 1 1 0 000 2zm1 5V9H7v4h2z","fill":"currentColor"}})]) } };

var iconColumnTwoImage = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M5.94 7.11a2 2 0 10-4 0 2 2 0 004 0zm-3 0a1 1 0 112 0 1 1 0 01-2 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 0h-14A1.5 1.5 0 00.002 1.5V13h1V4.49h14v5.22l-1.92-1.77a.5.5 0 00-.67 0l-3.85 3.57-2.19-1.9a.51.51 0 00-.68 0L.15 15.13a.49.49 0 00-.11.549.5.5 0 00.46.32h14a1.5 1.5 0 001.499-1.5V.5a.5.5 0 00-.5-.5zM15 14.49a.5.5 0 01-.5.5H1.71l4.35-4.32 2.18 1.89a.5.5 0 00.67 0L12.75 9 15 11.07v3.42zM1 1.5a.5.5 0 01.5-.5h6v2.49H1V1.5zm7.49 2V1H15v2.49l-6.51.01z","fill":"currentColor"}})]) } };

var iconColumnTwoSeeMore = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 0h-14A1.5 1.5 0 000 1.5V13.99h1V4.497h14v9.994a.5.5 0 01-.5.5H0v.51A.5.5 0 00.5 16h14a1.5 1.5 0 001.5-1.51V.5a.5.5 0 00-.5-.5zM1 1.5a.5.5 0 01.5-.5h6v2.498H1V1.499zm7.5 1.998V.999H15v2.499H8.5z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8 13.082a6.004 6.004 0 005.38-2.998 1 1 0 000-.93A5.998 5.998 0 008 6.086a6.003 6.003 0 00-5.39 2.998.999.999 0 000 .93A5.998 5.998 0 008 13.082zm0-5.997a5.002 5.002 0 014.5 2.499A4.998 4.998 0 018 12.082a5.002 5.002 0 01-4.5-2.498A4.999 4.999 0 018 7.085z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.01 11.063a1.5 1.5 0 100-2.999 1.5 1.5 0 000 2.999z","fill":"currentColor"}})]) } };

var iconColumnTwoText = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M11 8.42a.5.5 0 00.5-.5V6.75a.5.5 0 00-.5-.5H5a.5.5 0 00-.5.5v1.17a.5.5 0 101 0v-.67h2v5H6.2a.5.5 0 000 1h3.6a.5.5 0 000-1H8.5v-5h2v.67a.5.5 0 00.5.5z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 0h-14A1.5 1.5 0 000 1.5V14h1V4.49h14v10a.5.5 0 01-.5.5H0v.51a.5.5 0 00.5.5h14a1.5 1.5 0 001.5-1.5V.5a.5.5 0 00-.5-.5zM1 1.5a.5.5 0 01.5-.5h6v2.49H1V1.5zm7.5 2V1H15v2.49l-6.5.01z","fill":"currentColor"}})]) } };

var iconColumnTwoWysiwyg = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 0h-14A1.5 1.5 0 000 1.5V14h1V4.49h14v10a.5.5 0 01-.5.5H0v.51a.5.5 0 00.5.5h14a1.5 1.5 0 001.5-1.5V.5a.5.5 0 00-.5-.5zM1 1.5a.5.5 0 01.5-.5h6v2.49H1V1.5zm7.5 2V1H15v2.49l-6.5.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.503 12.563c-.838 0-1.497.03-2.007-.724v-1.678h.49c.208 0 .5-.106.5-.38 0-.276-.287-.388-.5-.388h-.49V7.66c.5-.739 1.184-.723 2.007-.723.132 0 .26-.05.353-.138a.455.455 0 00.147-.331.455.455 0 00-.147-.332.518.518 0 00-.353-.137c-.61 0-.961.023-1.518.297a2.719 2.719 0 00-.989.82 2.719 2.719 0 00-.99-.82C6.452 6.023 6.113 6 5.502 6c-.132 0-.26.05-.353.137A.454.454 0 005 6.47c0 .124.053.243.147.331.094.088.22.138.353.138.823 0 1.495-.016 1.995.723v1.732h-.49c-.213 0-.5.106-.5.387 0 .282.292.38.5.38h.49v1.68c-.51.753-1.157.723-1.995.723-.132 0-.26.049-.353.137A.454.454 0 005 13.03c0 .125.053.244.147.332.094.088.22.137.353.137.61 0 .95-.023 1.506-.297.395-.194.735-.476.99-.82.253.344.593.626.988.82.557.274.907.297 1.518.297.132 0 .26-.05.353-.137a.455.455 0 00.147-.332.455.455 0 00-.147-.331.518.518 0 00-.353-.137z","fill":"currentColor"}})]) } };

var iconCommentEdit = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M5.062 10.756a.684.684 0 00.184.719.665.665 0 00.726.117l2.769-1.257 7.11-7.01a.507.507 0 000-.72L13.878.645a.497.497 0 00-.7 0L6.234 7.525c-.027.028-1.173 3.23-1.173 3.23zm8.466-9.043l1.26 1.252-5.864 5.822L7.66 7.529l5.869-5.816zm-6.57 6.536l1.233 1.225-1.941.887.709-2.112z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.445 5.678c.355.585.544 1.256.548 1.94 0 2.768-3.14 5.019-6.997 5.019-.21 0-.422-.008-.629-.02a.488.488 0 00-.368.131l-.166.162a4.128 4.128 0 01-1.658 1.096c-.427.149-.865.269-1.309.359a7.29 7.29 0 00.425-.664c.176-.369.33-.749.459-1.137a.507.507 0 00-.251-.62c-.189-.094-1.223-.632-1.228-.632A4.545 4.545 0 011 7.618C1 4.851 4.139 2.6 7.996 2.6a9.503 9.503 0 012.12.236l.22-.985a10.494 10.494 0 00-2.34-.26C3.587 1.59 0 4.294 0 7.617a5.557 5.557 0 002.77 4.566s.502.262.886.46c-.068.19-.146.378-.235.56-.304.518-.666 1-1.08 1.435a.51.51 0 00.078.776.498.498 0 00.278.085 8.81 8.81 0 002.798-.537 5.07 5.07 0 002.032-1.327c.156.007.312.01.47.01 4.408 0 7.995-2.704 7.995-6.028a4.784 4.784 0 00-.688-2.457l-.859.517z","fill":"currentColor"}})]) } };

var iconCommentFill = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 1C3.589 1 0 3.722 0 7.067a5.593 5.593 0 002.763 4.59l.872.48.031.015.006.003a5.08 5.08 0 01-.25.534 7.903 7.903 0 01-1.08 1.445.514.514 0 00.077.78.5.5 0 00.278.086h.004a8.754 8.754 0 002.796-.54 5.079 5.079 0 002.033-1.336c.156.007.313.01.47.01 4.411 0 8-2.721 8-6.067C16 3.722 12.411 1 8 1z","fill":"currentColor"}})]) } };

var iconCommentSlash = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8.003 12.194c-.211 0-.421-.007-.628-.02a.49.49 0 00-.37.13l-.164.16a4.149 4.149 0 01-1.66 1.086c-.428.148-.865.266-1.309.356.153-.211.294-.43.424-.656.21-.392.36-.813.444-1.25a.5.5 0 00-.303-.503c-2.117-.898-3.432-2.535-3.432-4.273a4.05 4.05 0 011.271-2.847l-.695-.696A5.029 5.029 0 00.005 7.224c0 2.03 1.385 3.92 3.644 5.013-.06.179-.135.352-.222.519-.305.514-.667.99-1.08 1.421a.5.5 0 00.36.852 8.882 8.882 0 002.795-.531 5.08 5.08 0 002.032-1.314 10.381 10.381 0 003.192-.354l-.826-.827c-.625.126-1.26.19-1.897.19zM16 7.224c0-3.291-3.588-5.97-7.998-5.97A9.81 9.81 0 003.188 2.47L.72 0 0 .72 15.275 16l.72-.72-3.253-3.255A5.665 5.665 0 0016 7.225zm-7.998-4.97c3.859 0 6.998 2.23 6.998 4.97a4.77 4.77 0 01-2.998 4.06l-8.08-8.08a8.959 8.959 0 014.08-.95z","fill":"currentColor"}})]) } };

var iconComment = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M2.697 15a.5.5 0 01-.46-.313.514.514 0 01.105-.553c.4-.45.762-.933 1.08-1.445.204-.337.688-1.492.688-1.492l.834.396a9.315 9.315 0 01-.653 1.598c-.13.23-.27.453-.424.667.444-.09.882-.212 1.31-.362a4.135 4.135 0 001.659-1.103l.166-.162a.497.497 0 01.37-.133c.206.013.416.02.628.02 3.86 0 7-2.266 7-5.05 0-2.786-3.14-5.052-7-5.052S1 4.282 1 7.067a4.579 4.579 0 002.273 3.718l-.546.85A5.574 5.574 0 010 7.068C0 3.722 3.589 1 8 1s8 2.722 8 6.067c0 3.346-3.589 6.068-8 6.068-.157 0-.314-.004-.469-.01a5.084 5.084 0 01-2.034 1.334 8.761 8.761 0 01-2.8.541z","fill":"currentColor"}})]) } };

var iconCommunity = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.419 15.995H9.155a.573.573 0 01-.58-.563v-1.004c0-.961 1.363-1.424 1.781-1.543l.275.962a2.055 2.055 0 00-1.058.589l.001.56H15v-.568c-.017-.019-.195-.306-1.576-.807l-.157-.059a.98.98 0 01-.623-.684.779.779 0 01.224-.716 1.901 1.901 0 00.536-1.486c0-.819-.449-1.368-1.117-1.368-.668 0-1.116.55-1.116 1.368a1.991 1.991 0 00.433 1.397.393.393 0 00.323.124l.078.997a1.398 1.398 0 01-1.08-.387 2.893 2.893 0 01-.754-2.13 2.132 2.132 0 012.117-2.37 2.13 2.13 0 012.116 2.37 2.978 2.978 0 01-.65 2l.012.004c1.16.421 2.234.925 2.234 1.747v1.004a.573.573 0 01-.581.563zM6.871 15.995H.607a.573.573 0 01-.58-.563v-1.004c0-.822 1.074-1.326 2.234-1.747l.011-.005a2.98 2.98 0 01-.649-2 2.179 2.179 0 012.116-2.368 2.179 2.179 0 012.116 2.368 2.894 2.894 0 01-.754 2.131 1.404 1.404 0 01-1.08.387l.079-.997a.403.403 0 00.322-.124c.316-.394.471-.893.433-1.397 0-.819-.448-1.368-1.116-1.368-.668 0-1.116.55-1.116 1.368a1.906 1.906 0 00.536 1.487.78.78 0 01.224.715.979.979 0 01-.622.684l-.159.059c-1.38.501-1.56.788-1.58.84l.002.534h5.428v-.567a2.111 2.111 0 00-1.057-.581l.275-.962c.418.119 1.782.582 1.782 1.543v1.004a.573.573 0 01-.581.563zM11.126 7.688H4.862a.573.573 0 01-.58-.563V6.121c0-.961 1.37-1.427 1.791-1.547l.275.962a2.085 2.085 0 00-1.068.594l.001.558h5.426V6.12c-.017-.018-.194-.306-1.574-.808l-.16-.06a.979.979 0 01-.622-.682.78.78 0 01.224-.716 1.906 1.906 0 00.535-1.486C9.11 1.55 8.662 1 7.994 1c-.668 0-1.116.55-1.116 1.37a1.991 1.991 0 00.434 1.396.39.39 0 00.322.124l.078.997a1.396 1.396 0 01-1.08-.387 2.893 2.893 0 01-.754-2.13A2.179 2.179 0 017.994 0a2.179 2.179 0 012.116 2.37 2.984 2.984 0 01-.648 1.999l.013.005c1.159.422 2.232.925 2.232 1.747v1.004a.573.573 0 01-.581.563zM.36 10.364A8 8 0 015.073.547l.365.931a7 7 0 00-4.125 8.59l-.955.296zM15.64 10.364l-.955-.297a7 7 0 00-4.125-8.589l.366-.93a8 8 0 014.715 9.816z","fill":"currentColor"}})]) } };

var iconCompare = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M4 7.86l.7.71 2-2a.51.51 0 00.15-.35.53.53 0 00-.15-.36l-2-2-.7.7 1.12 1.15H2.18v1h2.94L4 7.86z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.77 11.91V.5a.5.5 0 00-.5-.5H1.5A1.5 1.5 0 000 1.5v10.41a.5.5 0 00.5.5h7.77a.5.5 0 00.5-.5zm-1-.5H1V1.5a.5.5 0 01.5-.5h6.27v10.41zM11.53 12.15l.7-.71-1.15-1.15H14v-1h-2.92l1.15-1.15-.7-.71-2 2a.51.51 0 00-.15.35.53.53 0 00.15.36l2 2.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 3.59H9.7v1H15v9.91a.5.5 0 01-.5.5H8.23v-1.55h-1v2.05a.5.5 0 00.5.5h6.77a1.5 1.5 0 001.5-1.5V4.09a.5.5 0 00-.5-.5z","fill":"currentColor"}})]) } };

var iconConnectFill = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 0a8 8 0 108 8 8.01 8.01 0 00-8-8zM5.277 9.062H4.3V4.466c0-.284 0-.44.093-.534.096-.093.251-.093.534-.093h1.95c1.226 0 1.9 0 2.24.34.338.338.338 1.013.338 2.237v2.646h-.977V6.416c0-1.602 0-1.602-1.6-1.602H5.276v4.248zm6.342 1.985c0 .283 0 .44-.093.533-.095.094-.25.094-.534.094h-1.95c-1.226 0-1.9 0-2.24-.34-.337-.34-.337-1.014-.337-2.238V6.45h.976v2.646c0 1.602 0 1.602 1.601 1.602h1.6V6.45h.977v4.596z","fill":"currentColor"}})]) } };

var iconConnectStroke = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}},[_c('path',{attrs:{"d":"M9.688 4.415c-.36-.362-1.078-.362-2.38-.362H5.236c-.3 0-.466 0-.567.1-.099.1-.099.265-.099.567v4.883h1.038V5.09h1.7c1.7 0 1.7 0 1.7 1.701v2.812h1.038V6.79c0-1.3 0-2.016-.358-2.376z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.5 17a8.5 8.5 0 116.394-2.9l-.799-.7a7.422 7.422 0 10-.93.894l.667.827A8.522 8.522 0 018.5 17z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.228 12.015c.36.362 1.078.362 2.38.362h2.072c.3 0 .465 0 .567-.1.099-.099.099-.265.099-.566V6.828h-1.038v4.513h-1.7c-1.7 0-1.7 0-1.7-1.702V6.828H6.87v2.811c0 1.3 0 2.017.358 2.377z","fill":"currentColor"}})]) } };

var iconConsulting = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M8.83 6.797H7.138v1H8.83v-1zM7.009 6.1a.5.5 0 00.5.499h.972a.5.5 0 00.5-.5c.032-.256.134-.498.294-.7.36-.507.559-1.11.57-1.73a1.905 1.905 0 00-1.85-1.954 1.907 1.907 0 00-1.85 1.954c.011.62.21 1.223.57 1.73.16.202.262.444.294.7zm.986-3.385a.908.908 0 01.85.954 2.149 2.149 0 01-.422 1.208 3.26 3.26 0 00-.363.722h-.13a3.259 3.259 0 00-.363-.722 2.148 2.148 0 01-.423-1.208.908.908 0 01.85-.954zM14.978 13.501a3.299 3.299 0 00-.597-.253 2.28 2.28 0 00.376-1.261A1.96 1.96 0 0012.958 9.9a1.961 1.961 0 00-1.798 2.086 1.958 1.958 0 001.798 2.085 2.655 2.655 0 011.54.306.978.978 0 01.434.622h-3.918c.098-.31.27-.591.502-.82l-.7-.714a3.04 3.04 0 00-.897 2.037.5.5 0 00.5.496h5.08a.5.5 0 00.5-.483 2.325 2.325 0 00-1.021-2.015zm-2.818-1.514c0-.589.366-1.086.798-1.086.433 0 .8.497.8 1.086 0 .588-.367 1.085-.8 1.085-.432 0-.798-.497-.798-1.085z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6.617 12.13l-.266.963c.753.208 1.447.62 1.467.799V15H.999l-.002-1.083a4.355 4.355 0 011.976-.987 1.1 1.1 0 00.855-1.144.501.501 0 00-.188-.39 2.06 2.06 0 01-.7-1.66c0-1.033.674-1.94 1.442-1.94.794 0 1.44.87 1.44 1.94 0 1.08-.66 1.994-1.44 1.994v1a2.737 2.737 0 002.43-2.88c.348.033.697.048 1.046.043a5.997 5.997 0 01-.55.868.634.634 0 00-.036.61.65.65 0 00.61.324 4.2 4.2 0 002.077-.706 3.116 3.116 0 001.02-1.45c3.059-.745 5.02-2.53 5.02-4.595 0-2.772-3.514-4.944-8-4.944C3.515 0 0 2.172 0 4.944A4.144 4.144 0 002.215 8.41c-.18.419-.273.87-.275 1.326a3.12 3.12 0 00.82 2.208.429.429 0 01-.069.027C1.883 12.202 0 12.852 0 13.892v1.552a.56.56 0 00.61.555h7.598a.674.674 0 00.463-.202.5.5 0 00.147-.353v-1.552c0-1.073-1.685-1.62-2.201-1.762zM1 4.944C1 2.806 4.206.999 8 .999c3.793 0 6.998 1.807 6.998 3.945 0 1.614-1.813 3.094-4.512 3.683a.501.501 0 00-.376.356 2.44 2.44 0 01-.718 1.182c-.228.157-.478.28-.741.368.106-.175.185-.364.235-.563a1.4 1.4 0 00.017-.588.499.499 0 00-.5-.5l-.223.004c-.496.02-.992 0-1.485-.059a2.496 2.496 0 00-2.313-2.03 2.219 2.219 0 00-1.634.77A3.19 3.19 0 011 4.944z","fill":"currentColor"}})]) } };

var iconCopy = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.745 12.475h-6.79a1.226 1.226 0 01-1.193-1.255V1.254A1.226 1.226 0 015.955 0h4.312a.5.5 0 01.37.163l3.17 3.466a.5.5 0 01-.367.838l-3.453.015a.378.378 0 01-.354-.146.499.499 0 01-.148-.354V1h-3.53c-.103 0-.193.119-.193.254v9.966c0 .136.09.255.193.255h6.79c.103 0 .194-.119.194-.255V5.432h1v5.788a1.227 1.227 0 01-1.194 1.255zm-2.26-10.996v2l1.822-.007-1.822-1.993z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.984 16h-6.79A1.227 1.227 0 012 14.746V4.78a1.227 1.227 0 011.194-1.254h.541v1h-.54c-.104 0-.195.119-.195.254v9.966c0 .135.09.254.194.254h6.79c.103 0 .194-.119.194-.254v-1.204h1v1.204A1.226 1.226 0 019.983 16z","fill":"currentColor"}})]) } };

var iconCorporateSocialResponsibility = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.04 2.74a1.51 1.51 0 00-.5.09v-1A1.52 1.52 0 009.96.55a1.69 1.69 0 00-.72.17A1.63 1.63 0 007.9 0a1.58 1.58 0 00-1.29.7 1.36 1.36 0 00-.63-.15A1.49 1.49 0 004.5 1.86v3.82a1.43 1.43 0 00-.5-.09 1.44 1.44 0 00-1.5 1.32V11c0 4.66 4.71 5 6.16 5 3.07 0 4.84-1.61 4.84-4.41V4.06a1.44 1.44 0 00-1.46-1.32zm.46 8.85c0 2.82-2.09 3.41-3.84 3.41-1.55 0-5.16-.39-5.16-4V6.91c0-.14.23-.32.46-.32s.5.21.5.32v3.39H5.5V1.86c0-.11.27-.31.52-.31s.44.18.44.31v5.43h1v-6c0-.13.24-.32.48-.32s.52.2.52.32v5.84h1V1.86c0-.12.27-.31.54-.31a.69.69 0 01.5.29v5.63h1V4.06c0-.11.25-.32.5-.32s.46.18.46.32l.04 7.53z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.85 9a1.52 1.52 0 00-2 0 1.59 1.59 0 00-.46 1.1c0 1.72 2.15 3 2.24 3.06a.551.551 0 00.25.07.591.591 0 00.26-.07c.09-.06 2.24-1.34 2.24-3.06a1.568 1.568 0 00-.49-1.1 1.53 1.53 0 00-2.04 0zm0 3.16c-.57-.4-1.49-1.22-1.49-2a.64.64 0 01.14-.42.49.49 0 01.34-.12.5.5 0 01.49.52.5.5 0 001 0 .51.51 0 01.677-.494.45.45 0 01.153.094.61.61 0 01.17.4c.02.86-.91 1.63-1.48 2.03v-.01z","fill":"currentColor"}})]) } };

var iconCreditCard = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M1 7.55V4.816h11.582v.268h1V1.532A1.506 1.506 0 0012.102 0H1.48A1.51 1.51 0 000 1.532V7.55A1.506 1.506 0 001.48 9.082v-1A.508.508 0 011 7.55zm0-3.733v-.802h11.582v.802H1zM1.48 1h10.624a.509.509 0 01.479.533v.484H1v-.484a.507.507 0 01.478-.533z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.508 6.024H3.91a1.495 1.495 0 00-1.492 1.49v5.995A1.491 1.491 0 003.91 15h10.598A1.495 1.495 0 0016 13.51V7.514a1.491 1.491 0 00-1.492-1.49zm.491 7.485a.492.492 0 01-.491.491H3.91a.493.493 0 01-.491-.49V7.514a.491.491 0 01.491-.491h10.598a.493.493 0 01.491.49v5.995z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6.023 9.971h-1.58v1h1.58v-1zM8.619 11.921H4.444v1h4.175v-1zM14.01 11.921h-2.548v1h2.547v-1zM14.01 9.971h-2.092v1h2.091v-1zM11.202 9.971H8.668v1h2.534v-1zM7.951 9.971H6.74v1H7.95v-1z","fill":"currentColor"}})]) } };

var iconCursor = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 27"}},[_c('g',{attrs:{"filter":"url(#assets-icon-cursor_svg__filter0_dd)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.497 15.34l2.332 5.307a.629.629 0 010 .546.743.743 0 01-.416.39l-2.04.859a.655.655 0 01-.542 0 .742.742 0 01-.417-.39l-2.207-5.034-3.624 3.473c-.222.234-.486.286-.791.156-.306-.13-.459-.351-.459-.663V3.206c0-.312.153-.527.459-.644.305-.117.569-.071.79.137L16.454 14.13c.223.208.271.462.146.76-.125.3-.354.45-.687.45h-4.415z","fill":"currentColor","stroke":"currentColor"}})]),_c('defs',[_c('filter',{attrs:{"id":"assets-icon-cursor_svg__filter0_dd","x":"-2","y":"0","width":"24","height":"27","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"1"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.0784314 0 0 0 0 0.12549 0 0 0 0 0.160784 0 0 0 0.12 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}}),_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"1"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.08 0 0 0 0 0.124 0 0 0 0 0.16 0 0 0 0.12 0"}}),_c('feBlend',{attrs:{"in2":"effect1_dropShadow","result":"effect2_dropShadow"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect2_dropShadow","result":"shape"}})],1)])]) } };

var iconDarkMode = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8.387 16A8.381 8.381 0 014.782.049a.5.5 0 01.59.783 6.938 6.938 0 009.795 9.796.5.5 0 01.784.589A8.428 8.428 0 018.387 16zM3.254 2.317a7.375 7.375 0 1010.43 10.428A7.938 7.938 0 013.254 2.317z","fill":"currentColor"}})]) } };

var iconDashboard = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M11.31 12.402H4.69a.5.5 0 00-.5.5V14.5a.5.5 0 00.5.5h6.619a.5.5 0 00.5-.5v-1.598a.499.499 0 00-.5-.5zM10.81 14H5.19v-.598h5.619V14zM12.107 5.566L8.852 7.692a1.478 1.478 0 10.636 1.212 1.45 1.45 0 00-.06-.394l3.226-2.107-.547-.837zM8 9.386a.482.482 0 11.013-.964.482.482 0 01-.013.964z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.667 3.34A7.967 7.967 0 008 1h-.015A8.088 8.088 0 000 8.963a7.928 7.928 0 002.032 5.294.737.737 0 001.06.026l.502-.501-.707-.707-.298.297a6.925 6.925 0 01-1.158-2.02l.829-.21-.246-.97-.848.216A6.911 6.911 0 011 8.962a6.63 6.63 0 01.193-1.564l.866.286.314-.95-.875-.289A7.128 7.128 0 013.28 3.882l.61.792.794-.61-.626-.812A6.944 6.944 0 017.49 2.027l.002 1.094 1-.002-.002-1.095a6.953 6.953 0 013.467 1.196l-.65.844.793.61.638-.828c.074.068.151.131.223.202a6.936 6.936 0 011.566 2.4l-.907.328.34.94.86-.31c.117.509.178 1.03.18 1.552-.005.482-.06.962-.164 1.433l-.859-.219-.246.97.843.214a6.803 6.803 0 01-1.161 2.029l-.249-.25-.707.708.48.48c.13.128.306.2.488.2a.67.67 0 00.375-.113.992.992 0 00.132-.112 7.928 7.928 0 00-.265-10.957z","fill":"currentColor"}})]) } };

var iconDataCenter = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.498 16H3.495a.5.5 0 01-.5-.5V.5a.5.5 0 01.5-.5h9.003A.5.5 0 0113 .5v15a.498.498 0 01-.502.5zm-8.501-1h8V1h-8v14z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.863 2.146h-5.65v1h5.65v-1zM10.863 4.868h-5.65v1h5.65v-1zM10.863 7.59h-5.65v1h5.65v-1zM10.863 10.313h-5.65v1h5.65v-1zM10.863 13.035h-5.65v1h5.65v-1zM2.481 15.18H.501a.5.5 0 01-.501-.5V1.182a.5.5 0 01.501-.5h1.98v1H1.003V14.18H2.48v1zM15.498 15.18h-1.98v-1h1.48V1.682h-1.48v-1h1.98a.5.5 0 01.502.5V14.68a.498.498 0 01-.502.5z","fill":"currentColor"}})]) } };

var iconDelete = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M5.95 4.98h-1v8h1v-8zM8.47 4.98h-1v8h1v-8zM10.96 4.98h-1v8h1v-8z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.5 2h-4.3V1a1 1 0 00-1-1H6.75a1 1 0 00-1 1v1H1.5v1h11l-.21 12h-8.6L3.5 4h-1l.2 11.51a.51.51 0 00.5.49h9.55a.51.51 0 00.5-.49L13.5 3h1V2zM6.75 1H9.2v1H6.75V1z","fill":"currentColor"}})]) } };

var iconDemo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.047 0H7.133a.97.97 0 00-.953.983V3.03h1l-.047-2.01L15 .983l.047 7.858-7.867.039V7.39h-1v1.49a.97.97 0 00.953.982h3.457v1.827l-3.513 3.537.703.727 2.81-2.829v2.703h1v-2.703l2.81 2.83.702-.728-3.512-3.537V9.862h3.457A.97.97 0 0016 8.88V.983A.97.97 0 0015.047 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.72 4.116a1.107 1.107 0 00-.462-.574V3.06L12.49 4.87 9.258 6.677v-.014h-1v.663a.635.635 0 00.3.559.589.589 0 00.306.087.646.646 0 00.32-.089l4.405-2.465a.624.624 0 00.333-.549.634.634 0 00-.336-.551l-4.4-2.462a.61.61 0 00-.633 0c-.295.183-.295.414-.295 1.276v.255c-.031.008-.066.002-.096.013L4.98 4.502h-.677a1.827 1.827 0 00.684-1.471A1.604 1.604 0 003.56 1.299a1.605 1.605 0 00-1.43 1.732 1.827 1.827 0 00.685 1.47H1.501A1.503 1.503 0 000 6.005v3.081a1.22 1.22 0 001.243 1.231 1.24 1.24 0 00.236-.045v4.447A1.282 1.282 0 002.758 16c.286-.004.562-.105.783-.288.218.18.49.282.773.288a1.282 1.282 0 001.28-1.282V6.85l3.253-1.138a1.228 1.228 0 00.873-1.596zM3.559 2.32c.202 0 .428.304.428.71 0 .407-.226.71-.428.71-.204 0-.43-.303-.43-.71 0-.406.226-.71.43-.71zm4.943 2.434L4.932 6a.51.51 0 00-.338.484v8.233c0 .296-.558.298-.558 0v-4h-1v4c.001.299-.556.297-.557 0v-5.52h-.017c.01-.043.018-.085.024-.128V6.317h-1V9.07c0 .103-.042.226-.243.226A.21.21 0 011 9.07V6.004a.492.492 0 01.501-.481h3.561a.487.487 0 00.16-.027l3.262-1.13a.288.288 0 01.287.074c.032.094.06.182-.269.314z","fill":"currentColor"}})]) } };

var iconDigitalStrategy = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M16 4.034L14.663 2.69a.531.531 0 00-.728 0l-1.338 1.344.728.699.47-.473v6.736a1.909 1.909 0 01-1.895 1.917h-.245a2.919 2.919 0 00-2.914 2.916V16h1.018v-.17a1.908 1.908 0 011.896-1.916h.245a2.918 2.918 0 002.914-2.917V4.273l.458.46.728-.7zM8.99 2.192l.729-.7L8.38.15a.515.515 0 00-.728 0L6.316 1.494l.728.699.465-.467V16h1.018V1.726l.464.466z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.458 10.396a1.553 1.553 0 103.106.01 1.553 1.553 0 00-3.106-.01zm2.088 0a.534.534 0 11-.534-.548.542.542 0 01.534.548zM5.005 9.08a1.549 1.549 0 10-.009-3.097 1.549 1.549 0 00.01 3.097zm0-2.097a.549.549 0 11-.535.548.542.542 0 01.535-.548z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M4.168 9.962A1.91 1.91 0 012.27 8.045V5.341l.464.466.728-.7-1.337-1.342a.531.531 0 00-.728 0L.06 5.108l.727.7.465-.467v2.704a2.919 2.919 0 002.915 2.917 1.91 1.91 0 011.897 1.916V16h1.018v-3.122a2.919 2.919 0 00-2.915-2.916zM2.501 12.729l-.887.89-.886-.89-.728.699.902.906L0 15.24l.728.699.886-.89.887.89.728-.699-.903-.906.903-.906-.728-.699zM9.382 5.576l.902.906-.902.906.728.699.886-.89.887.89.727-.699-.902-.906.902-.906-.727-.7-.887.891-.886-.891-.728.7z","fill":"currentColor"}})]) } };

var iconDigitalWorkspace = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.167 13.866V8.11a.921.921 0 00-.941-.898H1.229a.921.921 0 00-.942.898v5.755a.497.497 0 00-.287.448C0 15.037.142 16 1.364 16h9.658c1.432 0 1.432-1.268 1.432-1.685a.498.498 0 00-.287-.448zm-1-5.653v5.601H8.564l-.002-.01h1c0-.876-1.299-1.303-1.697-1.413l-.267.964c.342.083.66.24.936.46H3.955a4.018 4.018 0 011.271-.579.927.927 0 00.717-.962.5.5 0 00-.186-.39 1.368 1.368 0 01-.457-1.1c0-.679.424-1.273.908-1.273.5 0 .907.57.907 1.272 0 .712-.415 1.313-.907 1.313v1a2.142 2.142 0 001.907-2.313 2.091 2.091 0 00-1.907-2.272A2.116 2.116 0 004.3 10.783c-.014.554.16 1.096.492 1.539-.773.237-1.9.716-1.9 1.482v.01H1.287V8.213h9.88zm-.145 6.786H1.364c-.17 0-.273 0-.324-.185h10.363c-.065.185-.189.185-.381.185z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 0H8.802a1.489 1.489 0 00-1.472 1.502V6.44h1V1.502A.488.488 0 018.803 1H15v7.664a.484.484 0 01-.468.497H12.99v1h1.541A1.484 1.484 0 0016 8.664V.5a.5.5 0 00-.5-.5zM6.528 2.141a4.464 4.464 0 00-4.455 4.462h1a3.462 3.462 0 013.455-3.462v-1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6.63 1.048v-1A6.556 6.556 0 00.086 6.603h1A5.556 5.556 0 016.63 1.048zM6.63 5.167v-1a2.438 2.438 0 00-2.434 2.436h1A1.437 1.437 0 016.63 5.167zM9.928 4.692a2.618 2.618 0 00-.77 1.751l1-.006c.025-.389.192-.755.47-1.03l-.7-.715zM12.928 6.587v1h.935a.5.5 0 00.5-.5v-.63a1.96 1.96 0 00-.889-1.75 3 3 0 00-.401-.182c.173-.304.264-.649.262-1A1.71 1.71 0 0011.76 1.71a1.71 1.71 0 00-1.575 1.816A1.71 1.71 0 0011.76 5.34c.426-.045.856.04 1.233.243.372.204.37.837.37.856v.147h-.435zm-1.743-3.061c0-.442.264-.816.575-.816.312 0 .575.374.575.816 0 .442-.263.815-.575.815-.311 0-.575-.373-.575-.815z","fill":"currentColor"}})]) } };

var iconDiscussions = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M2.277 12.032a.635.635 0 01-.584-.418.621.621 0 01.145-.689c.417-.338.777-.74 1.065-1.193.022-.046.04-.093.057-.14A5.067 5.067 0 010 5.222C0 2.343 2.946 0 6.567 0c3.622 0 6.569 2.343 6.569 5.223s-2.947 5.223-6.569 5.223c-.111 0-.221-.002-.332-.007a4.21 4.21 0 01-1.652 1.126 6.904 6.904 0 01-2.306.467zm.244-.376h-.002.002zM6.567 1C3.497 1 1 2.895 1 5.223a4.189 4.189 0 002.73 3.631.5.5 0 01.291.495c-.02.277-.092.55-.21.802a3.26 3.26 0 01-.551.764c.333-.076.662-.173.983-.29A3.262 3.262 0 005.55 9.71l.136-.139a.498.498 0 01.382-.142c.165.011.331.017.5.017 3.07 0 5.569-1.894 5.569-4.223C12.136 2.895 9.638 1 6.567 1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.873 16a6.35 6.35 0 01-2.124-.43 3.844 3.844 0 01-1.492-1.003c-1.353.155-4.086-.34-5.237-1.976l.818-.575c.951 1.353 3.586 1.725 4.492 1.528a.497.497 0 01.457.132l.125.129c.318.368.722.651 1.177.825.25.092.505.17.764.234a2.79 2.79 0 01-.422-.609 2.17 2.17 0 01-.197-.749.5.5 0 01.292-.494A3.792 3.792 0 0015 9.728a3.38 3.38 0 00-1.388-2.625l.625-.781A4.358 4.358 0 0116 9.728a4.67 4.67 0 01-2.7 4.017l.039.09c.261.41.588.775.967 1.08A.638.638 0 0113.873 16z","fill":"currentColor"}})]) } };

var iconDiversity = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}},[_c('path',{attrs:{"d":"M15.662 6.996a4.04 4.04 0 10-5.669-5.753 7.9 7.9 0 00-1.533-.148 7.34 7.34 0 00-6.345 3.437H.529A.529.529 0 000 5.061v.518h6.588v5.51h-5.53V6.584H0v5.086a.529.529 0 00.529.529h1.49a7.465 7.465 0 004.57 3.458l-.34.529a.55.55 0 00.197.739.539.539 0 00.27.075h8.195a.539.539 0 00.536-.545.55.55 0 00-.07-.27l-1.63-2.59a7.318 7.318 0 002.116-5.097 6.78 6.78 0 00-.201-1.502zm-2.792-5.9a2.982 2.982 0 110 5.963 2.993 2.993 0 01-2.982-2.982 3.078 3.078 0 01.39-1.49 3.014 3.014 0 012.592-1.492zM7.656 15.9l3.173-5.012L14 15.9H7.656zm5.5-3.236L11.24 9.62a.54.54 0 00-.899 0L7.17 14.663a6.345 6.345 0 01-3.892-2.506h3.839a.529.529 0 00.529-.53V5.062a.529.529 0 00-.529-.529h-3.67a6.345 6.345 0 015.859-2.38 4.019 4.019 0 003.564 5.923c.641 0 1.273-.156 1.84-.455.051.29.083.583.095.878a6.26 6.26 0 01-1.65 4.166z","fill":"currentColor"}})]) } };

var iconDocumentArchive = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M5.114 8.596a22.359 22.359 0 00-.94 3.202 2.315 2.315 0 104.628 0c-.234-1.09-.55-2.16-.945-3.203a.5.5 0 00-.472-.337h-1.8a.498.498 0 00-.471.338zm1.915.663c.379 1.114.758 2.324.776 2.54a1.317 1.317 0 01-2.635.012 25.8 25.8 0 01.771-2.552H7.03z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.967 14.495a.504.504 0 01-.503.505H2.997V1.503a.501.501 0 01.5-.503h.001l5.921.006V4a.5.5 0 00.499.5h3.584a.5.5 0 00.352-.853L10.371.152a.497.497 0 00-.353-.146L3.498 0A1.5 1.5 0 002 1.503V15.5a.5.5 0 00.499.5h9.965a1.504 1.504 0 001.5-1.505V5.443h-.997v9.052zm-2.55-12.882L12.297 3.5h-1.882V1.613z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6.681 7.033h-.994v1h.994v-1zM6.681 4.81h-.994v1.001h.994v-1zM6.681 2.589h-.994v1h.994v-1zM7.674 5.945h-.993v1h.993v-1zM7.674 3.723h-.993v1h.993v-1zM7.674 1.5h-.993v1.001h.993v-1zM6.487 12.354a.537.537 0 100-1.074.537.537 0 000 1.074z","fill":"currentColor"}})]) } };

var iconDocumentAudio = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M11.942 9.355a3.928 3.928 0 00-1.06-2.796l-.692.72c.514.566.785 1.312.755 2.076a2.93 2.93 0 01-.746 2.068l.695.716a3.935 3.935 0 001.048-2.784z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.612 11.253a2.645 2.645 0 00.72-1.9 2.678 2.678 0 00-.73-1.909l-.689.722c.289.326.44.752.423 1.188a1.7 1.7 0 01-.419 1.183l.695.716zM8.233 6.403a.496.496 0 00-.511.026L5.607 7.85H4.509a.497.497 0 00-.499.5v2.002a.501.501 0 00.499.5h1.1l2.134 1.421a.497.497 0 00.774-.418l-.02-5.011a.501.501 0 00-.264-.44zM6.034 9.935a.494.494 0 00-.275-.084h-.752V8.85h.752c.099 0 .195-.03.277-.085l1.468-.986.012 3.142-1.482-.986z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.966 14.492a.505.505 0 01-.502.504H2.997V1.502a.503.503 0 01.5-.502h.001l5.922.005V4a.501.501 0 00.498.5h3.584a.498.498 0 00.489-.597.501.501 0 00-.137-.256L10.37.152a.498.498 0 00-.353-.146L3.498 0a1.493 1.493 0 00-1.384.928A1.506 1.506 0 002 1.502v13.994a.501.501 0 00.498.5h9.966c.397 0 .779-.16 1.06-.441.28-.282.439-.665.44-1.063v-9.05h-.998v9.05zm-2.55-12.879L12.298 3.5h-1.882V1.613z","fill":"currentColor"}})]) } };

var iconDocumentCode = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M5.361 11.831l-1.717-1.654a.5.5 0 01-.014-.707l1.718-1.783.72.694-1.37 1.423 1.357 1.306-.694.721zM10.59 11.818l-.72-.694L11.24 9.7 9.883 8.395l.693-.721 1.718 1.654a.5.5 0 01.014.707l-1.718 1.783zM8.736 6.114l-2.476 6.94.941.336 2.477-6.94-.942-.336z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.464 16H2.498A.501.501 0 012 15.5V1.503A1.5 1.5 0 013.498 0H3.5l6.52.006a.498.498 0 01.352.146l3.483 3.496a.5.5 0 01-.352.854H9.918a.499.499 0 01-.498-.5V1.005L3.5 1h-.002a.502.502 0 00-.501.503V15h9.467a.503.503 0 00.502-.505V5.442h.997v9.053a1.504 1.504 0 01-1.5 1.505zM10.416 3.501h1.882l-1.882-1.888V3.5z","fill":"currentColor"}})]) } };

var iconDocumentCsv = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.967 14.495a.504.504 0 01-.503.505H2.997V1.503a.502.502 0 01.5-.503H3.5l5.92.006V4a.499.499 0 00.499.5h3.584a.5.5 0 00.352-.853L10.371.152a.497.497 0 00-.353-.146L3.498 0A1.5 1.5 0 002 1.503V15.5a.499.499 0 00.499.5h9.965a1.504 1.504 0 001.5-1.505V5.443h-.997v9.052zm-2.55-12.882L12.297 3.5h-1.882V1.613z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.44 8.163a.725.725 0 01.78.572h.608A1.3 1.3 0 005.44 7.662a1.467 1.467 0 00-1.526 1.574 1.46 1.46 0 001.526 1.573 1.265 1.265 0 001.378-1.072h-.58a.746.746 0 01-.798.566.939.939 0 01-.942-1.067.943.943 0 01.942-1.073zM8.25 10.303a.581.581 0 01-.628-.562h-.558a1.088 1.088 0 001.186 1.068c.678 0 1.147-.347 1.147-.919 0-1.2-1.674-.69-1.674-1.37 0-.216.19-.357.492-.357a.507.507 0 01.562.448h.555a1.007 1.007 0 00-1.117-.949c-.623 0-1.059.352-1.059.857 0 1.178 1.653.72 1.653 1.38 0 .273-.229.404-.559.404zM10.041 7.697h-.585l1.12 3.077h.568l1.12-3.077h-.58l-.827 2.36-.816-2.36z","fill":"currentColor"}})]) } };

var iconDocumentExcel = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.967 14.495a.505.505 0 01-.503.505H2.997V1.503a.501.501 0 01.5-.503h.001l5.921.006V4a.499.499 0 00.499.5h3.584a.5.5 0 00.352-.853L10.37.152a.498.498 0 00-.352-.146L3.498 0A1.5 1.5 0 002 1.503V15.5a.5.5 0 00.499.5h9.965a1.504 1.504 0 001.5-1.505V5.443h-.997v9.052zm-2.55-12.882L12.297 3.5h-1.882V1.613z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6.772 12.169l1.233-2.006 1.226 2.006h1.166L8.584 9.223l1.796-2.928H9.231L8.005 8.283 6.78 6.295H5.63l1.796 2.928-1.821 2.946h1.167z","fill":"currentColor"}})]) } };

var iconDocumentPdf = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.967 14.495a.504.504 0 01-.503.505H2.997V1.503a.501.501 0 01.5-.503h.001l5.921.006V4a.5.5 0 00.499.5h3.584a.5.5 0 00.352-.853L10.371.152a.497.497 0 00-.353-.146L3.498 0A1.5 1.5 0 002 1.503V15.5a.5.5 0 00.499.5h9.965a1.504 1.504 0 001.5-1.505V5.443h-.997v9.052zm-2.55-12.882L12.297 3.5h-1.882V1.613z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.522 10.428c.057-.06.11-.124.157-.192-.957.475-2.197 1.238-1.45 1.808a.702.702 0 00.174.087c.571.215 1.37-.488 2.175-2.082.847-.307 1.72-.533 2.61-.676 1.105.763 1.846.918 2.35.722a.775.775 0 00.422-.466c-.41.511-1.366.155-2.13-.334a5.747 5.747 0 011.748-.023c.4.128.386.33.382.357a.548.548 0 00-.01-.43c-.336-.557-1.881-.233-2.443-.173a4.513 4.513 0 01-1.743-2.21 4.45 4.45 0 00.296-2.202c-.085-.31-.292-.466-.467-.443a.674.674 0 00-.525.356 6.032 6.032 0 00.354 2.553C6.91 8.651 5.158 11.757 4.3 11.967c-.018-.206.09-.8 1.222-1.54zm2.134-6.033c.651.379.247 1.279.022 2.105-.148-.534-.354-1.721-.022-2.105zM7.57 7.309a5.904 5.904 0 001.325 1.84c-.779.156-1.538.397-2.264.717a18.1 18.1 0 00.939-2.557z","fill":"currentColor"}})]) } };

var iconDocumentPlain = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.464 16H2.499A.501.501 0 012 15.5V1.503A1.5 1.5 0 013.497 0h.001l6.52.006a.497.497 0 01.352.146l3.484 3.496a.5.5 0 01-.352.854H9.918a.499.499 0 01-.499-.5V1.005L3.5 1h-.002a.496.496 0 00-.462.31.501.501 0 00-.038.193V15h9.467a.505.505 0 00.503-.505V5.443h.997v9.052a1.504 1.504 0 01-1.5 1.505zM10.416 3.501h1.882l-1.882-1.888V3.5z","fill":"currentColor"}})]) } };

var iconDocumentPowerpoint = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.967 14.495a.505.505 0 01-.503.505H2.997V1.503a.501.501 0 01.5-.503h.001l5.921.006V4a.499.499 0 00.499.5h3.584a.5.5 0 00.352-.853L10.37.152a.498.498 0 00-.352-.146L3.498 0A1.5 1.5 0 002 1.503V15.5a.5.5 0 00.499.5h9.965a1.504 1.504 0 001.5-1.505V5.443h-.997v9.052zm-2.55-12.882L12.297 3.5h-1.882V1.613z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.405 6.128H6.046v5.874h1.117V9.77h1.242a1.774 1.774 0 001.955-1.822 1.775 1.775 0 00-1.955-1.82zm-.051 2.71H7.163V7.06h1.191a.836.836 0 01.923.89.837.837 0 01-.923.89z","fill":"currentColor"}})]) } };

var iconDocumentText = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.964 14.496a.503.503 0 01-.501.504H3V1.502a.496.496 0 01.308-.464A.491.491 0 013.5 1H3.5l5.917.005v2.996a.5.5 0 00.5.5H13.5a.5.5 0 00.354-.853L10.372.153a.503.503 0 00-.354-.147L3.5 0h-.001A1.501 1.501 0 002 1.502V15.5a.5.5 0 00.5.5h9.963a1.504 1.504 0 001.5-1.504V5.442h-1v9.054zm-2.547-12.88L12.296 3.5h-1.879V1.615z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.995 5.502h-6v1h6v-1zM10.995 8.502h-6v1h6v-1zM10.995 11.502h-6v1h6v-1z","fill":"currentColor"}})]) } };

var iconDocumentVideo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M9.404 6.608h-4.91a.5.5 0 00-.5.5v4.441a.5.5 0 00.5.5h4.91a.499.499 0 00.5-.5v-.667l1.297 1.055a.5.5 0 00.816-.39L12 7.107a.501.501 0 00-.817-.385L9.904 7.77v-.663a.5.5 0 00-.5-.5zm-.5 4.441h-3.91V7.61h3.91v3.44zM9.922 9.05l1.083-.888.008 2.333-1.093-.889-.016-.008V9.06c.006-.005.012-.005.018-.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.963 14.496a.503.503 0 01-.5.504H3V1.502a.496.496 0 01.308-.464A.491.491 0 013.5 1H3.5l5.917.005v2.996a.5.5 0 00.5.5H13.5a.5.5 0 00.354-.853L10.372.153a.503.503 0 00-.354-.147L3.5 0h-.001A1.501 1.501 0 002 1.502V15.5a.5.5 0 00.5.5h9.963a1.504 1.504 0 001.5-1.504V5.442h-1v9.054zm-2.546-12.88L12.296 3.5h-1.879V1.615z","fill":"currentColor"}})]) } };

var iconDocumentVisio = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.967 14.495a.504.504 0 01-.503.505H2.997V1.503a.501.501 0 01.5-.503h.001l5.921.006V4a.499.499 0 00.499.5h3.584a.5.5 0 00.352-.853L10.371.152a.497.497 0 00-.353-.146L3.498 0A1.5 1.5 0 002 1.503V15.5a.499.499 0 00.498.5h9.966a1.504 1.504 0 001.5-1.505V5.443h-.997v9.052zm-2.55-12.882L12.297 3.5h-1.882V1.613z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.997 10.801l-1.56-4.506H5.32l2.139 5.874h1.083l2.14-5.874H9.576l-1.58 4.506z","fill":"currentColor"}})]) } };

var iconDocumentWord = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.967 14.495a.504.504 0 01-.503.505H2.997V1.503a.502.502 0 01.5-.503H3.5l5.92.006V4a.499.499 0 00.499.5h3.584a.5.5 0 00.352-.853L10.371.152a.497.497 0 00-.353-.146L3.498 0A1.5 1.5 0 002 1.503V15.5a.5.5 0 00.499.5h9.965a1.504 1.504 0 001.5-1.505V5.443h-.997v9.052zm-2.55-12.882L12.297 3.5h-1.882V1.613z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.473 6.295h-.949l-1.276 4.237-1.217-4.237H3.907l1.762 5.874h1.083l1.25-4.154 1.251 4.154h1.091l1.754-5.874h-1.117l-1.224 4.237-1.284-4.237z","fill":"currentColor"}})]) } };

var iconDownload = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15 11.768l-.023 3.23L1 15.01v-3.243H0v3.243A1.008 1.008 0 001.023 16h13.954A1.008 1.008 0 0016 15.01v-3.242h-1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8 13.158a.5.5 0 00.353-.147l3.632-3.64-.707-.708L8.5 11.447V0h-1v11.447L4.723 8.663l-.707.709 3.63 3.64a.497.497 0 00.354.146z","fill":"currentColor"}})]) } };

var iconDownvoteStroke = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M5.804.5h4.272a.502.502 0 01.501.5v6.417h2.407a.492.492 0 01.441.27.49.49 0 010 .521l-5.014 7.098a.533.533 0 01-.822 0L2.575 8.298a.49.49 0 010-.52.49.49 0 01.38-.27h3.35v.5a.5.5 0 01-.501.5H3.929l4.01 5.646 4.072-5.736h-1.935a.502.502 0 01-.502-.5V1.5H6.305v5.005H5.302V1.001A.5.5 0 015.804.5z","fill":"currentColor"}})]) } };

var iconDrag = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.496 1.705v4.303h1V1.697l1.457 1.458.706-.707L8.353.14a.514.514 0 00-.707 0L5.34 2.448l.707.707 1.449-1.45zM8.504 14.288V9.986h-1v4.312l-1.457-1.459-.707.707 2.306 2.308a.498.498 0 00.707 0l2.306-2.307-.706-.708-1.449 1.45zM15.853 7.644l-2.306-2.307-.707.707 1.45 1.449H9.987v1h4.31L12.84 9.95l.707.708 2.306-2.307a.5.5 0 000-.708zM6.012 8.501v-1h-4.31l1.457-1.457-.707-.707L.146 7.644a.5.5 0 000 .707l2.306 2.306.707-.706L1.71 8.5h4.301z","fill":"currentColor"}})]) } };

var iconEdit = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.85 2.833L13.117.143a.501.501 0 00-.701 0l-11.37 11.19a.511.511 0 00-.137.243l-.896 3.838a.501.501 0 00.19.517.273.273 0 00.193.069 29.08 29.08 0 003.85-1.11.498.498 0 00.201-.121l9.415-9.265-.7-.715-8.011 7.883-2.02-1.988 9.636-9.481 2.02 1.987-.727.714.702.715 1.088-1.071a.502.502 0 000-.715zM4.438 13.375l-.604.594-2.647.822.664-2.846.567-.558 2.02 1.988z","fill":"currentColor"}})]) } };

var iconEndToEnd = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M16 2.47a1.292 1.292 0 00-1.29-1.29H1.29A1.305 1.305 0 000 2.523a1.27 1.27 0 00.495.99v8.978a.5.5 0 00.5.5h6.153L4.735 15.2l.676.738 2.196-2.01V16h1v-2.088l2.214 2.025.676-.737-2.413-2.208h4.914a1.475 1.475 0 001.498-1.447V4.631h-1v6.914a.475.475 0 01-.498.447H1.495V3.815H14.71A1.305 1.305 0 0016 2.47zM1.29 2.18h13.42a.307.307 0 01.29.344.291.291 0 01-.29.29H1.29A.307.307 0 011 2.47a.29.29 0 01.29-.29zM9.537 0h-3.02v1h3.02V0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.022 9.205V5.68a.5.5 0 00-.5-.5H6.999v1h2.316l-4.41 4.412.708.707 4.409-4.412v2.318h1z","fill":"currentColor"}})]) } };

var iconExecutive = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8.25 8.022c1.8 0 3.264-1.8 3.264-4.01C11.514 1.798 10.05 0 8.25 0 6.451 0 4.987 1.8 4.987 4.011c0 2.212 1.464 4.01 3.263 4.01zm0-7.02c1.248 0 2.264 1.35 2.264 3.01 0 1.658-1.016 3.007-2.264 3.007-1.248 0-2.263-1.35-2.263-3.008S7.002 1.003 8.25 1.003z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.536 7.495a.5.5 0 00-.476.35l-1.525 4.852L8.9 11.11l.967-1.874a.503.503 0 00-.444-.732H7.079a.502.502 0 00-.444.732l.967 1.875-.636 1.586L5.44 7.846a.5.5 0 00-.476-.351C1.687 7.495 1 9.099 1 10.445v5.053a.5.5 0 00.5.502h11.715v-1.003H2v-4.553c0-.862.305-1.846 2.6-1.939l1.833 5.83a.5.5 0 00.457.35.478.478 0 00.483-.314l.877-2.19.878 2.19a.467.467 0 00.483.314.499.499 0 00.457-.35l1.832-5.83c2.295.093 2.6 1.077 2.6 1.94v4.552h-.285V16H15a.502.502 0 00.5-.502v-5.054c0-1.345-.688-2.95-3.964-2.95zM8.6 9.507l-.35.677-.35-.677h.7z","fill":"currentColor"}})]) } };

var iconExpand = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6.888 8.397L1 14.287v-3.613H0V15.5a.5.5 0 00.5.5h4.826v-1H1.7l5.895-5.896-.707-.707zM15.5 0h-4.826v1h3.625L8.404 6.896l.707.707L15 1.713v3.613h1V.5a.5.5 0 00-.5-.5z","fill":"currentColor"}})]) } };

var iconExperience = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M4.65 15c.278-1.395.405-2.816.38-4.239a3.601 3.601 0 00-.795-2.14 4.871 4.871 0 01-1.027-3.163c0-.453.07-.902.205-1.334.34-.247.596-.591.735-.987.061-.188.095-.383.1-.58a.48.48 0 00.052-.04 4.337 4.337 0 011.483-1.116A4.41 4.41 0 017.606 1c3.444 0 4.768 1.957 4.857 3.633-.001.336-.055.669-.16.988a2.561 2.561 0 00-.12.64c.038.409.22.792.513 1.08l.272.347c.148.192.397.514.521.71-.084.026-.2.05-.272.065-.25.052-.768.16-.768.657 0 .087.012.207.026.34.023.162.034.326.032.49-.054.06-.114.114-.178.162a1.015 1.015 0 00-.407.443.993.993 0 00-.08.592c.103.361.047.595-.012.614a1.443 1.443 0 01-.84-.174 2.038 2.038 0 00-1.17-.216c-.909.182-1.086 1.02-1.139 1.729-.022.63-.004 1.262.056 1.89V15l-3.03-.024L5.716 16h3.352a.719.719 0 00.516-.218.691.691 0 00.191-.518l-.024-.344a14.06 14.06 0 01-.055-1.747c.056-.768.226-.802.328-.822.204.016.403.072.586.164a2.221 2.221 0 001.539.195c.627-.203.901-.886.702-1.72.038-.035.091-.079.13-.112.204-.141.365-.334.468-.559.082-.29.098-.595.045-.891.367-.079 1.068-.269 1.068-.993 0-.306-.227-.63-.785-1.352l-.284-.363c-.13-.13-.23-.287-.293-.46.019-.129.048-.256.087-.381.132-.42.196-.858.19-1.298C13.358 2.301 11.497 0 7.606 0a5.392 5.392 0 00-3.643 1.422A2.104 2.104 0 002.809.487a2.163 2.163 0 00-1.777.19c-.264.155-.49.366-.665.618A2.063 2.063 0 00.506 3.82c.2.232.449.418.728.545.28.127.585.193.894.194.049 0 .095-.02.144-.023-.053.304-.08.612-.08.92a5.808 5.808 0 001.228 3.76c.367.446.576 1.002.593 1.579a19.436 19.436 0 01-.433 4.378l-.16.8 1.028.01L4.65 15zM1.773 3.502a1.113 1.113 0 01-.641-.548 1.07 1.07 0 01-.058-.833c.076-.218.218-.406.407-.538a1.132 1.132 0 011.157-.085c.156.078.291.193.395.334a1.076 1.076 0 01-.41 1.613c-.265.129-.57.149-.85.057zM15.326 5.001a.584.584 0 00-.365.213.565.565 0 00.064.772.585.585 0 00.958-.284.563.563 0 00.01-.222l-.001-.012a.575.575 0 00-.237-.366.595.595 0 00-.43-.1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.472 3.383a1.014 1.014 0 00-.357-.727c-.578-.48-1.466-.153-2.297.484-.93-.49-1.862-.665-2.349-.099a1.023 1.023 0 00-.226.774c.103.552.356 1.065.731 1.483a3.046 3.046 0 00-.463 1.58 1.015 1.015 0 00.356.726c.188.154.425.236.668.23a2.93 2.93 0 001.636-.714c.451.265.958.421 1.48.456a1.09 1.09 0 00.863-.357 1.022 1.022 0 00.226-.774 3.062 3.062 0 00-.732-1.483c.297-.474.457-1.02.464-1.579zm-1.027.021c.028.272-.032.545-.169.781-.09-.082-.166-.166-.263-.246-.09-.075-.187-.144-.282-.216.21-.159.455-.268.714-.319zM8.058 5.886a6.662 6.662 0 01-.836-.693 6.402 6.402 0 01.702-.818 6.612 6.612 0 01.838.692 6.571 6.571 0 01-.704.819zM6.252 3.692c.267-.012.532.047.769.171-.082.087-.166.172-.243.262-.082.094-.143.19-.218.287a1.486 1.486 0 01-.308-.72zm.276 3.14a1.46 1.46 0 01.177-.758c.09.082.167.167.264.247.092.076.193.142.289.214a1.462 1.462 0 01-.73.298zm3.227-.273a1.338 1.338 0 01-.788-.162c.08-.086.162-.172.238-.261.082-.096.144-.193.219-.29.168.206.282.451.331.713zM1.127 10.33a.778.778 0 00-.486.283.752.752 0 00.086 1.03.78.78 0 001.275-.38.754.754 0 00.015-.294l-.003-.017a.766.766 0 00-.315-.487.793.793 0 00-.572-.134z","fill":"currentColor"}})]) } };

var iconExperiment = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"opacity":".98","d":"M14.672 7.254c-.207 0-.41-.053-.59-.156L7.459 3.305l-.914-.013a.5.5 0 01-.427-.749L7.437.25A.5.5 0 017.864 0a.52.52 0 01.433.238l.485.79 6.611 3.786a1.198 1.198 0 01.562.734c.09.347.041.716-.139 1.026v.001a1.333 1.333 0 01-1.144.679zm-7.263-4.95l.193.003a.502.502 0 01.24.066L14.58 6.23a.295.295 0 00.37-.154.356.356 0 00.041-.265.205.205 0 00-.093-.128l-6.722-3.85a.501.501 0 01-.178-.172l-.112-.183-.476.827z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.913 14.351H3.117a.5.5 0 01-.43-.756l1.199-2.007a.5.5 0 01.428-.244l2.36-.009h.002a.5.5 0 01.426.238l1.237 2.017a.5.5 0 01-.426.762zm-3.915-1H7.02l-.623-1.015-1.797.007-.602 1.008z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.802 16H1.228a1.233 1.233 0 01-1.076-.62 1.154 1.154 0 01.019-1.176l3.594-5.922v-.719h-.28a1.171 1.171 0 010-2.334h4.061a1.171 1.171 0 010 2.334l-1.28.002v-.502a.5.5 0 01.5-.5h.78a.485.485 0 00.07-.174.249.249 0 00-.095-.164l-4.036.004a.38.38 0 00-.07.16c.01.07.045.135.1.18l.75-.006a.5.5 0 01.5.5v1.358a.505.505 0 01-.073.26l-3.666 6.042a.156.156 0 00-.002.167.223.223 0 00.204.11h8.574a.227.227 0 00.205-.11.154.154 0 00-.004-.167L6.338 8.68a.505.505 0 01-.072-.26v-.153l.995.006 3.597 5.93a1.152 1.152 0 01.02 1.177A1.234 1.234 0 019.802 16z","fill":"currentColor"}})]) } };

var iconExternalLink = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.524 14.499a.501.501 0 01-.5.501H1V3.979a.5.5 0 01.499-.499h8.758v-1H1.499A1.5 1.5 0 000 3.979V15.5a.5.5 0 00.5.5h11.523a1.502 1.502 0 001.501-1.501V5.732h-1v8.767z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 0h-4.485v1h3.278L5.77 9.521l.707.707L15 1.707v3.277h1V.5a.5.5 0 00-.5-.5z","fill":"currentColor"}})]) } };

var iconFacebook = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6.286 16V8.844H3.88V6h2.406V3.75c0-1.188.333-2.11 1-2.766C7.953.328 8.838 0 9.942 0c.896 0 1.625.042 2.188.125v2.531h-1.5c-.563 0-.948.125-1.156.375-.167.209-.25.542-.25 1V6h2.656l-.375 2.844H9.224V16H6.286z","fill":"currentColor"}})]) } };

var iconFederalGovernment = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M15.5 9h-2v-.5A.5.5 0 0013 8h-.5V6a.5.5 0 00-.5-.5 4 4 0 00-3.5-3.72V0h-1v1.78A4 4 0 004 5.5a.5.5 0 00-.5.5v2H3a.5.5 0 00-.5.5V9h-2a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h6.38a.5.5 0 00.5-.5v-2h1.23v2a.5.5 0 00.14.35.51.51 0 00.36.15H13a.5.5 0 00.5-.5V10H15v5h-.47v1h1a.498.498 0 00.5-.5v-6a.5.5 0 00-.53-.5zM1 10h1.5v5H1v-5zm7-7.27a3 3 0 013 2.77H5a3 3 0 013-2.77zM4.5 6.5h7V8h-7V6.5zm8 8.5H9.61v-2a.51.51 0 00-.5-.51H6.88a.52.52 0 00-.35.14.49.49 0 00-.15.36v2H3.5V9h9v6z","fill":"currentColor"}})]) } };

var iconFeedFill = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}},[_c('path',{attrs:{"d":"M1.582 13.804a1.582 1.582 0 00-.308 3.13 1.58 1.58 0 10.308-3.13zM9.788 16.967H7.244a.316.316 0 01-.313-.309 6.916 6.916 0 00-1.948-4.514A6.918 6.918 0 00.31 10.036.317.317 0 010 9.721V7.179a.332.332 0 01.338-.33 10.094 10.094 0 016.86 3.006 10.093 10.093 0 012.92 6.774.332.332 0 01-.33.338z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16.674 17h-2.548a.314.314 0 01-.313-.311 13.773 13.773 0 00-4.048-9.454A13.774 13.774 0 00.311 3.187.314.314 0 010 2.874V.326A.328.328 0 01.33 0a16.95 16.95 0 0111.662 4.957A16.95 16.95 0 0117 16.67a.327.327 0 01-.326.33z","fill":"currentColor"}})]) } };

var iconFeedSlash = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.293 0l-4.238 4.24A15.438 15.438 0 001.992.093v.998a14.413 14.413 0 018.384 3.828l-1.3 1.301A12.523 12.523 0 00.995 2.84V.023H.797a.726.726 0 00-.557.23.781.781 0 00-.24.559v2.206a.768.768 0 00.757.77 11.568 11.568 0 017.631 3.12L6.8 8.497A9.374 9.374 0 00.807 6.014c-.21.01-.41.09-.567.23a.8.8 0 00-.24.609v2.236a.778.778 0 00.747.78c1.233.06 2.411.53 3.348 1.334l-1.089 1.09a1.982 1.982 0 00-2.854.945c-.15.365-.19.766-.113 1.154.047.219.13.429.248.62l-.275.275.708.708L16 .708 15.293 0zM.996 8.88V7.062a8.402 8.402 0 015.095 2.144l-1.306 1.306A6.569 6.569 0 00.996 8.88zm.02 4.927a.997.997 0 01.782-.784.987.987 0 01.452.026l-1.21 1.21a.994.994 0 01-.025-.452zM1.928 15.976c.281.017.563-.027.825-.13a1.997 1.997 0 001.23-1.844c0-.025-.007-.049-.008-.074l-2.047 2.048zM7.321 10.58A8.417 8.417 0 018.88 15H7.068a6.597 6.597 0 00-1.058-3.108l-.72.72c.475.792.75 1.687.803 2.608a.767.767 0 00.766.749H9.1a.775.775 0 00.557-.24.81.81 0 00.23-.569 9.446 9.446 0 00-1.852-5.293l-.713.713zM11.646 6.253A14.397 14.397 0 0114.932 15H13.12a12.607 12.607 0 00-2.784-7.437l-.697.697a11.649 11.649 0 012.496 6.94.767.767 0 00.806.798h2.24a.798.798 0 00.786-.799 15.422 15.422 0 00-3.638-9.63l-.683.683z","fill":"currentColor"}})]) } };

var iconFeedStroke = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M1.996 12a1.99 1.99 0 00-1.843 1.234 2.005 2.005 0 00.432 2.18A1.994 1.994 0 003.991 14c0-.53-.21-1.04-.585-1.415A1.992 1.992 0 001.996 12zm0 3a.996.996 0 01-.978-1.195 1 1 0 01.783-.786.995.995 0 011.024.425A1.002 1.002 0 011.995 15z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M.809 6c-.21.01-.411.09-.569.23a.8.8 0 00-.24.61v2.24a.781.781 0 00.749.78c1.43.062 2.783.67 3.78 1.7a5.717 5.717 0 011.576 3.66.77.77 0 00.768.75h2.244a.777.777 0 00.559-.24.81.81 0 00.229-.57 9.461 9.461 0 00-2.713-6.32A9.404 9.404 0 00.81 6zm6.273 9a6.607 6.607 0 00-1.835-4.1A6.606 6.606 0 00.998 8.87V7.05a8.428 8.428 0 015.486 2.5A8.43 8.43 0 018.898 15H7.082z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.401 4.52A15.483 15.483 0 001.996.07v1a14.457 14.457 0 018.757 4.16A14.407 14.407 0 0114.962 15h-1.815a12.624 12.624 0 00-3.7-8.47A12.562 12.562 0 00.997 2.82V0h-.2A.726.726 0 00.24.23a.78.78 0 00-.239.56V3a.771.771 0 00.758.77 11.605 11.605 0 017.98 3.43 11.664 11.664 0 013.42 8 .77.77 0 00.808.8h2.244a.796.796 0 00.788-.8 15.437 15.437 0 00-4.598-10.68z","fill":"currentColor"}})]) } };

var iconFeedback = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.036 14.5a.653.653 0 01-.29-.069l-4.664-2.785-6.581-.013a1.512 1.512 0 01-1.06-.438A1.486 1.486 0 010 10.143V1.496a.491.491 0 01.309-.458A.503.503 0 01.5 1h13.998c.398 0 .78.157 1.062.437.281.279.44.657.44 1.052v8.647a.492.492 0 01-.309.458.506.506 0 01-.191.037h-1.758v-.99H15V2.488a.496.496 0 00-.502-.498H1v8.152a.507.507 0 00.503.499l6.65.013c.046 0 .092.006.136.019l.125.035c.069.02.136.044.2.075l3.637 2.192-1.025-2.247.912-.408 1.489 3.263a.65.65 0 01-.59.916z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.717 3.265H3.27v.991h9.447v-.99zM12.717 5.515H3.27v.991h9.447v-.99zM12.717 7.765H3.27v.991h9.447v-.991z","fill":"currentColor"}})]) } };

var iconFilter = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.085 16a.444.444 0 01-.241-.072.506.506 0 01-.228-.427V8.49L1.199 2.185a.518.518 0 01-.09-.15A1.637 1.637 0 011.153.758 1.205 1.205 0 012.217 0h12.565a1.235 1.235 0 011.099.833c.155.384.159.813.01 1.2a.5.5 0 01-.082.143l-5.307 6.45a.456.456 0 01-.353.17H8.483V7.8h1.454l5.107-6.207a.568.568 0 00-.02-.353c-.06-.144-.158-.241-.242-.241H2.217c-.078 0-.168.082-.228.21a.575.575 0 00-.033.381L7.43 7.961c.08.094.123.213.123.336v6.375l1.892-1.067V9.662h.938v4.243a.506.506 0 01-.25.441l-2.829 1.596a.45.45 0 01-.22.058z","fill":"currentColor"}})]) } };

var iconFlag = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M1.36 9.09a.5.5 0 10-1 0 .5.5 0 001 0zM1 6.55a.5.5 0 10-1 0 .5.5 0 101 0zM8.65 9.34H2.9a.47.47 0 00-.35.15l-2 2.05.7.71 1.9-1.9h5.28l1.8 1.89.77-.69-2-2a.52.52 0 00-.35-.21zM2.9 6.66h5.75A.52.52 0 009 6.5l2-2-.77-.75-1.8 1.9H3.11l-1.9-1.9-.7.71 2 2.05a.47.47 0 00.39.15zM4.09 8.08a.5.5 0 101-.02.5.5 0 00-1 .02zM1.82 7.63a.5.5 0 00.5.5.51.51 0 10-.5-.5zM6.36 8.08a.51.51 0 00.5.5.51.51 0 000-1 .51.51 0 00-.5.5zM8.64 8.08a.5.5 0 00.5.5.51.51 0 10-.5-.5zM15.85 7.75l-2.06-2.1-.71.71 1.21 1.21h-3.73v1h3.74L13.08 9.8l.71.71 2.06-2.08a.47.47 0 00.15-.35.48.48 0 00-.15-.33z","fill":"currentColor"}})]) } };

var iconFolderClosed = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M14.511 4.168h-13.5v-.697C1.01 3 1.207 3 1.29 3h5.812c.077 0 .281 0 .281.471h1A1.307 1.307 0 007.104 2H1.291A1.307 1.307 0 00.01 3.471v10.032A1.499 1.499 0 001.507 15H15.51a.501.501 0 00.5-.5V5.667a1.5 1.5 0 00-1.499-1.499zm.5 9.832H1.506a.497.497 0 01-.497-.497V5.168h13.501a.5.5 0 01.5.499V14z","fill":"currentColor"}})]) } };

var iconFolderOpen = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M15.781 6.074a1.216 1.216 0 00-.97-.44H3.457a1.586 1.586 0 00-1.519 1.12l-.937 3.844V3.32c0-.198.112-.32.173-.32h5.004c.06 0 .173.122.173.32v.97a.5.5 0 00.5.5l7.252.012V4.29a.5.5 0 00-.5-.5H7.352v-.47A1.255 1.255 0 006.179 2H1.175A1.255 1.255 0 00.002 3.32V13.6A1.374 1.374 0 001.346 15H12.77a1.583 1.583 0 001.518-1.119l1.68-6.89a1.063 1.063 0 00-.188-.917zm-2.464 7.571a.592.592 0 01-.546.355H1.42c-.11 0-.168-.035-.189-.119l1.68-6.89a.596.596 0 01.548-.356H14.81c.11 0 .167.035.188.118l-1.68 6.892z","fill":"currentColor"}})]) } };

var iconGear = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.953 9.525a.732.732 0 00-.332-.328l-1.429-.583c.044-.435.04-.873-.008-1.307l1.425-.604a.607.607 0 00.327-.332.74.74 0 00-.002-.466L15.03 3.77a.615.615 0 00-.799-.32l-1.422.6c-.27-.329-.572-.63-.903-.897l.589-1.428a.735.735 0 00-.001-.47.74.74 0 00-.331-.329L10.021.043a.614.614 0 00-.792.335l-.59 1.429a6.197 6.197 0 00-1.304.003L6.74.385a.611.611 0 00-.8-.33L3.815.94a.609.609 0 00-.333.33.744.744 0 000 .472l.593 1.428c-.34.275-.65.586-.925.926l-1.43-.583a.612.612 0 00-.792.332l-.001.001-.88 2.134a.606.606 0 000 .469.735.735 0 00.332.33l1.43.585c-.045.435-.043.874.004 1.31l-1.42.6a.618.618 0 00-.327.8l.883 2.124a.613.613 0 00.333.334.74.74 0 00.47 0l1.428-.6c.275.338.586.648.926.922l-.583 1.428a.605.605 0 00-.002.467c.072.144.19.26.334.332l2.138.872a.606.606 0 00.47-.002.731.731 0 00.328-.331l.583-1.429c.435.044.874.041 1.308-.007l.602 1.429a.615.615 0 00.8.322l2.125-.896a.614.614 0 00.326-.799l-.596-1.426a6.16 6.16 0 00.921-.926l1.433.586a.608.608 0 00.468-.005.733.733 0 00.326-.332l.869-2.149a.737.737 0 00-.003-.463zm-1.646 1.874l-1.425-.583a.502.502 0 00-.599.175c-.34.485-.76.908-1.243 1.25a.5.5 0 00-.172.602l.596 1.425-1.41.595-.599-1.422a.5.5 0 00-.547-.3 5.235 5.235 0 01-1.768.01.497.497 0 00-.546.304l-.581 1.426-1.418-.578.583-1.428a.5.5 0 00-.175-.598 5.22 5.22 0 01-1.253-1.246.501.501 0 00-.6-.171l-1.425.598-.587-1.413 1.419-.6a.499.499 0 00.297-.546A5.19 5.19 0 012.85 7.13a.5.5 0 00-.304-.547L1.12 6.001l.583-1.414 1.426.58a.5.5 0 00.596-.174 5.225 5.225 0 011.249-1.25.5.5 0 00.172-.6l-.592-1.427 1.414-.59.592 1.425a.503.503 0 00.548.3 5.166 5.166 0 011.764-.004.51.51 0 00.545-.302l.589-1.427 1.418.585-.588 1.427a.499.499 0 00.175.6c.476.336.892.75 1.232 1.224a.501.501 0 00.6.168l1.42-.599.597 1.411-1.422.602a.5.5 0 00-.296.549c.104.583.108 1.18.01 1.764a.5.5 0 00.305.545l1.426.581-.576 1.424z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8 4.965a3.035 3.035 0 101.865 5.43l-.615-.79a2.034 2.034 0 11.625-.813l.922.389A3.036 3.036 0 008 4.965z","fill":"currentColor"}})]) } };

var iconGithub = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M5.355 12.868c0 .089-.06.138-.178.15C5.06 13.027 5 12.99 5 12.9c0-.088.054-.132.161-.132a.26.26 0 01.145.033c.033.022.049.044.049.066zm-1-.132c.021-.088.086-.116.193-.083.108.033.156.077.146.133a.154.154 0 01-.081.115.134.134 0 01-.13 0 .43.43 0 01-.112-.082c-.032-.033-.038-.06-.016-.083zm1.42-.066c.107 0 .166.033.177.1.01.065-.038.12-.146.165a.35.35 0 01-.112-.017c-.033-.011-.054-.05-.065-.116-.01-.066.038-.11.145-.132zM7.902 0c1.463 0 2.817.353 4.065 1.059a7.765 7.765 0 012.935 2.878C15.634 5.194 16 6.572 16 8.072c0 1.83-.5 3.468-1.5 4.912-1 1.445-2.306 2.443-3.92 2.994-.171.044-.306.022-.403-.066a.429.429 0 01-.145-.331v-2.779c0-.705-.183-1.213-.548-1.521.796-.089 1.387-.199 1.774-.331.602-.22 1.065-.552 1.387-.993.366-.573.549-1.356.549-2.348 0-.42-.076-.783-.226-1.092-.108-.22-.312-.496-.613-.827.086-.22.14-.485.161-.794a3.815 3.815 0 00-.226-1.456c-.215-.066-.516-.022-.903.133a8.69 8.69 0 00-.903.463l-.42.298a7.14 7.14 0 00-2.048-.298c-.699 0-1.37.1-2.016.298l-.42-.298a7.176 7.176 0 00-.935-.463c-.387-.155-.677-.199-.87-.133-.194.486-.27.97-.227 1.456 0 .309.043.562.13.76-.259.332-.447.635-.565.91-.118.276-.178.624-.178 1.043 0 .992.173 1.764.517 2.315.3.463.752.805 1.354 1.026.388.132.968.242 1.742.33-.28.265-.451.64-.516 1.125-.365.177-.72.243-1.064.199-.56-.044-.99-.342-1.29-.893a1.71 1.71 0 00-.517-.596 3.298 3.298 0 00-.484-.232l-.225-.033c-.237 0-.36.039-.371.116-.011.077.037.16.145.248l.161.133c.15.088.301.231.452.43.129.154.236.33.322.529l.13.265c.107.33.311.584.612.76.258.155.57.254.936.298.258.022.527.011.806-.033L6 13.563l.032 2.018a.429.429 0 01-.145.33c-.097.089-.231.111-.403.067-1.635-.551-2.957-1.55-3.968-2.994C.506 11.54 0 9.902 0 8.072c0-1.5.344-2.867 1.032-4.102a7.595 7.595 0 012.839-2.911C5.075.353 6.419 0 7.903 0zM3.13 11.413c.043-.044.097-.033.161.033.065.066.076.121.033.165-.043.044-.097.033-.162-.033-.064-.066-.075-.121-.032-.165zm-.355-.265c.043-.044.097-.05.161-.016.065.033.087.077.065.132-.022.055-.07.06-.145.017-.075-.045-.102-.089-.08-.133zm1.065 1.158c.021-.022.053-.028.096-.016a.247.247 0 01.177.182c.012.043.006.077-.015.099-.065.066-.14.055-.226-.033-.043-.045-.065-.089-.065-.133 0-.044.011-.077.033-.099zm-.387-.463c.043-.022.08-.028.113-.017.032.011.059.039.08.083.065.088.065.154 0 .198-.021.023-.048.023-.08 0a1.049 1.049 0 00-.113-.066c-.043-.11-.043-.176 0-.198z","fill":"currentColor"}})]) } };

var iconGlobe = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M16 7.999A7.978 7.978 0 008.544.072a2.093 2.093 0 00-1.089 0 7.942 7.942 0 00-.01 15.853c.363.1.747.1 1.11 0A7.978 7.978 0 0016 7.999zm-1.816-3.252H13v.994h1.615a6.804 6.804 0 010 4.515h-2.599c.11-.747.166-1.5.166-2.256a11.37 11.37 0 00-1.73-6.512 7.02 7.02 0 013.732 3.259zM8.391 14.939c-.13.007-.259.02-.391.02s-.261-.013-.391-.02c-.967-.292-1.914-1.638-2.418-3.689h5.617c-.504 2.051-1.451 3.397-2.417 3.689zM4.99 10.256a14.913 14.913 0 010-4.515H9.75v-.994H5.191c.506-2.056 1.457-3.402 2.426-3.689.128-.007.254-.02.383-.02.13 0 .255.013.383.02 1.414.419 2.799 3.098 2.799 6.942.001.755-.056 1.51-.172 2.256H4.99zm.558-8.767a8.891 8.891 0 00-1.379 3.258H1.816a7.02 7.02 0 013.731-3.258zM1.385 5.74h2.598a15.456 15.456 0 000 4.515H1.385a6.804 6.804 0 010-4.515zm.43 5.509h2.353a8.901 8.901 0 001.377 3.258 7.02 7.02 0 01-3.73-3.258zm8.64 3.258a8.9 8.9 0 001.376-3.258h2.354a7.02 7.02 0 01-3.73 3.258z","fill":"currentColor"}})]) } };

var iconGoogle = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M16 8.184c0-.544-.044-1.09-.14-1.626H8.16v3.08h4.409a3.7 3.7 0 01-1.632 2.431v2h2.63c1.545-1.394 2.433-3.452 2.433-5.885z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.162 16c2.2 0 4.057-.709 5.41-1.932l-2.63-1.998c-.732.487-1.677.764-2.777.764-2.13 0-3.935-1.408-4.583-3.301H.868v2.06C2.254 14.295 5.076 16 8.162 16z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M3.58 9.533a4.701 4.701 0 010-3.063V4.41H.867a7.864 7.864 0 000 7.184L3.58 9.533z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.162 3.166a4.485 4.485 0 013.13 1.2l2.33-2.284A7.933 7.933 0 008.163 0C5.076 0 2.254 1.705.868 4.41L3.58 6.47c.645-1.896 2.453-3.304 4.583-3.304z","fill":"currentColor"}})]) } };

var iconGradientCaseStudy = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46.115 35.793L63.413 53.05a1.997 1.997 0 010 2.828L58.777 60.5a2.008 2.008 0 01-2.835 0l-1.9-1.896a5.979 5.979 0 01-5.94 5.391H2.006a2.002 2.002 0 01-2.005-2V5.98A5.995 5.995 0 015.995 0h46.13a2.001 2.001 0 012.004 2v32.369h-4.01V3.999H5.995A1.984 1.984 0 004.01 5.98v54.016h44.093a1.989 1.989 0 001.99-1.983v-3.349L38.67 43.271a15.043 15.043 0 01-5.252 1.343A15.058 15.058 0 0117.412 30.58a15.067 15.067 0 0114.073-15.974 15.07 15.07 0 0116.003 14.038 14.86 14.86 0 01-1.373 7.15zm-17.229 4.27c1.375.466 2.827.656 4.275.56v-.001a11.043 11.043 0 0010.325-11.72 11.067 11.067 0 00-11.746-10.3 11.033 11.033 0 00-2.854 21.462zm13.245 1.003l15.228 15.192 1.801-1.795-15.212-15.176c-.032.038-.06.08-.086.12-.029.044-.058.089-.094.13a15.115 15.115 0 01-1.637 1.53zm3.952-25.878V10a2.003 2.003 0 00-2.005-2H9.942a2.001 2.001 0 00-2.005 2v10a2.001 2.001 0 002.005 2h4.225v-4h-2.22v-6h30.127v3.19h4.009zm-19.9 8.783a8.872 8.872 0 00-2.208 6.472l4.002-.258a4.931 4.931 0 014.616-5.24l-.258-3.991a8.901 8.901 0 00-6.152 3.017zm-13.786 2.258H7.992v4h4.405v-4zm-4.405 8.573h5.662v4H7.992v-4zM21.4 43.376H7.992v4H21.4v-4zM7.992 51.949H43.55v4H7.992v-4z","fill":"url(#assets-icon-gradient-case-study_svg__paint0_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-case-study_svg__paint0_linear","x1":"8.503","y1":"8.463","x2":"63.871","y2":"60.369","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientComment = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 65"}},[_c('path',{attrs:{"d":"M10.79 60a1.995 1.995 0 01-1.845-1.25 2.057 2.057 0 01.422-2.214 42.286 42.286 0 004.32-5.779c.817-1.35 2.753-5.968 2.753-5.968l3.334 1.584a37.262 37.262 0 01-2.61 6.392c-.517.919-1.082 1.81-1.695 2.667a40.12 40.12 0 005.238-1.447 16.536 16.536 0 006.637-4.412l.664-.65a1.99 1.99 0 011.476-.531c.828.053 1.667.08 2.516.081 15.437 0 28-9.064 28-20.204S47.437 8.065 32 8.065c-15.438 0-28 9.064-28 20.204a18.315 18.315 0 009.094 14.872l-2.188 3.403A22.296 22.296 0 010 28.269C0 14.888 14.355 4 32 4s32 10.888 32 24.27c0 13.38-14.355 24.268-32 24.268-.629 0-1.258-.014-1.875-.041a20.33 20.33 0 01-8.137 5.34A35.044 35.044 0 0110.79 60z","fill":"url(#assets-icon-gradient-comment_svg__paint0_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-comment_svg__paint0_linear","x1":"8.503","y1":"11.406","x2":"56.94","y2":"63.297","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientDocument = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"d":"M51.284 57.982A2.012 2.012 0 0149.28 60H11.43V6.01a1.988 1.988 0 01.59-1.424A1.964 1.964 0 0113.425 4l23.672.021v11.985a2.001 2.001 0 002 2h14.332a2 2 0 001.418-3.412L40.917.61a2.01 2.01 0 00-1.418-.588L13.425 0a6.005 6.005 0 00-5.996 6.01V62a1.999 1.999 0 002 2H49.28a6.016 6.016 0 006.004-6.018V21.77h-4v36.212zM41.097 6.461l7.515 7.545h-7.515V6.46z","fill":"url(#assets-icon-gradient-document_svg__paint0_linear)"}}),_c('path',{attrs:{"d":"M43.41 22.01h-24v4h24v-4z","fill":"url(#assets-icon-gradient-document_svg__paint1_linear)"}}),_c('path',{attrs:{"d":"M43.41 34.01h-24v4h24v-4z","fill":"url(#assets-icon-gradient-document_svg__paint2_linear)"}}),_c('path',{attrs:{"d":"M43.41 46.01h-24v4h24v-4z","fill":"url(#assets-icon-gradient-document_svg__paint3_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-document_svg__paint0_linear","x1":"13.806","y1":"8.464","x2":"66.02","y2":"45.173","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-document_svg__paint1_linear","x1":"13.806","y1":"8.464","x2":"66.02","y2":"45.173","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-document_svg__paint2_linear","x1":"13.806","y1":"8.464","x2":"66.02","y2":"45.173","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-document_svg__paint3_linear","x1":"13.806","y1":"8.464","x2":"66.02","y2":"45.173","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientExperience = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"d":"M18.6 60a79.638 79.638 0 001.516-16.955 14.405 14.405 0 00-3.177-8.559 19.484 19.484 0 01-4.11-12.656c.004-1.809.28-3.607.82-5.334a8.273 8.273 0 002.94-3.949 8.21 8.21 0 00.404-2.32 1.91 1.91 0 00.205-.159 17.347 17.347 0 015.931-4.464A17.643 17.643 0 0130.422 4c13.775 0 19.073 7.828 19.427 14.531a12.856 12.856 0 01-.636 3.953c-.268.83-.43 1.69-.48 2.559a6.937 6.937 0 002.049 4.318l1.088 1.391c.591.768 1.588 2.055 2.084 2.838-.337.107-.797.203-1.088.264-1 .207-3.073.637-3.073 2.625 0 .347.047.828.103 1.361.096.649.14 1.304.131 1.96a5.47 5.47 0 01-.715.65 4.06 4.06 0 00-1.626 1.771 3.969 3.969 0 00-.323 2.365c.416 1.447.19 2.383-.044 2.459a5.77 5.77 0 01-3.364-.697 8.152 8.152 0 00-4.674-.864c-3.637.729-4.348 4.078-4.559 6.916a58.302 58.302 0 00.223 7.56l.004.04-12.124-.094.036 4.094h13.41a2.87 2.87 0 001.124-.225 2.83 2.83 0 00.94-.646c.264-.275.468-.602.6-.96a2.73 2.73 0 00.164-1.114l-.096-1.375a56.262 56.262 0 01-.222-6.987c.226-3.072.905-3.209 1.314-3.29a6.409 6.409 0 012.343.657 8.885 8.885 0 006.155.782c2.51-.813 3.607-3.547 2.808-6.88.155-.142.366-.318.524-.449a5.58 5.58 0 001.87-2.236c.328-1.16.389-2.379.18-3.566 1.47-.314 4.273-1.074 4.273-3.973 0-1.22-.91-2.517-3.141-5.406l-1.136-1.451a5.058 5.058 0 01-1.172-1.838c.074-.518.19-1.028.346-1.527.529-1.68.786-3.432.762-5.192C53.43 9.204 45.985 0 30.421 0a21.569 21.569 0 00-14.573 5.688 8.415 8.415 0 00-4.615-3.74 8.651 8.651 0 00-7.108.758 8.454 8.454 0 00-2.658 2.472 8.253 8.253 0 00.554 10.108 8.502 8.502 0 002.913 2.177 8.643 8.643 0 003.575.775c.197 0 .38-.075.576-.089a22.17 22.17 0 00-.322 3.68 23.23 23.23 0 004.916 15.04 10.42 10.42 0 012.371 6.314 77.751 77.751 0 01-1.731 17.514c-.08.403-.645 3.203-.645 3.203l4.114.04L18.6 60zM7.09 14.008a4.453 4.453 0 01-1.504-.845 4.364 4.364 0 01-1.06-1.347 4.283 4.283 0 01-.231-3.332 4.387 4.387 0 011.626-2.153 4.529 4.529 0 014.627-.34 4.425 4.425 0 011.582 1.336 4.303 4.303 0 01.608 3.939 4.414 4.414 0 01-2.248 2.514 4.542 4.542 0 01-3.4.228z","fill":"url(#assets-icon-gradient-experience_svg__paint0_linear)"}}),_c('path',{attrs:{"d":"M61.3 20.006a2.337 2.337 0 00-1.458.848 2.259 2.259 0 00.257 3.092 2.343 2.343 0 003.452-.338 2.263 2.263 0 00.422-1.686l-.008-.049a2.302 2.302 0 00-.946-1.465 2.381 2.381 0 00-1.718-.402z","fill":"url(#assets-icon-gradient-experience_svg__paint1_linear)"}}),_c('path',{attrs:{"d":"M41.886 13.533a4.058 4.058 0 00-.411-1.597 4.122 4.122 0 00-1.015-1.31c-2.313-1.92-5.865-.613-9.192 1.936-3.721-1.964-7.444-2.663-9.393-.398a4.09 4.09 0 00-.775 1.459c-.155.531-.2 1.09-.13 1.64a12.257 12.257 0 002.926 5.93 12.186 12.186 0 00-1.855 6.317c.027.555.167 1.098.411 1.596.246.501.592.947 1.015 1.31v.003c.753.614 1.7.94 2.672.92a11.72 11.72 0 006.543-2.857 13.496 13.496 0 005.92 1.823 4.365 4.365 0 001.891-.325 4.3 4.3 0 001.56-1.102c.354-.429.617-.925.773-1.459.156-.532.2-1.09.132-1.64a12.248 12.248 0 00-2.927-5.93 12.19 12.19 0 001.855-6.316zm-4.107.084a5.185 5.185 0 01-.676 3.124c-.359-.327-.666-.666-1.051-.985-.364-.3-.75-.577-1.13-.862a6.939 6.939 0 012.857-1.277zm-5.55 9.925a26.144 26.144 0 01-3.345-2.77c.396-.547.829-1.108 1.33-1.692a25.43 25.43 0 011.482-1.58c.56.393 1.136.82 1.735 1.317a26.53 26.53 0 011.614 1.453 26.253 26.253 0 01-1.332 1.691 25.912 25.912 0 01-1.484 1.581zm-7.221-8.772a6.017 6.017 0 013.072.682c-.327.347-.663.687-.971 1.046-.326.38-.571.766-.869 1.15a5.945 5.945 0 01-1.232-2.878zm1.104 12.56a5.838 5.838 0 01.707-3.034c.36.328.669.669 1.056.99.367.303.77.564 1.153.852a5.85 5.85 0 01-2.916 1.192zm12.906-1.095a5.353 5.353 0 01-3.153-.648c.325-.343.648-.688.953-1.044.329-.382.576-.772.876-1.158a6.392 6.392 0 011.324 2.85z","fill":"url(#assets-icon-gradient-experience_svg__paint2_linear)"}}),_c('path',{attrs:{"d":"M4.507 41.323a3.112 3.112 0 00-1.943 1.13 3.007 3.007 0 00.342 4.115 3.12 3.12 0 004.597-.449 3.015 3.015 0 00.562-2.245l-.011-.065c-.148-.79-.6-1.49-1.26-1.95a3.169 3.169 0 00-2.287-.536z","fill":"url(#assets-icon-gradient-experience_svg__paint3_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-experience_svg__paint0_linear","x1":"8.502","y1":"8.464","x2":"63.875","y2":"60.368","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-experience_svg__paint1_linear","x1":"8.502","y1":"8.464","x2":"63.875","y2":"60.368","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-experience_svg__paint2_linear","x1":"8.502","y1":"8.464","x2":"63.875","y2":"60.368","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-experience_svg__paint3_linear","x1":"8.502","y1":"8.464","x2":"63.875","y2":"60.368","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientExperiment = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M58.687 29.016a4.715 4.715 0 01-2.355-.623l-26.5-15.172-3.656-.051a2.002 2.002 0 01-1.707-2.998l5.28-9.17A2 2 0 0131.458 0a2.077 2.077 0 011.73.953l1.942 3.16 26.445 15.145a4.791 4.791 0 012.246 2.935 5.433 5.433 0 01-.555 4.104l-.004.004a5.333 5.333 0 01-4.574 2.715zM29.637 9.219l.77.01c.338.005.67.095.964.263L58.316 24.92a1.18 1.18 0 001.48-.615c.192-.32.25-.7.164-1.063a.821.821 0 00-.371-.512L32.699 7.332a2.004 2.004 0 01-.71-.69l-.45-.73-1.902 3.307zm2.015 48.187H12.47a2.002 2.002 0 01-1.719-3.025l4.793-8.03a1.999 1.999 0 011.711-.974l9.441-.037h.008a2 2 0 011.703.953l4.95 8.066a1.998 1.998 0 01-1.704 3.047zm-15.66-4h12.086l-2.492-4.062-7.187.029-2.407 4.033zM4.911 64h34.296a4.934 4.934 0 004.304-2.477 4.61 4.61 0 00-.078-4.707l-14.388-23.72-3.982-.024v.613c0 .366.1.724.289 1.038l14.66 24.168a.622.622 0 01.015.67.904.904 0 01-.82.439H4.911a.892.892 0 01-.817-.441.625.625 0 01.012-.668L18.77 34.723a2.02 2.02 0 00.289-1.037v-5.434a1.997 1.997 0 00-2-2l-2.996.021a1.096 1.096 0 01-.402-.716 1.52 1.52 0 01.277-.639l16.144-.018c.208.16.345.397.38.657a1.94 1.94 0 01-.278.695h-3.121a1.997 1.997 0 00-2 2v2.008l5.12-.008a4.685 4.685 0 000-9.334H13.939a4.684 4.684 0 000 9.334h1.12v2.875L.685 56.817a4.617 4.617 0 00-.078 4.704A4.932 4.932 0 004.911 64z","fill":"url(#assets-icon-gradient-experiment_svg__paint0_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-experiment_svg__paint0_linear","x1":"8.502","y1":"8.464","x2":"63.875","y2":"60.368","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientGear = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M62.516 36.786a2.93 2.93 0 011.328 1.313c.204.6.208 1.25.012 1.854l-3.478 8.595a2.932 2.932 0 01-1.306 1.328 2.437 2.437 0 01-1.872.02l-5.733-2.346a24.658 24.658 0 01-3.685 3.705l2.384 5.706a2.453 2.453 0 01-1.306 3.197l-8.504 3.584a2.462 2.462 0 01-3.2-1.29l-2.408-5.716c-1.74.194-3.496.204-5.237.03l-2.334 5.714a2.926 2.926 0 01-1.309 1.327 2.425 2.425 0 01-1.884.005l-8.555-3.488a2.934 2.934 0 01-1.337-1.328 2.42 2.42 0 01.008-1.867l2.333-5.714a24.989 24.989 0 01-3.708-3.69l-5.71 2.4a2.96 2.96 0 01-1.884.003 2.453 2.453 0 01-1.333-1.338L.265 40.294a2.471 2.471 0 011.31-3.201l5.682-2.4a24.973 24.973 0 01-.02-5.24l-5.721-2.34a2.942 2.942 0 01-1.329-1.317 2.424 2.424 0 01.004-1.877l3.517-8.534.004-.008a2.447 2.447 0 013.17-1.324l5.725 2.332a24.58 24.58 0 013.701-3.705l-2.376-5.713a2.976 2.976 0 01.004-1.889A2.436 2.436 0 0115.27 3.76L23.777.217a2.448 2.448 0 013.201 1.32l2.376 5.701a24.817 24.817 0 015.222-.011l2.36-5.717a2.456 2.456 0 013.17-1.338l8.575 3.535a2.962 2.962 0 011.324 1.318c.207.609.208 1.268.004 1.877l-2.356 5.714a24.875 24.875 0 013.61 3.588l5.695-2.403a2.463 2.463 0 013.197 1.284l3.611 8.533c.205.605.21 1.26.012 1.867a2.43 2.43 0 01-1.31 1.328l-5.705 2.414c.197 1.737.209 3.49.035 5.229l5.718 2.33zm-10.963 6.477l5.702 2.332 2.306-5.694-5.706-2.324a2 2 0 01-1.22-2.18c.39-2.338.376-4.725-.042-7.058a1.999 1.999 0 011.188-2.194l5.69-2.408-2.392-5.645-5.682 2.397a2.008 2.008 0 01-2.4-.674 20.912 20.912 0 00-4.932-4.897 1.995 1.995 0 01-.7-2.398l2.353-5.708-5.675-2.341-2.356 5.707a2.038 2.038 0 01-2.18 1.21 20.688 20.688 0 00-7.06.016 2.014 2.014 0 01-2.192-1.2l-2.372-5.698-5.66 2.357 2.373 5.707a1.997 1.997 0 01-.692 2.399 20.903 20.903 0 00-4.995 5.002 2 2 0 01-2.388.7l-5.705-2.325-2.334 5.658 5.706 2.332a2.003 2.003 0 011.216 2.188 20.753 20.753 0 00.02 7.07 1.994 1.994 0 01-1.192 2.184l-5.68 2.4 2.35 5.655 5.702-2.394a2.006 2.006 0 012.403.683 20.88 20.88 0 005.014 4.987 2.003 2.003 0 01.7 2.392l-2.333 5.71 5.675 2.312 2.325-5.701a1.987 1.987 0 012.185-1.217c2.344.389 4.737.376 7.078-.037a2.003 2.003 0 012.188 1.195l2.396 5.688 5.643-2.377-2.384-5.703a1.999 1.999 0 01.688-2.405 20.614 20.614 0 004.975-5.002 2.01 2.01 0 012.396-.701zm-24.186-22.48a12.15 12.15 0 0110.391.52 12.15 12.15 0 016.351 9.568 12.142 12.142 0 01-.9 5.85l-3.69-1.554a8.132 8.132 0 00-2.301-9.425 8.14 8.14 0 00-12.852 3.497 8.132 8.132 0 002.797 9.29 8.142 8.142 0 004.852 1.609 8.056 8.056 0 005.003-1.717l2.462 3.156a12.034 12.034 0 01-7.465 2.561 12.15 12.15 0 01-11.22-7.494 12.137 12.137 0 016.572-15.862z","fill":"url(#assets-icon-gradient-gear_svg__paint0_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-gear_svg__paint0_linear","x1":"8.498","y1":"8.464","x2":"63.869","y2":"60.342","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientHand = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 68 64"}},[_c('path',{attrs:{"d":"M59.12 29.164a5.799 5.799 0 00-6.978.46c-2.428 2.045-10.97 8.978-10.97 8.98l2.546 3.095s8.588-6.972 11.027-9.029a1.746 1.746 0 012.097-.212 1.173 1.173 0 01.22 1.828 208.774 208.774 0 01-15.347 21.143l-.483.43a15.267 15.267 0 01-11.92 4.08 15.522 15.522 0 01-10.206-3.513 15.494 15.494 0 01-5.44-9.315 6.439 6.439 0 00-.216-.814v-30.07c0-.532.97-1.275 1.929-1.275 1.044 0 2.104.82 2.104 1.276v13.64h4.022V7.363a2.94 2.94 0 012.42-1.187c1.217 0 2.265.855 2.265 1.275v21.053h4.022V5.27c0-.398 1.076-1.274 2.226-1.274 1.072 0 2.011.794 2.011 1.274v23.857h4.022V7.45c0-.557.9-1.275 1.857-1.275 1.123 0 2.176.877 2.176 1.275v24.477h4.022V7.45a6.039 6.039 0 00-2.079-3.833 6.05 6.05 0 00-4.119-1.438 6.117 6.117 0 00-2.627.623A6.473 6.473 0 0032.438 0a6.76 6.76 0 00-5.518 2.897 7.047 7.047 0 00-2.996-.718c-3.04 0-6.44 2.21-6.44 5.167v3.977a6.556 6.556 0 00-2.106-.367 5.816 5.816 0 00-4.018 1.46 5.805 5.805 0 00-1.931 3.812v30.07a4.75 4.75 0 00.286 1.584 19.534 19.534 0 006.844 11.627 19.57 19.57 0 0012.753 4.427 19.052 19.052 0 0014.622-5.118l.436-.388a217.98 217.98 0 0015.964-21.822 5.075 5.075 0 001.033-3.936 5.202 5.202 0 00-2.247-3.508z","fill":"url(#assets-icon-gradient-hand_svg__paint0_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-hand_svg__paint0_linear","x1":"16.337","y1":"8.464","x2":"69.83","y2":"49.206","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientHeart = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"d":"M6 24.482C6 15.395 12.273 8 19.98 8a13.184 13.184 0 0110.43 5.541 2.073 2.073 0 003.192-.002A13.161 13.161 0 0144.023 8C51.73 8 58 15.395 58 24.482v.614h4v-.614C62 13.188 53.937 4 44.023 4a16.763 16.763 0 00-12.019 5.268A16.785 16.785 0 0019.981 4C10.066 4 2 13.188 2 24.482v.614h4v-.614z","fill":"url(#assets-icon-gradient-heart_svg__paint0_linear)"}}),_c('path',{attrs:{"d":"M32 57.49A106.04 106.04 0 019.672 34.762l-3.383 2.136a112.88 112.88 0 0024.527 24.715 2.003 2.003 0 002.363.002 112.161 112.161 0 0024.493-24.63l-3.383-2.141A105.583 105.583 0 0132 57.49z","fill":"url(#assets-icon-gradient-heart_svg__paint1_linear)"}}),_c('path',{attrs:{"d":"M43.543 28.582a2 2 0 00-1.867 1.281l-1.016 2.641-3.586-15.025a2.002 2.002 0 00-1.933-1.536h-.012a2.006 2.006 0 00-1.941 1.512l-4.262 16.932-3.188-13.36a2.001 2.001 0 00-1.812-1.531 1.966 1.966 0 00-2 1.277l-2.84 7.373H0v4h20.46a2 2 0 001.868-1.28l1.016-2.642L26.93 43.25a2.002 2.002 0 001.933 1.535h.012a2.004 2.004 0 001.941-1.512l4.262-16.931 3.188 13.36a2 2 0 001.812 1.53 2.076 2.076 0 002-1.277l2.84-7.373H64v-4H43.543z","fill":"url(#assets-icon-gradient-heart_svg__paint2_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-heart_svg__paint0_linear","x1":"9.971","y1":"6.79","x2":"22","y2":"38.858","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-heart_svg__paint1_linear","x1":"13.116","y1":"38.364","x2":"33.353","y2":"74.151","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-heart_svg__paint2_linear","x1":"8.503","y1":"19.758","x2":"28.032","y2":"60.381","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientLab = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('g',{attrs:{"clip-path":"url(#assets-icon-gradient-lab_svg__clip0)"}},[_c('path',{attrs:{"d":"M62.877 54.272L38.735 19.994v-6.178h-4v6.811c.002.412.129.814.364 1.152l24.509 34.797a1.958 1.958 0 01.152 2.11A2.518 2.518 0 0157.455 60H6.543a2.518 2.518 0 01-2.304-1.314 1.952 1.952 0 01.156-2.11L28.9 21.78c.237-.338.364-.742.363-1.156l-.02-12.14a1.999 1.999 0 00-1.999-1.997h-4.199a.929.929 0 01-.933-.921v-.641A.929.929 0 0123.045 4h17.908a.93.93 0 01.934.924v.64a.929.929 0 01-.934.922h-8.221v4h8.221a4.934 4.934 0 004.934-4.921v-.641A4.935 4.935 0 0040.953 0H23.045a4.935 4.935 0 00-4.933 4.924v.64a4.933 4.933 0 004.933 4.922h2.203l.016 9.508L1.126 54.272a5.936 5.936 0 00-.437 6.253A6.53 6.53 0 006.543 64h50.912a6.53 6.53 0 005.855-3.475 5.944 5.944 0 00-.433-6.253z","fill":"url(#assets-icon-gradient-lab_svg__paint0_linear)"}}),_c('path',{attrs:{"d":"M23.46 36.004L11.262 53.236a2 2 0 001.633 3.157H51.37a2.001 2.001 0 001.633-3.157L40.802 36.004a2.002 2.002 0 00-1.633-.844H25.093a2.002 2.002 0 00-1.633.844zm14.674 3.156l9.37 13.232H16.762l9.366-13.232h12.006z","fill":"url(#assets-icon-gradient-lab_svg__paint1_linear)"}})]),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-lab_svg__paint0_linear","x1":"8.503","y1":"8.464","x2":"63.875","y2":"60.369","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-lab_svg__paint1_linear","x1":"16.538","y1":"37.968","x2":"31.824","y2":"66.634","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('clipPath',{attrs:{"id":"assets-icon-gradient-lab_svg__clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h64v64H0z"}})])],1)]) } };

var iconGradientNetworking = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"d":"M55 18v-4H41.88V0h-4v14h-12V0h-4v14H9v4h3v8a20 20 0 0012 18.28V52a2 2 0 002 2h4v10h4V54h4a2 2 0 002-2v-7.64a20 20 0 0012-18.28v-4h-4v4a16 16 0 11-32 0v-8L55 18zM36 45.68V50h-8v-4.32c1.318.256 2.657.39 4 .4a21.879 21.879 0 004-.4z","fill":"url(#assets-icon-gradient-networking_svg__paint0_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-networking_svg__paint0_linear","x1":"15.111","y1":"8.464","x2":"66.537","y2":"43.112","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientPlaylist = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"d":"M19.2 50.32l14.6-8a2.4 2.4 0 001.28-2.08 2.36 2.36 0 00-1.28-2.08l-14.6-8a2.36 2.36 0 00-3.56 2.12v15.76A2.36 2.36 0 0018 50.48a2.56 2.56 0 001.2-.16zm.44-15.24l9.6 5.24-9.6 5.2V35.08z","fill":"url(#assets-icon-gradient-playlist_svg__paint0_linear)"}}),_c('path',{attrs:{"d":"M58.28 6H19.12a2 2 0 00-2 2v6.32h-6.28a2 2 0 00-2 2v8a2 2 0 002 2h30.84a1.76 1.76 0 011.8 1.72V54H5.76A1.76 1.76 0 014 52.28V22.2H2a2 2 0 00-2 2v28A5.76 5.76 0 005.76 58h39.72a2 2 0 002-2v-6.32h6.24a2 2 0 002-2v-6.32H62a2 2 0 002-2V11.68A5.72 5.72 0 0058.28 6zm-6.56 39.68h-4.24V27.92a5.76 5.76 0 00-5.8-5.72H12.84v-4H50a1.677 1.677 0 011.72 1.68v25.8zM60 37.36h-4.28V20A5.682 5.682 0 0050 14.32H21.12V10h37.16A1.68 1.68 0 0160 11.68v25.68z","fill":"url(#assets-icon-gradient-playlist_svg__paint1_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-playlist_svg__paint0_linear","x1":"18.222","y1":"32.565","x2":"35.995","y2":"48.242","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-playlist_svg__paint1_linear","x1":"8.503","y1":"12.877","x2":"53.13","y2":"64.364","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientSearch = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"d":"M8.012 21.372h3.997a9.758 9.758 0 012.83-6.678 9.7 9.7 0 016.645-2.865v-4.01a13.692 13.692 0 00-9.472 4.04 13.775 13.775 0 00-4 9.513z","fill":"url(#assets-icon-gradient-search_svg__paint0_linear)"}}),_c('path',{attrs:{"d":"M62.102 53.09l-17.83-17.843-2.798 2.847 17.83 17.844a2.33 2.33 0 01.68 1.644 2.412 2.412 0 01-.72 1.724 2.278 2.278 0 01-2.53.516 2.278 2.278 0 01-.748-.516L34.837 38.134A21.464 21.464 0 0042.392 25.5a21.51 21.51 0 00-2.35-14.542 21.407 21.407 0 00-11.145-9.594 21.328 21.328 0 00-14.687-.12 21.404 21.404 0 00-11.302 9.408A21.508 21.508 0 00.321 25.154 21.467 21.467 0 007.668 37.91a21.35 21.35 0 0013.817 4.996 21.178 21.178 0 009.914-2.527l21.748 21.734A6.314 6.314 0 0057.645 64a6.3 6.3 0 004.497-1.887A6.297 6.297 0 0064 57.642a6.314 6.314 0 00-1.858-4.471l-.04-.08zM4.014 21.373A17.601 17.601 0 016.95 11.6a17.522 17.522 0 017.856-6.486 17.461 17.461 0 0110.126-1.01c3.4.677 6.524 2.35 8.975 4.81a17.58 17.58 0 014.794 9.002c.675 3.41.325 6.945-1.006 10.156a17.552 17.552 0 01-6.466 7.88 17.473 17.473 0 01-22.085-2.2 17.59 17.59 0 01-5.129-12.38z","fill":"url(#assets-icon-gradient-search_svg__paint1_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-search_svg__paint0_linear","x1":"8.503","y1":"8.464","x2":"63.875","y2":"60.37","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-search_svg__paint1_linear","x1":"8.503","y1":"8.464","x2":"63.875","y2":"60.37","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientServices = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"d":"M9.077 64a1.89 1.89 0 01-1.405-.6L.608 56.312a1.922 1.922 0 01-.45-2.164c.105-.241.258-.459.45-.638L18.95 35.135a15.3 15.3 0 01-.562-4.003c0-3.848 1.53-7.538 4.253-10.262a14.587 14.587 0 0110.276-4.271c2.156.005 4.283.497 6.221 1.441a2.046 2.046 0 011.124 1.482 1.837 1.837 0 01-.562 1.721l-7.064 7.086 3.09 3.083 7.064-7.046a2.006 2.006 0 012.605-.196c.256.188.464.433.606.716a14.381 14.381 0 01-.727 14.032 14.434 14.434 0 01-5.299 4.977 14.477 14.477 0 01-7.058 1.769 14 14 0 01-4.014-.6l-9.512 9.728 5.54 3.483c.233.08.487.08.721 0a1.084 1.084 0 00.643-.68L28.1 52.91a2.083 2.083 0 012.167-1.28c2.338.32 4.713.238 7.024-.241a2.051 2.051 0 012.247 1.12l2.047 4.485a1.04 1.04 0 00.683.6.964.964 0 00.883 0l3.37-1.521a1.202 1.202 0 00.603-1.521l-2.047-4.484a2.037 2.037 0 01.642-2.442 20.599 20.599 0 004.776-5.085 2.006 2.006 0 012.368-.8l4.616 1.721a1.166 1.166 0 001.525-.72l1.204-3.483a1.157 1.157 0 00-.682-1.522l-4.696-1.761a2.006 2.006 0 01-1.285-2.162 21.643 21.643 0 00-.28-7.006 1.957 1.957 0 011.123-2.202l4.495-2.082a1.164 1.164 0 00.677-1.117 1.157 1.157 0 00-.115-.444l-1.525-3.323a1.08 1.08 0 00-.682-.64.966.966 0 00-.883 0l-4.495 2.041a2.011 2.011 0 01-2.448-.6 20.65 20.65 0 00-5.017-4.684 2.043 2.043 0 01-.803-2.403l1.766-4.604a1.159 1.159 0 00-.682-1.48l-3.452-1.322a1.206 1.206 0 00-1.565.68l-1.726 4.685a1.963 1.963 0 01-2.167 1.28 20.437 20.437 0 00-6.984.241 2.011 2.011 0 01-2.248-1.121L24.49 5.229a1.203 1.203 0 00-1.566-.6l-3.371 1.52a1.202 1.202 0 00-.602 1.562l2.047 4.484a1.956 1.956 0 01-.602 2.442 20.235 20.235 0 00-4.816 5.325 2.007 2.007 0 01-2.368.76l-4.616-1.921a1.207 1.207 0 00-1.525.68l-1.284 3.443a1.159 1.159 0 00.682 1.522l4.615 1.721a2.045 2.045 0 011.285 2.162 20.566 20.566 0 00.24 7.006 1.958 1.958 0 01-1.123 2.202l-8.67 4.004a3.995 3.995 0 011.008-4.748c.441-.38.96-.658 1.521-.817l3.05-1.401a24.64 24.64 0 010-5.165l-3.17-1.161a5.22 5.22 0 01-3.026-2.688 5.194 5.194 0 01-.185-4.038l1.324-3.443a5.162 5.162 0 012.7-2.899A5.19 5.19 0 0110 15.038l3.17 1.2a26.475 26.475 0 013.532-4.003l-1.364-3.042a5.152 5.152 0 01-.066-3.86 5.17 5.17 0 012.634-2.826L21.278.985a5.23 5.23 0 013.934-.104 5.213 5.213 0 012.889 2.667l1.405 3.082c1.72-.18 3.456-.18 5.177 0l1.445-3.323A5.21 5.21 0 0138.77.493a5.23 5.23 0 013.86-.228l3.451 1.321a5.252 5.252 0 012.822 2.751 5.233 5.233 0 01.108 3.935l-1.164 3.162a24.493 24.493 0 013.653 3.403l3.09-1.4a5.27 5.27 0 014.014 0 5.14 5.14 0 012.93 2.722l1.525 3.322a5.193 5.193 0 01.158 3.963 5.21 5.21 0 01-2.687 2.923l-3.09 1.402c.18 1.716.18 3.447 0 5.164l3.17 1.201a5.18 5.18 0 012.925 2.708 5.154 5.154 0 01.126 3.978l-1.044 3.163a5.202 5.202 0 01-2.71 2.926 5.228 5.228 0 01-3.992.156l-3.171-1.2a24.36 24.36 0 01-3.532 3.802l1.405 3.043a5.196 5.196 0 01-2.449 6.966l-3.33 1.521a5.187 5.187 0 01-6.904-2.562l-1.405-3.042c-1.72.18-3.456.18-5.177 0l-1.204 3.162a5.123 5.123 0 01-2.692 2.915 5.148 5.148 0 01-3.97.128h-.402l-7.947-4.964a2.086 2.086 0 01-.923-1.442 2.238 2.238 0 01.562-1.641l12.04-12.37a2.048 2.048 0 012.208-.481c1.271.526 2.637.785 4.013.76 2.8 0 5.485-1.109 7.464-3.083a10.516 10.516 0 003.092-7.445c.04-.547.04-1.096 0-1.642l-6.462 6.165a2.049 2.049 0 01-1.404.6 2.049 2.049 0 01-1.405-.6l-5.94-5.925a2 2 0 010-2.802l6.18-6.206a10.58 10.58 0 00-5.425.597 10.553 10.553 0 00-4.402 3.22 10.516 10.516 0 00-1.611 10.396 1.917 1.917 0 01-.441 2.122L4.863 54.912l4.013 4.244 2.85 2.842-1.445 1.441a1.97 1.97 0 01-1.204.56z","fill":"url(#assets-icon-gradient-services_svg__paint0_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-services_svg__paint0_linear","x1":"8.503","y1":"8.464","x2":"63.875","y2":"60.37","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientSpeakerSeries = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"d":"M53.288 24.857h.028a3.787 3.787 0 10-.028 0zm.028-4l.2.225h-.427a.226.226 0 01.227-.225z","fill":"url(#assets-icon-gradient-speaker-series_svg__paint0_linear)"}}),_c('path',{attrs:{"d":"M62 37.346h-.466l-.101-7.698a1.958 1.958 0 00-.309-1.039l-2.668-4.242-3.382 2.13 2.367 3.765.092 7.084H49.91v-7.018c0-4.508-7.196-6.828-9.403-7.432l-1.058 3.858c3.418.941 6.46 2.783 6.46 3.574v7.018H16.1l-.006-6.953a18.454 18.454 0 018.648-4.338 4.576 4.576 0 003.586-4.774 1.995 1.995 0 00-.758-1.566 8.955 8.955 0 01-3.078-7.24C24.492 7.88 27.422 4 30.886 4c3.524 0 6.391 3.8 6.391 8.475 0 4.722-2.926 8.71-6.39 8.71v4a11.74 11.74 0 0010.39-12.71A11.45 11.45 0 0030.887 0a11.591 11.591 0 00-10.395 12.475 13.17 13.17 0 003.629 9.515c-.153.1-.32.176-.496.225-3.465.982-11.524 3.742-11.524 8.113v7.018H2a1.999 1.999 0 00-2 2v8.705a1.999 1.999 0 002 2h51.601v7.97A1.996 1.996 0 0151.593 60H12.461a2.047 2.047 0 01-2.059-2.031v-3.961h-4v3.961A6.052 6.052 0 0012.461 64h39.132a6 6 0 006.008-5.978V50.05h4.398a2.001 2.001 0 002-2v-8.705a1.999 1.999 0 00-2-2zm-2 8.705H4v-4.705h56v4.705z","fill":"url(#assets-icon-gradient-speaker-series_svg__paint1_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-speaker-series_svg__paint0_linear","x1":"8.503","y1":"8.464","x2":"63.875","y2":"60.369","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-speaker-series_svg__paint1_linear","x1":"8.503","y1":"8.464","x2":"63.875","y2":"60.369","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientTechnology = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41.998 12.04h.48a5.78 5.78 0 004.077-2.127 5.983 5.983 0 001.44-4.373 6.031 6.031 0 00-1.276-3.256A5.996 5.996 0 0043.855.29a5.975 5.975 0 00-6.414 1.84 5.983 5.983 0 00-1.439 4.373c.012.133.012.268 0 .401l-13.511 8.225a2.003 2.003 0 00-.96 1.726v12.037h3.998V17.938L38 10.475a5.945 5.945 0 003.997 1.565zm-.755-7.806c.234-.125.491-.2.755-.219.504-.001.99.188 1.36.53a2.009 2.009 0 01.547 2.088 1.927 1.927 0 01-.388.672 2 2 0 01-1.359.722 2.074 2.074 0 01-1.441-.496 2.089 2.089 0 01-.718-1.35 1.932 1.932 0 01.64-1.444c.165-.208.37-.38.604-.503zM14.816 15.77h.48v-.04c.982-.079 1.93-.4 2.76-.934a6.034 6.034 0 00.189-10.003 5.983 5.983 0 00-9.132 3.09 5.959 5.959 0 00-.253 2.35c.12 1.505.8 2.909 1.902 3.934a5.984 5.984 0 004.054 1.603zM13.457 8.43a2.036 2.036 0 011.36-.682v.04a1.994 1.994 0 011.448.457c.404.338.66.823.71 1.348a1.931 1.931 0 01-.48 1.445 1.959 1.959 0 01-1.359.682 1.994 1.994 0 01-1.449-.458 2.008 2.008 0 01-.71-1.348 1.972 1.972 0 01.48-1.484zm33.579 40.337V32.1l-8.315-5.055-4.717 2.809v5.617a2.012 2.012 0 01-.96 1.725L26.25 41.21a1.954 1.954 0 01-2.039 0L13.937 34.95a2.003 2.003 0 01-.96-1.725V19.182h3.998v12.92l8.275 5.055 4.757-2.849v-5.617a1.931 1.931 0 01.999-1.725l6.716-4.013a1.952 1.952 0 012.038 0l10.274 6.26a2.043 2.043 0 01.96 1.725v17.774a6 6 0 013.115 2.516 6.036 6.036 0 01-.951 7.507 5.985 5.985 0 01-3.644 1.653h-.48a5.984 5.984 0 01-4.053-1.603 6.027 6.027 0 01-1.903-3.934 5.835 5.835 0 01.927-3.757 5.799 5.799 0 013.03-2.328zm2.95 7.413c-.234.117-.49.184-.752.197h.16a1.992 1.992 0 01-1.926-1.086 2.012 2.012 0 01.247-2.204 2.036 2.036 0 011.36-.682c.503-.002.989.187 1.36.53a2.009 2.009 0 01.547 2.087 1.928 1.928 0 01-.388.673 1.879 1.879 0 01-.608.485zm-28.414-4.016a6.014 6.014 0 014.517 1.525l12.472-7.423V35.31h3.998v12.037a2.012 2.012 0 01-1 1.726l-13.591 8.024v.401a5.797 5.797 0 01-1.4 4.374 6.03 6.03 0 01-3.997 2.126h-.48a5.94 5.94 0 01-3.25-.923 5.971 5.971 0 01-2.228-2.55 5.998 5.998 0 01.922-6.437 5.797 5.797 0 014.037-1.926zm.64 8.025a2.036 2.036 0 001.356-.71c.343-.405.516-.927.482-1.457a2.01 2.01 0 00-.639-1.316 1.995 1.995 0 00-1.36-.53 1.794 1.794 0 00-1.358.723 1.927 1.927 0 00-.48 1.444c.065.494.3.95.666 1.287.365.337.837.535 1.332.559zm29.78-33.303a5.881 5.881 0 010-1.685l-9.994-6.219 1.999-3.41 10.194 6.178a5.904 5.904 0 013.317-1.324 5.976 5.976 0 014.373 1.402 6.013 6.013 0 012.103 4.095 6.154 6.154 0 01-1.439 4.414 5.95 5.95 0 01-3.997 2.086h-.56a5.983 5.983 0 01-4.079-1.59 6.027 6.027 0 01-1.917-3.947zm6.156 1.525a2.01 2.01 0 00.93-3.7 1.993 1.993 0 00-1.09-.312 1.954 1.954 0 00-1.359.682 1.924 1.924 0 00-.64 1.484c.051.529.305 1.017.708 1.361.402.345.923.519 1.451.485zm-19.974-9.417l-2.038-3.452-7.329 4.359 2.039 3.452 7.328-4.359zM1.463 33.947a5.8 5.8 0 013.997-2.086 6.015 6.015 0 014.414 1.384 6.053 6.053 0 012.142 4.113 8.05 8.05 0 010 1.725l10.434 6.38-2.079 3.45-10.433-6.42a5.904 5.904 0 01-3.318 1.324h-.48a5.983 5.983 0 01-4.142-1.533A6.026 6.026 0 01.024 38.32a5.798 5.798 0 011.439-4.373zm4.717 5.898a1.794 1.794 0 001.36-.722 1.928 1.928 0 00.479-1.444 2.01 2.01 0 00-.64-1.317 1.995 1.995 0 00-1.359-.53 2.036 2.036 0 00-1.356.71A2.051 2.051 0 004.18 38c.057.497.29.957.658 1.296.367.339.843.534 1.34.55zm29.463 4.16l-2.04-3.45-8.285 4.936 2.04 3.45 8.285-4.935z","fill":"url(#assets-icon-gradient-technology_svg__paint0_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-technology_svg__paint0_linear","x1":"8.503","y1":"8.464","x2":"63.875","y2":"60.37","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientTraining = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"d":"M41.222.491a33.51 33.51 0 00-23.964 4.913 16.816 16.816 0 00-7.55 13.74c.03 1.56.217 3.112.56 4.634 0 .48.2 1.118.24 1.478l-.88 1.198a31.077 31.077 0 00-5.55 8.468 2.836 2.836 0 00.518 2.396 5.631 5.631 0 004.234 1.638 7.43 7.43 0 00-.56 3.195c.141 1.007.571 1.95 1.24 2.716.012.16.012.32 0 .48a7.99 7.99 0 00.798 6.67 8.267 8.267 0 007.11 1.798 31.03 31.03 0 015.591-.28 35.63 35.63 0 01-.24 7.989 1.957 1.957 0 00.48 1.597 1.959 1.959 0 001.518.68h15.976v-3.795h-13.74c.28-2.956.44-7.989-1.158-9.347-1.598-1.358-6.87-.958-8.987-.679a4.514 4.514 0 01-3.515-.48 6.631 6.631 0 01.24-3.155 5.67 5.67 0 00.2-1.198 3.995 3.995 0 00-1.039-2.716 3.032 3.032 0 01-.439-.639c.161-.894.43-1.766.799-2.596.223-.515.397-1.05.519-1.598a2.237 2.237 0 00-.48-1.558c-.678-.799-1.597-.839-2.955-.918H8.471c1.038-1.918 3.594-5.073 4.353-6.271a17.46 17.46 0 001.278-1.798c.64-1.038.4-2.197 0-3.994a19.97 19.97 0 01-.479-3.994A12.662 12.662 0 0119.614 8.56a29.835 29.835 0 0121.05-3.994A18.412 18.412 0 0156 23.059c0 8.947-2.716 11.983-4.713 14.06a18.413 18.413 0 00-1.478 1.797 36.429 36.429 0 00-5.073 18.533V64h3.994v-6.47a32.593 32.593 0 014.394-16.337c.337-.456.71-.884 1.118-1.278 2.277-2.597 5.752-6.351 5.752-16.856A22.368 22.368 0 0041.222.49z","fill":"url(#assets-icon-gradient-training_svg__paint0_linear)"}}),_c('path',{attrs:{"d":"M44.538 26.055v3.994a5.99 5.99 0 002.916-11.184 6.151 6.151 0 00-1.558-5.632 6.072 6.072 0 00-5.871-1.518 6.27 6.27 0 00-10.864 0 5.99 5.99 0 00-5.791 1.518 6.071 6.071 0 00-1.598 5.632 5.992 5.992 0 002.956 11.184h6.31a5.951 5.951 0 005.592 3.994h1.957v5.992h3.994v-7.989a1.997 1.997 0 00-1.997-1.997H36.59a1.957 1.957 0 01-1.917-1.997 1.997 1.997 0 011.957-1.997V22.06a5.99 5.99 0 00-5.592 3.994h-6.27a1.997 1.997 0 01-1.958-1.997 2.037 2.037 0 011.239-1.918 2.078 2.078 0 001.597 0 2.157 2.157 0 00.919-2.316 1.718 1.718 0 00-.799-1.199 1.998 1.998 0 01.48-2.556 1.957 1.957 0 012.755 0 2.037 2.037 0 002.157.44 1.997 1.997 0 001.238-1.838 2.356 2.356 0 013.994-1.438 1.878 1.878 0 01.6 1.398 1.998 1.998 0 001.238 1.878 2.038 2.038 0 002.037-.44 1.916 1.916 0 012.795 0 1.997 1.997 0 01.24 2.477 2.995 2.995 0 00-.799 1.318 1.996 1.996 0 002.676 2.316 2.022 2.022 0 11-.639 3.995v-.12z","fill":"url(#assets-icon-gradient-training_svg__paint1_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-training_svg__paint0_linear","x1":"11.44","y1":"8.464","x2":"65.856","y2":"53.097","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-training_svg__paint1_linear","x1":"22.979","y1":"12.738","x2":"50.208","y2":"38.449","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientUpload = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"d":"M51.32 20.32c-.44-5.007-2.665-9.662-6.24-13.051C41.507 3.879 36.843 2 32.002 2s-9.504 1.88-13.078 5.269c-3.574 3.39-5.8 8.044-6.24 13.05-3.137.523-5.973 2.249-7.945 4.838-1.972 2.588-2.937 5.852-2.705 9.144.232 3.293 1.645 6.375 3.959 8.638 2.314 2.262 5.361 3.54 8.539 3.582h11.406V42.35H14.532c-2.3 0-4.507-.95-6.134-2.64-1.627-1.69-2.541-3.982-2.541-6.372 0-2.39.914-4.682 2.54-6.372 1.628-1.69 3.834-2.64 6.135-2.64a1.97 1.97 0 001.42-.61c.376-.392.588-.923.588-1.476 0-4.238 1.62-8.303 4.505-11.3 2.885-2.996 6.797-4.68 10.877-4.68 4.08 0 7.992 1.684 10.877 4.68 2.884 2.998 4.505 7.062 4.505 11.3 0 .553.212 1.084.588 1.475.377.391.887.611 1.42.611 2.3 0 4.507.95 6.134 2.64 1.627 1.69 2.54 3.982 2.54 6.372 0 2.39-.913 4.682-2.54 6.372-1.627 1.69-3.833 2.64-6.134 2.64H37.986v4.172h11.406c3.184-.022 6.244-1.286 8.573-3.542 2.328-2.256 3.755-5.339 3.998-8.637.243-3.298-.717-6.57-2.688-9.168-1.972-2.597-4.811-4.33-7.955-4.854z","fill":"url(#assets-icon-gradient-upload_svg__paint0_linear)"}}),_c('path',{attrs:{"d":"M42.486 34.172l2.851-2.921-12.049-12.517a2.009 2.009 0 00-1.425-.6c-.532 0-1.044.215-1.426.6L18.388 31.251l2.852 2.92 8.715-8.845V62h4.016V25.326l8.515 8.846z","fill":"url(#assets-icon-gradient-upload_svg__paint1_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-upload_svg__paint0_linear","x1":"9.971","y1":"9.935","x2":"61.883","y2":"58.597","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-upload_svg__paint1_linear","x1":"9.971","y1":"9.935","x2":"61.883","y2":"58.597","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientWebinar = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"d":"M51.303 44.019h-9.436v3.98h9.436v-3.98z","fill":"url(#assets-icon-gradient-webinar_svg__paint0_linear)"}}),_c('path',{attrs:{"d":"M51.303 36.485h-9.436v3.98h9.436v-3.98z","fill":"url(#assets-icon-gradient-webinar_svg__paint1_linear)"}}),_c('path',{attrs:{"d":"M44.44 20.718a1.995 1.995 0 01-1.727.1 1.985 1.985 0 01-1.227-1.84V9.473a1.988 1.988 0 012.954-1.74l8.544 4.753a1.993 1.993 0 010 3.479l-8.544 4.754z","fill":"url(#assets-icon-gradient-webinar_svg__paint2_linear)"}}),_c('path',{attrs:{"d":"M61.609 54.118h-1.223V28.837h-3.975v25.281H7.191l.168-33.906h18.477v-3.98H7.359a4.193 4.193 0 00-4.145 4.229v33.657H1.987A1.986 1.986 0 000 56.108C0 59.782.737 64 6.486 64h50.267c4.603 0 6.843-2.581 6.843-7.892a1.988 1.988 0 00-1.987-1.99zm-4.856 5.901H6.486c-1.277 0-2.104 0-2.395-1.92h55.383c-.36 1.92-1.359 1.92-2.721 1.92z","fill":"url(#assets-icon-gradient-webinar_svg__paint3_linear)"}}),_c('path',{attrs:{"d":"M36.053 25.865a17.005 17.005 0 01-2.477 2.657 2.642 2.642 0 00-.544 2.552 2.336 2.336 0 002.158 1.518 18.492 18.492 0 006.204-1.25 11.464 11.464 0 004.328-2.869c.19.006.383.008.578.008 9.758 0 17.7-6.389 17.7-14.242C64 6.386 56.058 0 46.3 0S28.6 6.387 28.6 14.24a13.664 13.664 0 007.453 11.625zM46.3 3.98c7.57 0 13.726 4.603 13.726 10.26 0 5.658-6.157 10.26-13.726 10.26-.419 0-.838-.014-1.246-.043a2.068 2.068 0 00-1.526.564l-.372.381a7.71 7.71 0 01-3.61 2.37c.088-.147.168-.298.24-.454.344-.732.551-1.52.614-2.326a1.995 1.995 0 00-1.165-1.965 10.19 10.19 0 01-6.66-8.788C32.574 8.583 38.73 3.98 46.3 3.98z","fill":"url(#assets-icon-gradient-webinar_svg__paint4_linear)"}}),_c('path',{attrs:{"d":"M15.138 40.497a12.1 12.1 0 00-3.578 8.111 1.99 1.99 0 001.987 1.979h20.196a1.992 1.992 0 001.987-1.927 9.286 9.286 0 00-4.056-8.023c-.756-.413-1.55-.75-2.373-1.008a9.1 9.1 0 001.496-5.023 7.8 7.8 0 00-7.15-8.304 7.803 7.803 0 00-7.154 8.303 7.802 7.802 0 007.15 8.303c2.116-.22 4.25.205 6.121 1.22a3.884 3.884 0 011.723 2.478H15.915a7.991 7.991 0 011.995-3.26l-2.772-2.849zm8.508-1.569c-1.723 0-3.178-1.978-3.178-4.322 0-2.345 1.455-4.323 3.178-4.323 1.72 0 3.176 1.979 3.176 4.322 0 2.344-1.456 4.323-3.175 4.323z","fill":"url(#assets-icon-gradient-webinar_svg__paint5_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-webinar_svg__paint0_linear","x1":"8.503","y1":"8.464","x2":"63.875","y2":"60.37","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-webinar_svg__paint1_linear","x1":"8.503","y1":"8.464","x2":"63.875","y2":"60.37","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-webinar_svg__paint2_linear","x1":"8.503","y1":"8.464","x2":"63.875","y2":"60.37","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-webinar_svg__paint3_linear","x1":"8.503","y1":"8.464","x2":"63.875","y2":"60.37","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-webinar_svg__paint4_linear","x1":"8.503","y1":"8.464","x2":"63.875","y2":"60.37","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1),_c('linearGradient',{attrs:{"id":"assets-icon-gradient-webinar_svg__paint5_linear","x1":"8.503","y1":"8.464","x2":"63.875","y2":"60.37","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGradientWorkshop = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 65 64"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41.207 31.212l21.64 21.22a3.927 3.927 0 011.16 2.766 3.91 3.91 0 01-.315 1.522 3.948 3.948 0 01-.885 1.284l-2.96 2.924a4.027 4.027 0 01-2.72 1.054 4.027 4.027 0 01-2.72-1.054l-21.24-21.575-12.4 12.17v.514a9.333 9.333 0 01-2.344 6.777 9.563 9.563 0 01-6.496 3.18h-.6a9.512 9.512 0 01-6.768-2.507 9.282 9.282 0 01-2.992-6.502 9.266 9.266 0 012.539-6.687 9.496 9.496 0 016.581-2.954 8.09 8.09 0 011.68 0l12.52-12.408-.24-.237-8.44-8.575c-.6-.553-1.28-.395-1.76 0s-.48.553-.48 1.185a2.423 2.423 0 01-.68 2.095c-.8.83-1.64 1.62-2.48 2.41a2.51 2.51 0 01-2.2.632 3.02 3.02 0 01-1.28-.513 39.787 39.787 0 01-5.48-5.216 20.302 20.302 0 01-1.48-2.095 2.465 2.465 0 01.32-3.003c.72-.75 1.44-1.501 2.24-2.252a3.582 3.582 0 011.84-.79 3 3 0 01.84 0c1.28-.277 2.32-1.265 2.32-2.213-.05-1.01.294-2 .96-2.766l.48-.514a13.152 13.152 0 013.52-3.043 20.211 20.211 0 0114.36-2.291 18.58 18.58 0 014.68 1.738 2.044 2.044 0 011.16 1.067 1.875 1.875 0 01-.56 1.66l-1.08 1.106a2.913 2.913 0 01-2.44.83h-1.12a12.147 12.147 0 00-2.36 0c-1.44 0-1.44 0-2.8 1.383a3.61 3.61 0 01-.224.294c-.187.227-.274.331-.096.654l1 .988 1.64 1.66-2.84 2.766-.32-.316c-2.84-2.648-2.84-2.766-2.84-3.082a4.264 4.264 0 01-.594-2.927 4.294 4.294 0 011.474-2.606 14.491 14.491 0 011.84-1.738 17.025 17.025 0 00-6.8 2.173 10.434 10.434 0 00-2.52 2.292l-.52.553a6.473 6.473 0 01-1.524 4.094 6.616 6.616 0 01-3.796 2.229c-.33.056-.669.056-1 0-.434.317-.848.66-1.24 1.027l.52.672a55.674 55.674 0 004 3.951l1.04-1.067c-.06-.809.092-1.62.442-2.354a4.717 4.717 0 011.558-1.834 4.93 4.93 0 011.68-1.01 4.975 4.975 0 013.847.214c.594.29 1.122.695 1.553 1.19l38.04 38.607 2.88-2.806-14.08-14.146A3640.704 3640.704 0 0034.921 30.22c-3.34-3.29-6.455-6.359-9.074-8.964l-.4-.435 2.8-2.766.44.435c.518.51.957.949 1.386 1.377.832.83 1.628 1.626 2.894 2.85l8-7.902V14.3c-.22-1.38-.162-2.79.175-4.146a10.454 10.454 0 011.785-3.757 10.387 10.387 0 013.034-2.858 10.52 10.52 0 013.926-1.45c.97-.119 1.95-.119 2.92 0a8.076 8.076 0 012.76.752c.397.178.745.446 1.016.783.27.336.457.731.544 1.153.06.427.014.861-.132 1.267-.146.406-.389.77-.708 1.064l-4.36 3.557.4 1.936 1.8.632.52-.435 2.4-2.015a5.05 5.05 0 012.2-1.343 2.59 2.59 0 012.08.553 2.58 2.58 0 01.8 1.936c.156.89.156 1.798 0 2.687a10.826 10.826 0 01-3.08 5.69 10.803 10.803 0 01-5.8 3.003c-1.258.2-2.541.2-3.8 0l-8.24 7.903zm3.48-14.264l-9 8.85 2.68 2.648 9.08-8.89c.257-.255.58-.434.932-.518a1.984 1.984 0 011.068.043 6.314 6.314 0 003.12 0 6.868 6.868 0 003.68-1.896 7.392 7.392 0 001.36-1.858l-.36.316-1.36 1.146a1.97 1.97 0 01-1.96.396l-4-1.383a1.961 1.961 0 01-.889-.604 1.926 1.926 0 01-.43-.977l-.68-4.228a1.992 1.992 0 01.68-1.66l2.84-2.292h-.88c-.897.165-1.75.51-2.507 1.013a6.638 6.638 0 00-1.894 1.911 6.447 6.447 0 00-1.14 2.364 6.403 6.403 0 00-.1 2.615c.062.334.142.664.24.988a1.874 1.874 0 01-.48 2.016zm-28.03 33.42c.091-.326.267-.622.51-.86l13.16-13.12-2.68-2.686-13.32 13.08a1.984 1.984 0 01-1.84.514H10.847a5.52 5.52 0 00-2.995 1.094 5.417 5.417 0 00-1.868 2.559 5.351 5.351 0 00-.107 3.153 5.405 5.405 0 001.69 2.677 5.766 5.766 0 004 1.304 5.494 5.494 0 002.057-.542 5.434 5.434 0 001.688-1.28 5.358 5.358 0 001.062-1.823c.23-.67.322-1.379.273-2.085.042-.328.042-.66 0-.988a1.914 1.914 0 01.01-.997zm-7.45 2.578l.6-2.094 2.12-.554 1.56 1.541-.56 2.095-2.16.553-1.56-1.541z","fill":"url(#assets-icon-gradient-workshop_svg__paint0_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"assets-icon-gradient-workshop_svg__paint0_linear","x1":"8.504","y1":"9.935","x2":"60.524","y2":"61.955","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#EE282A"}}),_c('stop',{attrs:{"offset":".493","stop-color":"#1C0087"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0086EA"}})],1)],1)]) } };

var iconGraphPieEmpty = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.995 15.972A8 8 0 017.28.004L7.37 1A6.994 6.994 0 108.585.996L8.667 0a8 8 0 01-.672 15.972z","fill":"currentColor"}})]) } };

var iconGraphPieFull = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.52 2.185A8.01 8.01 0 008.666 0l-.082.998c1.799.15 3.47.99 4.666 2.345a7.025 7.025 0 01-.385 9.7 6.999 6.999 0 01-9.69.035A7.023 7.023 0 017.37 1.002L7.28.004a7.995 7.995 0 00-5.305 2.71 8.023 8.023 0 00.494 11.062 7.993 7.993 0 0012.994-2.902 8.027 8.027 0 00-1.944-8.69z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8 13.966a6 6 0 100-12 6 6 0 000 12z","fill":"currentColor"}})]) } };

var iconGraphPieHalf = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M2.48 2.212A7.996 7.996 0 019.539.15a7.993 7.993 0 015.758 4.578 8.026 8.026 0 01-3.04 10.07A7.99 7.99 0 018.668 16l-.084-.997a6.995 6.995 0 004.51-2.18 7.018 7.018 0 00-.027-9.647 6.996 6.996 0 00-4.9-2.172A7.032 7.032 0 003.17 2.937a7.015 7.015 0 00-1.78 7.386 7.012 7.012 0 002.304 3.218 6.993 6.993 0 003.676 1.456l-.09.998a7.991 7.991 0 01-4.202-1.663 8.027 8.027 0 01-.598-12.12z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14 7.967a6 6 0 01-6 6v-12a6 6 0 016 6z","fill":"currentColor"}})]) } };

var iconGraphPieOneFourth = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('g',{attrs:{"clip-path":"url(#assets-icon-graph-pie-one-fourth_svg__clip0)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M2.485 2.205A8.019 8.019 0 0110.859.517a8.012 8.012 0 013.555 2.665A7.993 7.993 0 0116 7.328l-.998.083a7.009 7.009 0 00-2.345-4.673 7.032 7.032 0 00-9.71.381 7.007 7.007 0 00-.04 9.701 7.03 7.03 0 0012.09-4.194l.998.09a7.996 7.996 0 01-2.573 5.184A8.021 8.021 0 01.539 10.88a7.987 7.987 0 011.946-8.675z"}}),_c('path',{attrs:{"d":"M14.023 8c0-1.591-.63-3.117-1.75-4.243A5.966 5.966 0 008.045 2l-.023 6h6z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"assets-icon-graph-pie-one-fourth_svg__clip0"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h16v15.996H0z"}})])])]) } };

var iconGraphPieThreeFourths = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}},[_c('path',{attrs:{"d":"M1.069 9.117a7.447 7.447 0 002.492 4.965 7.473 7.473 0 0010.318-.405 7.446 7.446 0 00.041-10.308A7.47 7.47 0 001.074 7.827L.014 7.73a8.49 8.49 0 012.885-5.638 8.52 8.52 0 0111.758.551 8.487 8.487 0 01-.041 11.75 8.517 8.517 0 01-11.762.47A8.49 8.49 0 01.009 9.205l1.06-.088z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.887 8.468a6.372 6.372 0 01-12.743 0l6.371.024V2.097a6.372 6.372 0 016.372 6.371z","fill":"currentColor"}})]) } };

var iconGridView = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M15.51 5.169h-2.002V.512a.489.489 0 00-.19-.39.48.48 0 00-.43-.11l-4.423 1.13a.51.51 0 00-.38.49.51.51 0 00.38.479l4.003 1v1.998h-2.002a.5.5 0 00-.5.5v2.247H5.503a.5.5 0 00-.5.5v2.178H.5a.5.5 0 00-.5.47V15.5a.5.5 0 00.5.5H14.01v-1h-3.002V6.169h4.002V16h.49a.5.5 0 00.501-.5V5.668a.5.5 0 00-.49-.5zm-3.002-3.997v.999l-1.881-.47 1.88-.53zM1 11.533h4.002v3.468H1.001v-3.467zm5.003-.529V8.856h4.002V15H6.004v-3.997z","fill":"currentColor"}})]) } };

var iconHamburger = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M16 2.5H0v1h16v-1zM13 7.5H0v1h13v-1zM16 12.5H0v1h16v-1z","fill":"currentColor"}})]) } };

var iconHand = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M14.423 7.298a1.449 1.449 0 00-1.745.116c-.607.511-2.742 2.246-2.742 2.247l.636.774s2.147-1.745 2.757-2.26a.437.437 0 01.524-.052.292.292 0 01.055.457 52.241 52.241 0 01-3.836 5.291l-.121.107A3.816 3.816 0 016.97 15a3.878 3.878 0 01-3.912-3.21 1.622 1.622 0 00-.054-.204V4.06c0-.133.243-.32.482-.32.262 0 .527.206.527.32v3.414h1.005V1.842a.735.735 0 01.605-.297c.304 0 .566.214.566.32v5.268h1.006V1.319c0-.1.269-.319.556-.319.268 0 .503.199.503.319v5.97h1.006V1.864c0-.139.224-.319.464-.319.28 0 .544.22.544.32V7.99h1.005V1.864A1.512 1.512 0 009.724.545a1.528 1.528 0 00-.656.156A1.619 1.619 0 007.752 0a1.689 1.689 0 00-1.38.725 1.76 1.76 0 00-.748-.18c-.76 0-1.61.553-1.61 1.293v.995c-.17-.059-.347-.09-.527-.091A1.453 1.453 0 002 4.06v7.525c.001.135.025.27.072.396A4.89 4.89 0 006.97 16a4.758 4.758 0 003.655-1.28l.11-.098a54.533 54.533 0 003.99-5.46 1.27 1.27 0 00.07-1.483 1.302 1.302 0 00-.373-.38z","fill":"currentColor"}})]) } };

var iconHappyFace = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M8.002 16a8 8 0 115.09-14.17l-.64.77a6.9 6.9 0 10.91.89l.76-.64A8 8 0 018.002 16z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.002 12.55a4.71 4.71 0 01-4.33-2.84l.91-.4a3.73 3.73 0 006.86 0l.92.39a4.71 4.71 0 01-4.36 2.85zM4.992 7.04a.99.99 0 100-1.98.99.99 0 000 1.98zM11.002 7.04a.99.99 0 100-1.98.99.99 0 000 1.98z","fill":"currentColor"}})]) } };

var iconHeart = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M1.5 6.12C1.5 3.85 3.068 2 4.995 2a3.296 3.296 0 012.608 1.385.518.518 0 00.797 0A3.29 3.29 0 0111.006 2C12.933 2 14.5 3.849 14.5 6.12v.154h1V6.12C15.5 3.297 13.484 1 11.006 1A4.19 4.19 0 008 2.317 4.196 4.196 0 004.995 1C2.517 1 .5 3.297.5 6.12v.154h1V6.12zM8 14.373A26.512 26.512 0 012.418 8.69l-.846.535a28.22 28.22 0 006.132 6.178.5.5 0 00.59 0 28.041 28.041 0 006.124-6.157l-.846-.535A26.396 26.396 0 018 14.373z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.886 7.146a.5.5 0 00-.467.32l-.254.66-.896-3.756a.5.5 0 00-.484-.384h-.003a.502.502 0 00-.485.378L7.23 8.597l-.796-3.34a.5.5 0 00-.954-.064l-.71 1.844H0v1h5.115a.5.5 0 00.467-.32l.254-.66.896 3.755a.5.5 0 00.484.384h.003a.5.5 0 00.485-.378L8.77 6.585l.796 3.34a.5.5 0 00.454.383.52.52 0 00.5-.32l.71-1.842H16v-1h-5.114z","fill":"currentColor"}})]) } };

var iconHideVideo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.94 3.905a.503.503 0 00-.289-.452.466.466 0 00-.528.07l-3.985 3.38a.532.532 0 00-.18.39v4.622H4.893L15.94.837l-.747-.712-3.467 3.489a1.353 1.353 0 00-.2-.27 1.53 1.53 0 00-1.065-.442H.498A.497.497 0 000 3.403v.502h10.46a.485.485 0 01.36.15.473.473 0 01.139.33l-7.482 7.53H1.484a.497.497 0 01-.498-.501V4.907H0v6.507c0 .399.157.781.438 1.063.28.282.66.44 1.056.44h.997L.249 15.164l.707.712 2.99-3.008h7.511a.497.497 0 00.498-.5V9.608l3.228 2.697a.467.467 0 00.528.07.489.489 0 00.289-.451l-.06-8.02zm-3.985 4.4v-.781l2.989-2.547v5.875l-2.989-2.546z","fill":"currentColor"}})]) } };

var iconHome = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M16 7.646L8.359.146a.516.516 0 00-.72 0L5.191 2.547V1.273a.505.505 0 00-.51-.5H2.217a.505.505 0 00-.51.5V6L0 7.643l.714.714 1.86-1.79a.496.496 0 00.152-.358V1.773h1.447v1.952a.502.502 0 00.204.433.517.517 0 00.7-.083l2.922-2.868 5.272 5.175V15H9.845v-3.456a.504.504 0 00-.51-.5H6.662a.505.505 0 00-.51.5V15H2.727V8.94H1.707v6.56a.504.504 0 00.51.5H6.66a.505.505 0 00.51-.5v-3.456h1.655V15.5a.504.504 0 00.51.5h4.444a.505.505 0 00.51-.5V7.382l.99.972.72-.708z","fill":"currentColor"}})]) } };

var iconIdBadge = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M4.16 10.15s-1.8.54-1.8 1.18v.62a.07.07 0 00.07.06h5.85s.08 0 .08-.06v-.62c0-.64-1.75-1.15-1.75-1.15a.53.53 0 01-.41-.53h-.09a2.25 2.25 0 00.76-1.75c0-1.13-.68-2.05-1.51-2.05s-1.51.92-1.51 2.05a2.27 2.27 0 00.69 1.72.47.47 0 01-.38.53z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 3.36H15v9.27a.89.89 0 01-.93.84H1V5.23a.89.89 0 01.93-.85H6A1.5 1.5 0 007.5 5.6h1A1.51 1.51 0 0010 4.38h3.47v-1H10V2.01a.5.5 0 00-.5-.51h-3a.51.51 0 00-.5.51v1.35H1.93A1.9 1.9 0 000 5.23v8.76a.5.5 0 00.5.51h13.57A1.91 1.91 0 0016 12.63V3.87a.501.501 0 00-.5-.51zM7 2.5h2v1.56a.51.51 0 01-.5.52h-1a.51.51 0 01-.5-.52V2.5z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13 7.14H9v1.03h4V7.14zM12 9.18H9v1.03h3V9.18z","fill":"currentColor"}})]) } };

var iconImageBreak = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M3.286 6.857a1.461 1.461 0 10-1.48-1.461 1.472 1.472 0 001.48 1.46zm0-1.924a.463.463 0 11-.48.463.473.473 0 01.48-.463z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.095 0l-.362 1.345H.5a.499.499 0 00-.5.5v9.808a.5.5 0 00.5.498h.832l.02.021.022-.02h3.458l-.504 1.874.967.259L9.062.258 8.095 0zm-.63 2.344L5.935 8.04l-.645-.549a.502.502 0 00-.678.027L1 11.113v-8.77h6.465zm-5.089 8.81L4.992 8.55l.657.559-.55 2.044H2.377zM15.5 2.97h-4.206l.268-.996-.967-.259-3.767 14.027.967.258.597-2.223H15.5a.498.498 0 00.5-.499V3.47a.5.5 0 00-.5-.5zm-.5.999v5.324l-1.424-1.288a.5.5 0 00-.673.001l-2.905 2.649-.625-.532 1.653-6.154H15zm-6.34 8.81l.426-1.589.599.51a.5.5 0 00.66-.011l2.896-2.64L15 10.64v2.14H8.66z","fill":"currentColor"}})]) } };

var iconImageLink = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M.499 11.014H15.46a.496.496 0 00.5-.499v-.505l-14.569.006 4.654-3.725 2.222 1.523a.498.498 0 00.577-.01l3.87-2.836 2.248 1.636v2.409h.997V.499A.5.5 0 0015.461 0H1.494A1.496 1.496 0 000 1.494v9.021a.498.498 0 00.499.499zM1.494.998h13.469V5.37l-1.956-1.423a.499.499 0 00-.589 0L8.54 6.792 6.305 5.26a.497.497 0 00-.594.023L.998 9.055v-7.56a.498.498 0 01.496-.498z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M3.992 4.849a1.647 1.647 0 10-1.659-1.647A1.654 1.654 0 003.992 4.85zm0-2.296a.65.65 0 11-.661.65.656.656 0 01.661-.65zM13.972 12H10.92a1.998 1.998 0 00-1.93 1.501H6.995a1.999 1.999 0 00-1.93-1.5H2.013a2 2 0 100 3.999h3.05a1.998 1.998 0 001.93-1.501h1.999A1.998 1.998 0 0010.92 16h3.051a2 2 0 100-4zm-8.908 3.002H2.013a1.002 1.002 0 010-2.004h3.05a.99.99 0 01.851.503H4.592v.998h1.322a.99.99 0 01-.85.503zm8.908 0H10.92a.99.99 0 01-.85-.503h1.321V13.5h-1.32a.989.989 0 01.849-.503h3.051a1.003 1.003 0 110 2.005z","fill":"currentColor"}})]) } };

var iconImageRepeater = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 4.487h-1.273V2.684a.5.5 0 00-.5-.5h-1.19V.5a.5.5 0 00-.5-.5H.5a.5.5 0 00-.5.5v9.513a.5.5 0 00.5.5h11.537a.5.5 0 00.5-.5v-6.83h.69v8.514H3.064a.37.37 0 01-.375-.366h-1a1.372 1.372 0 001.375 1.366h10.654a.515.515 0 00.509-.51v-6.7H15V14H4.838a.37.37 0 01-.374-.365h-1A1.37 1.37 0 004.838 15H15.49a.515.515 0 00.509-.509V4.987a.5.5 0 00-.5-.5zM11.537 1v4.353l-1.282-1.169a.5.5 0 00-.675.002L6.697 6.834 5.086 5.45a.5.5 0 00-.68.027L1 8.892V1h10.537zM1.794 9.513l2.992-3.002 1.596 1.371a.5.5 0 00.664-.01l2.873-2.64 1.618 1.475v2.806H1.794z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M3.143 4.861A1.433 1.433 0 101.7 3.428a1.44 1.44 0 001.443 1.433zm0-1.866a.433.433 0 11-.443.433.439.439 0 01.443-.433z","fill":"currentColor"}})]) } };

var iconImage = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M2.53 4.352a1.97 1.97 0 103.94-.005 1.97 1.97 0 00-3.94.005zm2.94 0a.97.97 0 11-1.94-.005.97.97 0 011.94.005z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16 7.999V.5a.5.5 0 00-.5-.5H1.503A1.504 1.504 0 000 1.503V15.5a.5.5 0 00.5.5h14a1.501 1.501 0 001.5-1.5l-.001-4.623a.501.501 0 00-.192-.395L12.81 7.147a.5.5 0 00-.616.001l-4.24 3.33-2.45-1.797a.503.503 0 00-.622.025L1 12.062V1.502A.503.503 0 011.503 1H15v6.999h1zM1.008 13.377l4.226-3.654 2.434 1.786a.498.498 0 00.604-.01l4.232-3.323 2.495 1.945.001 4.38a.5.5 0 01-.5.499H1v-1.632l.008.01z","fill":"currentColor"}})]) } };

var iconIndustry = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}},[_c('path',{attrs:{"d":"M16.552 8.449a27.765 27.765 0 00-4.075-2.022.528.528 0 00-.688.232.54.54 0 00-.065.258v.868L7.995 6.411a.527.527 0 00-.653.258.54.54 0 00-.06.248v.864l-3.655-1.37a.525.525 0 00-.655.257.541.541 0 00-.06.249v1.19a1.471 1.471 0 00-.996 1.375v6.198A1.347 1.347 0 003.286 17h12.182a1.5 1.5 0 001.528-1.466V9.482a1.428 1.428 0 00-.444-1.033zm-.618 7.085a.439.439 0 01-.466.388H3.286a.285.285 0 01-.308-.242V9.482a.433.433 0 01.466-.388.535.535 0 00.53-.54v-.863L7.63 9.06a.528.528 0 00.655-.258.542.542 0 00.06-.248v-.869l3.728 1.375a.52.52 0 00.487-.065.541.541 0 00.226-.441v-.796c1.474.693 2.882 1.374 3.034 1.47a.356.356 0 01.114.253v6.052z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.992 9.835H10.96l-.014.003-.015-.003h-3.03l-.015.003-.014-.003H4.84a.535.535 0 00-.531.539v2.343a.535.535 0 00.53.539h3.032l.014-.003.015.003h3.031l.015-.003.013.003h3.032a.534.534 0 00.531-.539v-2.343a.534.534 0 00-.53-.54zm-6.651 2.343H5.37v-1.266h1.97v1.266zm3.06 0h-1.97v-1.266h1.97v1.266zm3.06 0h-1.97v-1.266h1.97v1.266zM3.702 1.088l.27 4.918 1.06-.06L4.745.718a.823.823 0 00-.914-.712H1.707A.826.826 0 00.793.71L.002 16a.905.905 0 00.902.965h.466v-1.077h-.3l.767-14.804 1.865.004zM6.843 1.084l1.866.004.288 5.202 1.06-.06L9.75.713a.826.826 0 00-.914-.707H6.714A.826.826 0 005.8.709l-.307 5.57 1.06.06.29-5.255z","fill":"currentColor"}})]) } };

var iconInfrastructureModernization = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.999 14.923L5.326 13.38l-.5.866 2.923 1.686a.5.5 0 00.5 0l2.77-1.598-.5-.866-2.52 1.454zM13.822 6.998h1V4.14a.502.502 0 00-.25-.433l-2.391-1.381-.5.866 2.141 1.237v2.57zM2.116 4.429L4.26 3.192l-.5-.866-2.393 1.38a.5.5 0 00-.25.434v2.858h1v-2.57zM7.232 11.49V8.463a.5.5 0 00-.25-.433L4.366 6.52a.502.502 0 00-.5 0L1.25 8.031a.5.5 0 00-.25.433v3.025a.5.5 0 00.25.433l2.616 1.51a.5.5 0 00.5 0l2.616-1.51a.5.5 0 00.25-.433zm-1-.29l-2.116 1.221L2 11.201V8.752l2.116-1.22 2.116 1.22v2.449zM14.75 8.03l-2.616-1.509a.502.502 0 00-.5 0l-2.617 1.51a.501.501 0 00-.25.433v3.025a.501.501 0 00.25.433l2.617 1.51a.5.5 0 00.5 0l2.616-1.51a.5.5 0 00.25-.433V8.464a.5.5 0 00-.25-.433zM14 11.2l-2.116 1.221-2.117-1.22V8.752l2.117-1.221L14 8.752v2.449zM7.749 6.977a.5.5 0 00.5 0l2.616-1.51a.5.5 0 00.25-.432V2.009a.501.501 0 00-.25-.433L8.248.066a.502.502 0 00-.5 0l-2.616 1.51a.501.501 0 00-.25.433v3.026a.5.5 0 00.25.433l2.617 1.509zm-1.867-4.68l2.116-1.22 2.117 1.221v2.448L8 5.966l-2.117-1.22V2.297z","fill":"currentColor"}})]) } };

var iconInfrastructureServices = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.002 3.802L7.867.057a.501.501 0 00-.466 0L.268 3.802A.501.501 0 000 4.245v7.51a.5.5 0 00.268.442l7.134 3.746a.5.5 0 00.465 0l6.036-3.17-.465-.885-5.803 3.047L1 11.452V4.548l1.376-.723 5.258-2.76 6.636 3.483v6.903l.46.89.272-.144a.502.502 0 00.268-.443V4.245a.502.502 0 00-.268-.443z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.768 11.06a.64.64 0 00.439 0 .651.651 0 00.31-.313l.56-1.387a.627.627 0 00-.313-.743l-.802-.327a4.217 4.217 0 00-.004-.618l.8-.339a.575.575 0 00.305-.748l-.584-1.38a.577.577 0 00-.748-.3l-.8.337c-.13-.149-.27-.289-.42-.418l.329-.797a.576.576 0 00.003-.441.652.652 0 00-.312-.312l-1.378-.568a.574.574 0 00-.749.31l-.33.803a4.12 4.12 0 00-.617 0l-.335-.805a.575.575 0 00-.747-.303l-1.378.573a.58.58 0 00-.307.748l.334.803a4.121 4.121 0 00-.437.438l-.799-.326a.641.641 0 00-.44 0 .641.641 0 00-.308.31l-.57 1.382a.64.64 0 00.003.437.65.65 0 00.31.306l.803.329c-.015.206-.014.413.003.62l-.798.336a.573.573 0 00-.307.748l.572 1.377a.573.573 0 00.75.306l.801-.337c.135.156.281.302.438.436l-.33.807a.574.574 0 00.314.743l1.378.562a.57.57 0 00.441 0 .645.645 0 00.308-.311l.327-.803c.206.015.413.014.62-.003l.337.803a.576.576 0 00.748.303l1.378-.58a.572.572 0 00.301-.746l-.335-.802c.156-.135.301-.281.436-.437l.8.326zm-1.372-1.221a3.163 3.163 0 01-.76.765.5.5 0 00-.172.6l.316.76-.585.246-.318-.756a.5.5 0 00-.547-.299 3.154 3.154 0 01-1.083.006.5.5 0 00-.546.305l-.308.757-.59-.24.311-.758a.5.5 0 00-.176-.598 3.205 3.205 0 01-.766-.763.5.5 0 00-.6-.172l-.758.319-.244-.587.755-.32a.5.5 0 00.299-.545 3.206 3.206 0 01-.004-1.084.5.5 0 00-.304-.546l-.757-.31.242-.587.758.31a.5.5 0 00.597-.175 3.21 3.21 0 01.764-.765.5.5 0 00.174-.6l-.316-.76.587-.244.315.757a.497.497 0 00.548.3 3.153 3.153 0 011.08-.002.508.508 0 00.544-.303l.313-.758.59.243-.313.759a.499.499 0 00.175.6c.292.205.547.459.755.75a.501.501 0 00.6.167l.754-.319.248.587-.755.32a.5.5 0 00-.297.548c.063.357.065.723.007 1.081a.5.5 0 00.304.545l.757.308-.24.591-.755-.309a.502.502 0 00-.599.176z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.773 6.326a1.68 1.68 0 10.002 3.362 1.68 1.68 0 00-.002-3.362zm0 2.362a.681.681 0 11.002-1.362.681.681 0 01-.002 1.362z","fill":"currentColor"}})]) } };

var iconInsightEasy = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M8.002 10.272a.836.836 0 00-.348.078L4.98 8.817l-.495.877 2.68 1.536c.021.21.118.404.272.546a.845.845 0 00.565.224.854.854 0 00.606-.253.867.867 0 000-1.222.854.854 0 00-.606-.253zM15.839 10.38a8.014 8.014 0 00-2.162-4.04l-.708.714a6.961 6.961 0 011.504 2.264c.349.848.527 1.756.526 2.673H16c0-.541-.054-1.08-.161-1.61zM9.667 4.162a7.971 7.971 0 00-3.196 0l.202.988a6.986 6.986 0 012.794 0c.885.183 1.727.54 2.475 1.05l.562-.835a7.861 7.861 0 00-2.837-1.203zM5.574 6.18L4.89 4.556A8.072 8.072 0 000 11.99h1.752A6.346 6.346 0 012.82 8.467a6.284 6.284 0 012.754-2.286z","fill":"currentColor"}})]) } };

var iconInsightHard = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M11.02 8.817L8.346 10.35a.836.836 0 00-.954.175.867.867 0 000 1.222c.16.162.379.253.606.253a.845.845 0 00.565-.223.858.858 0 00.272-.547l2.68-1.536-.495-.877zM1.355 7.523A7.998 7.998 0 000 11.992h1.001a6.967 6.967 0 011.183-3.905c.25-.37.533-.717.847-1.034l-.708-.713c-.36.362-.684.758-.968 1.183zM9.328 5.15l.2-.989a8.001 8.001 0 00-3.195 0 7.841 7.841 0 00-2.836 1.203l.56.836a6.848 6.848 0 012.476-1.05 7.026 7.026 0 012.795 0zM15.837 10.366a8.071 8.071 0 00-4.727-5.812l-.685 1.626c.744.317 1.42.776 1.99 1.352a6.314 6.314 0 011.833 4.46H16c0-.547-.054-1.091-.163-1.626z","fill":"currentColor"}})]) } };

var iconInsightMedium = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8.5 10.377V7.329h-1v3.037a.833.833 0 00-.362.67.828.828 0 00.25.594.855.855 0 00.604.246.867.867 0 00.604-.246.84.84 0 00.25-.594.818.818 0 00-.346-.66zM15.838 10.415a7.755 7.755 0 00-1.205-2.816 7.993 7.993 0 00-.976-1.164l-.707.695a6.88 6.88 0 011.5 2.19A6.827 6.827 0 0115 12h1c0-.533-.055-1.063-.162-1.585zM9.61 4.159a8.245 8.245 0 00-3.221 0 7.997 7.997 0 00-2.863 1.185l.98 1.426a6.263 6.263 0 012.233-.924 6.45 6.45 0 012.52 0 6.268 6.268 0 012.234.924l.98-1.426A8.023 8.023 0 009.61 4.16zM1.367 7.6a7.79 7.79 0 00-1.205 2.815A7.85 7.85 0 000 12h1a6.826 6.826 0 01.55-2.68 6.817 6.817 0 011.5-2.19l-.707-.695a7.99 7.99 0 00-.976 1.164z","fill":"currentColor"}})]) } };

var iconInstagram = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 3.893c.738 0 1.423.184 2.054.553a4.12 4.12 0 011.5 1.5c.369.631.553 1.316.553 2.054 0 .738-.184 1.423-.553 2.054a4.12 4.12 0 01-1.5 1.5A3.997 3.997 0 018 12.107a3.997 3.997 0 01-2.054-.553 4.12 4.12 0 01-1.5-1.5A3.997 3.997 0 013.893 8c0-.738.184-1.423.553-2.054a4.12 4.12 0 011.5-1.5A3.997 3.997 0 018 3.893zm0 6.786a2.58 2.58 0 001.893-.786A2.58 2.58 0 0010.679 8a2.58 2.58 0 00-.786-1.893A2.58 2.58 0 008 5.321a2.58 2.58 0 00-1.893.786A2.58 2.58 0 005.321 8c0 .738.262 1.369.786 1.893A2.58 2.58 0 008 10.679zm5.25-6.965a1.113 1.113 0 01-.304.679.87.87 0 01-.66.286.927.927 0 01-.679-.286.927.927 0 01-.286-.679c0-.262.096-.488.286-.678a.927.927 0 01.679-.286c.262 0 .488.095.678.286.19.19.286.416.286.678zm2.714.965C15.988 5.345 16 6.452 16 8c0 1.548-.018 2.66-.054 3.34-.035.678-.136 1.267-.303 1.767a4.163 4.163 0 01-.982 1.554c-.44.44-.959.768-1.554.982-.5.166-1.09.268-1.768.303C10.661 15.982 9.548 16 8 16s-2.66-.018-3.34-.054c-.678-.035-1.267-.148-1.767-.339a3.806 3.806 0 01-1.554-.946 4.162 4.162 0 01-.982-1.554c-.167-.5-.268-1.09-.303-1.768C.018 10.661 0 9.548 0 8s.018-2.66.054-3.34c.035-.678.136-1.267.303-1.767a4.163 4.163 0 01.982-1.554C1.78.9 2.298.571 2.893.357 3.393.19 3.983.09 4.66.054 5.339.018 6.452 0 8 0s2.66.018 3.34.054c.678.035 1.267.136 1.767.303a4.162 4.162 0 011.554.982c.44.44.768.959.982 1.554.166.5.274 1.095.321 1.786zm-1.714 8.035c.143-.405.238-1.047.286-1.928.024-.524.035-1.262.035-2.215V7.43a50.6 50.6 0 00-.035-2.215c-.048-.904-.143-1.547-.286-1.928a2.577 2.577 0 00-1.536-1.536c-.38-.143-1.024-.238-1.928-.286A52.102 52.102 0 008.57 1.43H7.43c-.953 0-1.69.011-2.215.035-.88.048-1.524.143-1.928.286A2.578 2.578 0 001.75 3.286c-.143.38-.238 1.024-.286 1.928A52.103 52.103 0 001.43 7.43V8.57c0 .953.011 1.69.035 2.215.048.88.143 1.524.286 1.928.31.738.821 1.25 1.536 1.536.404.143 1.047.238 1.928.286.524.024 1.262.035 2.215.035H8.57c.977 0 1.715-.011 2.215-.035.905-.048 1.547-.143 1.928-.286.738-.31 1.25-.821 1.536-1.536z","fill":"currentColor"}})]) } };

var iconInventoryManagement = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.498 3.018H5.676a.502.502 0 01-.502-.502V.507a.502.502 0 01.502-.503h9.822A.502.502 0 0116 .508v2.007a.501.501 0 01-.502.503zm-9.32-1.005h8.817V1.01H6.178v1.003zM1.418 2.86a.502.502 0 01-.361-.153L0 1.617.722.918l.696.718L3 0l.722.698-1.944 2.01a.503.503 0 01-.361.152zM1.418 7.215a.501.501 0 01-.361-.153L0 5.97l.722-.699.696.718L3 4.354l.722.699L1.779 7.06a.503.503 0 01-.361.154zM1.418 11.569a.5.5 0 01-.361-.153L0 10.325l.722-.698.696.718L3 8.708l.722.699-1.944 2.009a.503.503 0 01-.361.153zM1.418 15.923a.5.5 0 01-.361-.153L0 14.68l.722-.699.696.718L3 13.063l.722.698-1.944 2.01a.503.503 0 01-.361.152zM10.29 7.345H5.676a.502.502 0 01-.502-.502V4.835a.502.502 0 01.502-.502h4.614a.502.502 0 01.502.502v2.008a.501.501 0 01-.502.502zM6.178 6.341h3.61V5.337h-3.61v1.004zM12.856 11.673h-7.18a.501.501 0 01-.502-.502V9.162a.502.502 0 01.502-.502h7.18a.501.501 0 01.502.502v2.008a.503.503 0 01-.502.503zm-6.678-1.005h6.176V9.664H6.178v1.004zM14.902 16H5.676a.501.501 0 01-.502-.502v-2.009a.502.502 0 01.502-.502h9.226a.502.502 0 01.503.502v2.009a.5.5 0 01-.503.502zm-8.724-1.005H14.4v-1.003H6.178v1.003z","fill":"currentColor"}})]) } };

var iconInventory = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 7.5h-3.25v-7a.5.5 0 00-.5-.5h-7.5a.5.5 0 00-.5.5v7H.5A.5.5 0 000 8v6.49A1.5 1.5 0 001.5 16h14a.5.5 0 00.5-.5V8a.5.5 0 00-.5-.5zm-4.33 1h1.16v1.32h-1.16V8.5zM7.42 1h1.16v1.32H7.42V1zM4.75 1h1.67v1.82a.5.5 0 00.5.5h2.16a.51.51 0 00.5-.5V1h1.67v6.5h-6.5V1zM3.67 8.5h1.16v1.32H3.67V8.5zM7.5 15h-6a.5.5 0 01-.5-.5v-6h1.67v1.82a.51.51 0 00.5.5h2.16a.5.5 0 00.5-.5V8.5H7.5V15zm7.5 0H8.5V8.5h1.67v1.82a.5.5 0 00.5.5h2.16a.51.51 0 00.5-.5V8.5H15V15z","fill":"currentColor"}})]) } };

var iconInvite = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.5 7.97h1V5.96h1.997v-1H8.499V2.95H7.5v2.01H5.503v1H7.5v2.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.981 8.28v5.94L11.036 10l4.774-4.12a.51.51 0 00.17-.54.5.5 0 00-.5-.34h-.998V1.23a1.141 1.141 0 00-1-1.23H2.548a1.138 1.138 0 00-.999 1.23V5A1.567 1.567 0 000 6.58v8.92a.5.5 0 00.5.5h13.912a1.567 1.567 0 001.568-1.57V8.28h-.999zm-.64 6.72H1.619l3.995-4.37 1.728 1.44a1.048 1.048 0 001.348-.01l1.608-1.39L14.342 15zm-9.517-5L.999 14.19V6.81L4.824 10zM2.497 1.23a.862.862 0 010-.23h10.916a.35.35 0 01.08.24v5.32L7.99 11.3 2.417 6.69h.08V1.23z","fill":"currentColor"}})]) } };

var iconJet = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M15.735 8.316l-.384-.206v-.876h-1v.343l-1.764-.942v-.928h-1v.394L9.558 5.018C9.381 2.755 8.964.5 8 .5c-.964 0-1.38 2.255-1.557 4.518L4.413 6.1v-.394h-1v.928l-1.764.942v-.343h-1v.877l-.384.205a.5.5 0 00-.265.44v2.259a.5.5 0 00.643.479l.01-.003v.121h1v-.419l1.763-.525v.125h1v-.423l1.92-.57c.02.843.065 1.81.157 2.75l-2.42 1.389a.5.5 0 00-.25.437l.011 1.627a.5.5 0 00.666.469l2.588-.91c.23.577.527.938.912.938s.682-.361.912-.937l2.589.909a.5.5 0 00.666-.469l.012-1.627a.501.501 0 00-.251-.437l-2.42-1.389c.144-1.48.175-3.043.175-4.05 0-.612-.011-1.43-.052-2.31L15 9.057v1.287l-4.565-1.359-.285.958 1.434.427v.423h1v-.125l1.764.525v.42h1v-.122l.01.003a.496.496 0 00.496-.126.5.5 0 00.146-.353V8.757a.5.5 0 00-.265-.441zM1 10.344V9.057L6.37 6.19c-.04.88-.052 1.698-.052 2.31l.002.26L1 10.345zm3.83 4.952l-.006-.635 1.8-1.033c.052.342.109.672.177.976l-1.972.692zM8 15.23A23.841 23.841 0 017.318 8.5c-.093-2.264.136-4.53.682-6.729.547 2.199.777 4.465.683 6.729A23.784 23.784 0 018 15.229zm3.177-.568l-.005.635-1.973-.692c.07-.303.126-.634.177-.976l1.8 1.033z","fill":"currentColor"}})]) } };

var iconLab = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('g',{attrs:{"clip-path":"url(#assets-icon-lab_svg__clip0)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M15.72 13.568l-6.036-8.57V3.455h-1v1.703c0 .103.032.203.09.288l6.128 8.699a.489.489 0 01.038.527.63.63 0 01-.576.329H1.636a.629.629 0 01-.576-.329.488.488 0 01.039-.527l6.126-8.7a.501.501 0 00.09-.288L7.312 2.12a.5.5 0 00-.5-.5h-1.05a.232.232 0 01-.233-.23v-.16A.232.232 0 015.76 1h4.477a.232.232 0 01.234.231v.16a.232.232 0 01-.234.23H8.183v1h2.055a1.233 1.233 0 001.234-1.23v-.16A1.234 1.234 0 0010.238 0H5.761a1.234 1.234 0 00-1.233 1.231v.16a1.233 1.233 0 001.233 1.23h.551L6.316 5 .281 13.568a1.484 1.484 0 00-.109 1.563A1.633 1.633 0 001.636 16h12.728a1.633 1.633 0 001.463-.869 1.486 1.486 0 00-.108-1.563z"}}),_c('path',{attrs:{"d":"M5.865 9.001l-3.05 4.308a.5.5 0 00.409.79h9.619a.5.5 0 00.408-.79L10.2 9.001a.501.501 0 00-.409-.211H6.273a.5.5 0 00-.408.211zm3.668.789l2.343 3.308H4.19L6.532 9.79h3.001z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"assets-icon-lab_svg__clip0"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h16v16H0z"}})])])]) } };

var iconLaptop = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 11.937H9.45a.5.5 0 00-.5.5v.16H7.051v-.16a.5.5 0 00-.5-.5H1.987V3.052a.528.528 0 01.498-.552h11.028a.528.528 0 01.498.553v7.77h1v-7.77A1.527 1.527 0 0013.513 1.5H2.485A1.528 1.528 0 00.987 3.052v8.885H.5a.5.5 0 00-.5.5c0 .96.186 2.063 1.632 2.063h12.646c1.543 0 1.722-1.178 1.722-2.063a.5.5 0 00-.5-.5zM1.632 13.5c-.319 0-.535 0-.607-.563h5.027v.16a.5.5 0 00.203.403H1.632zm12.646 0H9.746a.5.5 0 00.203-.402v-.162h5.019c-.088.564-.35.564-.69.564z","fill":"currentColor"}})]) } };

var iconLearn = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('g',{attrs:{"clip-path":"url(#assets-icon-learn_svg__clip0)"}},[_c('path',{attrs:{"d":"M15.392 6.003a.981.981 0 00-.007-1.818l-6.74-2.566a1.81 1.81 0 00-1.29 0L.615 4.185A.982.982 0 00.61 6.003l2.912 1.132V10.7c0 1.275 2.086 2.394 4.466 2.394 2.38 0 4.466-1.119 4.466-2.394V6.857a.5.5 0 00-.675-.468l-3.485 1.3a.811.811 0 01-.587 0L.971 5.12l6.74-2.566a.819.819 0 01.578 0l6.74 2.518-.898.35-5.653-2.218-.366.93 5.507 2.161.001 1.603a1.13 1.13 0 00-.593.993c.007.093.025.185.054.274l-.242 4.19a1.193 1.193 0 001.284 1.146 1.198 1.198 0 001.283-1.175l-.24-4.16c.028-.09.046-.182.053-.275a1.13 1.13 0 00-.599-.998V6.303l.772-.3zM4.52 7.523l2.823 1.098c.42.165.885.166 1.305.003l2.804-1.046V10.7c0 .426-1.31 1.394-3.466 1.394-2.157 0-3.466-.968-3.466-1.394V7.524zm9.506 1.367c0-.08.051-.137.096-.137.045 0 .096.057.096.137 0 .16-.192.16-.192 0zm.096 4.61c-.003 0-.284-.004-.285-.117l.195-3.376c.031.003.058.019.09.019.032 0 .059-.016.09-.019l.194 3.347c0 .142-.281.146-.284.146z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"assets-icon-learn_svg__clip0"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h16v16H0z"}})])])]) } };

var iconLightMode = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M11 6.18l-.86.52a2.53 2.53 0 11-.94-.89l.48-.88A3.5 3.5 0 1011.5 8c0-.64-.172-1.27-.5-1.82zM8.5 0h-1v3.05h1V0zM8.5 12.95h-1V16h1v-3.05zM16 7.5h-3.05v1H16v-1zM3.05 7.5H0v1h3.05v-1zM13.295 1.995L11.138 4.15l.707.707 2.157-2.156-.707-.707zM4.152 11.142l-2.157 2.156.707.707L4.86 11.85l-.707-.707zM11.852 11.144l-.707.707 2.157 2.157.707-.707-2.157-2.157zM2.695 1.992l-.707.707 2.157 2.156.707-.707-2.157-2.156z","fill":"currentColor"}})]) } };

var iconLineGraph = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M1 13.278h1v-1H1V9.715h1v-1H1V6.152h1v-1H1V2.59h1v-1H1V0H0v15.5a.5.5 0 00.5.5H16v-1H1v-1.722z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 2.49h-3.873v1h2.666L8.486 9.298 7.353 8.257a.5.5 0 00-.692.014l-3.62 3.621.707.707 3.281-3.282 1.133 1.041a.499.499 0 00.692-.014L15 4.197v2.666h1V2.99a.5.5 0 00-.5-.5z","fill":"currentColor"}})]) } };

var iconLink = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10.163 5.262l-4.948 4.835.7.715 4.947-4.834-.699-.716z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.179 1.046a2.834 2.834 0 00-3.938 0L8.4 3.821a2.716 2.716 0 00-.733 2.622l.967-.253a1.691 1.691 0 01.465-1.653L11.94 1.76a1.826 1.826 0 012.539 0 1.701 1.701 0 010 2.449l-2.842 2.776a1.824 1.824 0 01-1.615.481l-.186.983a2.834 2.834 0 002.5-.748l2.842-2.777a2.702 2.702 0 000-3.88zM7.368 9.808a1.69 1.69 0 01-.466 1.653L4.06 14.24a1.826 1.826 0 01-2.54 0 1.7 1.7 0 010-2.45l2.842-2.776a1.822 1.822 0 011.617-.48l.185-.984a2.825 2.825 0 00-2.5.748L.82 11.074a2.702 2.702 0 000 3.88 2.834 2.834 0 003.938 0l2.843-2.777a2.713 2.713 0 00.733-2.622l-.967.253z","fill":"currentColor"}})]) } };

var iconLinkedIn = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M3.571 16H.25V5.321h3.321V16zM1.93 3.857c-.524 0-.977-.19-1.358-.571A1.854 1.854 0 010 1.929C0 1.405.19.952.571.57A1.854 1.854 0 011.93 0c.523 0 .976.19 1.357.571.38.381.571.834.571 1.358 0 .523-.19.976-.571 1.357-.381.38-.834.571-1.357.571zM16 16h-3.321v-5.214c0-.857-.072-1.476-.215-1.857-.262-.643-.774-.965-1.535-.965-.762 0-1.298.286-1.608.857-.238.429-.357 1.06-.357 1.893V16H5.68V5.321h3.178v1.465h.036c.238-.476.619-.87 1.143-1.179.571-.38 1.238-.571 2-.571 1.547 0 2.63.488 3.25 1.464.476.786.714 2 .714 3.643V16z","fill":"currentColor"}})]) } };

var iconListView = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 3.004H.5a.5.5 0 01-.5-.5V.5A.5.5 0 01.5 0h15a.5.5 0 01.5.5v2.004a.5.5 0 01-.5.5zm-14.5-1h14V1H1v1.004zM15.5 7.336H.5a.5.5 0 01-.5-.5V4.832a.5.5 0 01.5-.5h15a.5.5 0 01.5.5v2.004a.5.5 0 01-.5.5zm-14.5-1h14V5.332H1v1.004zM15.5 11.668H.5a.5.5 0 01-.5-.5V9.164a.5.5 0 01.5-.5h15a.5.5 0 01.5.5v2.004a.5.5 0 01-.5.5zm-14.5-1h14V9.664H1v1.004zM15.5 16H.5a.5.5 0 01-.5-.5v-2.004a.5.5 0 01.5-.5h15a.5.5 0 01.5.5V15.5a.5.5 0 01-.5.5zM1 15h14v-1.004H1V15z","fill":"currentColor"}})]) } };

var iconLogIn = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M9.846 10.878l.705.709 3.245-3.233a.5.5 0 000-.709L10.55 4.413l-.705.709L12.233 7.5H0v1h12.233l-2.387 2.378z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 0H6.462a1.502 1.502 0 00-1.5 1.5v5.015h1V1.5a.5.5 0 01.5-.5H15v13.503a.498.498 0 01-.497.497H5.962V9.515h-1V15.5a.5.5 0 00.5.5h9.04A1.499 1.499 0 0016 14.503V.5a.5.5 0 00-.5-.5z","fill":"currentColor"}})]) } };

var iconLogOut = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.852 7.646l-3.248-3.232-.705.708 2.39 2.378H2.54v1h11.747l-2.39 2.378.706.708 3.248-3.232a.499.499 0 000-.708z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.558 14.5a.478.478 0 01-.452.5H1V1.497A.476.476 0 011.451 1h8.107v5.485h1V.5a.5.5 0 00-.5-.5H1.45A1.475 1.475 0 000 1.497V15.5a.5.5 0 00.5.5h8.606a1.479 1.479 0 001.453-1.5V9.485H9.558V14.5z","fill":"currentColor"}})]) } };

var iconLogo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6.42 6.559A1.64 1.64 0 004.684 8.1c-.072.43-.002.873.2 1.26a1.383 1.383 0 00.992.734c.065.01.131.015.197.015a1.69 1.69 0 001.54-1.558c.072-.43.001-.873-.2-1.26a1.383 1.383 0 00-.993-.733zm.204 1.84c-.071.46-.351.746-.595.708a.406.406 0 01-.266-.224 1.023 1.023 0 01-.09-.63c.065-.434.337-.71.557-.71a.25.25 0 01.038.004.406.406 0 01.265.223c.097.195.129.416.091.63zM12.403 7.768c.066.01.132.015.198.015a1.69 1.69 0 001.539-1.557c.072-.43.002-.873-.2-1.26a1.383 1.383 0 00-.992-.734 1.636 1.636 0 00-1.737 1.542c-.072.43-.002.873.2 1.26a1.384 1.384 0 00.992.734zM12.2 5.927c.067-.434.338-.71.558-.71.013 0 .026.001.038.003a.406.406 0 01.266.224c.096.195.128.415.09.63-.07.459-.352.747-.595.706a.406.406 0 01-.266-.224 1.021 1.021 0 01-.09-.63zM8.237 10.511c-.152.25-.253.527-.298.815a1.907 1.907 0 001.433 2.264c.086.014.173.02.26.02a1.796 1.796 0 001.708-1.669 1.92 1.92 0 00-1.353-2.344 1.604 1.604 0 00-1.045.208.425.425 0 01-.16-.273c.01-.25.107-.487.274-.672.02.004.037.013.057.016.063.01.126.015.189.015a1.712 1.712 0 001.549-1.557c.071-.432 0-.875-.204-1.261a1.55 1.55 0 00.285-1.162l-.985.18a.625.625 0 01-.053.314 1.273 1.273 0 00-.236-.065 1.655 1.655 0 00-1.737 1.543A1.943 1.943 0 008.225 8.3a1.97 1.97 0 00-.438 1.337c.042.335.201.645.45.873zm1.515.068c.028 0 .055.002.083.006.364.056.605.619.516 1.204-.07.457-.341.882-.827.813a.933.933 0 01-.596-1.124.974.974 0 01.824-.9zm-.843-3.544c.066-.423.34-.71.56-.71.013 0 .025.001.037.003.224.035.424.407.356.853-.07.445-.367.745-.596.707-.225-.035-.425-.408-.357-.853z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.004 0C4.165 0 .876 2.751.876 5.004a2.103 2.103 0 001.44 1.9c.34.116.703.159 1.062.123-.038.395-.076.826-.115 1.296a23.896 23.896 0 01-.285 2.232 6.118 6.118 0 00-1.765 1.02c-1.084.877-1.258 1.792-1.059 2.357a1.085 1.085 0 001.051.732c1.478 0 2.23-1.518 2.639-3.32a2.453 2.453 0 011.786.243 1.386 1.386 0 01.647 1.54l.975.227a2.38 2.38 0 00-1.09-2.614 3.328 3.328 0 00-2.123-.432c.1-.644.169-1.295.22-1.9.053-.633.103-1.182.153-1.662a5.97 5.97 0 002.115-1.753c.88-1.078.736-2.086.203-2.606a1.367 1.367 0 00-1.895.023c-.776.663-1.095 1.504-1.347 3.595-.278.061-.567.046-.837-.044a1.103 1.103 0 01-.775-.957C1.876 3.423 4.621 1 8.004 1a7 7 0 11-4.055 12.705l-.58.815A8 8 0 108.004 0zM1.205 13.664c-.078 0-.094-.027-.107-.066-.072-.201.068-.699.744-1.244.266-.218.552-.411.853-.578-.324 1.1-.798 1.888-1.49 1.888zM5.485 3.17a.546.546 0 01.342-.152.288.288 0 01.205.083c.206.202.176.7-.28 1.259a6.132 6.132 0 01-1.19 1.153c.218-1.5.468-1.956.922-2.343z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M1.49 10.581A6.983 6.983 0 011 8a7.1 7.1 0 01.13-1.353l-.98-.192a8.048 8.048 0 00.41 4.494l.93-.368z","fill":"currentColor"}})]) } };

var iconMailFill = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M11.092 7.602l4.093 4.533-.738.674L10.34 8.26 8.755 9.65a1.08 1.08 0 01-.684.251 1.053 1.053 0 01-.666-.243l-1.72-1.426-4.132 4.577-.738-.674 4.1-4.542L.817 4.195l.64-.769 6.585 5.46 7.35-6.386H1.572A1.574 1.574 0 000 4.072V13a.5.5 0 00.5.5h13.928A1.574 1.574 0 0016 11.928V4.609l-.023-1.288-4.885 4.28z","fill":"currentColor"}})]) } };

var iconMailStroke = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.977 5.5v6.22L11.033 7.5l4.773-4.12a.5.5 0 00.17-.55.5.5 0 00-.5-.33H1.568A1.576 1.576 0 000 4.07V13a.5.5 0 00.5.5h13.908a1.577 1.577 0 001.568-1.57V4.61l-.999.89zm-.639 7H1.618L5.61 8.13 7.32 9.56a.998.998 0 001.348 0l1.607-1.4 4.064 4.34zm-.21-9l-6.14 5.29-6.38-5.29h12.52zm-9.305 4L.998 11.69V4.3l3.825 3.2z","fill":"currentColor"}})]) } };

var iconManagedServices = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10.128 3.433H8.28A1.69 1.69 0 009.572 1.73 1.656 1.656 0 008.01 0a1.656 1.656 0 00-1.563 1.731A1.69 1.69 0 007.74 3.433H5.893a1.145 1.145 0 00-1.194 1.086v4.45a1.124 1.124 0 00.994 1.072l.268 4.524A1.38 1.38 0 007.276 16H8.75a1.371 1.371 0 001.314-1.406l.264-4.553a1.124 1.124 0 00.994-1.071V4.519a1.145 1.145 0 00-1.193-1.086zM7.448 1.73A.673.673 0 018.01 1a.673.673 0 01.562.731.673.673 0 01-.562.732.673.673 0 01-.563-.732zM10.32 8.97c0 .016-.064.087-.193.087h-.274a.5.5 0 00-.499.47l-.29 5.038c0 .236-.145.435-.316.435h-.24v-3.84h-1V15h-.233c-.17 0-.315-.2-.316-.464l-.296-5.009a.5.5 0 00-.499-.47h-.272c-.13 0-.194-.07-.194-.087V4.519a.208.208 0 01.194-.086h1.656a.705.705 0 00-.258.538.718.718 0 00.437.658H7.5V8.08h1V5.63h-.208a.717.717 0 00.437-.66.706.706 0 00-.258-.537h1.657a.208.208 0 01.193.086v4.45zM14.957 4.132h-1.001a1.547 1.547 0 00.705-1.322 1.45 1.45 0 00-1.364-1.52 1.45 1.45 0 00-1.364 1.52 1.548 1.548 0 00.705 1.322h-.718v1l.877-.004V8.09h1V5.123L15 5.118l-.043 3.671h-.215a.5.5 0 00-.499.473l-.227 4.174c0 .168-.092.274-.14.274h-1.154c-.04 0-.139-.096-.14-.304l-.231-3.853-.999.06.231 3.823a1.214 1.214 0 001.139 1.274h1.154a1.205 1.205 0 001.139-1.247l.203-3.705A1 1 0 0016 8.803V5.118a1.017 1.017 0 00-1.043-.986zm-1.66-1.842c.194 0 .364.243.364.52 0 .276-.17.52-.364.52-.195 0-.364-.244-.364-.52 0-.277.17-.52.364-.52zM3.422 13.436c0 .168-.092.274-.14.274H2.128c-.04 0-.139-.096-.14-.302l-.231-4.147a.5.5 0 00-.5-.472L1 8.803l.044-3.671h1.16V8.09h1V5.132h.872v-1h-.714a1.548 1.548 0 00.705-1.322 1.45 1.45 0 00-1.364-1.52A1.45 1.45 0 001.34 2.81a1.547 1.547 0 00.705 1.322h-1A1.018 1.018 0 000 5.118v3.685a1 1 0 00.783.955l.206 3.678a1.214 1.214 0 001.139 1.274h1.154a1.205 1.205 0 001.139-1.245l.226-3.853-.998-.058-.227 3.882zM2.703 2.29c.194 0 .364.243.364.52 0 .276-.17.52-.364.52-.194 0-.364-.244-.364-.52 0-.277.17-.52.364-.52z","fill":"currentColor"}})]) } };

var iconMapPin = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M8.002 16.001a1.988 1.988 0 01-.965-.247 1.669 1.669 0 01-.706-.723L2.414 7.48A4.277 4.277 0 012.002 5.5a5.11 5.11 0 011.776-3.905A6.086 6.086 0 018.002 0a6.086 6.086 0 014.225 1.595A5.11 5.11 0 0114.002 5.5a4.277 4.277 0 01-.41 1.979l-.39.751-.888-.46.39-.752c.217-.475.32-.995.298-1.518a4.094 4.094 0 00-1.447-3.165 5.05 5.05 0 00-3.553-1.335A5.05 5.05 0 004.45 2.336a4.095 4.095 0 00-1.448 3.165c-.02.522.081 1.042.298 1.518l3.921 7.558c.065.13.169.235.297.3a1.002 1.002 0 00.969 0 .747.747 0 00.31-.306l3.001-5.803.889.46-3.005 5.81c-.162.303-.41.553-.714.716a1.99 1.99 0 01-.966.247z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.002 7.888A2.547 2.547 0 1110.58 5.34a2.565 2.565 0 01-2.577 2.547zm0-4.094A1.547 1.547 0 109.58 5.34a1.565 1.565 0 00-1.577-1.547z","fill":"currentColor"}})]) } };

var iconMission = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M16.13 2.364V1.362h-1.371V0H13.75v1.663l-.373.34v-.63h-1.009v1.632l-.796.801A6.987 6.987 0 002.859 3.6 6.908 6.908 0 00.33 7.443a6.87 6.87 0 00.453 4.568 6.933 6.933 0 003.233 3.28 6.997 6.997 0 004.589.542 6.963 6.963 0 003.918-2.433 6.883 6.883 0 00.31-8.211l-.736.74a5.892 5.892 0 01.19 6.032 5.938 5.938 0 01-2.193 2.244 5.99 5.99 0 01-3.038.82 6.01 6.01 0 01-2.77-.653 5.968 5.968 0 01-2.153-1.853 5.918 5.918 0 01-.747-5.446c.326-.9.867-1.71 1.575-2.357a6.016 6.016 0 017.896-.178l-.917.911a4.677 4.677 0 00-2.924-1.002 4.72 4.72 0 00-2.602.802 4.674 4.674 0 00-1.717 2.1 4.64 4.64 0 001.038 5.077 4.726 4.726 0 005.116.998 4.69 4.69 0 002.104-1.719c.514-.767.79-1.668.79-2.59a4.594 4.594 0 00-.596-2.213l-.746.73c.21.468.32.972.323 1.483a3.67 3.67 0 01-.633 2.05 3.705 3.705 0 01-1.674 1.352 3.732 3.732 0 01-4.044-.823 3.664 3.664 0 01-.774-4.03A3.692 3.692 0 014.985 6.02a3.728 3.728 0 012.071-.601 3.655 3.655 0 012.198.741L8.246 7.162a2.178 2.178 0 00-1.19-.34 2.3 2.3 0 00-1.28.369 2.26 2.26 0 00-.375 3.505 2.294 2.294 0 002.5.5c.42-.173.779-.466 1.03-.842.252-.376.385-.817.383-1.269.01-.123.01-.247 0-.37l-1.38 1.302a1.283 1.283 0 01-2.199-.892 1.265 1.265 0 01.379-.933 1.281 1.281 0 01.942-.369c.153-.001.304.03.444.09l-.756.751.715.712 5.646-5.65h1.654V2.725h-.646l.363-.361h1.654z","fill":"currentColor"}})]) } };

var iconMobile = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M11.005 16H4a.5.5 0 01-.5-.5V1.501A1.503 1.503 0 015.001 0H12a.5.5 0 01.5.5v12.485h-1V1H5.001a.502.502 0 00-.501.501V15h6.505a.496.496 0 00.495-.496v-.519h1v.52A1.497 1.497 0 0111.005 16z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8 14.464a.625.625 0 100-1.25.625.625 0 000 1.25z","fill":"currentColor"}})]) } };

var iconMoney = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.23 6.997c0-.292.259-.483.673-.483a.692.692 0 01.767.609h.755a1.297 1.297 0 00-1.12-1.252v-.59H7.62v.572a1.196 1.196 0 00-1.163 1.144c0 1.597 2.254.978 2.254 1.871 0 .37-.312.548-.761.548a.793.793 0 01-.858-.762h-.761a1.442 1.442 0 001.289 1.424v.62l.683.006v-.626a1.244 1.244 0 001.211-1.222c0-1.626-2.284-.935-2.284-1.859z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.565 3.705a30.503 30.503 0 00-7.619.07 29.227 29.227 0 01-7.382.074A.497.497 0 000 4.34v7.453a.498.498 0 00.436.493c1.086.142 2.18.213 3.275.213a41.05 41.05 0 004.339-.283 29.223 29.223 0 017.385-.074.5.5 0 00.564-.493L16 4.198a.498.498 0 00-.435-.493zm-.566 7.386a31.427 31.427 0 00-7.052.137A29.844 29.844 0 011 11.354V4.901c2.347.22 4.712.173 7.049-.138A29.9 29.9 0 0115 4.638l-.001 6.453z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M1.995 6.446a.5.5 0 100-.999.5.5 0 000 1zM1.995 11.082a.5.5 0 100-1 .5.5 0 000 1zM13.995 5.95a.5.5 0 100-1 .5.5 0 000 1zM13.995 10.582a.496.496 0 10-.007-.992.496.496 0 00.007.992z","fill":"currentColor"}})]) } };

var iconMultiCloudArchitecture = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.455 5.074a7.493 7.493 0 00-1.229-1.679l-.72.693c.425.438.783.928 1.066 1.456l.883-.47zM9.759 1.888l.132-.419.016-.057-.148.476zM14.336 8.803l1.001.033a7.416 7.416 0 00-.224-2.066l-.97.245a6.39 6.39 0 01.193 1.788zM11.276 3.097l.528-.847a7.56 7.56 0 00-1.896-.838l-.017.057-.253.903c.58.167 1.132.411 1.638.725zM1.325 8.427l-1-.028c-.02.694.059 1.388.234 2.064l.97-.25a6.41 6.41 0 01-.204-1.786zM1.228 12.157c.329.607.745 1.17 1.237 1.672l.716-.696a6.563 6.563 0 01-1.073-1.45l-.88.474zM3.893 14.965a7.524 7.524 0 001.852.814l.067.02.213-.976a6.55 6.55 0 01-1.607-.707l-.525.85zM2.45 7.196l.028-.006c.022.002.079.006.102.006h4.875a2.187 2.187 0 001.47-.628c.382-.382.589-.891.573-1.416a1.99 1.99 0 00-.23-.935 2.133 2.133 0 00-.65-.741c.035-.148.052-.3.052-.45.013-.456-.147-.901-.451-1.256a2.077 2.077 0 00-1.211-.684l-.157.985c.234.044.444.164.593.338a.92.92 0 01.225.616c0 .156-.037.31-.111.45a.498.498 0 00.263.7c.203.082.375.219.495.393.12.174.184.377.181.584a.985.985 0 01-.294.726 1.121 1.121 0 01-.754.322l-4.836.002c-.022-.003-.14-.002-.163-.002a1.542 1.542 0 01-1.041-.44 1.355 1.355 0 01-.407-1.002 1.38 1.38 0 01.249-.805 1.52 1.52 0 01.683-.541.53.53 0 00.266-.185c.065-.086.099-.19.097-.296a.539.539 0 00-.01-.105 1.526 1.526 0 01-.021-.252c-.013-.406.148-.8.445-1.095A1.688 1.688 0 013.85.997c.433.013.843.186 1.14.482.297.295.457.69.445 1.096 0 .204-.04.407-.119.598l.927.377c.128-.311.193-.642.193-.975A2.42 2.42 0 005.71.787 2.755 2.755 0 003.85 0a2.755 2.755 0 00-1.86.787 2.42 2.42 0 00-.727 1.788v.05c-.389.223-.71.536-.932.91a2.353 2.353 0 00-.331 1.223 2.292 2.292 0 00.688 1.694c.459.456 1.092.724 1.761.744zM15.118 12.278c.035-.147.053-.298.053-.45.013-.455-.147-.9-.451-1.255a2.077 2.077 0 00-1.211-.683l-.157.984c.234.044.444.164.593.339a.964.964 0 01.112 1.068.5.5 0 00.087.58c.05.05.11.09.177.117.203.082.376.219.496.393.12.174.184.377.181.585a.985.985 0 01-.294.725 1.121 1.121 0 01-.754.322l-4.836.002c-.022-.003-.14-.002-.163-.002a1.542 1.542 0 01-1.041-.44 1.355 1.355 0 01-.407-1.002 1.38 1.38 0 01.248-.805c.166-.24.404-.428.684-.541a.53.53 0 00.265-.185c.066-.086.1-.19.098-.296a.528.528 0 00-.011-.105 1.525 1.525 0 01-.02-.25c-.013-.407.147-.801.444-1.097.297-.296.707-.469 1.14-.482.433.013.843.187 1.14.482.297.296.457.69.444 1.096.001.205-.039.407-.117.598l.927.378c.128-.312.193-.642.192-.976a2.42 2.42 0 00-.726-1.788 2.754 2.754 0 00-1.86-.787 2.755 2.755 0 00-1.86.787 2.42 2.42 0 00-.726 1.788v.05c-.39.223-.71.536-.932.91a2.353 2.353 0 00-.331 1.224 2.292 2.292 0 00.688 1.693A2.609 2.609 0 008.95 16l.028-.007c.022.003.079.007.101.007h4.876a2.188 2.188 0 001.47-.629c.382-.382.588-.89.573-1.415a1.991 1.991 0 00-.23-.936 2.133 2.133 0 00-.65-.742z","fill":"currentColor"}})]) } };

var iconNetworking = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.75 4.5v-1h-3.28V0h-1v3.5h-3V0h-1v3.5H2.25v1H3v2a5 5 0 003 4.57V13a.5.5 0 00.5.5h1V16h1v-2.5h1a.5.5 0 00.5-.5v-1.91a5 5 0 003-4.57v-1h-1v1a4 4 0 11-8 0v-2l9.75-.02zM9 11.42v1.08H7v-1.08c.33.064.664.097 1 .1.336-.003.67-.036 1-.1z","fill":"currentColor"}})]) } };

var iconNotification = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.093 12.037l-.733-.733h-.978v.205c-.001.128.048.25.136.342l.88.88a.126.126 0 010 .156.128.128 0 01-.126.088H2.66a.146.146 0 01-.147-.127.146.146 0 010-.156l.88-.88a.498.498 0 00.147-.342V7.776a4.553 4.553 0 013.961-4.594 4.413 4.413 0 014.506 2.582c.253.565.384 1.177.384 1.796v2.522h.978V7.56a5.412 5.412 0 00-1.76-3.978 5.341 5.341 0 00-1.702-1.036v-.283A1.954 1.954 0 007.157.18a1.956 1.956 0 00-1.113 2.083v.332A5.633 5.633 0 002.6 7.775v3.49l-.733.772a1.124 1.124 0 00.792 1.955h2.934A2.443 2.443 0 008 16a2.446 2.446 0 002.406-2.008h2.934a1.125 1.125 0 00.792-1.955h-.039zM7.022 2.263a.977.977 0 111.907 0 5.725 5.725 0 00-1.477 0h-.43zM8 14.969a1.467 1.467 0 01-1.389-.977H9.36a1.485 1.485 0 01-1.379.977H8z","fill":"currentColor"}})]) } };

var iconOil = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8.639 3.13a.778.778 0 00-1.043-.273.778.778 0 00-.282.273L5.162 6.71a4.122 4.122 0 00.179 4.6 3.42 3.42 0 002.64 1.3 3.408 3.408 0 002.64-1.3 4.14 4.14 0 00.18-4.6L8.639 3.13zm1.215 7.54a2.413 2.413 0 01-1.873.94 2.434 2.434 0 01-1.883-.94 3.128 3.128 0 01-.09-3.44L7.982 4l1.993 3.27a3.129 3.129 0 01-.12 3.4z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.42 8a1.684 1.684 0 010 1.84l.767.64a2.646 2.646 0 00.12-3L8.42 8z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.212 14.06V8.92a1.058 1.058 0 00.478-.9 1.002 1.002 0 00-.478-.89V1.94A1.059 1.059 0 0013.71 1a1.002 1.002 0 00-.996-1H3.249a.994.994 0 00-.996 1 1.073 1.073 0 00.478.9v5.2a1.079 1.079 0 00-.353 1.41c.084.158.205.291.353.39v5.16a1.068 1.068 0 00-.478.94 1.002 1.002 0 00.996 1h9.505a.995.995 0 00.996-1 1.064 1.064 0 00-.538-.94zm-9.963.86a.497.497 0 00.498-.5V8.54A.571.571 0 003.25 8a.497.497 0 00.498-.5V1.58A.581.581 0 003.25 1l9.395.09a.488.488 0 00-.399.49v5.9c.001.145.05.286.14.4a.567.567 0 00.359.18.527.527 0 00-.359.15.521.521 0 00-.14.36v5.85a.572.572 0 00.489.58l-9.485-.08z","fill":"currentColor"}})]) } };

var iconOverview = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.83 5.517H8a2.7 2.7 0 001.31-.45l2.24 2.23.71-.71-2.21-2.22a2.732 2.732 0 00-.4-3.682 2.76 2.76 0 10-1.82 4.832zM6.51 1.595a1.76 1.76 0 011.21-.6h.11a1.71 1.71 0 011.17.44 1.76 1.76 0 11-2.92 1.43 1.731 1.731 0 01.43-1.27zM8 7.477a7.999 7.999 0 00-8 8.003V16h14v-1h-1.85a15.008 15.008 0 00-.41-3.001H14c.645 1.073.99 2.299 1 3.55V16h1v-.5a8.006 8.006 0 00-4.934-7.412A7.998 7.998 0 008 7.478zm2.39 3.521H5.62c.61-1.6 1.51-2.51 2.38-2.51.87 0 1.77.91 2.39 2.51zm-4.79-2a7.733 7.733 0 00-1 2H2.68a7 7 0 012.92-2.08v.08zm-3.6 3h2.26A15.01 15.01 0 003.85 15H1a7.004 7.004 0 011-3.111v.11zM11.15 15h-6.3c.03-1.014.175-2.02.43-3.001h5.44c.255.98.399 1.987.43 3zm.3-4.052a7.745 7.745 0 00-1-2 7 7 0 012.92 2h-1.92z","fill":"currentColor"}})]) } };

var iconPadlockLocked = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M14.5 7.003H14v7.43a.68.68 0 01-.74.57H2v-6.43a.68.68 0 01.74-.57h10a.5.5 0 00.5-.5v-2.95A5.09 5.09 0 008 .003a5.1 5.1 0 00-5.25 4.58l.03 2.42A1.66 1.66 0 001 8.573v6.93a.5.5 0 00.5.5h11.76a1.67 1.67 0 001.74-1.57v-6.93a.5.5 0 00-.5-.5zm-4.45 0H5.92v-2.15c0-.07 0-1.69 2.06-1.69a1.92 1.92 0 012.07 1.6v2.24zm-2.05-6a4.09 4.09 0 014.23 3.58v2.42h-1.18v-2.26A2.91 2.91 0 008 2.153a2.77 2.77 0 00-3.06 2.7v2.15H3.78v-2.38A4.09 4.09 0 018 1.003z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.01 9.503H3v1h4.01v-1zM6.01 11.503H3v1h3.01v-1z","fill":"currentColor"}})]) } };

var iconPadlockUnlocked = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M13.5 7.003H13v7.43a.68.68 0 01-.74.57H1v-6.43a.68.68 0 01.74-.57h10a.5.5 0 00.5-.5v-2.95A5.09 5.09 0 007 .003a5.09 5.09 0 00-5.25 4.58v.27a1.43 1.43 0 001.43 1.31h.31a1.42 1.42 0 001.42-1.31c0-.07 0-1.69 2.06-1.69a1.92 1.92 0 012.07 1.6v2.24h-7.3A1.66 1.66 0 000 8.573v6.93a.5.5 0 00.5.5h11.76a1.67 1.67 0 001.74-1.57v-6.93a.5.5 0 00-.5-.5zm-3.45-2.26A2.91 2.91 0 007 2.153a2.76 2.76 0 00-3.07 2.58.43.43 0 01-.43.43h-.32a.43.43 0 01-.43-.43v-.11A4.09 4.09 0 017 1.003a4.09 4.09 0 014.23 3.58v2.42h-1.18v-2.26z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6.01 9.503H2v1h4.01v-1zM5 11.503H2v1h3v-1z","fill":"currentColor"}})]) } };

var iconPaintbrush = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M15.74.262a.84.84 0 00-1.22 0l-.34.27c-1.1.898-4.44 3.485-5.59 4.743A44.566 44.566 0 006 8.361l-2 2.746a.509.509 0 00.06.649l.75.719a2.423 2.423 0 01-.73 1.887 2.171 2.171 0 01-2.27.52l.19-.14c.23-.272.405-.583.52-.919.18-.558.53-1.046 1-1.398l-.57-.819a3.805 3.805 0 00-1.35 1.828 2.237 2.237 0 01-.32.609.62.62 0 01-.62.15.51.51 0 00-.59.22.499.499 0 00.09.588A3.703 3.703 0 002.58 16a3.252 3.252 0 002.2-.899 3.436 3.436 0 001.06-2.636l2.48-1.997c.985-.84 1.926-1.73 2.82-2.666A65.907 65.907 0 0015.63 1.7l.15-.22a.868.868 0 00-.04-1.218zM6.43 9.41l.79.66-1.87 1.507-.25-.25L6.43 9.41zm4-2.306C9.48 8.09 8.49 9.01 8 9.419L7 8.6a46.22 46.22 0 012.32-2.586c.91-.929 3.84-3.325 5.15-4.354a54.136 54.136 0 01-4.06 5.443h.02z","fill":"currentColor"}})]) } };

var iconPaperAirplane = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.936 13.535L8.435.252 8.427.243a.495.495 0 00-.06-.073.513.513 0 00-.05-.056.516.516 0 00-.068-.04.506.506 0 00-.082-.045l-.01-.005a.456.456 0 00-.069-.01A.474.474 0 008 0 .486.486 0 007.9.015a.49.49 0 00-.06.009l-.008.005a.486.486 0 00-.09.048.515.515 0 00-.06.036.503.503 0 00-.049.055.482.482 0 00-.063.076l-.007.008L.064 13.536a.5.5 0 00.436.745h5.59l1.554 1.57a.5.5 0 00.705.006l1.756-1.718a.501.501 0 00.147-.423L8.832 2.993l5.811 10.288h-3.265v1H15.5a.5.5 0 00.436-.746zm-14.58-.254L7.164 2.995 5.8 13.281H1.356zm7.871.318l-1.222 1.196-1.231-1.244.725-5.472v5.202h1V8.092l.728 5.507z","fill":"currentColor"}})]) } };

var iconPartners = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.38 6.412s-1.45 1.239-1.83 1.538l.61.759L16 7.16l-.62-.749z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.46 6.432a.47.47 0 00-.46-.19c-.2.017-.4.017-.6 0-.59 0-1.23-.708-1.43-.998a.48.48 0 00-.68 0s-.61.56-.9.869c-.5.529-.9.559-1 .5-.1-.06-.19-.18-.22-.15a28.624 28.624 0 012.6-2.787c.604.064 1.203.174 1.79.33.977.272 1.985.42 3 .44a17.382 17.382 0 003.32-2.098l-.62-.778a25 25 0 01-2.91 1.927 14.43 14.43 0 01-2.64-.44 9.552 9.552 0 00-2.1-.34c-.11 0-.35.05-1.2.89a9.223 9.223 0 01-1.33.05A25.234 25.234 0 012 1.25l-.6.739a16.148 16.148 0 003.5 2.616c.17.011.34.011.51 0-.3.34-.64.719-1 1.188a.898.898 0 00-.2.8A1.247 1.247 0 005 7.51c.25.11 1.12.36 2.13-.73.12-.129.31-.309.48-.468a2.781 2.781 0 001.86.998h.49l3 3.205a.38.38 0 010 .51.25.25 0 01-.4 0 .82.82 0 00-.12-.2l-1.85-1.877-.7.659 1.75 1.887a.38.38 0 010 .51.27.27 0 01-.4 0 1.128 1.128 0 00-.16-.26L9.8 10.446l-.7.67 1.26 1.337a.409.409 0 010 .51.208.208 0 01-.15.08.64.64 0 01-.31-.15l-.32-.35v-.06l-.79-.838-.5.479a1.367 1.367 0 00-.38-.889 1.2 1.2 0 00-.91-.43 1.337 1.337 0 00-.31-.708 1.22 1.22 0 00-.87-.38 1.277 1.277 0 00-.31-.689 1.23 1.23 0 00-1.8 0l-.1.1a1.108 1.108 0 00-.17-.27 1.22 1.22 0 00-1-.369 3.878 3.878 0 01-.08-.509 2.782 2.782 0 00-.21-.998A10.81 10.81 0 00.64 5.334L0 6.063c.481.414.93.864 1.34 1.348.07.213.106.435.11.659.022.289.079.574.17.849l-.32.32a1.377 1.377 0 000 1.836 1.21 1.21 0 00.9.4h.08c.037.231.142.446.3.619a1.18 1.18 0 00.89.4h.09a1.212 1.212 0 001.19.979c.141-.005.28-.036.41-.091.058.145.14.28.24.4a1.241 1.241 0 001.39.287c.155-.067.294-.165.41-.288l.53.57a1.21 1.21 0 001.592.18c.203-.14.36-.34.448-.57.133.043.27.066.41.07a1.19 1.19 0 00.82-.38c.14-.168.239-.366.29-.579h.09a1.212 1.212 0 001.2-1.028h.06a1.21 1.21 0 00.9-.4 1.387 1.387 0 000-1.847l-3.08-3.365zM2 10.446a.4.4 0 010-.519l.38-.4a.25.25 0 01.19-.09.25.25 0 01.2.09.38.38 0 010 .51l-.37.41a.281.281 0 01-.4 0zm1.28.999a.399.399 0 010-.52l1.16-1.238a.25.25 0 01.2-.09.28.28 0 01.2.09.389.389 0 010 .48l-.98 1.068v.05l-.16.17a.25.25 0 01-.19.09.25.25 0 01-.23-.09v-.01zm1.28.998a.399.399 0 010-.489l1-1.058v-.11a.31.31 0 01.2-.09.33.33 0 01.2.09.399.399 0 01.04.45l-1 1.178a.28.28 0 01-.44 0v.03zm1.75.79a.28.28 0 01-.2-.09.4.4 0 010-.52l.7-.749a.27.27 0 01.2-.09.28.28 0 01.2.09.399.399 0 010 .52l-.7.748a.25.25 0 01-.2.09zm2.54.469a.27.27 0 01-.4 0l-.57-.62c.145-.16.245-.357.29-.569l.2.22.46.51a.39.39 0 01.02.429v.03z","fill":"currentColor"}})]) } };

var iconPercent = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M11.27 4.064L4.04 11.217l.703.71 7.23-7.153-.704-.71zM10.69 8.57a2.13 2.13 0 102.13 2.12 2.12 2.12 0 00-2.13-2.12zm0 3.25a1.13 1.13 0 110-2.26 1.13 1.13 0 010 2.26zM7.43 5.31a2.13 2.13 0 10-4.26-.02 2.13 2.13 0 004.26.02zm-3.25 0a1.13 1.13 0 112.25-.212 1.13 1.13 0 01-2.25.212z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8 0a8 8 0 100 16A8 8 0 008 0zm0 15A7 7 0 118 1a7 7 0 010 14z","fill":"currentColor"}})]) } };

var iconPhone = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.092 15.996h-.22c-2.756-.1-5.891-2.088-7.845-3.997C2.073 10.091.019 7.064.019 4.306A3.569 3.569 0 011.843.809l.48.869A2.621 2.621 0 00.972 4.276c.06 2.468 2.064 5.325 3.767 6.994 1.703 1.669 4.71 3.647 7.174 3.727a2.742 2.742 0 002.751-1.364c.179-.315.293-.664.335-1.024l-3.006-1.829-1.814 1.689a.512.512 0 01-.53.1A12.877 12.877 0 015.98 10.26a11.987 11.987 0 01-2.545-3.757.508.508 0 01.1-.5l1.743-1.798L2.895.369l.44-.28a.522.522 0 01.391-.08.52.52 0 01.31.23l2.305 3.767a.479.479 0 01-.07.6L4.498 6.424a10.841 10.841 0 002.194 3.117c.913.82 1.947 1.494 3.066 1.999L11.61 9.8a.511.511 0 01.621-.06l3.537 2.198a.49.49 0 01.23.44 3.718 3.718 0 01-1.193 2.626 3.737 3.737 0 01-2.714.991z","fill":"currentColor"}})]) } };

var iconPlaylist = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M4.8 12.58l3.65-2a.6.6 0 00.32-.52.59.59 0 00-.32-.52l-3.65-2a.59.59 0 00-.89.53v3.94a.59.59 0 00.59.61.638.638 0 00.3-.04zm.11-3.81l2.4 1.31-2.4 1.3V8.77z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.57 1.5H4.78a.5.5 0 00-.5.5v1.58H2.71a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h7.71a.44.44 0 01.45.43v6.49H1.44a.44.44 0 01-.44-.43V5.55H.5a.5.5 0 00-.5.5v7a1.44 1.44 0 001.44 1.45h9.93a.5.5 0 00.5-.5v-1.58h1.56a.5.5 0 00.5-.5v-1.58h1.57a.5.5 0 00.5-.5V2.92a1.43 1.43 0 00-1.43-1.42zm-1.64 9.92h-1.06V6.98a1.44 1.44 0 00-1.45-1.43H3.21v-1h9.29a.42.42 0 01.43.42v6.45zM15 9.34h-1.07V5a1.42 1.42 0 00-1.43-1.42H5.28V2.5h9.29a.42.42 0 01.43.42v6.42z","fill":"currentColor"}})]) } };

var iconPoc = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.904 4.07a4.997 4.997 0 00-1.091-2.289A5.018 5.018 0 007.207.059a5.025 5.025 0 00-2.332 1.01 5.097 5.097 0 00-1.861 3.57 5.08 5.08 0 001.32 3.805c.55.636.976 1.369 1.254 2.162v2.832a.5.5 0 00.502.5h3.803a.503.503 0 00.502-.5v-2.842a.5.5 0 00-.502-.5H6.401a7.372 7.372 0 00-1.365-2.302 4.07 4.07 0 01-1.065-3.05 4.064 4.064 0 011.496-2.865 3.959 3.959 0 013.373-.8c.77.17 1.473.562 2.021 1.128.548.566.917 1.28 1.06 2.054a4.052 4.052 0 01-.843 3.352c-.295.353-.566.724-.813 1.111l.843.54c.228-.35.48-.684.752-1a5.1 5.1 0 001.044-4.193zm-6.353 7.006h2.84v1.922h-2.84v-1.922zM9.904 15H6.05v1h3.854v-1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M4.966 5.161h1.003a2.219 2.219 0 01.635-1.573c.412-.42.974-.66 1.563-.668V1.919c-.854.01-1.67.357-2.27.964a3.228 3.228 0 00-.931 2.278z","fill":"currentColor"}})]) } };

var iconPodcast = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.933 10.654a2.293 2.293 0 002.212-2.36V2.359A2.292 2.292 0 007.933 0h-.038a2.292 2.292 0 00-2.213 2.36v5.934a2.299 2.299 0 002.25 2.36zM6.619 2.359A1.321 1.321 0 017.895 1h.038a1.32 1.32 0 011.274 1.36v5.934a1.296 1.296 0 11-2.588 0V2.359z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.913 11.618A3.06 3.06 0 014.9 8.52h-.937a4.04 4.04 0 003.482 4.049v.87H6.116a.738.738 0 00-.726.666l-.252 1.017-.016.128a.741.741 0 00.73.75h4.123a.741.741 0 00.73-.75l-.268-1.144a.74.74 0 00-.726-.668H8.382v-.87a4.04 4.04 0 003.483-4.048h-.938a3.06 3.06 0 01-3.014 3.098zM9.69 15H6.138l.14-.562H9.55l.139.562zM11.491 2.907a2.085 2.085 0 010 2.804l.663.706a3.131 3.131 0 000-4.216l-.663.706zM14.348 1.33l-.664.706a3.378 3.378 0 010 4.547l.664.706a4.429 4.429 0 000-5.959zM4.51 2.908L3.845 2.2a3.13 3.13 0 000 4.217l.663-.707a2.082 2.082 0 010-2.803zM1.653 1.33a4.425 4.425 0 000 5.959l.663-.706a3.379 3.379 0 010-4.547l-.663-.706z","fill":"currentColor"}})]) } };

var iconPointer = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 31 36"}},[_c('g',{attrs:{"filter":"url(#assets-icon-pointer_svg__filter0_dd)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 4.52v13.662s.03 2.138 0 2.102c-1.603-1.886-2.116-2.848-2.577-2.985-.705-.208-1.938-.3-2.618.353-.681.654 0 3.142 0 3.142l7.749 10.51 1.697.136 11.31-.137 1.39-1.606 2.01-7.851v-5.84l-1.078-1.565s-2.319-.567-2.882 0c-.562.567-.795 1.362-.795 1.362s-.96-3.211-2.615-3.211c-1.654 0-2.366 1.849-2.366 1.849s-.251-2.629-2.295-2.629c-2.043 0-2.42 2.124-2.42 2.124V5.752s-.148-2.936-2.258-2.936S8.5 4.52 8.5 4.52z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.153 26.635h1.808v-6.75h-1.808v6.75zm4.855 0h1.809v-6.75h-1.809v6.75zm4.856 0h1.809v-6.75h-1.809v6.75zM4.881 17.69c-.323 0-.617.097-.893.294a1.396 1.396 0 00-.6.991c-.065.434.03.825.294 1.198l7.06 9.832c.305.413.692.61 1.212.61h11.477c.363 0 .677-.109.962-.331.274-.216.445-.495.521-.855l1.77-7.614c.025-.103.036-.215.036-.345v-5.366c0-.452-.138-.803-.434-1.103-.296-.3-.643-.44-1.09-.44-.446 0-.792.14-1.089.44-.296.3-.434.651-.434 1.103v.693h-1.808v-2.034c0-.453-.138-.803-.435-1.103-.296-.3-.642-.44-1.09-.44-.446 0-.792.14-1.088.44-.297.3-.435.65-.435 1.103v2.034H17.01V13.87c0-.453-.138-.803-.434-1.103-.297-.3-.643-.44-1.09-.44-.447 0-.792.14-1.089.44-.296.3-.434.65-.434 1.103v2.928h-1.809V4.928c0-.453-.137-.803-.434-1.103-.296-.3-.643-.44-1.09-.44-.446 0-.792.14-1.089.44-.296.3-.434.65-.434 1.103v17.554l-3.002-4.18c-.233-.342-.535-.525-.957-.59a1.762 1.762 0 00-.266-.02zM23.43 32H11.954c-.946 0-1.745-.405-2.313-1.171l-7.068-9.845c-.477-.676-.656-1.42-.537-2.215.12-.807.513-1.451 1.165-1.916a2.842 2.842 0 012.151-.51c.798.122 1.426.512 1.867 1.157l.52.724V4.928c0-.821.28-1.522.835-2.082C9.128 2.284 9.82 2 10.63 2s1.502.284 2.055.846c.554.56.835 1.26.835 2.082V11.7c.539-.503 1.199-.758 1.965-.758.81 0 1.502.285 2.056.846.291.295.507.628.646.998a3.51 3.51 0 01.098-.104c.554-.56 1.246-.846 2.056-.846s1.502.285 2.056.846c.377.383.628.83.75 1.335.552-.556 1.242-.839 2.05-.839.81 0 1.501.284 2.055.845.554.561.835 1.262.835 2.082v5.366c0 .243-.025.47-.076.672l-1.763 7.59a2.769 2.769 0 01-1.02 1.648c-.525.41-1.13.619-1.797.619z"}})]),_c('defs',[_c('filter',{attrs:{"id":"assets-icon-pointer_svg__filter0_dd","x":"-1.304","y":"0","width":"34","height":"36","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"1"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.0784314 0 0 0 0 0.12549 0 0 0 0 0.160784 0 0 0 0.12 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}}),_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"1"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.08 0 0 0 0 0.124 0 0 0 0 0.16 0 0 0 0.12 0"}}),_c('feBlend',{attrs:{"in2":"effect1_dropShadow","result":"effect2_dropShadow"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect2_dropShadow","result":"shape"}})],1)])]) } };

var iconPopBack = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.76 2.64L7.48 7.88V5.57h-1v3.51a.5.5 0 00.5.5h3.54v-1H8.19l5.27-5.23-.7-.71zM5.83 15H1v-4.78h1.89v-1H1a1 1 0 00-1 1V15a1 1 0 001 1h4.83a1 1 0 001-1v-1.92h-1V15z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16 .5a.5.5 0 00-.5-.5H5.21a1.29 1.29 0 00-1.29 1.29v10.25a.5.5 0 00.5.5h10.29A1.29 1.29 0 0016 10.75V1.81h-1v8.94a.29.29 0 01-.29.29H4.92V1.29A.29.29 0 015.21 1H16V.5z","fill":"currentColor"}})]) } };

var iconPopOut = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8.36 8.35l4.14-4.13V6h1V3a.5.5 0 00-.5-.5h-3v1h1.79L7.65 7.64l.71.71z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 0H5.24A1.29 1.29 0 004 1.29V8h1V1.29A.29.29 0 015.24 1H16V.5a.5.5 0 00-.5-.5zM15 10.75a.29.29 0 01-.29.29H8v1h6.71A1.29 1.29 0 0016 10.75V1.82h-1v8.93zM6.49 9H.5a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h6a.5.5 0 00.5-.5v-6a.5.5 0 00-.51-.5zM6 15H1v-5h5v5z","fill":"currentColor"}})]) } };

var iconPressRelease = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M9.954 2.19a.998.998 0 00-.828-.16l-.19.12C7.69 2.788 2.252 6.589.526 7.796l-.07.07a2.324 2.324 0 00-.27 2.294c.42 1.516 1.327 1.765 1.437 1.785H3.41A2.404 2.404 0 005.724 14c.62 0 1.215-.243 1.656-.678.374-.35.623-.812.708-1.317a26.824 26.824 0 003.811-.17c1.278-.399 1.168-2.992.48-5.446-.57-2.035-1.547-3.72-2.425-4.2zm-8.82 7.7a1.685 1.685 0 010-1.316C3.29 7.067 6.432 4.893 8.118 3.766a2.992 2.992 0 000 .309c-.02.48.004.96.07 1.436l.998-.12a7.24 7.24 0 01-.06-1.276c0-.788.21-.998.26-1.087.299 0 1.336 1.177 1.995 3.62.658 2.444.449 4.14.17 4.23-.28.09-1.318-1.167-1.996-3.631-.06-.23-.12-.449-.17-.668l-.997.22c.05.238.11.478.18.727.334 1.254.899 2.435 1.665 3.482h-8.41c-.12-.1-.47-.33-.689-1.118zm5.587 2.713a1.257 1.257 0 01-.997.4 1.397 1.397 0 01-1.297-.998H7.02a1.376 1.376 0 01-.3.598zM15.66 6.13l-.289-.958-2.085.659.3.947 2.075-.648zM13.805 8.085l-.28.957 2.185.659.29-.958-2.195-.658zM13.835 2.28l-1.427 1.786.768.618 1.427-1.775-.768-.629z","fill":"currentColor"}})]) } };

var iconPricingRules = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.5 1.945h-1.08v1.002H14v11.44a.582.582 0 01-.57.581H2V3.478a.581.581 0 01.57-.53h.93v1a.501.501 0 00.5.502h8a.5.5 0 00.5-.501V1.945a.502.502 0 00-.5-.5H9.88A1.944 1.944 0 008.005 0 1.938 1.938 0 006.13 1.445H4a.5.5 0 00-.5.5h-.93A1.579 1.579 0 001 3.478V15.5a.502.502 0 00.5.501h11.93A1.578 1.578 0 0015 14.387V2.367a.501.501 0 00-.5-.422zm-10 .501h2.06a.5.5 0 00.5-.5.973.973 0 01.97-.972.97.97 0 01.97.971.501.501 0 00.5.501h2v1.002h-7V2.446z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.66 13.466v-1.002a1.64 1.64 0 001.15-1.573c0-.912-.73-1.272-1.32-1.553l-.22-.11c-.58-.27-.77-.46-.77-.701a.672.672 0 01.66-.661.65.65 0 01.59.38l.91-.42a1.673 1.673 0 00-1-.882v-.992h-1v1.002A1.67 1.67 0 003.5 8.527c0 .911.77 1.282 1.33 1.563l.23.11c.59.29.75.4.75.651a.662.662 0 01-.65.661.639.639 0 01-.62-.45l-1 .31a1.663 1.663 0 001.08 1.062v1.002l1.04.03zM11.46 6.924H8.35v1.002h3.11V6.924zM12.46 8.938H8.35v1.001h4.11V8.938zM10.46 10.951H8.35v1.002h2.11V10.95z","fill":"currentColor"}})]) } };

var iconPrint = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.5 3.48H4V1h8v1.51h1V.5a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v3H.5A.5.5 0 000 4v8a1.51 1.51 0 001.5 1.5H3v2a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-2h2.5a.5.5 0 00.5-.5V5a1.5 1.5 0 00-1.5-1.52zM12 15H4V9h8v6zm3-2.5h-2v-4a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v4H1.5A.51.51 0 011 12V4.48h13.5A.5.5 0 0115 5v7.5z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.02 10.36h-6v1h6v-1zM11.02 12.68h-6v1h6v-1zM13.74 5.28a.5.5 0 10.5.5.51.51 0 00-.5-.5z","fill":"currentColor"}})]) } };

var iconPrivatelyHeld = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.59 11.201a1.54 1.54 0 00-.89-.771 1.506 1.506 0 00-1.16.09l-.27.14V2.525a.512.512 0 00-.5-.501H8.25V.5A.501.501 0 007.75 0h-2a.5.5 0 00-.5.5v1.504h-.52a.5.5 0 00-.5.5v1.504H1.75a.5.5 0 00-.5.5v4.94h-.5a.5.5 0 00-.5.5v.512h2.47a3.835 3.835 0 011.73.42l.62.311c.372.19.783.29 1.2.29h2.84a.52.52 0 01.52.531.562.562 0 01-.09.311.53.53 0 01-.43.22H5.73v1.002h3.75c.236-.002.468-.056.68-.16l3.83-2.004a.56.56 0 01.4 0 .54.54 0 01.07 1.002c-2.53 1.213-5.41 2.565-5.7 2.645H6.83l-4-1.092H1.25v-2.394h-1v2.875a.501.501 0 00.5.501h1.92l4 1.082H8.8c.13 0 .44 0 6.15-2.765a1.542 1.542 0 00.64-2.034zm-3.34-3.246h-7V5.77h7v2.184zm-6-6.953h1v1.002h-1V1.002zm6 2.004v1.763h-7V3.006h7zm-10 6.442V5.009h2V9.7a4.872 4.872 0 00-1.51-.251h-.49zm6.86 1.002H6.25a1.679 1.679 0 01-.74-.18l-.26-.131V8.957h7v2.214l-1.62.852a1.525 1.525 0 00-1.52-1.553v-.02z","fill":"currentColor"}})]) } };

var iconProcess = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M3.725 7.734l-.986 1.185a6.292 6.292 0 011.026-4.122A6.086 6.086 0 017.154 2.32l-.256-.985a7.112 7.112 0 00-3.91 2.871A7.352 7.352 0 001.774 8.96L.65 7.955 0 8.779l2.08 1.768a.565.565 0 00.324.12.466.466 0 00.345-.18l1.705-2.11-.73-.643zM13.44 12.154l-2.601-.482-.178 1.005 1.488.281a5.836 5.836 0 01-3.478 1.145 5.814 5.814 0 01-2.31-.468 5.91 5.91 0 01-1.947-1.35l-.71.723a6.902 6.902 0 004.336 2.09 6.857 6.857 0 004.632-1.266l-.257 1.497.986.17.463-2.752a.51.51 0 00-.234-.527.486.486 0 00-.19-.066zM11.75 2.007l1.38-.563L12.755.5l-2.513 1.005a.507.507 0 00-.271.273.522.522 0 00-.004.39l.985 2.552.936-.372-.562-1.447a6.151 6.151 0 013.028 2.922 6.33 6.33 0 01.48 4.221l.986.231a7.391 7.391 0 00-.577-4.88 7.186 7.186 0 00-3.493-3.388z","fill":"currentColor"}})]) } };

var iconProject = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.85 12.72L11.13 8l4.44-4.44c.26-.24.415-.575.43-.93a1.32 1.32 0 00-.39-.94L14.38.51a1.36 1.36 0 00-1.87 0L8.07 4.94 3.28.15a.5.5 0 00-.71 0L.15 2.57a.5.5 0 000 .71l4.77 4.81-3 3a1.43 1.43 0 00-.32.49L.5 14.42a1.05 1.05 0 00.28 1.17c.198.178.454.278.72.28.173.002.344-.035.5-.11l2.58-1.29c.137-.066.262-.154.37-.26l5.5-5.51 1 1-.86.85.71.71.86-.85 1.24 1.24-.85.86.71.7.85-.85.69.69-1.72 1.72-3.55-3.52-.71.7 3.9 3.9a.5.5 0 00.35.15.51.51 0 00.36-.15l2.42-2.42a.49.49 0 00.15-.36.47.47 0 00-.15-.35zM13.22 1.21a.28.28 0 01.22-.09.29.29 0 01.23.1l1.18 1.18a.29.29 0 01.1.23.29.29 0 01-.09.22L13.69 4l-1.64-1.62 1.17-1.17zm-12 1.72l1.71-1.72.69.69-.86.85.71.71.86-.85 1.24 1.24-.85.86.71.7.85-.85 1.09 1.09-1.74 1.73-4.41-4.45zm.26 11.88l.93-2.55 1.45 1.45-2.38 1.1zm3.16-1.73L3 11.44l8.35-8.35L13 4.73l-8.36 8.35z","fill":"currentColor"}})]) } };

var iconPushpin = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M10.182 4.017L7.689 6.512l.706.707 2.493-2.495-.706-.707z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.45 4.894L11.096.536a1.817 1.817 0 00-3.106 1.29c-.005.46.17.906.49 1.239l-1.828 1.83a3.99 3.99 0 00-2.946-.17c-.113.02-.223.053-.329.1l.809.809a2.993 2.993 0 012.307.31.519.519 0 00.609-.08l2.436-2.44a.53.53 0 00.15-.359.51.51 0 00-.15-.35l-.31-.31a.8.8 0 01-.239-.58.78.78 0 01.24-.58.819.819 0 011.158 0l4.354 4.359a.78.78 0 01.24.58.822.822 0 01-.24.58.828.828 0 01-1.159 0l-.31-.31a.499.499 0 00-.708 0l-2.437 2.439a.47.47 0 00-.08.6 3.002 3.002 0 01-.14 3.278l-2.406-2.409-1.847-1.85-1.748-1.748-1.428-1.42-.36.35a.51.51 0 000 .7l2.527 2.529L.092 15.21a.49.49 0 00.06.64A.47.47 0 00.5 16a.449.449 0 00.29-.1l6.29-4.548 2.507 2.509a.5.5 0 00.4.14.509.509 0 00.36-.15 4 4 0 00.788-4.528l1.777-1.82a1.817 1.817 0 002.939-2.024 1.821 1.821 0 00-.402-.585zM2.738 13.271l2.626-3.639.999 1-3.625 2.639z","fill":"currentColor"}})]) } };

var iconPuzzle = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 0H.5a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h13.57v-1H8.52v-1.33c.15.04.305.06.46.06a2 2 0 100-4 1.75 1.75 0 00-.46.05V8.5h2.1a.51.51 0 00.45-.29.53.53 0 00-.07-.54 1 1 0 111.48 0 .531.531 0 00-.07.54.51.51 0 00.45.29H15V16h.5a.492.492 0 00.49-.5V.5a.5.5 0 00-.49-.5zM1 1h6.48v1.33A2 2 0 107 6.27c.153.02.307.02.46 0V7.5H5.38a.49.49 0 00-.45.29.51.51 0 00.07.53 1 1 0 11-1.48 0 .51.51 0 00.07-.53.49.49 0 00-.45-.29H1V1zm8 9.78a1 1 0 010 2 1 1 0 01-.63-.24.51.51 0 00-.752.112.49.49 0 00-.078.268V15H1V8.5h1.33a2.3 2.3 0 00-.05.5 2 2 0 004 0 2.3 2.3 0 000-.45h1.24v2.13a.49.49 0 00.29.45.47.47 0 00.53-.13 1 1 0 01.66-.22zm4.67-3.28c.035-.164.052-.332.05-.5a2 2 0 10-4 0c.001.155.018.309.05.46H8.48V5.37a.48.48 0 00-.29-.45.47.47 0 00-.53.08 1 1 0 01-.66.22 1 1 0 110-1.95 1 1 0 01.63.24.53.53 0 00.54.07.49.49 0 00.29-.45V1H15v6.5h-1.33z","fill":"currentColor"}})]) } };

var iconQuoteIntegration = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M5.03 10.53H2.5v1h2.53v-1zM13.6 10.53H7.04v1h6.56v-1zM9.2 12.78H2.5v1h6.7v-1zM13.6 12.78h-2.41v1h2.41v-1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16 .5a.5.5 0 00-.5-.5H1.57A1.58 1.58 0 000 1.57V15.5a.5.5 0 00.5.5h13.93A1.58 1.58 0 0016 14.43V2h-1v12.43a.58.58 0 01-.57.57H1V1.57A.58.58 0 011.57 1H16V.5z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.56 2v1a1.67 1.67 0 00-1.15 1.59c0 .92.77 1.29 1.33 1.56l.26.11c.6.28.76.4.76.65a.66.66 0 01-1.28.2l-1 .31a1.64 1.64 0 001.08 1.06v1h1v-1a1.67 1.67 0 001.16-1.57C9.72 6 9 5.64 8.4 5.36l-.23-.11c-.57-.28-.76-.41-.76-.66a.65.65 0 01.65-.65.66.66 0 01.6.38l.91-.42a1.66 1.66 0 00-1-.88V2H7.56z","fill":"currentColor"}})]) } };

var iconRedirects = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.81 2.65v-.69l.83.82.71-.7L12.67.4a.5.5 0 00-.71 0l-1.69 1.68.71.7.83-.82v.69a5.58 5.58 0 01-2.74 4.54l1 .49a6.42 6.42 0 002.74-5.03zM5.77 8.85a6.9 6.9 0 00-4.27 6v.9h1v-.9a5.89 5.89 0 013.7-5.09l.65-.31a9 9 0 01-1-.61l-.08.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.23 8.85l-1.11-.52L8 7.79h-.11a5.91 5.91 0 01-3.7-5.14v-.69l.83.82.71-.7L4.04.4a.46.46 0 00-.35-.15.5.5 0 00-.36.14L1.65 2.08l.71.7.83-.82v.69a6.72 6.72 0 003.69 5.68c.19.1.37.22.58.31L8 8.9l1.8.86a5.89 5.89 0 013.7 5.09v.9h1v-.9a6.9 6.9 0 00-4.27-6z","fill":"currentColor"}})]) } };

var iconReload = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10.46 12.88a5.66 5.66 0 01-4.292.36 5.572 5.572 0 01-3.28-2.742 5.334 5.334 0 01-.36-4.192 5.492 5.492 0 012.73-3.191 5.71 5.71 0 014.29-.36 5.591 5.591 0 013.002 2.31l-2.03-.42-.201 1 3.18.631h.1a.5.5 0 00.49-.4l.661-3.202-1-.21-.4 1.921a6.542 6.542 0 00-3.471-2.581 6.64 6.64 0 00-5.001.42 6.452 6.452 0 00-3.3 3.802 6.355 6.355 0 00.42 5.002 6.592 6.592 0 003.88 3.172 6.88 6.88 0 002 .3 6.57 6.57 0 003.001-.73 6.472 6.472 0 003.27-3.802l-.89-.3a5.494 5.494 0 01-2.8 3.211z","fill":"currentColor"}})]) } };

var iconRemoveUser = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.908 15.5H.66a.642.642 0 01-.66-.62v-2.66c0-1.57 3.162-2.61 4.133-2.89.3-.09.41-.23.45-.36A5.23 5.23 0 013.122 5.2c0-2.59 1.641-4.7 3.662-4.7s3.663 2.11 3.663 4.7c0 2.59-1.642 4.71-3.663 4.71v-1c1.471 0 2.662-1.66 2.662-3.71s-1.19-3.7-2.662-3.7c-1.47 0-2.661 1.66-2.661 3.7a4.128 4.128 0 001.27 3.15.66.66 0 01.19.39 1.45 1.45 0 01-1.18 1.55C2.802 10.76 1 11.67 1 12.22v2.28h11.567v-2.28c0-.61-1.681-1.41-2.892-1.75l.33-.97c.6.17 3.612 1.1 3.612 2.71v2.65a.65.65 0 01-.71.64zM16 5.82h-4.103v1H16v-1z","fill":"currentColor"}})]) } };

var iconRepeat = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M4.72 2.272a6.234 6.234 0 015-.44 6.592 6.592 0 013.7 3.114l-2.19-.44-.21 1 3.23.681h.1a.57.57 0 00.28-.08.47.47 0 00.21-.32l.66-3.405-1-.19-.39 2.003A7.592 7.592 0 0010.04.88a7.25 7.25 0 00-5.8.511A7.778 7.778 0 00.5 6.017l1 .29a6.747 6.747 0 013.22-4.035zM11.28 13.748a6.232 6.232 0 01-5 .44 6.592 6.592 0 01-3.7-3.114l2.19.44.21-1-3.23-.642a.52.52 0 00-.38.07.47.47 0 00-.21.321L.5 13.637l1 .19.39-2.002a7.542 7.542 0 004.1 3.295 6.99 6.99 0 002.3.38 7.353 7.353 0 003.49-.891 7.788 7.788 0 003.72-4.596l-1-.3a6.747 6.747 0 01-3.22 4.035z","fill":"currentColor"}})]) } };

var iconRequest = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13 11.56a5.69 5.69 0 00-3.18-4.63l-.4.92A4.68 4.68 0 0112 11.78c0 .5-1.91 1-3.93 1h-.15c-2 0-3.93-.47-3.93-1a4.35 4.35 0 014.06-4.35.51.51 0 00.45-.5v-1.1c.52-.07.89-.25.89-.45S8.77 4.89 8 4.89c-.77 0-1.39.22-1.39.49s.37.38.89.45v.66A5.31 5.31 0 003 11.57c-1.54.4-1.68.71-1.75.87a2.65 2.65 0 00-.08 1.63C1.4 14.58 3.42 16 8 16s6.59-1.42 6.82-1.94a2.62 2.62 0 00-.08-1.62c-.06-.16-.2-.44-1.74-.88zM8 15c-3.92 0-5.7-1.11-5.89-1.32a1.91 1.91 0 010-.76 7.3 7.3 0 011.11-.37c.88 1.11 3.69 1.22 4.66 1.22h.16c1 0 3.78-.11 4.66-1.22.379.093.75.217 1.11.37.062.225.092.457.09.69-.19.27-1.97 1.39-5.9 1.39zM4.91 5a1.94 1.94 0 01.87-1.26l-.56-.84a3 3 0 00-1.3 1.9l.99.2zM2 4.8L3 5a4 4 0 011.71-2.6l-.55-.84A4.94 4.94 0 002 4.8zM3.8.84L3.24 0A7.36 7.36 0 000 4.8L1 5A6.36 6.36 0 013.8.84zM11.09 5l1-.18a2.999 2.999 0 00-1.3-1.92l-.56.84A1.94 1.94 0 0111.09 5zM13.05 5l1-.18a4.941 4.941 0 00-2.19-3.24l-.55.84A4 4 0 0113.05 5zM12.76 0l-.56.84A6.36 6.36 0 0115 5l1-.18A7.36 7.36 0 0012.76 0z","fill":"currentColor"}})]) } };

var iconReturnToLocation = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.82 8a.5.5 0 00.5.5H16v-1h-2.2a5.82 5.82 0 00-5.3-5.28V0h-1v2.2a5.82 5.82 0 00-5.31 5.3H0v1h2.19a5.82 5.82 0 005.31 5.3V16h1v-2.21a5.81 5.81 0 005.06-4.06l-1-.3A4.82 4.82 0 1112.82 8z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.36 8a2.63 2.63 0 105.26 0 2.63 2.63 0 00-5.26 0zm4.26 0a1.63 1.63 0 11-3.26 0 1.63 1.63 0 013.26 0z","fill":"currentColor"}})]) } };

var iconReward = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.68 5.247l.32-.49-3.48-3.507h-9L0 4.757l8 9.993 7-8.324h-1.11L9 12.372l1.84-7.125h4.84zM7.07 2.149L5.58 4.038 4.45 2.149h2.62zm.93.27l1.55 1.999h-3.1L8 2.419zm-4.42 0l1.16 1.999H1.65l1.93-1.999zm-2.2 2.828h3.78l2 7.095-5.78-7.095zm6.69 7.295L6.08 5.247h3.84l-1.85 7.295zm2.35-8.504L8.93 2.149h2.62l-1.13 1.889zm.84.34l1.16-1.949 1.93 1.999-3.09-.05z","fill":"currentColor"}})]) } };

var iconRocket = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M15.994.797a.701.701 0 00-.79-.79 15.416 15.416 0 00-8.614 4l-.14.15H6.3c-1-.23-1.729-.39-2.199-.09-1.339.76-3.677 2.27-3.677 2.27l-.08.07a1.15 1.15 0 00-.33 1 1 1 0 00.49.75c.902.501 1.837.942 2.798 1.32l1.26 1.26-1.14 1.15.71.7 1.139-1.14 1.269 1.26c.388.968.846 1.907 1.369 2.81a1 1 0 00.73.48h.15c.307-.001.6-.123.819-.34l.06-.08s1.519-2.34 2.358-3.67c.3-.48.14-1.25-.1-2.21l-.08-.35a.56.56 0 000-.12.51.51 0 00-.35-.33.51.51 0 00-.499.11 18.34 18.34 0 01-3.927 2.81L6 10.737l3.498-3.5-.71-.71-3.517 3.48-1.11-1.08v-.11c.252-.556.553-1.088.9-1.59l-.76-.59c-.385.549-.72 1.13-.999 1.74-.48-.2-1.45-.68-2.299-1.12a.15.15 0 010-.11l3.598-2.31c.42-.012.838.045 1.24.17l.619.56c.27-.3.54-.59.83-.88a14.307 14.307 0 017.704-3.63 15.004 15.004 0 01-2.828 6.76l.78.62a16.136 16.136 0 003.048-7.64zm-4.937 9.53c.096.324.143.662.14 1-.77 1.21-2.079 3.24-2.319 3.61h-.09c-.46-.88-.999-1.87-1.179-2.35a19.917 19.917 0 003.438-2.26h.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.226 3.767a1 1 0 10-1.409 1.42.999.999 0 001.628-1.095 1 1 0 00-.219-.325z","fill":"currentColor"}})]) } };

var iconRocketship = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.354 8.95c-1.266-1.258-2.576-2.56-2.644-3.984h-.012a7.997 7.997 0 00-.089-1.023C10.06 1.669 8.97.015 8.012 0h-.023C7.03.015 5.94 1.67 5.392 3.943a8.137 8.137 0 00-.09 1.04l-.012-.001c-.068 1.425-1.378 2.726-2.644 3.983C1.286 10.316 0 11.592 0 13.151v.897a.508.508 0 00.5.516h2.411v-1.032h-1.91v-.38c0-1.121 1.135-2.249 2.338-3.443a19.156 19.156 0 001.883-2.064c-.018.927-.033 1.94-.044 2.954L3.96 11.624a.524.524 0 00-.184.4v2.822a.508.508 0 00.5.516H7.5V16h1v-.638h3.225a.507.507 0 00.5-.516v-.298H15.5a.508.508 0 00.5-.516v-.897c0-1.56-1.285-2.835-2.646-4.186zm-8.578 3.32l.39-.328c-.006.854-.01 1.667-.012 2.388h-.378v-2.06zm2.724-.417v2.477H6.153c.011-4.967.107-9.667.21-10.138.501-2.086 1.372-3.098 1.634-3.159.274.068 1.14 1.08 1.642 3.157.102.473.198 5.173.209 10.14H8.5v-2.477h-1zm3.725 2.477h-.378c-.002-.72-.006-1.534-.012-2.388l.39.328v2.06zM15 13.516h-2.775v-1.491a.524.524 0 00-.184-.4l-1.219-1.026c-.01-1.019-.025-2.038-.043-2.969a19.19 19.19 0 001.882 2.063C13.864 10.887 15 12.015 15 13.135v.38z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.656 3.726H7.191v1.032h1.465V3.726z","fill":"currentColor"}})]) } };

var iconSalesPlaybook = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M4.243 6.3h6.16a1.147 1.147 0 001.107-.94l.29-1.71a1 1 0 00-.2-.77.997.997 0 00-.738-.33h-6.16a1.157 1.157 0 00-1.118.94l-.28 1.7a1.001 1.001 0 00.2.77.999.999 0 00.739.34zm.33-2.65a.17.17 0 01.129-.1l6.12-.06-.29 1.7a.18.18 0 01-.13.11l-6.12.06.29-1.71z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.903 3.28a.539.539 0 00-.33-.2L15.066 3l-.16 1-1.767 10.6a.51.51 0 01-.51.41H1.768a.738.738 0 01-.749-.73c0-.71.46-.71.61-.71h9.224a1.316 1.316 0 001.268-1.06l1.876-11.28a1.053 1.053 0 00-.22-.86 1.058 1.058 0 00-.778-.37H4.542a2.553 2.553 0 00-2.466 2.07L.08 13.72c-.053.181-.08.37-.08.56a1.733 1.733 0 001.096 1.6c.214.084.442.125.671.12h10.872a1.496 1.496 0 001.487-1.24l1.867-11.1a.51.51 0 00-.09-.38zm-12.838-1A1.57 1.57 0 014.542 1l8.486.06-1.897 11.28a.31.31 0 01-.28.23H1.628a1.76 1.76 0 00-.33 0L3.066 2.28z","fill":"currentColor"}})]) } };

var iconSandbox = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 10h-1.08c-.38-4.4-.54-6.26-.62-7.06h.07a.64.64 0 00.64-.64V.65a.65.65 0 00-.64-.65h-1.65a.64.64 0 00-.63.65v.55h-.35V.65a.64.64 0 00-.63-.65H9a.64.64 0 00-.63.65v.55H8V.65A.64.64 0 007.34 0H5.68a.64.64 0 00-.63.65v1.62a.64.64 0 00.63.64h.07c0 .4-.09 1.07-.19 2.16H4.09V1.33A.6.6 0 003.505.8.53.53 0 003.3.84L.68 2.2a.5.5 0 00-.27.49.49.49 0 00.37.43l2.31.64v1.31H3a.9.9 0 00-.89.9l-.35 4H.5a.5.5 0 00-.5.5v1.76a.5.5 0 00.5.5h13.91V15H1.59v-1.25h-1v1.33a.9.9 0 00.88.92h13.06a.9.9 0 00.88-.92v-2.35h.09a.5.5 0 00.5-.5v-1.76a.5.5 0 00-.5-.47zM2.29 2.5l.8-.41v.63l-.8-.22zm.79 3.57h2.4c-.06.69-.13 1.5-.21 2.47l1 .08c.2-2.36.5-5.94.52-6.08a.54.54 0 00-.09-.43.49.49 0 00-.4-.2h-.25V1H7v.7a.5.5 0 00.5.5h1.32a.5.5 0 00.5-.5V1h.92v.7a.499.499 0 00.5.5h1.35a.5.5 0 00.5-.5V1h.92v.91h-.25a.48.48 0 00-.499.358.45.45 0 00-.001.212c0 .2.4 4.49.65 7.49h-1.6V6.63a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5V10h-5l.27-3.93zM10.81 10H8.75V7.13h2l.06 2.87zM1 11h14v.76H1V11z","fill":"currentColor"}})]) } };

var iconSave = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M16 14V4.25a.47.47 0 00-.15-.35L12.1.15a.47.47 0 00-.35-.15H.5a.5.5 0 00-.5.5v13.93A1.58 1.58 0 001.57 16H15.5a.5.5 0 00.5-.5V15h-2.5V9a.5.5 0 00-.5-.5H3a.5.5 0 00-.5.5v6h-.93a.58.58 0 01-.57-.57V1h7.82v2.42h1V1h1v3.53H5V2H4v3a.5.5 0 00.5.5h6.84a.5.5 0 00.5-.5V1.29L15 4.46V14h1zM3.5 9.5h9V15h-9V9.5z","fill":"currentColor"}})]) } };

var iconScalability = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M3.44 4.32h8v8.19h1V3.82a.5.5 0 00-.5-.51h-8.5v1.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.5 12.51V6.8a.51.51 0 00-.5-.51H3.44v1h5.05v5.21l1.01.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6.65 12.51V9.73a.51.51 0 00-.51-.51h-2.7v1h2.2v2.28l1.01.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.85 13.58l-1.72-1.7-.71.72.85.83H2.57V1.73l.83.85.72-.71L2.42.15A.48.48 0 002.06 0a.51.51 0 00-.36.15L0 1.87l.72.71.84-.85v11.7H1v1h.55V15h1v-.55h11.7l-.85.84.71.72 1.72-1.7a.51.51 0 00.15-.36.489.489 0 00-.13-.37z","fill":"currentColor"}})]) } };

var iconSearch = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M2.003 5.343h1a2.44 2.44 0 01.707-1.67 2.425 2.425 0 011.661-.716V1.955c-.89.015-1.74.378-2.368 1.01a3.444 3.444 0 00-1 2.378z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.526 13.273l-4.458-4.461-.7.711 4.458 4.461a.582.582 0 01.123.645.601.601 0 01-.133.197.567.567 0 01-.82 0L8.71 9.534A5.378 5.378 0 0010.01 2.74 5.352 5.352 0 007.225.342a5.332 5.332 0 00-3.672-.03A5.35 5.35 0 00.727 2.663a5.377 5.377 0 001.19 6.814 5.337 5.337 0 003.454 1.25 5.293 5.293 0 002.479-.632l5.437 5.433a1.578 1.578 0 002.249 0 1.575 1.575 0 000-2.235l-.01-.02zM1.004 5.343A4.4 4.4 0 011.737 2.9a4.365 4.365 0 016.74-.672 4.395 4.395 0 01.947 4.79 4.388 4.388 0 01-1.617 1.97 4.368 4.368 0 01-5.521-.55 4.398 4.398 0 01-1.282-3.095z","fill":"currentColor"}})]) } };

var iconSecurityTransformation = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.54 4.205h-.09V3.05a.477.477 0 00-.31-.468L9 .928v1.066l3.49 1.384v3.606c-.65.11-1.47.2-2.5.269l.07.996c.92-.06 1.72-.15 2.42-.249v.388a3.607 3.607 0 01-.91 2.42l-3.58 3.487-3.59-3.446a3.677 3.677 0 01-.94-2.48v-.28c.72.12 1.49.2 2.25.25l-1 .996.7.707 1.83-1.823a.478.478 0 000-.697L5.37 5.659l-.71.698 1 .996a18.65 18.65 0 01-2.17-.27V3.379L8 1.566V.5L2.78 2.582a.51.51 0 00-.32.458v1.175C1.42 4.484 0 4.783 0 6.008c0 .896 1 1.464 2.46 1.862v.499a4.67 4.67 0 001.22 3.167l3.89 3.815a.47.47 0 00.35.149.501.501 0 00.35-.15l4-3.854a4.621 4.621 0 001.19-3.098v-.587C15.14 7.472 16 6.845 16 6.008c0-1.235-1.44-1.524-2.46-1.803zM2.46 6.835C1.5 6.555 1 6.227 1 6.008c0-.388.76-.608 1.46-.777v1.604zm11-.05V5.2c.87.21 1.51.419 1.51.807.03.01-.05.408-1.54.777h.03z","fill":"currentColor"}})]) } };

var iconSeries = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 5.012H4.007a.5.5 0 00-.5.5v6.997h-.674V4.02h10.121a.368.368 0 01.372.364h1a1.369 1.369 0 00-1.372-1.364H2.342a.515.515 0 00-.509.51v6.956H1V2h10.121a.368.368 0 01.372.363h1A1.369 1.369 0 0011.121 1H.51A.515.515 0 000 1.509v9.478a.5.5 0 00.5.5h1.333v1.522a.5.5 0 00.5.5h1.174V15a.5.5 0 00.5.5H15.5a.5.5 0 00.5-.5V5.512a.5.5 0 00-.5-.5zM15 14.5H4.507V6.012H15V14.5z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.96 7.753H7.983v1h5.977v-1zM6.916 7.753H5.737v1h1.179v-1zM13.96 9.748H7.983v1h5.977v-1zM6.916 9.748H5.737v1h1.179v-1zM13.96 11.742H7.983v1h5.977v-1zM6.916 11.742H5.737v1h1.179v-1z","fill":"currentColor"}})]) } };

var iconServiceOffering = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M2.967 7.113a1 1 0 001.279.581l.37-.14c.114.16.241.31.38.45l-.16.351c-.1.244-.1.518 0 .762a1 1 0 00.499.55l.5.231a.997.997 0 001.318-.49l.18-.402c.19.015.38.015.569 0l.14.361a1.001 1.001 0 00.929.641c.116.02.234.02.35 0l.529-.2a1 1 0 00.56-.521c.1-.244.1-.518 0-.761l-.14-.361c.145-.117.282-.244.409-.38l.36.16a.996.996 0 001.318-.502l.23-.51c.1-.244.1-.518 0-.762a1.001 1.001 0 00-.52-.56l-.36-.161a3.503 3.503 0 000-.561l.37-.13a.998.998 0 00.645-.907 1.004 1.004 0 00-.065-.386l-.21-.53a1 1 0 00-1.209-.602l-.37.14a2.728 2.728 0 00-.369-.39l.16-.351a.924.924 0 000-.762 1 1 0 00-.48-.56L9.66.18a.996.996 0 00-1.318.49l-.16.321a3.606 3.606 0 00-.57 0l-.13-.36A1 1 0 006.244.05l-.54.2a1 1 0 00-.559.521c-.097.241-.097.51 0 .751l.1.371a3.79 3.79 0 00-.42.38l-.38-.16a.996.996 0 00-1.318.491l-.24.521a1.005 1.005 0 00.5 1.323l.35.16a3.386 3.386 0 000 .551l-.36.14a1 1 0 00-.56.511c-.1.244-.1.518 0 .762l.15.54zM4.416 6a.49.49 0 00.32-.531 3.185 3.185 0 010-1.002.502.502 0 00-.28-.561l-.7-.3.28-.612.69.32a.508.508 0 00.599-.15 3.15 3.15 0 01.759-.7.501.501 0 00.16-.562l-.23-.711.53-.2.27.71a.49.49 0 00.529.291c.33-.056.668-.056.999 0a.498.498 0 00.559-.28l.34-.621.519.22-.31.681a.482.482 0 00.15.601c.267.21.5.46.69.742a.5.5 0 00.589.19l.719-.27.2.52-.72.271a.49.49 0 00-.31.541 3.2 3.2 0 010 1.002.492.492 0 00.29.551l.69.31-.27.552-.7-.31a.508.508 0 00-.598.15 2.94 2.94 0 01-.75.7.49.49 0 00-.2.592l.27.711-.53.16-.269-.71a.49.49 0 00-.46-.291h-.07c-.33.056-.668.056-.998 0a.498.498 0 00-.55.28l-.38.721-.519-.23.34-.771a.482.482 0 00-.15-.602 2.942 2.942 0 01-.67-.72.48.48 0 00-.588-.191l-.72.27-.2-.53.68-.231z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.752 6.522a1.495 1.495 0 001.375-.93 1.507 1.507 0 00-.322-1.632 1.497 1.497 0 00-2.561 1.039 1.507 1.507 0 00.927 1.41c.184.076.382.114.58.113zm0-2.004a.498.498 0 01.476.612.501.501 0 01-.694.345.5.5 0 01.218-.957zM15.573 11.24a1.53 1.53 0 00-2.047-.67l-2.907 1.442A1.525 1.525 0 009.1 10.499H6.244c-.26.001-.518-.06-.75-.18l-.599-.31a4.833 4.833 0 00-2.178-.512H.75a.498.498 0 00-.5.511v.491h2.467c.6.002 1.19.14 1.729.4l.629.322c.362.187.761.29 1.169.3H9.1a.508.508 0 01.52.511.512.512 0 01-.09.3.529.529 0 01-.43.221H5.724v1.002H9.47c.236.002.469-.053.68-.16l3.825-1.934a.518.518 0 01.7.23.472.472 0 010 .401.51.51 0 01-.26.3c-2.498 1.213-5.374 2.546-5.664 2.626H6.813l-3.946-1.072H1.25V11.59H.25v2.836a.501.501 0 00.5.5h1.917L6.663 16h2.128c.13 0 .44 0 6.133-2.725a1.469 1.469 0 00.76-.881 1.516 1.516 0 00-.11-1.152z","fill":"currentColor"}})]) } };

var iconServices = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M2.27 16a.474.474 0 01-.352-.15L.152 14.078a.48.48 0 010-.7l4.585-4.594a3.629 3.629 0 01.923-3.566A3.647 3.647 0 018.23 4.15a3.57 3.57 0 011.554.36.512.512 0 01.268.604.46.46 0 01-.127.197L8.159 7.082l.773.77 1.766-1.76a.502.502 0 01.802.13 3.595 3.595 0 01-1.506 4.752 3.619 3.619 0 01-2.768.292l-2.378 2.432 1.385.87a.28.28 0 00.18 0 .27.27 0 00.16-.17l.452-1.17a.52.52 0 01.542-.32 5.18 5.18 0 001.756-.06.513.513 0 01.562.28l.512 1.12a.26.26 0 00.17.15.242.242 0 00.22 0l.844-.38a.301.301 0 00.15-.38l-.511-1.121a.51.51 0 01.16-.61 5.148 5.148 0 001.194-1.272.502.502 0 01.592-.2l1.154.43a.29.29 0 00.381-.18l.301-.87a.29.29 0 00-.17-.38l-1.174-.441a.501.501 0 01-.321-.54 5.408 5.408 0 00-.07-1.752.49.49 0 01.28-.55l1.124-.521a.291.291 0 00.14-.39l-.38-.831a.27.27 0 00-.171-.16.24.24 0 00-.221 0l-1.124.51a.503.503 0 01-.612-.15A5.163 5.163 0 0011.1 3.44a.51.51 0 01-.2-.601l.44-1.151a.29.29 0 00-.17-.37l-.863-.331a.302.302 0 00-.391.17l-.432 1.171a.49.49 0 01-.541.32 5.11 5.11 0 00-1.746.06.503.503 0 01-.562-.28l-.512-1.12a.3.3 0 00-.391-.15l-.843.38a.3.3 0 00-.15.39l.511 1.12a.49.49 0 01-.15.611c-.478.369-.886.82-1.204 1.331a.502.502 0 01-.592.19L2.149 4.7a.302.302 0 00-.382.17l-.32.861a.29.29 0 00.17.38l1.154.43a.511.511 0 01.32.541c-.08.583-.059 1.176.061 1.752a.49.49 0 01-.28.55L.703 10.385a.998.998 0 01.632-1.391l.763-.35a6.16 6.16 0 010-1.292l-.793-.29A1.305 1.305 0 01.424 5.89a1.298 1.298 0 01.08-.51l.33-.86a1.29 1.29 0 011.167-.841c.17-.006.34.021.499.08l.793.3a6.62 6.62 0 01.883-1l-.342-.76A1.288 1.288 0 014.477.626l.842-.38a1.307 1.307 0 011.706.64l.351.77c.43-.044.864-.044 1.295 0l.361-.83a1.302 1.302 0 011.625-.76l.863.33a1.313 1.313 0 01.733 1.67l-.291.792c.332.251.638.537.913.85l.773-.35a1.317 1.317 0 011.003 0 1.285 1.285 0 01.732.68l.382.831a1.298 1.298 0 01-.633 1.722l-.772.35c.045.43.045.862 0 1.291l.793.3a1.295 1.295 0 01.846 1.172c.006.17-.023.34-.084.5l-.26.79a1.3 1.3 0 01-1.173.85 1.308 1.308 0 01-.503-.079l-.793-.3a6.1 6.1 0 01-.883.95l.351.761a1.298 1.298 0 01-.612 1.742l-.833.38a1.298 1.298 0 01-1.726-.64l-.35-.76c-.431.044-.865.044-1.295 0l-.301.79a1.28 1.28 0 01-1.166.844c-.17.006-.34-.023-.5-.083h-.1l-1.987-1.242a.52.52 0 01-.23-.36.56.56 0 01.14-.41l3.01-3.093a.513.513 0 01.552-.12c.318.132.66.196 1.003.19.7 0 1.371-.277 1.866-.77a2.629 2.629 0 00.773-1.862c.01-.137.01-.274 0-.41l-1.615 1.54a.512.512 0 01-.351.151.512.512 0 01-.352-.15L7.095 7.433a.5.5 0 010-.701l1.546-1.551a2.645 2.645 0 00-2.457.954 2.63 2.63 0 00-.403 2.599.48.48 0 01-.11.53l-4.455 4.464 1.003 1.06.712.711-.36.36a.492.492 0 01-.302.141z","fill":"currentColor"}})]) } };

var iconShare = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}},[_c('path',{attrs:{"d":"M11.862 3.92a1.96 1.96 0 100-3.92 1.96 1.96 0 000 3.92zm0-2.85a.9.9 0 110 1.8.9.9 0 010-1.8zM11.862 13.052c-.496-.001-.974.189-1.335.53L3.864 9.079c.064-.191.1-.391.106-.593a1.97 1.97 0 00-.106-.615l5.498-3.74-.593-.879-5.541 3.719a1.96 1.96 0 10-1.218 3.454 1.94 1.94 0 001.218-.477l6.706 4.544a1.96 1.96 0 101.886-1.44h.042zM2.01 9.365a.9.9 0 110-1.8.9.9 0 010 1.8zm9.852 6.537a.9.9 0 110-1.802.9.9 0 010 1.802z","fill":"currentColor"}})]) } };

var iconShipping = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 14"}},[_c('path',{attrs:{"d":"M6.18 5.014H1v.999h5.18v-.999zM2.19 4.086h5.19v-.999H2.69V2H9a.54.54 0 01.52.559v.749h1v-.75a1.534 1.534 0 00-.932-1.432A1.542 1.542 0 009 1H2.19a.5.5 0 00-.5.5v2.086a.499.499 0 00.5.5z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.5 6.842v-.999A1.497 1.497 0 0013 4.325h-3a.5.5 0 00-.5.5v5.602H6.88A1.997 1.997 0 005 8.989a2.002 2.002 0 00-2 1.598h-.31V8.11h2.49v-.998H0v.998h1.69v2.996a.5.5 0 00.5.5h.87a1.997 1.997 0 001.974 1.393 2.002 2.002 0 001.876-1.524h3.9a1.997 1.997 0 001.916 1.518 2.002 2.002 0 001.954-1.468h.82a.502.502 0 00.5-.539V8.35a1.507 1.507 0 00-1.5-1.508zM5 11.985a1.001 1.001 0 01-.98-1.194.998.998 0 011.363-.727.999.999 0 01-.383 1.92zm7.78 0a1.001 1.001 0 01-.98-1.194.998.998 0 011.363-.727.999.999 0 01-.413 1.92h.03zM15 10.477h-.32a1.997 1.997 0 00-1.906-1.481 2.002 2.002 0 00-1.944 1.43h-.33V5.325H13a.5.5 0 01.5.51V7.34a.5.5 0 00.5.5h.5a.5.5 0 01.5.509v2.127z","fill":"currentColor"}})]) } };

var iconSilverware = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}},[_c('path',{attrs:{"d":"M10.466 5.896l3.42-3.484-.722-.787L9.744 5.1l.722.797zM11.985 7.437l3.42-3.485-.722-.786-3.42 3.474.722.797z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.14 13.056l-4.515-3.835 1.53.213a1.52 1.52 0 001.328-.457l3.516-3.516-.722-.797-3.464 3.527a.53.53 0 01-.478.16l-1.604-.224a1.54 1.54 0 00-1.338.457l-.776.797-5.205 6.32a.574.574 0 01-.404.203.564.564 0 01-.414-.17l-.988-.999a.543.543 0 01-.16-.393.531.531 0 01.191-.383l6.215-5.364.786-.797a1.7 1.7 0 00.457-1.424l-.244-1.561A.489.489 0 019 4.356l3.346-3.41-.722-.787-3.347 3.41a1.636 1.636 0 00-.457 1.424l.245 1.562a.52.52 0 01-.149.457l-.754.765-.5.435-1.349-.127a1.615 1.615 0 01-1.137-.648L1.478 3.793a1.551 1.551 0 01-.319-.893l-.095-.998L6.078 7l.723-.786L.883.149A.5.5 0 00.31.053a.531.531 0 00-.308.52l.117 2.38C.14 3.5.33 4.027.66 4.462l2.698 3.644a2.656 2.656 0 001.87 1.062h.287L.979 13.11a1.667 1.667 0 00-.096 2.411l.988 1.063c.304.277.704.426 1.116.414h.074a1.573 1.573 0 001.19-.584l3.803-4.728 3.878 4.653a1.603 1.603 0 001.136.659h.064c.423 0 .828-.169 1.126-.468l.978-1.009a1.635 1.635 0 00.478-1.232 1.7 1.7 0 00-.574-1.232zm-.627 1.637l-.977.998a.572.572 0 01-.425.17.595.595 0 01-.404-.202L8.745 10.9l.626-.764.33-.34 4.78 4.111c.113.102.181.243.192.393a.51.51 0 01-.16.394z","fill":"currentColor"}})]) } };

var iconSlideshow = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M15.5 0H.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5H1v7.27c0 .44.49.74.93.74H7.5v1.12l-3.14 3.12.71.71 2.43-2.42V16h1v-2.46L10.93 16l.71-.71-3.14-3.16V11h5.6a.89.89 0 00.93-.85V3.92H14V10H2V3h13.5a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zM15 2H1V1h14v1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.06 4a.62.62 0 00-.62 0 .6.6 0 00-.28.53v3.95a.58.58 0 00.29.52.52.52 0 00.3.08.56.56 0 00.3-.08l3.57-2a.61.61 0 00.31-.52.6.6 0 00-.31-.48L7.06 4zm.1 3.78V5.22l2.33 1.29-2.33 1.27z","fill":"currentColor"}})]) } };

var iconSmallCaretDoubleRight = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}},[_c('g',{attrs:{"clip-path":"url(#assets-icon-small-caret-double-right_svg__clip0)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M6.495 5.443L1.15 0 .071 1.042l4.832 4.921L0 10.959 1.08 12l5.414-5.516a.74.74 0 000-1.041z"}}),_c('path',{attrs:{"d":"M11.786 5.443L6.443 0l-1.08 1.042 4.831 4.921-4.903 4.995L6.372 12l5.415-5.516a.74.74 0 000-1.041z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"assets-icon-small-caret-double-right_svg__clip0"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h12v12H0z"}})])])]) } };

var iconSmallCaretDown = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}},[_c('path',{attrs:{"d":"M6.036 9.87a.743.743 0 01-.526-.217L0 4.18 1.052 3.12l4.984 4.951 4.912-4.879L12 4.252 6.562 9.653a.745.745 0 01-.526.217z","fill":"currentColor"}})]) } };

var iconSmallCaretLeft = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}},[_c('path',{attrs:{"d":"M7.749 12L2.346 6.563a.748.748 0 010-1.053L7.82 0l1.06 1.053-4.951 4.983 4.879 4.911L7.748 12z","fill":"currentColor"}})]) } };

var iconSmallCaretRight = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}},[_c('path',{attrs:{"d":"M4.18 12l-1.06-1.053 4.951-4.984-4.878-4.911L4.253 0l5.4 5.437a.747.747 0 010 1.053L4.18 12z","fill":"currentColor"}})]) } };

var iconSmallCaretUp = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}},[_c('path',{attrs:{"d":"M10.948 8.88L5.963 3.928l-4.911 4.88L0 7.747l5.437-5.401a.747.747 0 011.052 0L12 7.82 10.948 8.88z","fill":"currentColor"}})]) } };

var iconSmallClose = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}},[_c('path',{attrs:{"d":"M12 1.055L10.945 0 6 4.945 1.055 0 0 1.055 4.945 6 0 10.945 1.055 12 6 7.055 10.945 12 12 10.945 7.055 6 12 1.055z","fill":"currentColor"}})]) } };

var iconSmallDoubleCaretLeft = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}},[_c('g',{attrs:{"clip-path":"url(#assets-icon-small-double-caret-left_svg__clip0)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M12 1.042L10.92 0 5.507 5.516a.74.74 0 000 1.041L10.85 12l1.08-1.042-4.831-4.921L12 1.042z"}}),_c('path',{attrs:{"d":"M6.708 1.042L5.628 0 .215 5.516a.74.74 0 000 1.041L5.557 12l1.08-1.042-4.831-4.921 4.902-4.995z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"assets-icon-small-double-caret-left_svg__clip0"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h12v12H0z"}})])])]) } };

var iconSmallEvent = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}},[_c('path',{attrs:{"d":"M7.7 1.01H4.49v1.04H7.7V1.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.49 1h-2V0h-1v2.46h1v-.41H11v1.2H1v-1a.23.23 0 01.23-.23h1.46v.41h1V0h-1v1H1.24A1.26 1.26 0 000 2.28v9.2a.51.51 0 00.51.52h10.25A1.258 1.258 0 0012 10.72V1.53a.51.51 0 00-.51-.53zM3.7 6.88h1.87v1.65H3.7V6.88zm-1 1.65H1V6.88h1.69l.01 1.65zm2.87-2.69H3.7V4.29h1.87v1.55zm1-1.55h1.89v1.55H6.59l-.02-1.55zm-1 5.29V11H3.7V9.58h1.87zm1 0h1.89V11H6.59l-.02-1.42zm0-1.05V6.88h1.89v1.65H6.57zm2.9-1.65H11v1.65H9.47V6.88zm0-1V4.29H11v1.55l-1.53.04zM2.69 4.29v1.55H1V4.29h1.69zM1 9.58h1.69V11H1V9.58zM10.76 11H9.47V9.58H11v1.14a.231.231 0 01-.136.262.23.23 0 01-.104.018z","fill":"currentColor"}})]) } };

var iconSmallHide = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}},[_c('path',{attrs:{"d":"M10.629.75l-1.998 2a7.086 7.086 0 00-2.627-.55A6.538 6.538 0 00.12 5.64a1.1 1.1 0 000 1 6.097 6.097 0 002.298 2.43l-1.509 1.5.71.68 9.729-9.82-.72-.68zm-9.62 5.42a.17.17 0 010-.1 5.527 5.527 0 014.995-2.89c.65 0 1.294.108 1.908.32l-.49.49a2.995 2.995 0 00-1.159-.41 2.715 2.715 0 00-2.996 2.3c-.067.648.119 1.296.52 1.81l-.62.63a5.217 5.217 0 01-2.158-2.15zm3.217-.18a1.7 1.7 0 011.928-1.43c.192.033.377.098.549.19L4.455 6.98a1.561 1.561 0 01-.22-.99h-.01zM11.887 5.64A5.75 5.75 0 0010.43 3.8l-.65.74A4.94 4.94 0 0111 6.07a.17.17 0 010 .1 5.537 5.537 0 01-4.995 2.9 6.216 6.216 0 01-1.149-.11l-.2 1c.446.075.897.105 1.349.09a6.538 6.538 0 005.883-3.44 1.1 1.1 0 000-.97z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6.004 7.75v1A2.685 2.685 0 008.75 6.12h-.999a1.7 1.7 0 01-1.748 1.63z","fill":"currentColor"}})]) } };

var iconSmallSearch = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}},[_c('path',{attrs:{"d":"M2 4.472h1a1.516 1.516 0 011.52-1.457v-.998A2.522 2.522 0 002 4.472z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.72 9.613L9.11 7.008l-.71.709 2.6 2.585a.708.708 0 01-.23.47.81.81 0 01-.45.249L7.25 7.866a4.394 4.394 0 00.905-5.884A4.448 4.448 0 003.588.084 4.452 4.452 0 00.086 3.572a4.435 4.435 0 001.89 4.563c.733.489 1.593.75 2.474.75a4.506 4.506 0 001.94-.46l3.22 3.295a1 1 0 00.72.28A1.811 1.811 0 0012 10.331a.997.997 0 00-.28-.719zM1 4.453a3.44 3.44 0 012.123-3.19 3.455 3.455 0 013.763.74A3.442 3.442 0 014.45 7.886c-.913 0-1.79-.361-2.436-1.005A3.441 3.441 0 011 4.452z","fill":"currentColor"}})]) } };

var iconSmallShow = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}},[_c('path',{attrs:{"d":"M11.887 5.51A6.538 6.538 0 006.002 2 6.53 6.53 0 00.118 5.51a1.12 1.12 0 000 1A6.537 6.537 0 006.002 10a6.53 6.53 0 005.885-3.51 1.121 1.121 0 000-.98zm-.899.54A5.528 5.528 0 016.002 9a5.521 5.521 0 01-4.995-2.95.17.17 0 010-.05 5.528 5.528 0 014.995-3 5.521 5.521 0 014.996 3 .168.168 0 010 .05h-.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.241 3.59a2.596 2.596 0 00-1.998-.22A2.707 2.707 0 003.34 5.722c-.032.357.008.717.116 1.058a2.81 2.81 0 001.308 1.63c.38.21.806.323 1.24.33.257.003.513-.034.759-.11a2.657 2.657 0 001.139-.7l-.73-.69c-.19.204-.432.352-.699.43a1.617 1.617 0 01-1.269-.14 1.77 1.77 0 01-.83-1 1.701 1.701 0 011.12-2.2 1.617 1.617 0 011.269.14c.393.216.69.573.829 1 .074.295.074.605 0 .9l1 .21c.1-.464.079-.946-.06-1.4a2.84 2.84 0 00-1.29-1.59z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.454 5.81a.5.5 0 100-1 .5.5 0 000 1z","fill":"currentColor"}})]) } };

var iconSmallTrash = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 13"}},[_c('path',{attrs:{"d":"M4.72 3.71h-1v6.03h1V3.71zM6.52 3.71h-1v6.03h1V3.71zM8.3 3.71h-1v6.03h1V3.71z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.25 1.45H.75v1H9.4L9.18 11H2.82l-.18-7.54h-1L1.82 11a1 1 0 001.05 1h6.31a1 1 0 001.06-1l.16-8.53h.85V1.45zM7.53 0h-3v1h3V0z","fill":"currentColor"}})]) } };

var iconSnowflake = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.07 6.24l-1.76-.42 2.68-1.38-.43-.89-2.86 1.48.48-1.62-.93-.29-.98 3.24 3.58.86.22-.98z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16 11.55l-2.67-1.38 1.74-.41-.22-.98-2.89.69-2.87-1.48 1.37-.7-.43-.9-1.55.8V4.23l2.09-1.86-.64-.75-1.45 1.29V0h-.97v2.9L6.07 1.62l-.64.75 2.08 1.85v2.97l-3-1.54-.76-2.53-.93.29.49 1.62L.43 3.56 0 4.45l2.67 1.38-1.74.41.22.98 2.89-.69 2.87 1.48-2.86 1.47-2.9-.7-.22.98 1.76.42-2.68 1.38.43.89 2.86-1.47-.48 1.61.93.29.76-2.52 3.01-1.55v2.96l-2.09 1.86.64.75 1.45-1.29V16h.97v-2.9l1.44 1.28.64-.75-2.08-1.85V8.81l3 1.54.76 2.53.93-.29-.49-1.62 2.87 1.47.44-.89z","fill":"currentColor"}})]) } };

var iconSoftwareDevelopment = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M16 .5a.5.5 0 00-.5-.5h-14A1.52 1.52 0 000 1.55v10.26a.5.5 0 00.5.5h5.13v1.11c0 .49-.27.67-.75.94-.48.27-.88.51-.88 1.14a.5.5 0 00.5.5h7.1a.5.5 0 00.5-.5c0-.63-.52-.93-.91-1.14-.39-.21-.76-.45-.76-.94h-1a1.8 1.8 0 00.84 1.58H5.75a1.78 1.78 0 00.88-1.58v-1.11h7.87a1.52 1.52 0 001.5-1.55V2.1h-1v7.11H1V1.55A.53.53 0 011.5 1H16V.5zm-1 9.71v.55a.53.53 0 01-.5.55H1v-1.1h14z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.52 2.429l-2 5.23.935.358 1.998-5.231-.934-.357zM5.13 2.94L3.13 5a.49.49 0 000 .69l2 2.1.72-.69-1.67-1.72 1.67-1.75-.72-.69zM10.85 7.82l2-2.1a.51.51 0 000-.69l-2-2.09-.72.69 1.67 1.75-1.67 1.75.72.69z","fill":"currentColor"}})]) } };

var iconSort = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15 3.5L11.86.15a.5.5 0 00-.71 0L8 3.5l.71.69L11 1.75V15.5h1V1.75l2.29 2.44.71-.69zM5 14.25V.49H4v13.76L1.71 11.8l-.71.69 3.13 3.35a.52.52 0 00.36.16.5.5 0 00.36-.16L8 12.49l-.71-.69L5 14.25z","fill":"currentColor"}})]) } };

var iconSpeaker = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.322 6.214h.007a.947.947 0 10-.007 0zm.007-1l.05.056h-.107a.057.057 0 01.057-.056z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.5 9.336h-.117l-.025-1.924a.49.49 0 00-.077-.26l-.667-1.06-.846.532.592.941.023 1.771h-1.906V7.582c0-1.127-1.798-1.707-2.35-1.858l-.265.964c.855.236 1.615.696 1.615.894v1.754H4.025l-.002-1.738a4.614 4.614 0 012.162-1.084 1.144 1.144 0 00.897-1.194.499.499 0 00-.19-.391 2.239 2.239 0 01-.769-1.81C6.123 1.97 6.855 1 7.722 1c.88 0 1.597.95 1.597 2.119 0 1.18-.731 2.177-1.597 2.177v1a2.935 2.935 0 002.597-3.177A2.862 2.862 0 007.722 0a2.898 2.898 0 00-2.599 3.119 3.292 3.292 0 00.907 2.378.44.44 0 01-.124.057c-.866.245-2.88.935-2.88 2.028v1.754H.5a.5.5 0 00-.5.5v2.177a.5.5 0 00.5.5h12.9v1.992a.499.499 0 01-.502.495H3.115a.512.512 0 01-.514-.508v-.99h-1v.99A1.513 1.513 0 003.115 16h9.783a1.5 1.5 0 001.502-1.495v-1.992h1.1a.5.5 0 00.5-.5V9.836a.497.497 0 00-.5-.5zm-.5 2.177H1v-1.177h14v1.177z","fill":"currentColor"}})]) } };

var iconSquareCheck = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M3.13 7.81l-.71.71 3.27 3.26a.49.49 0 00.545.112.49.49 0 00.165-.112l7.18-7.17-.71-.71L6 10.72 3.13 7.81z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16 .5a.5.5 0 00-.5-.5H1.57A1.58 1.58 0 000 1.57V15.5a.5.5 0 00.5.5h13.93A1.58 1.58 0 0016 14.43V2h-1v12.43a.58.58 0 01-.57.57H1V1.57A.58.58 0 011.57 1H16V.5z","fill":"currentColor"}})]) } };

var iconSquareFeet = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M2.929.1H.999A1 1 0 000 1.099V14.98a.998.998 0 001 1h1.929a1 1 0 001-1V1.12a.998.998 0 00-1-1.019zm.07 14.881h-2v-.998h1v-1h-1v-1.238h1v-.998h-1V9.528h1V8.53h-1V7.311h1v-.999h-1V5.094h1v-.999h-1V2.877h1v-1h-1V1.1l2 .02V14.98zM14.923 11.985H5.488a.5.5 0 00-.5.5v1.498h1.01v-1h.899v1h1v-1h.999v1h1v-1h.999v1h1v-1h.999v1h1v-1h.92a.34.34 0 01.09.26v1.499c-.002.09-.026.18-.07.26H4.997V16h9.995a1.16 1.16 0 001-1.278v-1.498a1.158 1.158 0 00-1.07-1.239zM5.927 1.708l8.356 8.35h-1.29v.998h2.5a.5.5 0 00.5-.5V8.04h-1v1.308L6.637.998h1.36V0h-2.57a.5.5 0 00-.5.5v2.496h1V1.708z","fill":"currentColor"}})]) } };

var iconSquare = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.43 16H.5a.5.5 0 01-.5-.5V1.57A1.58 1.58 0 011.57 0H15.5a.5.5 0 01.5.5V1H1.57a.58.58 0 00-.57.57V15h13.43a.58.58 0 00.57-.57V2h1v12.43A1.58 1.58 0 0114.43 16z","fill":"currentColor"}})]) } };

var iconStarFill = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.219 16a1.143 1.143 0 01-.695-.24L8.09 13.15a.146.146 0 00-.18 0l-3.434 2.612a1.13 1.13 0 01-1.354.027 1.209 1.209 0 01-.455-1.356l1.312-4.226a.218.218 0 00-.068-.236L.477 7.358A1.199 1.199 0 01.069 6a1.157 1.157 0 011.104-.806h4.244a.174.174 0 00.158-.133L6.887.835a1.16 1.16 0 012.226 0l1.312 4.227a.174.174 0 00.158.132h4.244A1.157 1.157 0 0115.931 6a1.2 1.2 0 01-.409 1.358L12.09 9.97a.218.218 0 00-.068.236l1.31 4.227a1.21 1.21 0 01-.455 1.356c-.192.136-.422.21-.657.211z","fill":"currentColor"}})]) } };

var iconStar = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('g',{attrs:{"clip-path":"url(#assets-icon-star_svg__clip0)"}},[_c('path',{attrs:{"d":"M12.22 16a1.16 1.16 0 01-.7-.24l-3.43-2.61a.15.15 0 00-.18 0l-3.43 2.61a1.14 1.14 0 01-1.36 0 1.21 1.21 0 01-.45-1.36L4 10.21a.21.21 0 00-.09-.21L.48 7.36A1.2 1.2 0 01.07 6a1.16 1.16 0 011.1-.81h4.25a.16.16 0 00.15-.13L6.89.84a1.15 1.15 0 012.22 0l1.32 4.22a.16.16 0 00.15.13h4.25a1.16 1.16 0 011.1.81 1.2 1.2 0 01-.41 1.36L12.09 10a.21.21 0 00-.07.24l.36 1.15-1 .3-.36-1.16a1.21 1.21 0 01.41-1.33l3.44-2.61a.21.21 0 00.13-.27.17.17 0 00-.16-.13h-4.26a1.15 1.15 0 01-1.11-.83L8.16 1.13c-.07-.22-.25-.22-.32 0L6.53 5.36a1.16 1.16 0 01-1.11.83H1.17a.15.15 0 00-.17.13.19.19 0 00.06.24l3.46 2.61a1.22 1.22 0 01.41 1.33l-1.31 4.23a.21.21 0 00.08.27.13.13 0 00.17 0l3.43-2.65a1.17 1.17 0 011.4 0L12.13 15a.13.13 0 00.17 0 .21.21 0 00.08-.24l-.51-1.67 1-.29.51 1.66a1.21 1.21 0 01-.45 1.36 1.15 1.15 0 01-.71.18z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"assets-icon-star_svg__clip0"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h16v16H0z"}})])])]) } };

var iconStateGovernment = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}},[_c('path',{attrs:{"d":"M15.392 13.787h-.074v-6.14h1.06V6.585H.725v1.06h.954v6.14h-.074a1.592 1.592 0 00-1.59 1.623v1.06a.53.53 0 00.53.531h15.907a.53.53 0 00.53-.53v-1.06a1.592 1.592 0 00-1.59-1.623zm-1.135 0H12.74v-6.14h1.549l-.032 6.14zm-8.94 0v-6.14h1.347v6.14H5.317zm2.407-6.14h1.549v6.14H7.724v-6.14zm2.61 0h1.346v6.14h-1.347v-6.14zm-7.594 0h1.516v6.14H2.74v-6.14zm13.182 8.26H1.075v-.498a.52.52 0 01.53-.562h13.787a.53.53 0 01.53.53v.53zM.545 5.801h15.907a.54.54 0 00.53-.382.55.55 0 00-.243-.604L8.785.075a.551.551 0 00-.541 0L.279 4.814a.552.552 0 00-.265.604.53.53 0 00.53.382zm7.953-4.656l6.014 3.595H2.474l6.023-3.595z","fill":"currentColor"}})]) } };

var iconStatusErrorDark = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10.619 4.67l-2.62 2.619L5.382 4.67l-.707.707 2.619 2.619-2.62 2.618.708.707L8 8.703l2.619 2.618.707-.707-2.62-2.618 2.62-2.619-.707-.707z","fill":"#F57E7F"}}),_c('path',{attrs:{"d":"M8 0a8 8 0 105.017 14.231l-.627-.778A6.925 6.925 0 018 14.999a7 7 0 115.265-2.387l.752.659A8 8 0 008 0z","fill":"#F57E7F"}})]) } };

var iconStatusErrorLight = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10.619 4.67l-2.62 2.619L5.382 4.67l-.707.707 2.619 2.619-2.62 2.618.708.707L8 8.703l2.619 2.618.707-.707-2.62-2.618 2.62-2.619-.707-.707z","fill":"#D91214"}}),_c('path',{attrs:{"d":"M8 0a8 8 0 105.017 14.231l-.627-.778A6.925 6.925 0 018 14.999a7 7 0 115.265-2.387l.752.659A8 8 0 008 0z","fill":"#D91214"}})]) } };

var iconStatusSuccessDark = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6.709 11.082a.497.497 0 01-.354-.147L3.504 8.083l.707-.707 2.498 2.498 5.087-5.086.707.707-5.44 5.44a.498.498 0 01-.354.146z","fill":"#16986D"}}),_c('path',{attrs:{"d":"M7.998 15.998a7.999 7.999 0 116.019-2.729l-.752-.66a6.995 6.995 0 10-.876.842l.627.778a8.017 8.017 0 01-5.018 1.769z","fill":"#16986D"}})]) } };

var iconStatusSuccessLight = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6.709 11.082a.497.497 0 01-.354-.147L3.504 8.083l.707-.707 2.498 2.498 5.087-5.086.707.707-5.44 5.44a.498.498 0 01-.354.146z","fill":"#16986D"}}),_c('path',{attrs:{"d":"M7.998 15.998a7.999 7.999 0 116.019-2.729l-.752-.66a6.995 6.995 0 10-.876.842l.627.778a8.017 8.017 0 01-5.018 1.769z","fill":"#16986D"}})]) } };

var iconStatusWarningDark = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.998 15.998a7.999 7.999 0 116.019-2.729l-.752-.66a6.995 6.995 0 10-.876.842l.627.778a8.017 8.017 0 01-5.018 1.769z","fill":"#FDE68A"}}),_c('path',{attrs:{"d":"M7.25 3.5h1.5l-.346 6.931h-.808L7.25 3.5zm1.385 7.759V12.5h-1.27v-1.241h1.27z","fill":"#FDE68A"}})]) } };

var iconStatusWarningLight = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.998 15.998a7.999 7.999 0 116.019-2.729l-.752-.66a6.995 6.995 0 10-.876.842l.627.778a8.017 8.017 0 01-5.018 1.769z","fill":"#D97706"}}),_c('path',{attrs:{"d":"M7.25 3.5h1.5l-.346 6.931h-.808L7.25 3.5zm1.385 7.759V12.5h-1.27v-1.241h1.27z","fill":"#D97706"}})]) } };

var iconStore = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.992 3.52L14.993.57a.79.79 0 00-.72-.57H1.727a.799.799 0 00-.72.56L.007 3.52a1 1 0 000 .24V15.5a.5.5 0 00.5.5h14.986a.5.5 0 00.5-.5V15H6.25V9.3a.5.5 0 00-.5-.5H2.756a.5.5 0 00-.5.5V15H1.006V6.93c.303.18.647.276 1 .28a1.997 1.997 0 001.498-.68 1.998 1.998 0 002.997 0 1.998 1.998 0 002.997 0 1.998 1.998 0 002.998 0 1.999 1.999 0 001.498.68c.352-.004.697-.1 1-.28v7h.998V3.76c.01-.08.01-.16 0-.24zM3.234 9.8h1.998V15H3.234V9.8zm10.76-3.59a.998.998 0 01-.999-1 .5.5 0 10-.999 0 1 1 0 01-1.706.707 1 1 0 01-.292-.707.5.5 0 10-1 0 1 1 0 01-1.705.707 1 1 0 01-.292-.707.5.5 0 10-1 0 1 1 0 01-1.705.707 1 1 0 01-.293-.707.5.5 0 10-.999 0 1 1 0 01-1.705.707 1 1 0 01-.293-.707v-1.4L1.876 1h12.248l.63 2H2.114v1h12.878v1.21a1 1 0 01-.999 1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.589 8.8a.5.5 0 00-.5.5v3.57a.5.5 0 00.5.5h4.675a.5.5 0 00.5-.5V9.3a.5.5 0 00-.5-.5H8.59zm4.176 3.57H9.088V9.8h3.677v2.57z","fill":"currentColor"}})]) } };

var iconStrategy = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M11.74 13.29h-.37c-1.61-.08-1.81-3.11-1.84-3.78h-.92c.08 3.32 1.3 4.19 2.24 4.55v1.12h-5.7V14c2.31-1.59 2.19-5 2.1-6v-.4h-.92a.47.47 0 110-.93h3.34a.47.47 0 010 .93h-1v.88h1a1.34 1.34 0 00.32-2.65l.41-1.09a.56.56 0 000-.56.59.59 0 00-.49-.28H6.12a.58.58 0 00-.47.24.5.5 0 00-.08.51l.39 1.2a1.34 1.34 0 00.37 2.64h.06c.06 1.18-.07 3.78-1.93 4.88l-.21.13V16h7.5l-.01-2.71zM9.43 4.8l-.39 1H6.9l-.35-1h2.88zM8.48 1.1V0h-.96v1.1H6.41v.94h1.11v1.11h.96V2.04h1.11V1.1H8.48z","fill":"currentColor"}})]) } };

var iconSupport = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M11.5 11.66l-.26 1c1.37.34 3.26 1.2 3.26 1.87V15h-13v-.47c0-.6 2-1.59 3.83-2.1a1.52 1.52 0 001.28-1.58.63.63 0 00-.21-.43A4.38 4.38 0 014.98 7c0-2.2 1.35-4 3-4s3 1.78 3 4a4.86 4.86 0 01-.43 2c-.817.09-1.64.117-2.46.08v1h1.79A2.62 2.62 0 018 11v1a3.85 3.85 0 003.25-2c.146-.034.29-.077.43-.13.138-.063.272-.137.4-.22H13a1.5 1.5 0 001.5-1.55V6.41a1.5 1.5 0 00-.78-1.31A6 6 0 008 0a5.79 5.79 0 00-5.58 4.94 1.5 1.5 0 00-.92 1.38v1.87A1.5 1.5 0 003 9.69h1.6a4.76 4.76 0 001 1.38c0 .14-.15.32-.53.42C3.99 11.77.5 12.88.5 14.53v.84a.65.65 0 00.68.63h13.64a.65.65 0 00.68-.63v-.84c0-1.7-3.32-2.69-4-2.87zm2-3.56a.5.5 0 01-.5.5h-.86V5.91H13a.5.5 0 01.5.5V8.1zM8 1a4.94 4.94 0 014.68 3.91h-1.06A4 4 0 008 2.06a4 4 0 00-3.58 2.76H3.5A4.84 4.84 0 018 1zM4 8.69H3a.5.5 0 01-.5-.5V6.32a.5.5 0 01.5-.5h1v2.87z","fill":"currentColor"}})]) } };

var iconSustainability = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M15.83 11.066a1.53 1.53 0 00-.9-.79 1.58 1.58 0 00-1.19.09l-3 1.55a1.562 1.562 0 00-1.59-1.6H6.21a1.64 1.64 0 01-.78-.19l-.64-.32a5 5 0 00-2.25-.54H.5a.5.5 0 00-.5.5v.52h2.54a4 4 0 011.8.43l.66.3c.382.191.803.29 1.23.29h2.92a.56.56 0 01.394.957.58.58 0 01-.394.174h-3.5v1h3.88c.243-.002.483-.06.7-.17l4-2a.57.57 0 01.42 0 .57.57 0 01.08 1c-2.66 1.27-5.65 2.67-5.95 2.75h-2l-4.09-1.12H1v-2.48H0v3a.5.5 0 00.5.5h2l4.08 1.1H8.78c.14 0 .46 0 6.36-2.85a1.57 1.57 0 00.69-2.1zM7.5 5.447v2.77h1v-2.77a4.75 4.75 0 003.21-1.19 5.3 5.3 0 001.17-3.77.51.51 0 00-.46-.47 5.22 5.22 0 00-3.74 1.19A3.52 3.52 0 008 2.216a3.52 3.52 0 00-.68-1 5.16 5.16 0 00-3.74-1.2.51.51 0 00-.46.46 5.3 5.3 0 001.17 3.78 4.75 4.75 0 003.21 1.19zm1.89-3.53a3.82 3.82 0 012.5-.9 4 4 0 01-.89 2.54 3.77 3.77 0 01-2.5.89 3.86 3.86 0 01.89-2.53zm-2.78 0c.586.712.9 1.608.89 2.53a3.77 3.77 0 01-2.5-.89 3.9 3.9 0 01-.88-2.54 3.81 3.81 0 012.49.9z","fill":"currentColor"}})]) } };

var iconTabbedBlock = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.5 0H1.57A1.571 1.571 0 000 1.568v12.414h1V1.568a.579.579 0 01.57-.57H5v1.998c.01.374.16.73.42.999a1.47 1.47 0 001.06.44h8a.51.51 0 01.52.559v9.438a.58.58 0 01-.57.57H0v.498a.499.499 0 00.5.5h13.93A1.57 1.57 0 0016 14.412V.499A.499.499 0 0015.5 0zM6.13 3.336a.529.529 0 01-.13-.34V1h4v2.477H6.48a.5.5 0 01-.35-.14zm8.36.14H11V.999h4v2.576a1.452 1.452 0 00-.51-.1z","fill":"currentColor"}})]) } };

var iconTag = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.49.51A1.74 1.74 0 0014.25 0H9.12a.47.47 0 00-.35.15L.15 8.77a.47.47 0 00-.15.35.49.49 0 00.15.36l6.37 6.37a.51.51 0 00.36.15.5.5 0 00.35-.15l.35-.35-6.37-6.38L9.33 1h4.92a.75.75 0 01.75.75v4.93l-7.45 7.44.7.71 7.6-7.59a.52.52 0 00.15-.36V1.75a1.74 1.74 0 00-.51-1.24z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14 2.67a.67.67 0 10-1.34 0 .67.67 0 001.34 0z","fill":"currentColor"}})]) } };

var iconTasks = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.98 7.51h-3v1h3v-1zM11.98 11.62h-5v1h5v-1zM13.98 3.51h-4v1h4v-1z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.43 16H.5a.5.5 0 01-.5-.5V1.57A1.58 1.58 0 011.57 0H15.5a.5.5 0 01.5.5V1H1.57a.58.58 0 00-.57.57V15h13.43a.58.58 0 00.57-.57V2h1v12.43A1.58 1.58 0 0114.43 16z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M3.29 5.31a.51.51 0 01-.36-.15L1.6 3.8l.72-.7 1 1 1.82-1.93.72.7-2.21 2.29a.55.55 0 01-.36.15zM3.29 9.46a.48.48 0 01-.36-.15L1.6 8l.72-.7 1 1 1.82-1.97.72.67-2.21 2.31a.51.51 0 01-.36.15zM3.29 13.62a.48.48 0 01-.36-.15L1.6 12.12l.72-.7 1 1 1.85-1.92.72.7-2.24 2.27a.55.55 0 01-.36.15zM8.98 3.51h-2v1h2v-1zM9.98 7.51h-3v1h3v-1zM13.99 11.62h-1v1h1v-1z","fill":"currentColor"}})]) } };

var iconTeams = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.271 5.78c1.104 0 2.007-.89 2.007-1.977 0-1.088-.903-1.978-2.007-1.978-1.103 0-2.006.89-2.006 1.978 0 1.087.903 1.977 2.006 1.977zm0-2.966a.999.999 0 011.003.989.999.999 0 01-1.003.988.999.999 0 01-1.003-.988.999.999 0 011.003-.99z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.188 6.354H7.954V5.7c.14.02.28.04.421.04 1.465 0 2.659-1.177 2.659-2.62C11.034 1.676 9.84.5 8.375.5 6.912.5 5.718 1.677 5.718 3.12c0 .327.07.643.18.93H.502A.508.508 0 000 4.554v6.852c0 .277.22.495.502.495h3.56c.161.92.593 1.76 1.295 2.412a4.375 4.375 0 003.02 1.187c.08 0 .16 0 .24-.01 1.525-.079 2.849-1.018 3.571-2.333.301.098.612.178.933.178h.15C14.806 13.255 16 11.95 16 10.357V7.155c0-.445-.361-.801-.813-.801zM6.72 3.12c0-.9.742-1.631 1.655-1.631s1.655.731 1.655 1.631-.742 1.632-1.655 1.632c-.15 0-.29-.03-.421-.06v-.138a.493.493 0 00-.502-.494h-.431c-.19-.267-.301-.594-.301-.94zM2.217 6.74v-.99H5.728v.99H4.474v3.46H3.471V6.74H2.217zm9.55 4.211c0 1.87-1.435 3.461-3.2 3.55a3.393 3.393 0 01-2.518-.91 3.26 3.26 0 01-.973-1.7h2.377c.281 0 .502-.218.502-.495V7.342h3.812v3.61zm3.23-.603c0 1.048-.803 1.938-1.786 1.988-.22.01-.441-.03-.662-.099.12-.415.21-.84.21-1.286V7.352h2.238v2.996z","fill":"currentColor"}})]) } };

var iconTechnology = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M3.824 3.943h-.12a1.496 1.496 0 01-1.014-.401 1.507 1.507 0 01-.475-.984 1.49 1.49 0 01.943-1.526 1.494 1.494 0 011.881.717 1.51 1.51 0 01-.525 1.95 1.495 1.495 0 01-.69.234v.01zm-.12-2.006a.509.509 0 00-.438.343.493.493 0 00.156.535.498.498 0 00.362.115.488.488 0 00.34-.17.482.482 0 00-.058-.699.498.498 0 00-.362-.114v-.01zM11.758 12.198V8.025L9.68 6.761l-1.18.702v1.405a.503.503 0 01-.24.43l-1.698 1.004a.489.489 0 01-.51 0L3.484 8.737a.5.5 0 01-.24-.431v-3.51h1v3.23l2.068 1.263 1.19-.712V7.172a.483.483 0 01.25-.43L9.43 5.737a.488.488 0 01.51 0l2.568 1.565a.511.511 0 01.24.431v4.444a1.5 1.5 0 01.99 1.61 1.506 1.506 0 01-1.36 1.309h-.12a1.496 1.496 0 01-1.013-.401 1.507 1.507 0 01-.476-.984 1.459 1.459 0 011-1.524l-.01.01zm.55 1.896a.468.468 0 00.34-.171.482.482 0 00.12-.361.502.502 0 00-.5-.461.509.509 0 00-.34.17.502.502 0 00.42.822h-.04z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.393 13.04a1.503 1.503 0 011.129.381l3.118-1.855V8.828h1v3.009a.503.503 0 01-.25.43l-3.398 2.007v.1a1.45 1.45 0 01-.35 1.094c-.252.3-.61.49-1 .531h-.12a1.485 1.485 0 01-1.37-.868 1.5 1.5 0 01.231-1.61 1.45 1.45 0 011.01-.48zm.16 2.006a.51.51 0 00.46-.541.502.502 0 00-.5-.462.448.448 0 00-.34.18.481.481 0 00-.12.362.532.532 0 00.5.461zM10.619 3.01h-.12a1.486 1.486 0 01-1-.391L6.383 4.484v2.739h-1v-3.01a.503.503 0 01.24-.43L9 1.725a.544.544 0 000-.1A1.5 1.5 0 019.36.532a1.498 1.498 0 011.603-.46 1.5 1.5 0 01.675 2.406 1.45 1.45 0 01-1.019.532zm-.12-2.006a.478.478 0 00-.34.18.482.482 0 00-.16.361.522.522 0 00.54.462.498.498 0 00.34-.18.481.481 0 00.12-.362.502.502 0 00-.5-.461zM12.997 6.721c-.02-.14-.02-.282 0-.421L10.5 4.745l.5-.853 2.548 1.545c.236-.193.526-.309.83-.33a1.494 1.494 0 011.457.809c.09.176.145.367.161.564.03.401-.1.797-.36 1.104a1.487 1.487 0 01-.999.521h-.14a1.496 1.496 0 01-1.02-.397 1.507 1.507 0 01-.479-.987zm1.54.381a.51.51 0 00.458-.428.503.503 0 00-.499-.575.488.488 0 00-.34.17.482.482 0 00-.16.372.512.512 0 00.54.461z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.034 3.885l.51.863-1.833 1.09-.51-.863 1.833-1.09zM.366 8.486a1.45 1.45 0 01.999-.521 1.504 1.504 0 011.473.806c.092.177.148.37.166.568.015.143.015.288 0 .431l2.608 1.595-.52.863-2.608-1.605c-.236.193-.525.309-.83.33h-.12A1.496 1.496 0 01.5 10.572a1.507 1.507 0 01-.427-1.575c.062-.189.162-.362.294-.51zm1.179 1.475a.448.448 0 00.34-.18.482.482 0 00.12-.362.502.502 0 00-.5-.461.51.51 0 00-.46.542.522.522 0 00.5.46zM8.4 10.138l.51.863-2.07 1.234-.51-.863 2.07-1.234z","fill":"currentColor"}})]) } };

var iconThumbsDownFill = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('g',{attrs:{"clip-path":"url(#assets-icon-thumbs-down-fill_svg__clip0)"}},[_c('path',{attrs:{"d":"M14.393 11.118h-3.725c.19.261.319.562.377.88.072.67.068 1.347-.01 2.017a2.335 2.335 0 01-.816 1.65 1.868 1.868 0 01-1.446.304c-1.164-.184-1.55-1.869-1.83-3.1a6.698 6.698 0 00-.174-.676c-.133-.21-.976-1.227-2.205-2.66H.821A.822.822 0 010 8.71V1.81a.5.5 0 01.5-.5h2.733a.49.49 0 01.3.11c.017-.002.033-.01.051-.01h.822A6.204 6.204 0 006.145.856 8.901 8.901 0 019.28 0h3.204a1.581 1.581 0 011.608 1.626 2.05 2.05 0 01-.213.891 1.78 1.78 0 01.687 2.508 1.785 1.785 0 01.77 1.353 2.52 2.52 0 01-.23 1.126A1.974 1.974 0 0116 9.16v.332a1.618 1.618 0 01-1.607 1.626z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"assets-icon-thumbs-down-fill_svg__clip0"}},[_c('path',{attrs:{"fill":"currentColor","transform":"matrix(1 0 0 -1 0 16)","d":"M0 0h16v15.999H0z"}})])])]) } };

var iconThumbsDownStroke = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.49 0H9.28a9.016 9.016 0 00-3.14.858 6.24 6.24 0 01-1.73.549h-.83a.83.83 0 00-.82.828v5.178h1V2.425h.65a6.33 6.33 0 002.11-.629A8.434 8.434 0 019.28.998h3.21a.58.58 0 01.6.628 1.375 1.375 0 01-.36.819.509.509 0 00-.12.548.499.499 0 00.47.31.79.79 0 01.75.808 1.287 1.287 0 01-.42.768.5.5 0 00.33.878.69.69 0 01.6.649c0 .376-.118.743-.34 1.047a.489.489 0 00-.1.53.479.479 0 00.45.289c.4 0 .65.518.65.868v.329a.617.617 0 01-.61.628H9.63a.48.48 0 00-.44.27.488.488 0 000 .519l.11.09c.62.638.73.997.75 1.107a7.789 7.789 0 010 1.756 1.505 1.505 0 01-.42.998.89.89 0 01-.7.13c-.5-.08-.87-1.717-1-2.335a3.456 3.456 0 00-.31-.998c-.25-.4-1.86-2.275-2.34-2.834a.81.81 0 00-.62-.289H1V2.524h.68v-.997H.5a.5.5 0 00-.5.469V8.69a.817.817 0 00.82.818h3.74c1 1.127 2.05 2.414 2.21 2.654 0 .08.11.409.17.678.28 1.228.67 2.914 1.83 3.123a1.914 1.914 0 001.45-.3A2.324 2.324 0 0011 13.97c.08-.663.08-1.333 0-1.996a1.992 1.992 0 00-.36-.878h3.71a1.623 1.623 0 001.527-.998c.082-.199.124-.413.123-.628v-.33a1.993 1.993 0 00-.89-1.646 2.69 2.69 0 00.23-1.127 1.753 1.753 0 00-.77-1.377c.163-.276.253-.588.26-.908a1.783 1.783 0 00-.95-1.586c.138-.276.21-.58.21-.888a1.573 1.573 0 00-.982-1.49A1.583 1.583 0 0012.49 0z","fill":"currentColor"}})]) } };

var iconThumbsUpFill = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('g',{attrs:{"clip-path":"url(#assets-icon-thumbs-up-fill_svg__clip0)"}},[_c('path',{attrs:{"d":"M14.393 4.882h-3.725a2.16 2.16 0 00.377-.88 9.056 9.056 0 00-.01-2.018 2.335 2.335 0 00-.816-1.65A1.869 1.869 0 008.773.03c-1.164.183-1.55 1.868-1.83 3.1a6.693 6.693 0 01-.174.676c-.133.21-.976 1.227-2.205 2.66H.821A.822.822 0 000 7.288v6.902a.5.5 0 00.5.5h2.733a.49.49 0 00.3-.11c.017.002.033.011.051.011h.822c.604.097 1.19.283 1.739.551A8.9 8.9 0 009.28 16h3.204a1.58 1.58 0 001.608-1.626 2.049 2.049 0 00-.213-.89 1.78 1.78 0 00.687-2.509 1.786 1.786 0 00.77-1.353 2.52 2.52 0 00-.23-1.126A1.974 1.974 0 0016 6.839v-.331a1.618 1.618 0 00-1.607-1.626z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"assets-icon-thumbs-up-fill_svg__clip0"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h16v15.999H0z"}})])])]) } };

var iconThumbsUpStroke = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.49 16H9.28a9.016 9.016 0 01-3.14-.858 6.242 6.242 0 00-1.73-.549h-.83a.83.83 0 01-.82-.828V8.587h1v4.988h.65a6.33 6.33 0 012.11.629 8.434 8.434 0 002.76.798h3.21a.582.582 0 00.6-.629 1.375 1.375 0 00-.36-.818.508.508 0 01-.12-.548.5.5 0 01.47-.31.79.79 0 00.75-.808 1.287 1.287 0 00-.42-.768.499.499 0 01.33-.878.69.69 0 00.6-.649c0-.376-.118-.743-.34-1.047a.489.489 0 01-.1-.53.479.479 0 01.45-.289c.4 0 .65-.518.65-.868v-.329a.617.617 0 00-.61-.628H9.63a.48.48 0 01-.44-.27.488.488 0 010-.519l.11-.09c.62-.638.73-.997.75-1.107a7.788 7.788 0 000-1.756 1.505 1.505 0 00-.42-.998.891.891 0 00-.7-.13c-.5.08-.87 1.717-1 2.335a3.456 3.456 0 01-.31.998c-.25.4-1.86 2.275-2.34 2.834a.81.81 0 01-.62.289H1v5.987h.68v.997H.5a.5.5 0 01-.5-.469V7.31a.817.817 0 01.82-.818h3.74c1-1.127 2.05-2.414 2.21-2.654 0-.08.11-.409.17-.678C7.22 1.93 7.61.245 8.77.036a1.914 1.914 0 011.45.3A2.324 2.324 0 0111 2.03c.08.663.08 1.333 0 1.996a1.993 1.993 0 01-.36.878h3.71a1.623 1.623 0 011.527.998c.082.199.124.413.123.628v.33a1.993 1.993 0 01-.89 1.646c.157.355.236.74.23 1.127a1.753 1.753 0 01-.77 1.377c.163.276.253.588.26.908a1.783 1.783 0 01-.95 1.586c.138.276.21.58.21.888a1.573 1.573 0 01-.982 1.49c-.196.08-.406.12-.618.117z","fill":"currentColor"}})]) } };

var iconToggle = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}},[_c('path',{attrs:{"d":"M16 7.503H6.28v1H16v-1zM3.29 10.002a2 2 0 100-4 1.94 1.94 0 00-1.87 1.5H0v1h1.42a2 2 0 001.87 1.5zm0-3a1 1 0 110 2 1 1 0 010-2zM9.74 12.092a1.94 1.94 0 00-1.87 1.45H0v1h7.87a1.93 1.93 0 003.74 0H16v-1h-4.39a1.94 1.94 0 00-1.87-1.45zm0 2.91a1 1 0 11-.1-1.997 1 1 0 01.1 1.997zM14.05 1.453a1.93 1.93 0 00-3.74 0H0v1h10.31a1.93 1.93 0 003.74 0H16v-1h-1.95zm-1.87 1.46a1 1 0 010-1.91 1 1 0 010 1.91z","fill":"currentColor"}})]) } };

var iconTopic = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17"}},[_c('path',{attrs:{"d":"M11.819 5.682l1.97-1.891c.316.182.673.278 1.038.279a1.997 1.997 0 001.84-1.225 1.977 1.977 0 00-.432-2.162 1.995 1.995 0 00-3.4 1.403c.004.337.093.667.26.96l-1.992 1.892.716.744zm2.977-4.536a.957.957 0 01.882.589.947.947 0 01-.703 1.295.958.958 0 01-.978-.413.948.948 0 01-.156-.531.937.937 0 01.59-.872.947.947 0 01.365-.068z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.887 8.926c.125.462.415.862.815 1.127a1.988 1.988 0 002.588-.344 1.969 1.969 0 000-2.6 1.984 1.984 0 00-3.403.784h-.83a3.612 3.612 0 00-1.03-2.073 3.636 3.636 0 00-2.082-1.027v-.806a1.98 1.98 0 001.131-.812A1.967 1.967 0 009.732.597a1.986 1.986 0 00-2.61 0 1.971 1.971 0 00.786 3.39v.827a3.617 3.617 0 00-1.702.744L3.831 3.212A2.06 2.06 0 003.464.506a2.08 2.08 0 00-2.742.02 2.064 2.064 0 00.875 3.544c.49.123 1.007.064 1.456-.166L5.51 6.312a3.567 3.567 0 00-.622 1.591h-.82a1.974 1.974 0 00-.815-1.127 1.987 1.987 0 00-2.587.344 1.969 1.969 0 000 2.6 1.983 1.983 0 003.402-.784h.83a3.66 3.66 0 00.664 1.602l-2.427 2.418a1.967 1.967 0 00-.975-.269 2.08 2.08 0 00-1.288.38 2.067 2.067 0 00-.735 2.425c.165.428.468.79.861 1.027a2.081 2.081 0 002.526-.29 2.064 2.064 0 00.347-2.509L6.3 11.25a3.534 3.534 0 001.628.693v.827c-.466.125-.87.415-1.138.815a1.978 1.978 0 00.344 2.592 1.996 1.996 0 002.626 0 1.982 1.982 0 00.344-2.592c-.267-.4-.672-.69-1.138-.815v-.827a3.577 3.577 0 001.587-.61l2.458 2.45a1.977 1.977 0 00.662 2.528 1.998 1.998 0 002.605-.319 1.98 1.98 0 00-1.203-3.285 1.998 1.998 0 00-1.369.3L11.3 10.621c.389-.493.646-1.076.747-1.695h.84zm1.909-1.457a.947.947 0 01.864.588.936.936 0 01-.211 1.02.946.946 0 01-1.608-.668.937.937 0 01.59-.871.947.947 0 01.365-.069zM2.16 9.35a.947.947 0 01-.862-.58.937.937 0 01.673-1.279.947.947 0 01.97.376.938.938 0 01-.41 1.412.947.947 0 01-.371.072zm5.342-7.232a.948.948 0 01.563-.898.958.958 0 011.322.657.947.947 0 01-.382.988.957.957 0 01-.528.172.947.947 0 01-.903-.58.937.937 0 01-.072-.37v.03zm-5.342.95a.957.957 0 01-.882-.586.947.947 0 01.696-1.297.958.958 0 01.98.405c.104.156.16.34.16.528a.949.949 0 01-.954.92v.03zm0 12.544a.957.957 0 01-.883-.59.947.947 0 01.703-1.294.958.958 0 01.978.413.948.948 0 01.156.53.936.936 0 01-.59.873.95.95 0 01-.364.068zm3.724-7.233a2.576 2.576 0 011.6-2.386 2.603 2.603 0 012.827.56 2.58 2.58 0 01.562 2.815 2.6 2.6 0 01-4.23.838 2.578 2.578 0 01-.76-1.827zM9.4 14.671a.948.948 0 01-.596.88.957.957 0 01-1.298-.714.947.947 0 01.433-.972.957.957 0 011.193.144.949.949 0 01.268.662zm5.395-.95a.957.957 0 01.881.586.948.948 0 01-.695 1.296.957.957 0 01-.98-.404.948.948 0 01.119-1.2.957.957 0 01.675-.279z","fill":"currentColor"}})]) } };

var iconTraining = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10.306.123A8.377 8.377 0 004.314 1.35a4.204 4.204 0 00-1.887 3.435c.007.39.054.778.14 1.158 0 .12.05.28.06.37l-.22.3A7.769 7.769 0 001.02 8.73a.71.71 0 00.13.6 1.408 1.408 0 001.059.409 1.857 1.857 0 00-.14.799c.035.252.142.487.31.679.003.04.003.08 0 .12a1.997 1.997 0 00.199 1.667 2.066 2.066 0 001.777.45c.463-.066.931-.09 1.398-.07a8.907 8.907 0 01-.06 1.997.49.49 0 00.12.4.49.49 0 00.38.17h3.994V15H6.75c.07-.739.11-1.997-.29-2.336-.4-.34-1.717-.24-2.246-.17a1.127 1.127 0 01-.88-.12 1.657 1.657 0 01.06-.789c.028-.097.045-.198.05-.3a.998.998 0 00-.259-.678.762.762 0 01-.11-.16c.04-.224.108-.441.2-.65.056-.128.1-.262.13-.399a.56.56 0 00-.12-.389c-.17-.2-.4-.21-.739-.23h-.43c.26-.479.9-1.268 1.089-1.567.116-.143.223-.293.32-.45.16-.26.1-.549 0-.998a4.993 4.993 0 01-.12-.999A3.166 3.166 0 014.904 2.14a7.459 7.459 0 015.262-.999A4.604 4.604 0 0114 5.765c0 2.237-.679 2.995-1.178 3.515a4.612 4.612 0 00-.37.449 9.107 9.107 0 00-1.268 4.633V16h.999v-1.618c0-1.434.379-2.843 1.098-4.084.084-.114.178-.22.28-.32.569-.648 1.438-1.587 1.438-4.213A5.592 5.592 0 0010.306.123z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.135 6.514v.998a1.498 1.498 0 00.729-2.796 1.539 1.539 0 00-.39-1.408 1.517 1.517 0 00-1.468-.38 1.568 1.568 0 00-2.716 0 1.498 1.498 0 00-1.448.38 1.518 1.518 0 00-.399 1.408 1.498 1.498 0 00.739 2.796H7.76a1.488 1.488 0 001.398.999h.489v1.498h.998V8.012a.5.5 0 00-.499-.5h-.998a.489.489 0 01-.48-.499.5.5 0 01.49-.5v-.998a1.498 1.498 0 00-1.398.999H6.192a.5.5 0 01-.49-.5.51.51 0 01.31-.479.52.52 0 00.4 0 .54.54 0 00.23-.58.43.43 0 00-.2-.299.5.5 0 01.12-.639.49.49 0 01.688 0 .51.51 0 00.54.11.5.5 0 00.31-.46.59.59 0 01.998-.359.47.47 0 01.15.35.5.5 0 00.309.47.51.51 0 00.51-.11.479.479 0 01.698 0 .5.5 0 01.06.618.75.75 0 00-.2.33.5.5 0 00.67.58.506.506 0 01-.16.998v-.03z","fill":"currentColor"}})]) } };

var iconTrophy = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.68 1.93a.507.507 0 00-.4.09.499.499 0 00-.209.36c-.299 3.19-1.645 5.17-2.852 5.72a.489.489 0 00-.29.45v1.37a.481.481 0 00.22.41c.139.132.242.297.3.48H6.455a1 1 0 01.31-.48.5.5 0 00.229-.42V8.56a.51.51 0 00-.3-.46C5.41 7.53 4.073 4.74 4.004 1h9.165V.76a.771.771 0 00-.807-.76H3.742a.767.767 0 00-.738.76c0 .52 0 1 .09 1.51-.648.165-1.22.55-1.616 1.09a3.004 3.004 0 00-.399 2.32c.43 2.24 2.703 2.44 3.58 2.57l-.747 1.14.838.55.748-1.15c.042-.073.079-.15.11-.23.115.109.239.209.368.3v.82c-.285.322-.484.71-.578 1.13h-.698a.498.498 0 00-.499.5v1.59H3.055a.498.498 0 00-.498.5v2.1a.5.5 0 00.498.5H12.9a.498.498 0 00.499-.5v-2.1a.51.51 0 00-.499-.5h-1.147v-1.59a.501.501 0 00-.499-.5h-.758a2.493 2.493 0 00-.568-1.12v-.83a3.9 3.9 0 00.489-.34l.07.13.747 1.15.838-.55-.728-1.19c.858-.08 3.132-.28 3.56-2.51a2.947 2.947 0 00-1.145-3.146c-.324-.23-.69-.39-1.078-.473zM2.068 5.5a2.005 2.005 0 01.22-1.56c.228-.309.544-.542.907-.67.2 1.37.64 2.693 1.296 3.91-1.147-.13-2.194-.45-2.423-1.68zm8.687 7.4h-3.76v1h5.415V15H3.554v-1.1h2.443v-1H5.19v-1.09h5.565v1.09zm3.161-7.54c-.22 1.16-1.167 1.52-2.234 1.64a10.628 10.628 0 001.297-3.88 1.908 1.908 0 01.937 2.24z","fill":"currentColor"}})]) } };

var iconTwitter = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.344 4.75c.02.083.031.219.031.406 0 1.5-.365 2.948-1.094 4.344-.75 1.48-1.802 2.656-3.156 3.531-1.48.98-3.177 1.469-5.094 1.469-1.833 0-3.51-.49-5.031-1.469.23.021.49.031.781.031 1.521 0 2.886-.468 4.094-1.406-.73 0-1.37-.213-1.922-.64a3.263 3.263 0 01-1.14-1.61c.208.021.406.031.593.031.292 0 .584-.03.875-.093a3.306 3.306 0 01-1.875-1.156 3.146 3.146 0 01-.75-2.063v-.063c.459.271.948.417 1.469.438a3.64 3.64 0 01-1.063-1.188 3.152 3.152 0 01-.406-1.578c0-.573.156-1.12.469-1.64A9.048 9.048 0 004.109 4.53a9.083 9.083 0 003.766 1c-.042-.25-.063-.5-.063-.75 0-.583.146-1.13.438-1.64.292-.51.688-.912 1.188-1.204a3.17 3.17 0 011.624-.437c.48 0 .922.094 1.329.281.406.188.765.438 1.078.75a6.675 6.675 0 002.094-.781c-.25.77-.73 1.375-1.438 1.813A7.049 7.049 0 0016 3.03a7.213 7.213 0 01-1.656 1.719z","fill":"currentColor"}})]) } };

var iconUpload = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.83 5.08a5.112 5.112 0 00-1.56-3.263A4.75 4.75 0 008 .5a4.75 4.75 0 00-3.269 1.317 5.112 5.112 0 00-1.56 3.263 3.151 3.151 0 00-1.986 1.21 3.384 3.384 0 00-.677 2.285 3.35 3.35 0 00.99 2.16c.579.565 1.34.885 2.135.895h2.851v-1.043H3.633a2.128 2.128 0 01-1.534-.66 2.298 2.298 0 01-.635-1.593c0-.597.229-1.17.635-1.593.407-.422.959-.66 1.534-.66.133 0 .26-.055.355-.152a.532.532 0 00.147-.37c0-1.059.405-2.075 1.126-2.824.721-.75 1.7-1.17 2.72-1.17 1.02 0 1.997.42 2.719 1.17a4.075 4.075 0 011.126 2.825c0 .138.053.27.147.369a.493.493 0 00.355.152c.575 0 1.127.238 1.534.66.406.423.635.996.635 1.593 0 .598-.229 1.17-.636 1.593-.406.423-.958.66-1.533.66H9.497v1.043h2.851a3.11 3.11 0 002.143-.885 3.348 3.348 0 001-2.16 3.386 3.386 0 00-.672-2.291A3.152 3.152 0 0012.83 5.08z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.621 8.543l.713-.73-3.012-3.13a.502.502 0 00-.713 0l-3.012 3.13.713.73 2.179-2.211V15.5h1.004V6.332l2.128 2.21z","fill":"currentColor"}})]) } };

var iconUpvoteStroke = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10.196 15.5H5.924a.502.502 0 01-.501-.5V8.582H3.016a.492.492 0 01-.441-.27.49.49 0 010-.521L7.589.694a.531.531 0 01.822 0l5.014 7.008a.49.49 0 010 .52.49.49 0 01-.38.27h-3.35v-.5a.5.5 0 01.501-.5h1.875l-4.01-5.646-4.072 5.736h1.935a.502.502 0 01.502.5V14.5h3.269V9.494h1.002v5.505a.5.5 0 01-.5.501z","fill":"currentColor"}})]) } };

var iconUser = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.572 16H1.428a.66.66 0 01-.678-.636V12.52c0-1.654 3.38-2.764 4.412-3.026.364-.101.475-.283.506-.424a5.547 5.547 0 01-1.569-4.025C4.1 2.25 5.81 0 8.005 0s3.875 2.25 3.875 5.044c0 2.794-1.75 5.044-3.895 5.044V9.08c1.608-.07 2.883-1.866 2.883-4.035S9.593 1.009 8.005 1.009c-1.589 0-2.894 1.795-2.894 4.035a4.487 4.487 0 001.376 3.36.625.625 0 01.203.433 1.53 1.53 0 01-1.255 1.584c-1.73.504-3.673 1.493-3.673 2.098v2.472h12.476v-2.472c0-.665-1.811-1.533-3.117-1.906l.274-1.01c.647.182 3.855 1.171 3.855 2.876v2.845a.654.654 0 01-.678.676z","fill":"currentColor"}})]) } };

var iconUsers = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.52 4.925a3.247 3.247 0 00.71-2.08 2.612 2.612 0 00-.542-1.876A2.587 2.587 0 0012 0a2.587 2.587 0 00-1.713.956 2.612 2.612 0 00-.557 1.888 2.927 2.927 0 001.38 2.623l.46-.884a2.007 2.007 0 01-.84-1.739c0-.995.57-1.839 1.27-1.839.7 0 1.25.844 1.25 1.84a2.16 2.16 0 01-.65 1.607.675.675 0 00-.16.342 1.009 1.009 0 00.81 1.095 4.192 4.192 0 011.75.865v1.005h-4.09c-.07-2.01-1.35-3.598-2.92-3.598-1.57 0-2.86 1.638-2.93 3.638H1V6.794a3.803 3.803 0 011.72-.895 1.009 1.009 0 00.82-1.116.584.584 0 00-.19-.34 2.162 2.162 0 01-.62-1.589c0-1.005.57-1.849 1.27-1.849.7 0 1.25.844 1.25 1.84a2.019 2.019 0 01-.84 1.738l.47.884a2.937 2.937 0 001.35-2.623A2.612 2.612 0 005.688.97 2.587 2.587 0 004 0a2.587 2.587 0 00-1.713.956 2.612 2.612 0 00-.557 1.888 3.206 3.206 0 00.71 2.08C1.7 5.147 0 5.76 0 6.755V8.23a.575.575 0 00.366.535c.071.028.147.04.224.038h4.54a3.927 3.927 0 001 2.09c-.05.09-.18.121-.24.141-.76.221-3.26 1.005-3.26 2.352v2.01a.616.616 0 00.386.56c.074.03.154.044.234.043h9.45a.608.608 0 00.62-.603v-2.01c0-1.297-2.19-2.01-2.86-2.211l-.28 1.005c1.1.311 2.14.925 2.14 1.246v1.648H3.65v-1.688c0-.292 1.14-1.005 2.53-1.387.292-.056.554-.215.738-.45a1.24 1.24 0 00.262-.826.614.614 0 00-.18-.422 3.087 3.087 0 01-.94-2.352c0-1.518.87-2.744 1.94-2.744 1.07 0 1.92 1.226 1.92 2.744 0 1.517-.87 2.753-1.92 2.753v1.006a3.184 3.184 0 001.944-.938c.52-.53.84-1.226.906-1.967h4.54a.577.577 0 00.61-.573V6.754c0-.995-1.74-1.608-2.48-1.83z","fill":"currentColor"}})]) } };

var iconVideo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.94 4a.512.512 0 00-.289-.45.487.487 0 00-.528.07l-3.168 2.69V4.5a1.495 1.495 0 00-.428-1.06A1.512 1.512 0 0010.46 3H.498A.497.497 0 000 3.5V4h10.46a.487.487 0 01.36.15c.09.094.14.22.139.35V12H1.494a.497.497 0 01-.498-.5V5H0v6.49a1.505 1.505 0 00.92 1.395c.182.076.377.115.574.115h9.963a.497.497 0 00.498-.5V9.69l3.228 2.7c.092.07.204.108.319.11a.377.377 0 00.21-.05A.489.489 0 0016 12l-.06-8zm-3.985 4.39v-.78l2.989-2.54v5.86l-2.989-2.54z","fill":"currentColor"}})]) } };

var iconVimeo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('g',{attrs:{"clip-path":"url(#assets-icon-vimeo_svg__clip0)"}},[_c('path',{attrs:{"d":"M12.638 0H3.362A3.362 3.362 0 000 3.362v9.276A3.362 3.362 0 003.362 16h9.276A3.36 3.36 0 0016 12.638V3.362A3.361 3.361 0 0012.638 0zm.32 6.859a13.92 13.92 0 01-3.547 4.818c-.356.319-.76.581-1.196.778a1.28 1.28 0 01-1.826-.55 8.24 8.24 0 01-.853-2.264c-.255-.919-.47-1.85-.802-2.746a2.668 2.668 0 00-.284-.6.437.437 0 00-.657-.167c-.213.112-.413.25-.633.386l-.494-.636c.783-.76 1.624-1.46 2.514-2.093a1.226 1.226 0 011.953.672c.164.518.276 1.052.333 1.593.116.836.293 1.661.53 2.47.063.226.165.438.301.627a.306.306 0 00.488.062c.113-.09.216-.191.31-.3a6.728 6.728 0 001.06-1.8 1.61 1.61 0 00.128-.582c.009-.558-.257-.816-.82-.793-.233.028-.464.08-.687.155a3.419 3.419 0 012.283-2.438 1.708 1.708 0 012.275 1.73 3.966 3.966 0 01-.376 1.678z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"assets-icon-vimeo_svg__clip0"}},[_c('path',{attrs:{"fill":"currentColor","transform":"scale(1.00018)","d":"M0 0h15.997v15.997H0z"}})])])]) } };

var iconVolt = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.787.09a.5.5 0 01.153.647l-3.048 5.66 3.553-.394a.5.5 0 01.429.83l-8 9a.5.5 0 01-.814-.57l3.048-5.66-3.553.394a.5.5 0 01-.429-.83l8-9a.5.5 0 01.66-.077zM4.737 8.86l3.207-.357a.5.5 0 01.495.734L6.968 11.97l4.293-4.83-3.206.357a.5.5 0 01-.495-.734L9.032 4.03 4.738 8.86z","fill":"currentColor"}})]) } };

var iconWarning = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.995 13.997H1.366L8 2.486l3.326 5.772 3.25 5.2.847-.531-3.24-5.185-3.75-6.508a.52.52 0 00-.866 0l-7.5 13.015A.502.502 0 00.5 15h15a.5.5 0 00.5-.506l-.005-.497zm-7.64-2.027h-.91v.931h.91v-.931zm-.751-.65l-.23-5.428h1.04l-.23 5.427h-.58z","fill":"currentColor"}})]) } };

var iconWebex = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8.003 0a8 8 0 11-.006 16 8 8 0 01.006-16zM1.78 8.39a6.048 6.048 0 003.01 4.938 1.515 1.515 0 001.256.182 4.002 4.002 0 001.695-1.02 14.6 14.6 0 003.68-5.77 6.293 6.293 0 00.456-2.727 1.719 1.719 0 00-.965-1.496 6.232 6.232 0 00-3.832-.653 6.333 6.333 0 00-5.3 6.546z","fill":"currentColor"}})]) } };

var iconWebinar = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.826 11.005h-2.36V12h2.36v-.995zM12.826 9.121h-2.36v.995h2.36v-.995zM11.11 5.18a.498.498 0 01-.738-.435V2.368a.497.497 0 01.738-.435l2.136 1.188a.498.498 0 010 .87L11.11 5.179z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.402 13.53h-.305V7.21h-.994v6.32H1.798l.042-8.477h4.619v-.995h-4.62A1.048 1.048 0 00.804 5.115v8.415H.497a.499.499 0 00-.497.497C0 14.946.184 16 1.622 16h12.566c1.151 0 1.711-.645 1.711-1.973a.497.497 0 00-.497-.497zm-1.214 1.475H1.622c-.32 0-.526 0-.6-.48h13.846c-.09.48-.34.48-.68.48z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.013 6.466a4.25 4.25 0 01-.62.664.66.66 0 00-.135.638.584.584 0 00.54.38 4.623 4.623 0 001.55-.313c.411-.153.781-.398 1.082-.717.048.002.096.002.145.002C14.015 7.12 16 5.523 16 3.56S14.014 0 11.575 0C9.135 0 7.15 1.597 7.15 3.56a3.416 3.416 0 001.863 2.906zm2.562-5.47c1.892 0 3.431 1.15 3.431 2.564 0 1.414-1.539 2.565-3.431 2.565-.105 0-.21-.003-.312-.01a.517.517 0 00-.381.14l-.093.096a1.928 1.928 0 01-.903.592 1.68 1.68 0 00.213-.695.499.499 0 00-.29-.491A2.547 2.547 0 018.143 3.56c0-1.414 1.54-2.565 3.432-2.565zM3.784 10.124a3.025 3.025 0 00-.894 2.028.497.497 0 00.496.495h5.05a.498.498 0 00.496-.482 2.321 2.321 0 00-1.014-2.006 3.29 3.29 0 00-.593-.252c.245-.373.375-.81.374-1.256a1.95 1.95 0 00-1.788-2.076 1.95 1.95 0 00-1.788 2.076 1.95 1.95 0 001.787 2.076 2.636 2.636 0 011.53.305.971.971 0 01.432.62H3.978c.098-.308.27-.588.5-.815l-.694-.713zm2.127-.392c-.43 0-.794-.495-.794-1.08 0-.587.364-1.081.794-1.081.43 0 .794.494.794 1.08 0 .586-.364 1.081-.794 1.081z","fill":"currentColor"}})]) } };

var iconWhitePapers = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.179 13.089V2.065h-1.036v10.838h-9.84a.519.519 0 01-.517-.516V1.032h11.393V.857a.854.854 0 00-.531-.792.862.862 0 00-.33-.065H1.61a.861.861 0 00-.86.857v11.53c0 .41.164.805.455 1.095.291.29.687.453 1.099.453h10.015a.861.861 0 00.86-.846z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.732.516h-.518v14.297a.175.175 0 01-.186.165H2.82v.506A.515.515 0 003.34 16h10.689a1.214 1.214 0 001.222-1.187V1.033a.515.515 0 00-.518-.517zM11.107 2.064H2.821v1.033h8.286V2.064z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.107 4.82H2.821v1.033h8.286V4.82zM5.928 10.322H2.821v1.033h3.107v-1.033zM5.928 7.566H2.821V8.6h3.107V7.566zM8 11.871h2.072a1.038 1.038 0 001.035-1.032V8.774a1.03 1.03 0 00-1.035-1.032H8a1.037 1.037 0 00-1.036 1.032v2.065A1.03 1.03 0 008 11.87zm0-3.097h2.072v2.065H8V8.774z","fill":"currentColor"}})]) } };

var iconWifi = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.95 14.5a1.776 1.776 0 01-1.292-.534 1.854 1.854 0 01-.005-2.613 1.832 1.832 0 012.6-.005 1.87 1.87 0 010 2.618 1.822 1.822 0 01-1.303.534zm0-2.68a.859.859 0 00-.59.243.859.859 0 000 1.188.831.831 0 001.112.052.835.835 0 00.165-1.108.833.833 0 00-.687-.374z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M4.975 11.136a.449.449 0 01-.36-.161l-1.352-1.47a.505.505 0 010-.635 6.165 6.165 0 011.742-1.673 5.655 5.655 0 015.8-.06 5.882 5.882 0 011.882 1.733.516.516 0 010 .634l-1.392 1.47a.47.47 0 01-.42.162.51.51 0 01-.381-.252 2.874 2.874 0 00-1.002-1.078 3.2 3.2 0 00-3.004 0c-.42.269-.764.64-1.002 1.078a.513.513 0 01-.38.252h-.13zm-.69-2.015l.64.695c.282-.347.62-.643 1.002-.876a4.218 4.218 0 014.086 0c.38.234.719.53 1.002.876l.64-.695c-.387-.436-.848-.8-1.361-1.077a4.628 4.628 0 00-4.808 0A5.138 5.138 0 004.284 9.13v-.01z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M2.302 7.681a.468.468 0 01-.35-.151L.628 6.2a.505.505 0 010-.675c.21-.241.42-.493.651-.725a9.459 9.459 0 016.488-2.797 9.454 9.454 0 016.612 2.485l-.67.745a8.455 8.455 0 00-5.916-2.221 8.46 8.46 0 00-5.803 2.503l-.29.303.61.614a7.62 7.62 0 015.684-2.553 7.62 7.62 0 015.384 2.23c.107.097.208.202.3.313l1.002-1.007.32-.393.35.352a.504.504 0 010 .716L13.96 7.53a.54.54 0 01-.38.151.489.489 0 01-.371-.201 6.825 6.825 0 00-.571-.655A6.641 6.641 0 007.955 4.89a6.641 6.641 0 00-4.682 1.935c-.206.207-.397.43-.57.665a.521.521 0 01-.371.191h-.03z","fill":"currentColor"}})]) } };

var iconWorkFromHome = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.75 10.557L8.387 6.091a.465.465 0 00-.549 0L5.662 7.616V6.74a.503.503 0 00-.144-.353.486.486 0 00-.346-.145H3.21a.486.486 0 00-.347.146.503.503 0 00-.143.352V9.53l-1.471.997.559.828 1.676-1.187a.485.485 0 00.216-.408V7.237h.98v1.326a.504.504 0 00.265.409.474.474 0 00.5 0l2.667-1.864 4.412 3.1v4.795H9.582v-2.801a.503.503 0 00-.143-.353.486.486 0 00-.347-.146h-1.96a.486.486 0 00-.347.146.503.503 0 00-.144.353v2.801h-2.45a.486.486 0 01-.347-.146.502.502 0 01-.144-.352v-2.662h-.98v2.662c0 .396.155.777.43 1.057.276.28.65.438 1.04.438h2.941c.13 0 .255-.053.347-.146a.503.503 0 00.144-.352V12.7h.98v2.802c0 .132.052.258.143.352a.486.486 0 00.347.146h3.922c.13 0 .254-.053.346-.146a.503.503 0 00.144-.352v-4.606l.686.488.559-.827zM7.28 5.393a.985.985 0 01.793-.412.967.967 0 01.795.412l.754-.638a2.015 2.015 0 00-.693-.547 1.982 1.982 0 00-2.405.547l.755.638z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.054 3.47a3.826 3.826 0 00-1.307-1.076 3.763 3.763 0 00-1.634-.4 3.772 3.772 0 00-1.635.4A3.836 3.836 0 005.171 3.47l.755.638c.265-.336.6-.608.982-.795a2.785 2.785 0 012.448 0c.382.187.717.459.982.795l.716-.638z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.113.997a4.836 4.836 0 012.081.52 4.919 4.919 0 011.664 1.374l.755-.638A5.901 5.901 0 0010.61.614 5.803 5.803 0 008.113 0 5.725 5.725 0 005.59.598a5.823 5.823 0 00-2.016 1.655l.745.638a4.918 4.918 0 011.686-1.384 4.836 4.836 0 012.108-.51z","fill":"currentColor"}})]) } };

var iconWorkshop = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16"}},[_c('path',{attrs:{"d":"M2.452 12.713l-.15.524.39.385.54-.139.14-.523-.39-.385-.53.138z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.712 13.108l-5.41-5.305 2.06-1.976c.315.05.635.05.95 0a2.701 2.701 0 001.45-.75c.396-.387.665-.883.77-1.423.039-.222.039-.45 0-.672a.647.647 0 00-.2-.484.643.643 0 00-.52-.138c-.21.063-.4.178-.55.336l-.6.504-.13.108-.45-.158-.1-.484 1.09-.889a.67.67 0 00.21-.583.678.678 0 00-.39-.484 2.02 2.02 0 00-.69-.188 2.976 2.976 0 00-.73 0 2.63 2.63 0 00-1.74 1.077 2.613 2.613 0 00-.49 1.976v.128l-2 1.976c-.48-.464-.69-.681-1.07-1.057l-.11-.109-.7.692.1.109c1.34 1.333 3.2 3.151 5 4.939l3.52 3.537-.72.701-9.51-9.652a1.228 1.228 0 00-.864-.421 1.244 1.244 0 00-.906.323 1.18 1.18 0 00-.5 1.047l-.26.267a13.92 13.92 0 01-1-.988l-.13-.168c.098-.092.201-.178.31-.257a.739.739 0 00.25 0c.372-.073.707-.27.949-.557.242-.288.377-.65.38-1.024l.13-.138c.178-.224.39-.417.63-.573.522-.299 1.101-.484 1.7-.543-.165.131-.319.276-.46.434a1.066 1.066 0 00-.22 1.383c0 .08 0 .11.71.77l.08.08.71-.692-.41-.414-.25-.247c-.06-.11 0-.119.08-.238.34-.345.34-.345.7-.345.197-.02.395-.02.59 0h.28a.729.729 0 00.61-.208l.27-.276a.473.473 0 00.14-.415.504.504 0 00-.29-.267 4.645 4.645 0 00-1.17-.435 5.053 5.053 0 00-3.59.573c-.336.2-.634.458-.88.761l-.12.128a.98.98 0 00-.24.692c0 .237-.26.484-.58.553a.895.895 0 00-.67.198c-.2.187-.38.375-.56.563a.619.619 0 00-.08.75c.113.183.237.357.37.524.415.477.873.914 1.37 1.304.096.067.206.111.32.129a.627.627 0 00.55-.158c.21-.198.42-.396.62-.603a.611.611 0 00.17-.524c0-.158 0-.197.12-.296.12-.099.29-.138.44 0l2.11 2.144.06.059-3.13 3.102a2.02 2.02 0 00-.42 0 2.374 2.374 0 00-1.644.739 2.317 2.317 0 00.113 3.297 2.378 2.378 0 001.692.627h.15a2.39 2.39 0 001.624-.796 2.333 2.333 0 00.586-1.694v-.128l3.1-3.043 5.31 5.394a1.007 1.007 0 001.36 0l.74-.731a.989.989 0 00.3-.701.982.982 0 00-.29-.692zM8.922 6.45l2.25-2.213a.473.473 0 00.12-.504 1.6 1.6 0 01.25-1.492 1.659 1.659 0 011.1-.73h.22l-.71.572a.503.503 0 00-.17.415l.17 1.057a.48.48 0 00.33.395l1 .346a.496.496 0 00.49-.099l.34-.286.09-.08a1.85 1.85 0 01-.34.465c-.25.249-.571.414-.92.474a1.578 1.578 0 01-.78 0 .496.496 0 00-.5.119l-2.27 2.223-.67-.662zm-4.63 5.927a.483.483 0 00-.13.464c.01.082.01.165 0 .247a1.329 1.329 0 01-.334.977 1.358 1.358 0 01-.936.456c-.363.02-.72-.096-1-.326a1.338 1.338 0 01.071-2.097 1.38 1.38 0 01.749-.274H3.122a.496.496 0 00.46-.129l3.33-3.27.67.672-3.29 3.28z","fill":"currentColor"}})]) } };

var iconWwtLogo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M9.893 10.218l1.836 1.867a.081.081 0 00.058.023h2.296a.08.08 0 00.075-.05.084.084 0 00-.017-.09l-2.986-3.034 1.836-1.867a.083.083 0 000-.116l-1.147-1.167a.08.08 0 00-.115 0L6.796 10.8a.081.081 0 00-.025.06.083.083 0 00.025.058l1.147 1.167A.083.083 0 008 12.11a.08.08 0 00.058-.024l1.835-1.868zM9.781 3.914l-1.78 1.812-1.782-1.812a.081.081 0 00-.059-.024H3.865a.08.08 0 00-.076.05.084.084 0 00.018.091l2.931 2.978-.63.642-3.674-3.737a.082.082 0 00-.059-.024H.082a.08.08 0 00-.076.05.084.084 0 00.018.091l6.026 6.128a.08.08 0 00.09.019.08.08 0 00.026-.019l6.025-6.128a.084.084 0 00-.013-.127.08.08 0 00-.046-.014H9.838a.08.08 0 00-.058.024M13.567 3.914l-1.092 1.111a.082.082 0 00-.024.059.083.083 0 00.024.058l1.147 1.167a.08.08 0 00.088.018.08.08 0 00.026-.018l2.24-2.278a.083.083 0 00.018-.09.08.08 0 00-.075-.05h-2.296a.082.082 0 00-.058.023","fill":"currentColor"}})]) } };

var iconYoutube = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M15.678 4.138c.136.528.234 1.329.293 2.403L16 8.006l-.03 1.466c-.058 1.094-.156 1.904-.292 2.432a2.043 2.043 0 01-.528.879c-.254.254-.557.43-.908.527-.508.137-1.7.235-3.575.293L8 13.633l-2.667-.03c-1.875-.058-3.067-.156-3.575-.293a2.031 2.031 0 01-.908-.527 2.043 2.043 0 01-.528-.88C.186 11.377.088 10.567.03 9.473L0 8.006c0-.43.01-.918.03-1.465.058-1.074.156-1.875.292-2.403.098-.351.274-.654.528-.908s.557-.43.908-.528c.508-.136 1.7-.234 3.575-.293L8 2.38l2.667.03c1.875.058 3.067.156 3.575.292.351.098.654.274.908.528s.43.557.528.908zM6.359 10.41l4.19-2.403-4.19-2.373v4.776z","fill":"currentColor"}})]) } };

var iconZoom = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm1.77 10.2c0 .17-.13.3-.3.3H4.71c-.79 0-1.43-.64-1.43-1.43V5.82c0-.17.13-.3.3-.3h4.76c.79 0 1.43.64 1.43 1.43v3.25zm3.18.1c0 .12-.14.2-.24.12L10.77 9V7l1.95-1.44c.1-.07.24 0 .24.12v4.62h-.01z","fill":"currentColor"}})]) } };



// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/AppTile.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var AppTilevue_type_script_lang_js_ = ({
  name: 'AppTile',
  components: {
    IconStar: iconStar,
    IconStarFill: iconStarFill,
    IconCaretRight: iconCaretRight
  },
  props: {
    app: {
      type: Object,
      required: true
    },
    isRecent: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleFavorite: function () {
      var _toggleFavorite = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.app.toggleFavorite();

              case 2:
                this.$emit('toggle-favorite');

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function toggleFavorite() {
        return _toggleFavorite.apply(this, arguments);
      }

      return toggleFavorite;
    }(),
    removeFavorite: function removeFavorite() {
      this.app.removeFavorite();
      this.$emit('remove-favorite', this.app);
    }
  }
});
// CONCATENATED MODULE: ./src/AppTile.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_AppTilevue_type_script_lang_js_ = (AppTilevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/AppTile.vue?vue&type=style&index=0&id=06eec416&lang=less&scoped=true&
var AppTilevue_type_style_index_0_id_06eec416_lang_less_scoped_true_ = __webpack_require__("6894");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/AppTile.vue






/* normalize component */

var component = normalizeComponent(
  src_AppTilevue_type_script_lang_js_,
  AppTilevue_type_template_id_06eec416_scoped_true_lang_html_render,
  AppTilevue_type_template_id_06eec416_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "06eec416",
  null
  
)

/* harmony default export */ var AppTile = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"6f03bffb-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/AppList.vue?vue&type=template&id=fed10dde&scoped=true&lang=html&
var AppListvue_type_template_id_fed10dde_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-wrapper"},[_c('span',{staticClass:"favorite",attrs:{"tabindex":"0"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleFavorite($event)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggleFavorite($event)}}},[(!_vm.app.isFavorite)?_c('icon-star',{staticClass:"icon"}):_c('icon-star-fill',{staticClass:"icon"})],1),_c('a',{attrs:{"href":_vm.app.url,"target":"_blank"},on:{"click":function($event){return _vm.$emit('add-recent', _vm.app)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.$emit('check-focus', $event)}}},[_c('div',{staticClass:"app-wrapper"},[_c('span',{staticClass:"app-name"},[_vm._v(_vm._s(_vm.app.name))]),_c('icon-caret-right',{staticClass:"icon arrow"})],1)])])}
var AppListvue_type_template_id_fed10dde_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/AppList.vue?vue&type=template&id=fed10dde&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/AppList.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var AppListvue_type_script_lang_js_ = ({
  name: 'AppList',
  components: {
    IconStar: iconStar,
    IconStarFill: iconStarFill,
    IconCaretRight: iconCaretRight
  },
  props: {
    app: {
      type: Object,
      required: true
    }
  },
  methods: {
    toggleFavorite: function () {
      var _toggleFavorite = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.app.toggleFavorite();

              case 2:
                this.$emit('toggle-favorite');

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function toggleFavorite() {
        return _toggleFavorite.apply(this, arguments);
      }

      return toggleFavorite;
    }()
  }
});
// CONCATENATED MODULE: ./src/AppList.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_AppListvue_type_script_lang_js_ = (AppListvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/AppList.vue?vue&type=style&index=0&id=fed10dde&lang=less&scoped=true&
var AppListvue_type_style_index_0_id_fed10dde_lang_less_scoped_true_ = __webpack_require__("bc89");

// CONCATENATED MODULE: ./src/AppList.vue






/* normalize component */

var AppList_component = normalizeComponent(
  src_AppListvue_type_script_lang_js_,
  AppListvue_type_template_id_fed10dde_scoped_true_lang_html_render,
  AppListvue_type_template_id_fed10dde_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "fed10dde",
  null
  
)

/* harmony default export */ var AppList = (AppList_component.exports);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.to-string.js
var es6_regexp_to_string = __webpack_require__("6b54");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.date.to-string.js
var es6_date_to_string = __webpack_require__("87b3");

// CONCATENATED MODULE: ./src/objectHasValue.js



var objectHasValue = function objectHasValue(obj, term) {
  for (var prop in obj) {
    // loop through every property in the object
    if (obj.hasOwnProperty(prop) && !!obj[prop]) {
      var thisProp = obj[prop];

      if (Object.prototype.toString.call(thisProp) === '[object Object]') {
        // we have an object. recursive filter on its properties.
        if (objectHasValue(thisProp, term)) {
          return true;
        }
      } else if (thisProp.toString().toLowerCase().indexOf(term.toString().toLowerCase()) !== -1) {
        return true;
      }
    }
  }

  return false;
};

/* harmony default export */ var src_objectHasValue = (objectHasValue);
// EXTERNAL MODULE: ./src/wwtEnv.js
var wwtEnv = __webpack_require__("fe02");

// CONCATENATED MODULE: ./node_modules/@blue-steel/search-input/dist/search-input.js
var e={name:"WwtSearchInput",components:{IconSearch:iconSearch,IconClose:iconClose},props:{ariaLabel:{type:String,required:!0},placeholder:{type:String,default:""},value:{type:String,default:""},disabled:{type:Boolean,default:!1},darkBackground:{type:Boolean,default:!1},tabindex:{type:String,required:!1,default:"0"}},computed:{listeners:function(){var a=this;return Object.assign({},this.$listeners,{input:function(t){return a.$emit("input",t.target.value)}})},showClear:function(){return""!==this.value}}};function d(a,t,e,d,i,n,r,o,c,s){"boolean"!=typeof r&&(c=o,o=r,r=!1);var m,l="function"==typeof e?e.options:e;if(a&&a.render&&(l.render=a.render,l.staticRenderFns=a.staticRenderFns,l._compiled=!0,i&&(l.functional=!0)),d&&(l._scopeId=d),n?(m=function(a){(a=a||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(a=__VUE_SSR_CONTEXT__),t&&t.call(this,c(a)),a&&a._registeredComponents&&a._registeredComponents.add(n)},l._ssrRegister=m):t&&(m=r?function(a){t.call(this,s(a,this.$root.$options.shadowRoot))}:function(a){t.call(this,o(a))}),m)if(l.functional){var p=l.render;l.render=function(a,t){return m.call(t),p(a,t)}}else{var x=l.beforeCreate;l.beforeCreate=x?[].concat(x,m):[m]}return e}!function(a,t){void 0===t&&(t={});var e=t.insertAt;if(a&&"undefined"!=typeof document){var d=document.head||document.getElementsByTagName("head")[0],i=document.createElement("style");i.type="text/css","top"===e&&d.firstChild?d.insertBefore(i,d.firstChild):d.appendChild(i),i.styleSheet?i.styleSheet.cssText=a:i.appendChild(document.createTextNode(a))}}('/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html[data-v-8d50087a]{line-height:1.15;-webkit-text-size-adjust:100%}body[data-v-8d50087a]{margin:0}main[data-v-8d50087a]{display:block}h1[data-v-8d50087a]{font-size:2em;margin:.67em 0}hr[data-v-8d50087a]{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible}pre[data-v-8d50087a]{font-family:monospace,monospace;font-size:1em}a[data-v-8d50087a]{background-color:transparent}abbr[title][data-v-8d50087a]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b[data-v-8d50087a],strong[data-v-8d50087a]{font-weight:bolder}code[data-v-8d50087a],kbd[data-v-8d50087a],samp[data-v-8d50087a]{font-family:monospace,monospace;font-size:1em}small[data-v-8d50087a]{font-size:80%}sub[data-v-8d50087a],sup[data-v-8d50087a]{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub[data-v-8d50087a]{bottom:-.25em}sup[data-v-8d50087a]{top:-.5em}img[data-v-8d50087a]{border-style:none}button[data-v-8d50087a],input[data-v-8d50087a],optgroup[data-v-8d50087a],select[data-v-8d50087a],textarea[data-v-8d50087a]{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button[data-v-8d50087a],input[data-v-8d50087a]{overflow:visible}button[data-v-8d50087a],select[data-v-8d50087a]{text-transform:none}[type=button][data-v-8d50087a],[type=reset][data-v-8d50087a],[type=submit][data-v-8d50087a],button[data-v-8d50087a]{-webkit-appearance:button}[type=button][data-v-8d50087a]::-moz-focus-inner,[type=reset][data-v-8d50087a]::-moz-focus-inner,[type=submit][data-v-8d50087a]::-moz-focus-inner,button[data-v-8d50087a]::-moz-focus-inner{border-style:none;padding:0}[type=button][data-v-8d50087a]:-moz-focusring,[type=reset][data-v-8d50087a]:-moz-focusring,[type=submit][data-v-8d50087a]:-moz-focusring,button[data-v-8d50087a]:-moz-focusring{outline:1px dotted ButtonText}fieldset[data-v-8d50087a]{padding:.35em .75em .625em}legend[data-v-8d50087a]{-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress[data-v-8d50087a]{vertical-align:baseline}textarea[data-v-8d50087a]{overflow:auto}[type=checkbox][data-v-8d50087a],[type=radio][data-v-8d50087a]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}[type=number][data-v-8d50087a]::-webkit-inner-spin-button,[type=number][data-v-8d50087a]::-webkit-outer-spin-button{height:auto}[type=search][data-v-8d50087a]{-webkit-appearance:textfield;outline-offset:-2px}[type=search][data-v-8d50087a]::-webkit-search-decoration{-webkit-appearance:none}[data-v-8d50087a]::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details[data-v-8d50087a]{display:block}summary[data-v-8d50087a]{display:list-item}template[data-v-8d50087a]{display:none}[hidden][data-v-8d50087a]{display:none}blockquote[data-v-8d50087a],dd[data-v-8d50087a],dl[data-v-8d50087a],figure[data-v-8d50087a],h1[data-v-8d50087a],h2[data-v-8d50087a],h3[data-v-8d50087a],h4[data-v-8d50087a],h5[data-v-8d50087a],h6[data-v-8d50087a],hr[data-v-8d50087a],p[data-v-8d50087a],pre[data-v-8d50087a]{margin:0}button[data-v-8d50087a]{background-color:transparent;background-image:none}button[data-v-8d50087a]:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}fieldset[data-v-8d50087a]{margin:0;padding:0}ol[data-v-8d50087a],ul[data-v-8d50087a]{list-style:none;margin:0;padding:0}html[data-v-8d50087a]{font-family:Roobert,system-ui,BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif;line-height:1.5}*[data-v-8d50087a],[data-v-8d50087a]::after,[data-v-8d50087a]::before{-webkit-box-sizing:border-box;box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}hr[data-v-8d50087a]{border-top-width:1px}img[data-v-8d50087a]{border-style:solid}textarea[data-v-8d50087a]{resize:vertical}input[data-v-8d50087a]::-webkit-input-placeholder,textarea[data-v-8d50087a]::-webkit-input-placeholder{color:#a0aec0}input[data-v-8d50087a]::-moz-placeholder,textarea[data-v-8d50087a]::-moz-placeholder{color:#a0aec0}input[data-v-8d50087a]:-ms-input-placeholder,textarea[data-v-8d50087a]:-ms-input-placeholder{color:#a0aec0}input[data-v-8d50087a]::-ms-input-placeholder,textarea[data-v-8d50087a]::-ms-input-placeholder{color:#a0aec0}input[data-v-8d50087a]::placeholder,textarea[data-v-8d50087a]::placeholder{color:#a0aec0}[role=button][data-v-8d50087a],button[data-v-8d50087a]{cursor:pointer}table[data-v-8d50087a]{border-collapse:collapse}h1[data-v-8d50087a],h2[data-v-8d50087a],h3[data-v-8d50087a],h4[data-v-8d50087a],h5[data-v-8d50087a],h6[data-v-8d50087a]{font-size:inherit;font-weight:inherit}a[data-v-8d50087a]{color:inherit;text-decoration:inherit}button[data-v-8d50087a],input[data-v-8d50087a],optgroup[data-v-8d50087a],select[data-v-8d50087a],textarea[data-v-8d50087a]{padding:0;line-height:inherit;color:inherit}code[data-v-8d50087a],kbd[data-v-8d50087a],pre[data-v-8d50087a],samp[data-v-8d50087a]{font-family:Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace}audio[data-v-8d50087a],canvas[data-v-8d50087a],embed[data-v-8d50087a],iframe[data-v-8d50087a],img[data-v-8d50087a],object[data-v-8d50087a],svg[data-v-8d50087a],video[data-v-8d50087a]{display:block;vertical-align:middle}img[data-v-8d50087a],video[data-v-8d50087a]{max-width:100%;height:auto}.container[data-v-8d50087a]{width:100%}@media (min-width:350px){.container[data-v-8d50087a]{max-width:350px}}@media (min-width:440px){.container[data-v-8d50087a]{max-width:440px}}@media (min-width:576px){.container[data-v-8d50087a]{max-width:576px}}@media (min-width:768px){.container[data-v-8d50087a]{max-width:768px}}@media (min-width:992px){.container[data-v-8d50087a]{max-width:992px}}@media (min-width:1200px){.container[data-v-8d50087a]{max-width:1200px}}@media (min-width:1440px){.container[data-v-8d50087a]{max-width:1440px}}.appearance-none[data-v-8d50087a]{-webkit-appearance:none;-moz-appearance:none;appearance:none}.bg-transparent[data-v-8d50087a]{background-color:transparent}.bg-white[data-v-8d50087a]{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.bg-gray-100[data-v-8d50087a]{--bg-opacity:1;background-color:#f0f0fa;background-color:rgba(240,240,250,var(--bg-opacity))}.bg-gray-200[data-v-8d50087a]{--bg-opacity:1;background-color:#c9cad9;background-color:rgba(201,202,217,var(--bg-opacity))}.border-violet-300[data-v-8d50087a]{--border-opacity:1;border-color:#634291;border-color:rgba(99,66,145,var(--border-opacity))}.border-gray-400[data-v-8d50087a]{--border-opacity:1;border-color:#5e5f73;border-color:rgba(94,95,115,var(--border-opacity))}.rounded-none[data-v-8d50087a]{border-radius:0}.rounded-md[data-v-8d50087a]{border-radius:.25rem}.border-0[data-v-8d50087a]{border-width:0}.border-1[data-v-8d50087a]{border-width:1px}.border-2[data-v-8d50087a]{border-width:2px}.cursor-pointer[data-v-8d50087a]{cursor:pointer}.flex[data-v-8d50087a]{display:-webkit-box;display:-ms-flexbox;display:flex}.table[data-v-8d50087a]{display:table}.items-center[data-v-8d50087a]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.flex-none[data-v-8d50087a]{-webkit-box-flex:0;-ms-flex:none;flex:none}.flex-grow[data-v-8d50087a]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.h-3[data-v-8d50087a]{height:.75rem}.h-4[data-v-8d50087a]{height:1rem}.h-full[data-v-8d50087a]{height:100%}.text-base[data-v-8d50087a]{font-size:1rem}.mr-2[data-v-8d50087a]{margin-right:.5rem}.mb-2[data-v-8d50087a]{margin-bottom:.5rem}.mt-4[data-v-8d50087a]{margin-top:1rem}.focus\\:outline-none[data-v-8d50087a]:focus{outline:2px solid transparent;outline-offset:2px}.p-3[data-v-8d50087a]{padding:.75rem}.p-4[data-v-8d50087a]{padding:1rem}.relative[data-v-8d50087a]{position:relative}.text-gray-500[data-v-8d50087a]{--text-opacity:1;color:#292940;color:rgba(41,41,64,var(--text-opacity))}.w-3[data-v-8d50087a]{width:.75rem}.w-4[data-v-8d50087a]{width:1rem}.w-full[data-v-8d50087a]{width:100%}.transform[data-v-8d50087a]{--transform-translate-x:0;--transform-translate-y:0;--transform-rotate:0;--transform-skew-x:0;--transform-skew-y:0;--transform-scale-x:1;--transform-scale-y:1;-webkit-transform:translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));transform:translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))}.transition[data-v-8d50087a]{-webkit-transition-property:background-color,border-color,color,fill,stroke,opacity,-webkit-box-shadow,-webkit-transform;transition-property:background-color,border-color,color,fill,stroke,opacity,-webkit-box-shadow,-webkit-transform;transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform;transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,-webkit-box-shadow,-webkit-transform}@-webkit-keyframes spin-data-v-8d50087a{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin-data-v-8d50087a{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes ping-data-v-8d50087a{100%,75%{-webkit-transform:scale(2);transform:scale(2);opacity:0}}@keyframes ping-data-v-8d50087a{100%,75%{-webkit-transform:scale(2);transform:scale(2);opacity:0}}@-webkit-keyframes pulse-data-v-8d50087a{50%{opacity:.5}}@keyframes pulse-data-v-8d50087a{50%{opacity:.5}}@-webkit-keyframes bounce-data-v-8d50087a{0%,100%{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-animation-timing-function:cubic-bezier(.8,0,1,1);animation-timing-function:cubic-bezier(.8,0,1,1)}50%{-webkit-transform:none;transform:none;-webkit-animation-timing-function:cubic-bezier(0,0,.2,1);animation-timing-function:cubic-bezier(0,0,.2,1)}}@keyframes bounce-data-v-8d50087a{0%,100%{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-animation-timing-function:cubic-bezier(.8,0,1,1);animation-timing-function:cubic-bezier(.8,0,1,1)}50%{-webkit-transform:none;transform:none;-webkit-animation-timing-function:cubic-bezier(0,0,.2,1);animation-timing-function:cubic-bezier(0,0,.2,1)}}input[type=search][data-v-8d50087a]::-webkit-search-cancel-button{-webkit-appearance:none}input[type=search][data-v-8d50087a]::-ms-clear{display:none}.close-icon[data-v-8d50087a]:before,.search-container[data-v-8d50087a]:before{border-width:2px;border-color:transparent;content:\'\';position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);-webkit-transition:all .1s ease;transition:all .1s ease}.search-container[data-v-8d50087a]:before{border-radius:6px;height:calc(100% + 8px);width:calc(100% + 8px)}.search-container[data-v-8d50087a]:focus-within:before{--border-opacity:1;border-color:#0086ea;border-color:rgba(0,134,234,var(--border-opacity))}.search-container.disabled[data-v-8d50087a]{--border-opacity:1;border-color:#5e5f73;border-color:rgba(94,95,115,var(--border-opacity));--bg-opacity:1;background-color:#c9cad9;background-color:rgba(201,202,217,var(--bg-opacity))}.search-container.disabled .text-field[data-v-8d50087a]{--bg-opacity:1;background-color:#c9cad9;background-color:rgba(201,202,217,var(--bg-opacity));--text-opacity:1;color:#5e5f73;color:rgba(94,95,115,var(--text-opacity))}.close-icon[data-v-8d50087a]:before{border-radius:2px;height:20px;width:20px}.close-icon[data-v-8d50087a]:focus-within:before,.close-icon[data-v-8d50087a]:focus:before{--border-opacity:1;border-color:#0086ea;border-color:rgba(0,134,234,var(--border-opacity))}@media (min-width:350px){.xxs\\:container[data-v-8d50087a]{width:100%}@media (min-width:350px){.xxs\\:container[data-v-8d50087a]{max-width:350px}}@media (min-width:440px){.xxs\\:container[data-v-8d50087a]{max-width:440px}}@media (min-width:576px){.xxs\\:container[data-v-8d50087a]{max-width:576px}}@media (min-width:768px){.xxs\\:container[data-v-8d50087a]{max-width:768px}}@media (min-width:992px){.xxs\\:container[data-v-8d50087a]{max-width:992px}}@media (min-width:1200px){.xxs\\:container[data-v-8d50087a]{max-width:1200px}}@media (min-width:1440px){.xxs\\:container[data-v-8d50087a]{max-width:1440px}}}@media (min-width:440px){.xs\\:container[data-v-8d50087a]{width:100%}@media (min-width:350px){.xs\\:container[data-v-8d50087a]{max-width:350px}}@media (min-width:440px){.xs\\:container[data-v-8d50087a]{max-width:440px}}@media (min-width:576px){.xs\\:container[data-v-8d50087a]{max-width:576px}}@media (min-width:768px){.xs\\:container[data-v-8d50087a]{max-width:768px}}@media (min-width:992px){.xs\\:container[data-v-8d50087a]{max-width:992px}}@media (min-width:1200px){.xs\\:container[data-v-8d50087a]{max-width:1200px}}@media (min-width:1440px){.xs\\:container[data-v-8d50087a]{max-width:1440px}}}@media (min-width:576px){.sm\\:container[data-v-8d50087a]{width:100%}@media (min-width:350px){.sm\\:container[data-v-8d50087a]{max-width:350px}}@media (min-width:440px){.sm\\:container[data-v-8d50087a]{max-width:440px}}@media (min-width:576px){.sm\\:container[data-v-8d50087a]{max-width:576px}}@media (min-width:768px){.sm\\:container[data-v-8d50087a]{max-width:768px}}@media (min-width:992px){.sm\\:container[data-v-8d50087a]{max-width:992px}}@media (min-width:1200px){.sm\\:container[data-v-8d50087a]{max-width:1200px}}@media (min-width:1440px){.sm\\:container[data-v-8d50087a]{max-width:1440px}}}@media (min-width:768px){.md\\:container[data-v-8d50087a]{width:100%}@media (min-width:350px){.md\\:container[data-v-8d50087a]{max-width:350px}}@media (min-width:440px){.md\\:container[data-v-8d50087a]{max-width:440px}}@media (min-width:576px){.md\\:container[data-v-8d50087a]{max-width:576px}}@media (min-width:768px){.md\\:container[data-v-8d50087a]{max-width:768px}}@media (min-width:992px){.md\\:container[data-v-8d50087a]{max-width:992px}}@media (min-width:1200px){.md\\:container[data-v-8d50087a]{max-width:1200px}}@media (min-width:1440px){.md\\:container[data-v-8d50087a]{max-width:1440px}}}@media (min-width:992px){.lg\\:container[data-v-8d50087a]{width:100%}@media (min-width:350px){.lg\\:container[data-v-8d50087a]{max-width:350px}}@media (min-width:440px){.lg\\:container[data-v-8d50087a]{max-width:440px}}@media (min-width:576px){.lg\\:container[data-v-8d50087a]{max-width:576px}}@media (min-width:768px){.lg\\:container[data-v-8d50087a]{max-width:768px}}@media (min-width:992px){.lg\\:container[data-v-8d50087a]{max-width:992px}}@media (min-width:1200px){.lg\\:container[data-v-8d50087a]{max-width:1200px}}@media (min-width:1440px){.lg\\:container[data-v-8d50087a]{max-width:1440px}}}@media (min-width:1200px){.xl\\:container[data-v-8d50087a]{width:100%}@media (min-width:350px){.xl\\:container[data-v-8d50087a]{max-width:350px}}@media (min-width:440px){.xl\\:container[data-v-8d50087a]{max-width:440px}}@media (min-width:576px){.xl\\:container[data-v-8d50087a]{max-width:576px}}@media (min-width:768px){.xl\\:container[data-v-8d50087a]{max-width:768px}}@media (min-width:992px){.xl\\:container[data-v-8d50087a]{max-width:992px}}@media (min-width:1200px){.xl\\:container[data-v-8d50087a]{max-width:1200px}}@media (min-width:1440px){.xl\\:container[data-v-8d50087a]{max-width:1440px}}}@media (min-width:1440px){.xxl\\:container[data-v-8d50087a]{width:100%}@media (min-width:350px){.xxl\\:container[data-v-8d50087a]{max-width:350px}}@media (min-width:440px){.xxl\\:container[data-v-8d50087a]{max-width:440px}}@media (min-width:576px){.xxl\\:container[data-v-8d50087a]{max-width:576px}}@media (min-width:768px){.xxl\\:container[data-v-8d50087a]{max-width:768px}}@media (min-width:992px){.xxl\\:container[data-v-8d50087a]{max-width:992px}}@media (min-width:1200px){.xxl\\:container[data-v-8d50087a]{max-width:1200px}}@media (min-width:1440px){.xxl\\:container[data-v-8d50087a]{max-width:1440px}}}');var search_input_i=d({render:function(){var a=this,t=a.$createElement,e=a._self._c||t;return e("div",{staticClass:"flex items-center search-container border-1 border-violet-300 rounded-md p-3 relative",class:[{disabled:a.disabled},a.darkBackground?"bg-gray-100":"bg-white"]},[e("icon-search",{staticClass:"cursor-pointer mr-2 w-4 h-4",on:{click:function(t){return a.$emit("search-icon-click")}}}),a._v(" "),e("div",{staticClass:"flex flex-grow items-center relative"},[e("input",a._g(a._b({staticClass:"appearance-none border-0 flex-grow rounded-none text-field w-full text-base bg-transparent focus:outline-none",attrs:{type:"search","aria-label":a.ariaLabel,placeholder:a.placeholder,disabled:a.disabled,tabindex:a.tabindex},domProps:{value:a.value},on:{keyup:function(t){if(!t.type.indexOf("key")&&a._k(t.keyCode,"enter",13,t.key,"Enter"))return null;a.$emit("keyup-enter"),t.target.blur()}}},"input",a.$attrs,!1),a.listeners)),a._v(" "),a.showClear?e("div",{staticClass:"flex-none w-3 h-3 close-icon relative focus:outline-none",attrs:{role:"button",tabindex:a.tabindex},on:{click:function(t){return a.$emit("clear")},keyup:function(t){return!t.type.indexOf("key")&&a._k(t.keyCode,"enter",13,t.key,"Enter")?null:a.$emit("clear")}}},[e("icon-close",{staticClass:"w-full h-full text-gray-500 focus:outline-none",attrs:{"aria-label":"clear search value"}})],1):a._e()])],1)},staticRenderFns:[]},undefined,e,"data-v-8d50087a",false,undefined,!1,void 0,void 0,void 0);search_input_i.install=function(a){a.component(search_input_i.name,search_input_i)};/* harmony default export */ var search_input = (search_input_i);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Dropdown.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Dropdownvue_type_script_lang_js_ = ({
  name: 'Dropdown',
  components: {
    AppTile: AppTile,
    AppList: AppList,
    WwtSearchInput: search_input
  },
  props: {
    apps: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    favorites: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    recents: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showAppTour: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      searchTerm: '',
      showAllApps: false
    };
  },
  methods: {
    handleClear: function handleClear() {
      var _this = this;

      // setTimeout ensures this is the last action executed (after handleClose check)
      setTimeout(function () {
        return _this.searchTerm = '';
      }, 0);
    },
    checkToggleDropdown: function checkToggleDropdown(e) {
      if (!e.shiftKey) {
        this.$emit('toggle-dropdown');
      }
    },
    checkTileTabFocus: function checkTileTabFocus(e, idx) {
      if (!e.shiftKey && idx === this.favorites.length - 1) {
        this.$emit('toggle-dropdown');
      }
    },
    checkListTabFocus: function checkListTabFocus(e, idx) {
      if (!e.shiftKey && idx === this.filteredApps.length - 1) {
        this.$emit('toggle-dropdown');
      }
    }
  },
  computed: {
    filteredApps: function filteredApps() {
      var _this2 = this;

      if (this.searchTerm === '') {
        return this.apps;
      }

      return this.apps.filter(function (it) {
        var name = it.name,
            url = it.url;
        return src_objectHasValue({
          name: name,
          url: url
        }, _this2.searchTerm);
      });
    },
    constructNamUrl: function constructNamUrl() {
      if (!wwtEnv["a" /* default */]) {
        return;
      }

      ;
      var env = wwtEnv["a" /* default */].getEnv();
      var subdomain = '.wwt.com';

      if (env === 'dev' || env === 'local') {
        subdomain = '-dev.wwt.com';
      } else if (env === 'tst' || env === 'test') {
        subdomain = '-test.wwt.com';
      }

      return "https://secure".concat(subdomain, "/nidp/idff/sso/?target=").concat(encodeURIComponent(document.location.href));
    }
  },
  watch: {
    searchTerm: function searchTerm(newVal, oldVal) {
      // when searchTerm changes from an empty string to something else,
      // switch over to the "all apps" list to show the filtered results.
      if (oldVal === '' && newVal !== '') {
        this.showAllApps = true;
      }
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // if no recents or favorites, we should start on the "All Apps" list.
              if (this.favorites.length === 0 && this.recents.length === 0) {
                this.showAllApps = true;
              }

              _context.next = 3;
              return this.$nextTick();

            case 3:
              if (this.apps.length > 0) {
                document.getElementById('wwt-app-switcher-search').focus();
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }()
});
// CONCATENATED MODULE: ./src/Dropdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_Dropdownvue_type_script_lang_js_ = (Dropdownvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/Dropdown.vue?vue&type=style&index=0&id=224cdfb0&lang=less&scoped=true&
var Dropdownvue_type_style_index_0_id_224cdfb0_lang_less_scoped_true_ = __webpack_require__("7588");

// CONCATENATED MODULE: ./src/Dropdown.vue






/* normalize component */

var Dropdown_component = normalizeComponent(
  src_Dropdownvue_type_script_lang_js_,
  Dropdownvue_type_template_id_224cdfb0_scoped_true_lang_html_render,
  Dropdownvue_type_template_id_224cdfb0_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "224cdfb0",
  null
  
)

/* harmony default export */ var Dropdown = (Dropdown_component.exports);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.promise.js
var es6_promise = __webpack_require__("551c");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("bc3a");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/ApiRouterUrl.js

var API_ROUTER_URL = wwtEnv["a" /* default */] ? wwtEnv["a" /* default */].getApiForwardUrl() : null;
/* harmony default export */ var ApiRouterUrl = ({
  get: function get() {
    return API_ROUTER_URL;
  },
  set: function set(customUrl) {
    API_ROUTER_URL = customUrl;
    return API_ROUTER_URL;
  }
});
// CONCATENATED MODULE: ./src/safeAxios.js




function http(handled) {
  var instance = axios_default.a.create({
    baseURL: ApiRouterUrl.get(),
    withCredentials: true
  });

  if (!handled) {
    instance.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      return Promise.reject(error);
    });
  }

  return instance;
}

/* harmony default export */ var safeAxios = (http);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__("a481");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__("f751");

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/define-property.js
var define_property = __webpack_require__("85f2");
var define_property_default = /*#__PURE__*/__webpack_require__.n(define_property);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js


function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;

    define_property_default()(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
// CONCATENATED MODULE: ./src/userService.js
var currentUser = null;
/* harmony default export */ var userService = ({
  get: function get() {
    return currentUser;
  },
  set: function set(user) {
    currentUser = user;
    return user;
  }
});
// CONCATENATED MODULE: ./src/App.js











var user = userService.get();

var App_App =
/*#__PURE__*/
function () {
  function App(data) {
    var isFavorite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, App);

    Object.assign(this, data, {
      isFavorite: isFavorite
    });
  }

  _createClass(App, [{
    key: "toggleFavorite",
    value: function () {
      var _toggleFavorite = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isFavorite) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return this.removeFavorite();

              case 3:
                _context.next = 7;
                break;

              case 5:
                _context.next = 7;
                return this.addFavorite();

              case 7:
                return _context.abrupt("return", this);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function toggleFavorite() {
        return _toggleFavorite.apply(this, arguments);
      }

      return toggleFavorite;
    }()
  }, {
    key: "addFavorite",
    value: function () {
      var _addFavorite = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.user) {
                  safeAxios().post("/users/".concat(this.user.id, "/sidenav/favorites"), {
                    appName: this.name
                  });
                } else {
                  safeAxios().post('/corpsite/sidenav/favorites', {
                    appName: this.name
                  });
                }

                this.isFavorite = true;

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addFavorite() {
        return _addFavorite.apply(this, arguments);
      }

      return addFavorite;
    }()
  }, {
    key: "removeFavorite",
    value: function () {
      var _removeFavorite = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.user) {
                  safeAxios().delete("/users/".concat(this.user.id, "/sidenav/favorites/").concat(this.nameWithoutSpaces));
                } else {
                  safeAxios().delete("/corpsite/sidenav/favorites/".concat(this.nameWithoutSpaces));
                }

                this.isFavorite = false;

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function removeFavorite() {
        return _removeFavorite.apply(this, arguments);
      }

      return removeFavorite;
    }()
  }, {
    key: "addToRecents",
    value: function () {
      var _addToRecents = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var body;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                try {
                  body = {
                    applicationId: this.applicationId
                  };

                  if (user) {
                    body.userId = user.id;
                  }

                  safeAxios().post('/recent-applications', body);
                } catch (err) {
                  console.error("Error adding recent application: ".concat(err));
                }

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function addToRecents() {
        return _addToRecents.apply(this, arguments);
      }

      return addToRecents;
    }()
  }, {
    key: "isOnTelcobuy",
    get: function get() {
      if (!window || !window.location || !window.location.hostname || window.location.hostname === 'localhost') {
        return false;
      }

      return window.location.hostname.indexOf('telcobuy.com') > -1;
    }
  }, {
    key: "url",
    get: function get() {
      if (this.isOnTelcobuy) {
        if (this.baseUrl.indexOf('http') < 0) {
          this.baseUrl = "https://".concat(this.baseUrl);
        }

        var telcoBaseUrl = this.baseUrl.replace('wwt.com', 'telcobuy.com');
        var telcoLocation = this.location.replace('wwt.com', 'telcobuy.com');
        return "".concat(telcoBaseUrl).concat(telcoLocation);
      } else {
        if (this.baseUrl.indexOf('http') < 0) {
          this.baseUrl = "https://".concat(this.baseUrl);
        }

        return "".concat(this.baseUrl).concat(this.location);
      }
    }
  }, {
    key: "iconClass",
    get: function get() {
      if (this.isOnTelcobuy) {
        return "wwt-icon-".concat(this.iconName.replace('wwt-logo', 'telcobuy'));
      }

      return "wwt-icon-".concat(this.iconName);
    }
  }, {
    key: "favoriteIcon",
    get: function get() {
      return this.isFavorite ? 'wwt-icon-star' : 'wwt-icon-star-o';
    }
  }, {
    key: "nameWithoutSpaces",
    get: function get() {
      // replace spaces with + for use in userservice url.
      return this.name.replace(/\s/g, '+');
    }
  }]);

  return App;
}();


// CONCATENATED MODULE: ./src/sortBy.js
/* harmony default export */ var sortBy = (function (arr, props) {
  var sensitive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return arr.sort(function (a, b) {
    return props.map(function (prop) {
      var dir = 1;

      if (prop[0] === '-') {
        // they want a reverse sort
        dir = -1;
        prop = prop.substring(1);
      } // sort should be case insensitive


      var _a = typeof a[prop] === 'string' && sensitive === false ? a[prop].toLowerCase() : a[prop];

      var _b = typeof b[prop] === 'string' && sensitive === false ? b[prop].toLowerCase() : b[prop];

      return _a > _b ? dir : _a < _b ? -dir : 0;
    }).reduce(function (p, n) {
      return p ? p : n;
    }, 0);
  });
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/WwtAppSwitcher.vue?vue&type=script&lang=js&








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var WwtAppSwitchervue_type_script_lang_js_ = ({
  name: 'WwtAppSwitcher',
  components: {
    Dropdown: Dropdown
  },
  props: {
    apiRouterUrl: {
      type: String,
      default: undefined
    },
    showAppTour: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: undefined
    }
  },
  data: function data() {
    return {
      isOpen: false,
      apps: [],
      favorites: [],
      recents: [],
      allAppsMap: null
    };
  },
  methods: {
    getSideNavData: function () {
      var _getSideNavData = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.user) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", safeAxios().get('/corpsite/sidenav'));

              case 4:
                return _context.abrupt("return", safeAxios().get("/users/".concat(this.user.id, "/sidenav")));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSideNavData() {
        return _getSideNavData.apply(this, arguments);
      }

      return getSideNavData;
    }(),
    toggleDropdown: function toggleDropdown() {
      // don't toggle if the app tour is open
      if (this.showAppTour === true) {
        return;
      }

      this.isOpen = !this.isOpen;
    },
    checkToggleDropdown: function checkToggleDropdown(e) {
      if (this.isOpen && e.shiftKey) {
        this.toggleDropdown();
      }
    },
    handleClose: function handleClose(event) {
      var target = event.target;
      var thisNode = document.getElementById('wwt-app-switcher');

      if (!thisNode.contains(target)) {
        // we clicked outside the component wrapper
        // close the dropdown
        this.isOpen = false;
      }
    },
    handleEsc: function handleEsc(event) {
      // if the escape key is pressed and the dropdown is open, close it
      if (event.keyCode === 27 && this.isOpen === true) {
        this.isOpen = false;
      }
    },
    toggleFavorite: function toggleFavorite(app) {
      if (app.isFavorite === true) {
        this.favorites = sortBy([].concat(_toConsumableArray(this.favorites), [app]), ['name']);
      } else {
        this.removeFavorite(app);
      }
    },
    removeFavorite: function removeFavorite(app) {
      var thisApp = this.apps.find(function (it) {
        return it.applicationId === app.applicationId;
      });

      if (thisApp.isFavorite === true) {
        // the apps are not in sync, we need to update the item in this.apps.
        thisApp.removeFavorite();
      } // remove it from the favorites list


      this.favorites = this.favorites.filter(function (it) {
        return it.applicationId !== app.applicationId;
      });
    },
    addRecent: function () {
      var _addRecent = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(app) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return app.addToRecents();

              case 2:
                _context2.next = 4;
                return this.setRecentApps();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addRecent(_x) {
        return _addRecent.apply(this, arguments);
      }

      return addRecent;
    }(),
    getRecents: function () {
      var _getRecents = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var qp, _ref, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                qp = '';

                if (this.user) {
                  qp = "?userId=".concat(this.user.id);
                }

                _context3.next = 5;
                return safeAxios().get("/recent-applications".concat(qp));

              case 5:
                _ref = _context3.sent;
                data = _ref.data;
                return _context3.abrupt("return", data);

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);
                console.error("Error getting recent applications: ".concat(_context3.t0));

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 10]]);
      }));

      function getRecents() {
        return _getRecents.apply(this, arguments);
      }

      return getRecents;
    }(),
    setRecentApps: function () {
      var _setRecentApps = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var _this = this;

        var thisApp;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                thisApp = this.apps.find(function (it) {
                  return it.location === window.location.host;
                });
                _context4.prev = 1;

                if (!(thisApp !== undefined)) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 5;
                return thisApp.addToRecents();

              case 5:
                _context4.next = 7;
                return this.getRecents();

              case 7:
                this.recents = _context4.sent;

                if (this.recents.length > 0) {
                  this.recents = this.recents.slice(0, 6).map(function (recentApp) {
                    return _this.allAppsMap.has(recentApp.applicationId) ? _this.allAppsMap.get(recentApp.applicationId) : {
                      removeMe: true
                    };
                  }).filter(function (it) {
                    return it.removeMe !== true;
                  });
                }

                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](1);
                console.error("Error setting recent apps: ".concat(_context4.t0));

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 11]]);
      }));

      function setRecentApps() {
        return _setRecentApps.apply(this, arguments);
      }

      return setRecentApps;
    }(),
    hideAppTour: function hideAppTour() {
      this.$emit('hide-app-tour');
    }
  },
  watch: {
    isOpen: function isOpen(newVal) {
      if (newVal === true) {
        document.addEventListener('click', this.handleClose);
        window.addEventListener('keydown', this.handleEsc);
      } else {
        document.removeEventListener('click', this.handleClose);
        window.removeEventListener('keydown', this.handleEsc);
      }
    }
  },
  created: function created() {
    if (this.apiRouterUrl) {
      ApiRouterUrl.set(this.apiRouterUrl);
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5() {
      var _this2 = this;

      var sideNavData, _sideNavData$data, FavApps, Applications;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (this.user) {
                userService.set(this.user);
              }

              this.allAppsMap = new Map();
              _context5.next = 4;
              return this.getSideNavData();

            case 4:
              sideNavData = _context5.sent;
              _sideNavData$data = sideNavData.data, FavApps = _sideNavData$data.FavApps, Applications = _sideNavData$data.Applications;

              if (!FavApps || !FavApps.undefined) {
                this.favorites = [];
              } else {
                this.favorites = sortBy(FavApps.undefined.map(function (it) {
                  return new App_App(it, true);
                }), ['name']);
              }

              if (!Applications || !Applications.undefined) {
                this.apps = [];
              } else {
                this.apps = sortBy(Applications.undefined.map(function (app) {
                  var isFavorite = _this2.favorites.some(function (it) {
                    return it.applicationId === app.applicationId;
                  });

                  var newApp = new App_App(app, isFavorite); // add the new App instance to a map so we can easily find it later.

                  _this2.allAppsMap.set(newApp.applicationId, newApp);

                  return newApp;
                }), ['name']);
              }

              _context5.next = 10;
              return this.setRecentApps();

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    // make sure we clean up our events
    document.removeEventListener('click', this.handleClose);
    window.removeEventListener('keydown', this.handleEsc);
  }
});
// CONCATENATED MODULE: ./src/WwtAppSwitcher.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_WwtAppSwitchervue_type_script_lang_js_ = (WwtAppSwitchervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/WwtAppSwitcher.vue?vue&type=style&index=0&id=1861a91c&lang=less&scoped=true&
var WwtAppSwitchervue_type_style_index_0_id_1861a91c_lang_less_scoped_true_ = __webpack_require__("6fa9");

// CONCATENATED MODULE: ./src/WwtAppSwitcher.vue






/* normalize component */

var WwtAppSwitcher_component = normalizeComponent(
  src_WwtAppSwitchervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "1861a91c",
  null
  
)

/* harmony default export */ var WwtAppSwitcher = (WwtAppSwitcher_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (WwtAppSwitcher);



/***/ }),

/***/ "fe02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {// SSR check for Nuxt environments
var wwtEnv = !process.server ? __webpack_require__("40db") : null;
/* harmony default export */ __webpack_exports__["a"] = (wwtEnv);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("f28c")))

/***/ })

/******/ })["default"];
//# sourceMappingURL=WwtAppSwitcher.common.js.map